import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	AgendaPageModulesDynamicZoneInput: any;
	CondoleanceHomepageModulesDynamicZoneInput: any;
	CondoleancePageModulesDynamicZoneInput: any;
	ContactModulesDynamicZoneInput: any;
	Date: any;
	DateTime: any;
	DecisionsPageModulesDynamicZoneInput: any;
	DownloadsPageModulesDynamicZoneInput: any;
	EfroOostHomepageModulesDynamicZoneInput: any;
	EfroOostInConvoWithArticleModulesDynamicZoneInput: any;
	EfroOostInConvoWithDetailModulesDynamicZoneInput: any;
	EfroOostInConvoWithOverviewModulesDynamicZoneInput: any;
	EfroOostNewsDetailModulesDynamicZoneInput: any;
	EfroOostNewsOverviewModulesDynamicZoneInput: any;
	EfroOostNewsarticleModulesDynamicZoneInput: any;
	EfroOostPageModulesDynamicZoneInput: any;
	EventOverviewModulesDynamicZoneInput: any;
	GeolinkHomepageModulesDynamicZoneInput: any;
	GeolinkPageModulesDynamicZoneInput: any;
	HomePageModulesDynamicZoneInput: any;
	I18NLocaleCode: any;
	InConvoWithArticleModulesDynamicZoneInput: any;
	InConvoWithDetailModulesDynamicZoneInput: any;
	InConvoWithOverviewModulesDynamicZoneInput: any;
	JSON: any;
	LoginModulesDynamicZoneInput: any;
	MapsFiguresOverviewModulesDynamicZoneInput: any;
	NewsDetailModulesDynamicZoneInput: any;
	NewsOverviewModulesDynamicZoneInput: any;
	NewsarticleModulesDynamicZoneInput: any;
	NewsletterArchiveOverviewModulesDynamicZoneInput: any;
	OpOostHomepageModulesDynamicZoneInput: any;
	OpOostInConvoWithArticleModulesDynamicZoneInput: any;
	OpOostInConvoWithDetailModulesDynamicZoneInput: any;
	OpOostInConvoWithOverviewModulesDynamicZoneInput: any;
	OpOostNewsDetailModulesDynamicZoneInput: any;
	OpOostNewsOverviewModulesDynamicZoneInput: any;
	OpOostNewsarticleModulesDynamicZoneInput: any;
	OpOostPageModulesDynamicZoneInput: any;
	OpenGelderlandHomepageModulesDynamicZoneInput: any;
	OpenGelderlandWooOverviewModulesDynamicZoneInput: any;
	PageModulesDynamicZoneInput: any;
	PasswordProtectionPasswordPageModulesDynamicZoneInput: any;
	PermitDetailModulesDynamicZoneInput: any;
	PermitModulesDynamicZoneInput: any;
	PermitsOverviewModulesDynamicZoneInput: any;
	PressReleaseDetailModulesDynamicZoneInput: any;
	PressReleaseModulesDynamicZoneInput: any;
	PressReleaseOverviewModulesDynamicZoneInput: any;
	ProjectDetailModulesDynamicZoneInput: any;
	ProjectModulesDynamicZoneInput: any;
	ProjectOverviewModulesDynamicZoneInput: any;
	RegioExpresHomepageModulesDynamicZoneInput: any;
	RegioExpresInConvoOverviewModulesDynamicZoneInput: any;
	RegioExpresInConvoWithArticleModulesDynamicZoneInput: any;
	RegioExpresInConvoWithDetailModulesDynamicZoneInput: any;
	RegioExpresNewsDetailModulesDynamicZoneInput: any;
	RegioExpresNewsOverviewModulesDynamicZoneInput: any;
	RegioExpresNewsarticleModulesDynamicZoneInput: any;
	RegioExpresPageModulesDynamicZoneInput: any;
	RegionDetailModulesDynamicZoneInput: any;
	RegionModulesDynamicZoneInput: any;
	RegionOverviewModulesDynamicZoneInput: any;
	RoadMaintenanceDetailModulesDynamicZoneInput: any;
	RoadMaintenanceModulesDynamicZoneInput: any;
	RoadMaintenanceOverviewModulesDynamicZoneInput: any;
	SearchOverviewModulesDynamicZoneInput: any;
	SitemapModulesDynamicZoneInput: any;
	SubsidyDetailModulesDynamicZoneInput: any;
	SubsidyModulesDynamicZoneInput: any;
	SubsidyOverviewModulesDynamicZoneInput: any;
	ThemeDetailModulesDynamicZoneInput: any;
	ThemeModulesDynamicZoneInput: any;
	ThemeOverviewModulesDynamicZoneInput: any;
	VacancyDetailModulesDynamicZoneInput: any;
	VacancyInternalDetailModulesDynamicZoneInput: any;
	VacancyInternalOverviewModulesDynamicZoneInput: any;
	VacancyOverviewModulesDynamicZoneInput: any;
	WobRequestOverviewModulesDynamicZoneInput: any;
	WooDocumentDetailModulesDynamicZoneInput: any;
	WooRequestOverviewModulesDynamicZoneInput: any;
	WorkAtModulesDynamicZoneInput: any;
};

export type AgendaPage = {
	__typename?: 'AgendaPage';
	/** @deprecated Use root level fields instead */
	attributes: AgendaPage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: AgendaPage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<AgendaPage>>;
	localizations_connection?: Maybe<AgendaPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<AgendaPageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AgendaPageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['AgendaPageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type AgendaPageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| Error;

export type AgendaPageRelationResponseCollection = {
	__typename?: 'AgendaPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<AgendaPage>;
	nodes: Array<AgendaPage>;
};

export type AuditLogAuditLog = {
	__typename?: 'AuditLogAuditLog';
	action: Scalars['String'];
	/** @deprecated Use root level fields instead */
	attributes: AuditLogAuditLog;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: AuditLogAuditLog;
	date: Scalars['DateTime'];
	details?: Maybe<Scalars['JSON']>;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
	user?: Maybe<Scalars['String']>;
};

export type AuditLogAuditLogEntityResponseCollection = {
	__typename?: 'AuditLogAuditLogEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<AuditLogAuditLog>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<AuditLogAuditLog>;
	pageInfo: Pagination;
};

export type AuditLogAuditLogFiltersInput = {
	action?: InputMaybe<StringFilterInput>;
	and?: InputMaybe<Array<InputMaybe<AuditLogAuditLogFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	date?: InputMaybe<DateTimeFilterInput>;
	details?: InputMaybe<JsonFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	not?: InputMaybe<AuditLogAuditLogFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<AuditLogAuditLogFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	user?: InputMaybe<StringFilterInput>;
};

export type AuditLogAuditLogInput = {
	action?: InputMaybe<Scalars['String']>;
	date?: InputMaybe<Scalars['DateTime']>;
	details?: InputMaybe<Scalars['JSON']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	user?: InputMaybe<Scalars['String']>;
};

export type BooleanFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
	contains?: InputMaybe<Scalars['Boolean']>;
	containsi?: InputMaybe<Scalars['Boolean']>;
	endsWith?: InputMaybe<Scalars['Boolean']>;
	eq?: InputMaybe<Scalars['Boolean']>;
	eqi?: InputMaybe<Scalars['Boolean']>;
	gt?: InputMaybe<Scalars['Boolean']>;
	gte?: InputMaybe<Scalars['Boolean']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
	lt?: InputMaybe<Scalars['Boolean']>;
	lte?: InputMaybe<Scalars['Boolean']>;
	ne?: InputMaybe<Scalars['Boolean']>;
	nei?: InputMaybe<Scalars['Boolean']>;
	not?: InputMaybe<BooleanFilterInput>;
	notContains?: InputMaybe<Scalars['Boolean']>;
	notContainsi?: InputMaybe<Scalars['Boolean']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
	startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignNewsletterContact = {
	__typename?: 'CampaignNewsletterContact';
	contact?: Maybe<NewsletterContactData>;
	id: Scalars['String'];
};

export type CampaignNewsletterField = {
	__typename?: 'CampaignNewsletterField';
	campaignId?: Maybe<Scalars['String']>;
	newsletter?: Maybe<Scalars['String']>;
	value?: Maybe<Scalars['String']>;
};

export type ComponentComponentsButton = {
	__typename?: 'ComponentComponentsButton';
	/** @deprecated Use root level fields instead */
	attributes: ComponentComponentsButton;
	/** @deprecated Use root level fields instead */
	data: ComponentComponentsButton;
	href: Scalars['JSON'];
	iconLeft?: Maybe<UploadFile>;
	iconRight?: Maybe<UploadFile>;
	id: Scalars['ID'];
	title?: Maybe<Scalars['String']>;
	variant: Enum_Componentcomponentsbutton_Variant;
};

export type ComponentComponentsButtonFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentComponentsButtonFiltersInput>>>;
	href?: InputMaybe<JsonFilterInput>;
	not?: InputMaybe<ComponentComponentsButtonFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentComponentsButtonFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
	variant?: InputMaybe<StringFilterInput>;
};

export type ComponentComponentsButtonInput = {
	href?: InputMaybe<Scalars['JSON']>;
	iconLeft?: InputMaybe<Scalars['ID']>;
	iconRight?: InputMaybe<Scalars['ID']>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
	variant?: InputMaybe<Enum_Componentcomponentsbutton_Variant>;
};

export type ComponentComponentsIconLink = {
	__typename?: 'ComponentComponentsIconLink';
	/** @deprecated Use root level fields instead */
	attributes: ComponentComponentsIconLink;
	/** @deprecated Use root level fields instead */
	data: ComponentComponentsIconLink;
	href: Scalars['JSON'];
	icon: UploadFile;
	id: Scalars['ID'];
	title: Scalars['String'];
};

export type ComponentComponentsIconLinkFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentComponentsIconLinkFiltersInput>>>;
	href?: InputMaybe<JsonFilterInput>;
	not?: InputMaybe<ComponentComponentsIconLinkFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentComponentsIconLinkFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentComponentsIconLinkGroup = {
	__typename?: 'ComponentComponentsIconLinkGroup';
	/** @deprecated Use root level fields instead */
	attributes: ComponentComponentsIconLinkGroup;
	/** @deprecated Use root level fields instead */
	data: ComponentComponentsIconLinkGroup;
	id: Scalars['ID'];
	links: Array<Maybe<ComponentComponentsIconLink>>;
	title: Scalars['String'];
};

export type ComponentComponentsIconLinkGroupLinksArgs = {
	filters?: InputMaybe<ComponentComponentsIconLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentComponentsIconLinkGroupInput = {
	id?: InputMaybe<Scalars['ID']>;
	links?: InputMaybe<Array<InputMaybe<ComponentComponentsIconLinkInput>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentComponentsIconLinkInput = {
	href?: InputMaybe<Scalars['JSON']>;
	icon?: InputMaybe<Scalars['ID']>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentComponentsInternalLinkSubLayer = {
	__typename?: 'ComponentComponentsInternalLinkSubLayer';
	BodyTeskt?: Maybe<ComponentModulesBodyText>;
	/** @deprecated Use root level fields instead */
	attributes: ComponentComponentsInternalLinkSubLayer;
	/** @deprecated Use root level fields instead */
	data: ComponentComponentsInternalLinkSubLayer;
	id: Scalars['ID'];
	primaryLink?: Maybe<Scalars['JSON']>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentComponentsLink = {
	__typename?: 'ComponentComponentsLink';
	/** @deprecated Use root level fields instead */
	attributes: ComponentComponentsLink;
	/** @deprecated Use root level fields instead */
	data: ComponentComponentsLink;
	description?: Maybe<Scalars['String']>;
	href: Scalars['JSON'];
	id: Scalars['ID'];
	title: Scalars['String'];
};

export type ComponentComponentsLinkFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkFiltersInput>>>;
	description?: InputMaybe<StringFilterInput>;
	href?: InputMaybe<JsonFilterInput>;
	not?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentComponentsLinkGroup = {
	__typename?: 'ComponentComponentsLinkGroup';
	/** @deprecated Use root level fields instead */
	attributes: ComponentComponentsLinkGroup;
	/** @deprecated Use root level fields instead */
	data: ComponentComponentsLinkGroup;
	href?: Maybe<Scalars['JSON']>;
	id: Scalars['ID'];
	links: Array<Maybe<ComponentComponentsLink>>;
	title: Scalars['String'];
};

export type ComponentComponentsLinkGroupLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentComponentsLinkGroupFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkGroupFiltersInput>>>;
	href?: InputMaybe<JsonFilterInput>;
	links?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	not?: InputMaybe<ComponentComponentsLinkGroupFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkGroupFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentComponentsLinkGroupInput = {
	href?: InputMaybe<Scalars['JSON']>;
	id?: InputMaybe<Scalars['ID']>;
	links?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkInput>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentComponentsLinkInput = {
	description?: InputMaybe<Scalars['String']>;
	href?: InputMaybe<Scalars['JSON']>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentComponentsSubject = {
	__typename?: 'ComponentComponentsSubject';
	/** @deprecated Use root level fields instead */
	attributes: ComponentComponentsSubject;
	/** @deprecated Use root level fields instead */
	data: ComponentComponentsSubject;
	description?: Maybe<Scalars['String']>;
	href?: Maybe<Scalars['JSON']>;
	id: Scalars['ID'];
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalAboutMaintenance = {
	__typename?: 'ComponentInternalAboutMaintenance';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalAboutMaintenance;
	contractor?: Maybe<Scalars['String']>;
	contractorWebsite?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalAboutMaintenance;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	detour?: Maybe<Scalars['String']>;
	endDate?: Maybe<Scalars['DateTime']>;
	id: Scalars['ID'];
	startDate?: Maybe<Scalars['DateTime']>;
};

export type ComponentInternalAboutMaintenanceFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalAboutMaintenanceFiltersInput>>>;
	contractor?: InputMaybe<StringFilterInput>;
	contractorWebsite?: InputMaybe<StringFilterInput>;
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsFiltersInput>;
	detour?: InputMaybe<StringFilterInput>;
	endDate?: InputMaybe<DateTimeFilterInput>;
	not?: InputMaybe<ComponentInternalAboutMaintenanceFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalAboutMaintenanceFiltersInput>>>;
	startDate?: InputMaybe<DateTimeFilterInput>;
};

export type ComponentInternalAboutMaintenanceInput = {
	contractor?: InputMaybe<Scalars['String']>;
	contractorWebsite?: InputMaybe<Scalars['String']>;
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	detour?: InputMaybe<Scalars['String']>;
	endDate?: InputMaybe<Scalars['DateTime']>;
	id?: InputMaybe<Scalars['ID']>;
	startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ComponentInternalAccordeonItem = {
	__typename?: 'ComponentInternalAccordeonItem';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalAccordeonItem;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalAccordeonItem;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	itemTitle: Scalars['String'];
};

export type ComponentInternalAccordeonItemFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalAccordeonItemFiltersInput>>>;
	description?: InputMaybe<StringFilterInput>;
	itemTitle?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentInternalAccordeonItemFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalAccordeonItemFiltersInput>>>;
};

export type ComponentInternalAccordeonSection = {
	__typename?: 'ComponentInternalAccordeonSection';
	accordeonSectionName?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalAccordeonSection;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalAccordeonSection;
	id: Scalars['ID'];
	items: Array<Maybe<ComponentInternalAccordeonItem>>;
};

export type ComponentInternalAccordeonSectionItemsArgs = {
	filters?: InputMaybe<ComponentInternalAccordeonItemFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalAccordeonSectionFiltersInput = {
	accordeonSectionName?: InputMaybe<StringFilterInput>;
	and?: InputMaybe<Array<InputMaybe<ComponentInternalAccordeonSectionFiltersInput>>>;
	items?: InputMaybe<ComponentInternalAccordeonItemFiltersInput>;
	not?: InputMaybe<ComponentInternalAccordeonSectionFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalAccordeonSectionFiltersInput>>>;
};

export type ComponentInternalBodyTextColumn = {
	__typename?: 'ComponentInternalBodyTextColumn';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalBodyTextColumn;
	bodyText?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalBodyTextColumn;
	id: Scalars['ID'];
};

export type ComponentInternalDefaultModuleOptions = {
	__typename?: 'ComponentInternalDefaultModuleOptions';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalDefaultModuleOptions;
	backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
};

export type ComponentInternalDefaultModuleOptionsExtended = {
	__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalDefaultModuleOptionsExtended;
	backgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalDefaultModuleOptionsExtended;
	id: Scalars['ID'];
	padding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
};

export type ComponentInternalDefaultModuleOptionsExtendedFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalDefaultModuleOptionsExtendedFiltersInput>>>;
	backgroundColor?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentInternalDefaultModuleOptionsExtendedFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalDefaultModuleOptionsExtendedFiltersInput>>>;
	padding?: InputMaybe<StringFilterInput>;
};

export type ComponentInternalDefaultModuleOptionsExtendedInput = {
	backgroundColor?: InputMaybe<Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor>;
	id?: InputMaybe<Scalars['ID']>;
	padding?: InputMaybe<Enum_Componentinternaldefaultmoduleoptionsextended_Padding>;
};

export type ComponentInternalDefaultModuleOptionsFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalDefaultModuleOptionsFiltersInput>>>;
	backgroundColor?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentInternalDefaultModuleOptionsFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalDefaultModuleOptionsFiltersInput>>>;
	padding?: InputMaybe<StringFilterInput>;
};

export type ComponentInternalDefaultModuleOptionsInput = {
	backgroundColor?: InputMaybe<Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor>;
	id?: InputMaybe<Scalars['ID']>;
	padding?: InputMaybe<Enum_Componentinternaldefaultmoduleoptions_Padding>;
};

export type ComponentInternalEmptyState = {
	__typename?: 'ComponentInternalEmptyState';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalEmptyState;
	buttonHref?: Maybe<Scalars['String']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalEmptyState;
	id: Scalars['ID'];
	message?: Maybe<Scalars['String']>;
};

export type ComponentInternalFirstRowItems = {
	__typename?: 'ComponentInternalFirstRowItems';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalFirstRowItems;
	bodyText?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalFirstRowItems;
	id: Scalars['ID'];
};

export type ComponentInternalFirstRowItemsFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalFirstRowItemsFiltersInput>>>;
	bodyText?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentInternalFirstRowItemsFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalFirstRowItemsFiltersInput>>>;
};

export type ComponentInternalFooter = {
	__typename?: 'ComponentInternalFooter';
	accessibilityLink?: Maybe<Scalars['String']>;
	accessibilityLogo?: Maybe<UploadFile>;
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalFooter;
	bottomLinks?: Maybe<Array<Maybe<ComponentComponentsLink>>>;
	contactLinkGroup?: Maybe<ComponentComponentsLinkGroup>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalFooter;
	id: Scalars['ID'];
	logo?: Maybe<UploadFile>;
	socialLinkGroup?: Maybe<ComponentComponentsIconLinkGroup>;
	themeLinkGroup?: Maybe<ComponentComponentsLinkGroup>;
};

export type ComponentInternalFooterBottomLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalFooterInput = {
	accessibilityLink?: InputMaybe<Scalars['String']>;
	accessibilityLogo?: InputMaybe<Scalars['ID']>;
	bottomLinks?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkInput>>>;
	contactLinkGroup?: InputMaybe<ComponentComponentsLinkGroupInput>;
	id?: InputMaybe<Scalars['ID']>;
	logo?: InputMaybe<Scalars['ID']>;
	socialLinkGroup?: InputMaybe<ComponentComponentsIconLinkGroupInput>;
	themeLinkGroup?: InputMaybe<ComponentComponentsLinkGroupInput>;
};

export type ComponentInternalHighlightEvents = {
	__typename?: 'ComponentInternalHighlightEvents';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalHighlightEvents;
	buttonHref?: Maybe<Scalars['JSON']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalHighlightEvents;
	empty?: Maybe<ComponentInternalEmptyState>;
	events: Array<Maybe<Newsarticle>>;
	events_connection?: Maybe<NewsarticleRelationResponseCollection>;
	id: Scalars['ID'];
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalHighlightEventsEventsArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightEventsEvents_ConnectionArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightMapsAndStats = {
	__typename?: 'ComponentInternalHighlightMapsAndStats';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalHighlightMapsAndStats;
	buttonHref?: Maybe<Scalars['JSON']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalHighlightMapsAndStats;
	empty?: Maybe<ComponentInternalEmptyState>;
	id: Scalars['ID'];
	mapsAndStats: Array<Maybe<MapsFigure>>;
	mapsAndStats_connection?: Maybe<MapsFigureRelationResponseCollection>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalHighlightMapsAndStatsMapsAndStatsArgs = {
	filters?: InputMaybe<MapsFigureFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightMapsAndStatsMapsAndStats_ConnectionArgs = {
	filters?: InputMaybe<MapsFigureFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightNews = {
	__typename?: 'ComponentInternalHighlightNews';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalHighlightNews;
	buttonHref?: Maybe<Scalars['JSON']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalHighlightNews;
	empty?: Maybe<ComponentInternalEmptyState>;
	id: Scalars['ID'];
	newsArticles: Array<Maybe<Newsarticle>>;
	newsArticles_connection?: Maybe<NewsarticleRelationResponseCollection>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalHighlightNewsNewsArticlesArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightNewsNewsArticles_ConnectionArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightPermits = {
	__typename?: 'ComponentInternalHighlightPermits';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalHighlightPermits;
	buttonHref?: Maybe<Scalars['JSON']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalHighlightPermits;
	empty?: Maybe<ComponentInternalEmptyState>;
	id: Scalars['ID'];
	permits: Array<Maybe<Permit>>;
	permits_connection?: Maybe<PermitRelationResponseCollection>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalHighlightPermitsPermitsArgs = {
	filters?: InputMaybe<PermitFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightPermitsPermits_ConnectionArgs = {
	filters?: InputMaybe<PermitFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightSubsidies = {
	__typename?: 'ComponentInternalHighlightSubsidies';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalHighlightSubsidies;
	buttonHref?: Maybe<Scalars['JSON']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalHighlightSubsidies;
	empty?: Maybe<ComponentInternalEmptyState>;
	id: Scalars['ID'];
	subsidies: Array<Maybe<Subsidy>>;
	subsidies_connection?: Maybe<SubsidyRelationResponseCollection>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalHighlightSubsidiesSubsidiesArgs = {
	filters?: InputMaybe<SubsidyFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightSubsidiesSubsidies_ConnectionArgs = {
	filters?: InputMaybe<SubsidyFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightTopics = {
	__typename?: 'ComponentInternalHighlightTopics';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalHighlightTopics;
	buttonHref?: Maybe<Scalars['JSON']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalHighlightTopics;
	empty?: Maybe<ComponentInternalEmptyState>;
	id: Scalars['ID'];
	title?: Maybe<Scalars['String']>;
	topics: Array<Maybe<Newsarticle>>;
	topics_connection?: Maybe<NewsarticleRelationResponseCollection>;
};

export type ComponentInternalHighlightTopicsTopicsArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightTopicsTopics_ConnectionArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightWoo = {
	__typename?: 'ComponentInternalHighlightWoo';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalHighlightWoo;
	buttonHref?: Maybe<Scalars['JSON']>;
	buttonTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalHighlightWoo;
	empty?: Maybe<ComponentInternalEmptyState>;
	id: Scalars['ID'];
	requests: Array<Maybe<WooRequest>>;
	requests_connection?: Maybe<WooRequestRelationResponseCollection>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalHighlightWooRequestsArgs = {
	filters?: InputMaybe<WooRequestFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalHighlightWooRequests_ConnectionArgs = {
	filters?: InputMaybe<WooRequestFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalNavbar = {
	__typename?: 'ComponentInternalNavbar';
	ThemeGroupTitle?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalNavbar;
	bottomLinks?: Maybe<Array<Maybe<ComponentComponentsLink>>>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalNavbar;
	id: Scalars['ID'];
	logo?: Maybe<UploadFile>;
	mostPopularGroupLinks?: Maybe<Array<Maybe<ComponentComponentsLinkGroup>>>;
	mostPopularTitle?: Maybe<Scalars['String']>;
	notificationIsExternal?: Maybe<Scalars['Boolean']>;
	notificationLink?: Maybe<Scalars['JSON']>;
	notificationMessage?: Maybe<Scalars['String']>;
	notificationPublishDate?: Maybe<Scalars['DateTime']>;
	notificationUnpublishDate?: Maybe<Scalars['DateTime']>;
	rightNavLink?: Maybe<Scalars['JSON']>;
	searchPlaceholderText?: Maybe<Scalars['String']>;
	themeGroupLinks?: Maybe<Array<Maybe<ComponentComponentsLinkGroup>>>;
};

export type ComponentInternalNavbarBottomLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalNavbarMostPopularGroupLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkGroupFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalNavbarThemeGroupLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkGroupFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalNavbarInput = {
	ThemeGroupTitle?: InputMaybe<Scalars['String']>;
	bottomLinks?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkInput>>>;
	id?: InputMaybe<Scalars['ID']>;
	logo?: InputMaybe<Scalars['ID']>;
	mostPopularGroupLinks?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkGroupInput>>>;
	mostPopularTitle?: InputMaybe<Scalars['String']>;
	notificationIsExternal?: InputMaybe<Scalars['Boolean']>;
	notificationLink?: InputMaybe<Scalars['JSON']>;
	notificationMessage?: InputMaybe<Scalars['String']>;
	notificationPublishDate?: InputMaybe<Scalars['DateTime']>;
	notificationUnpublishDate?: InputMaybe<Scalars['DateTime']>;
	rightNavLink?: InputMaybe<Scalars['JSON']>;
	searchPlaceholderText?: InputMaybe<Scalars['String']>;
	themeGroupLinks?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkGroupInput>>>;
};

export type ComponentInternalNewsletter = {
	__typename?: 'ComponentInternalNewsletter';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalNewsletter;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalNewsletter;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	fieldLabel?: Maybe<Scalars['String']>;
	fieldPlaceholder?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	submitButton?: Maybe<ComponentComponentsButton>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentInternalNewsletterInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	fieldLabel?: InputMaybe<Scalars['String']>;
	fieldPlaceholder?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	submitButton?: InputMaybe<ComponentComponentsButtonInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentInternalPhoto = {
	__typename?: 'ComponentInternalPhoto';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalPhoto;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalPhoto;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	photo: UploadFile;
	title: Scalars['String'];
};

export type ComponentInternalPhotoFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalPhotoFiltersInput>>>;
	description?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentInternalPhotoFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalPhotoFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentInternalSecondColumnItems = {
	__typename?: 'ComponentInternalSecondColumnItems';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalSecondColumnItems;
	bodyText?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalSecondColumnItems;
	id: Scalars['ID'];
};

export type ComponentInternalSecondColumnItemsFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalSecondColumnItemsFiltersInput>>>;
	bodyText?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentInternalSecondColumnItemsFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalSecondColumnItemsFiltersInput>>>;
};

export type ComponentInternalSeo = {
	__typename?: 'ComponentInternalSeo';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalSeo;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalSeo;
	description: Scalars['String'];
	id: Scalars['ID'];
	noFollow: Scalars['Boolean'];
	noIndex: Scalars['Boolean'];
	ogDescription?: Maybe<Scalars['String']>;
	ogImage?: Maybe<UploadFile>;
	ogTitle?: Maybe<Scalars['String']>;
	ogType?: Maybe<Scalars['String']>;
	ogUrl?: Maybe<Scalars['String']>;
	title: Scalars['String'];
};

export type ComponentInternalSeoInput = {
	description?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	noFollow?: InputMaybe<Scalars['Boolean']>;
	noIndex?: InputMaybe<Scalars['Boolean']>;
	ogDescription?: InputMaybe<Scalars['String']>;
	ogImage?: InputMaybe<Scalars['ID']>;
	ogTitle?: InputMaybe<Scalars['String']>;
	ogType?: InputMaybe<Scalars['String']>;
	ogUrl?: InputMaybe<Scalars['String']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentInternalSidebar = {
	__typename?: 'ComponentInternalSidebar';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalSidebar;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalSidebar;
	files: Array<Maybe<UploadFile>>;
	files_connection?: Maybe<UploadFileRelationResponseCollection>;
	id: Scalars['ID'];
	links?: Maybe<Array<Maybe<ComponentComponentsLink>>>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentInternalSidebarFilesArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalSidebarFiles_ConnectionArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalSidebarLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalSidebarFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalSidebarFiltersInput>>>;
	links?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	not?: InputMaybe<ComponentInternalSidebarFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalSidebarFiltersInput>>>;
	title?: InputMaybe<JsonFilterInput>;
};

export type ComponentInternalSidebarInput = {
	files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	id?: InputMaybe<Scalars['ID']>;
	links?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkInput>>>;
	title?: InputMaybe<Scalars['JSON']>;
};

export type ComponentInternalStepByStepCard = {
	__typename?: 'ComponentInternalStepByStepCard';
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalStepByStepCard;
	cardDescription?: Maybe<Scalars['String']>;
	cardTitle: Scalars['String'];
	/** @deprecated Use root level fields instead */
	data: ComponentInternalStepByStepCard;
	id: Scalars['ID'];
};

export type ComponentInternalStepByStepCardFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentInternalStepByStepCardFiltersInput>>>;
	cardDescription?: InputMaybe<StringFilterInput>;
	cardTitle?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentInternalStepByStepCardFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentInternalStepByStepCardFiltersInput>>>;
};

export type ComponentInternalTest = {
	__typename?: 'ComponentInternalTest';
	Title?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	attributes: ComponentInternalTest;
	/** @deprecated Use root level fields instead */
	data: ComponentInternalTest;
	id: Scalars['ID'];
	nieuws_artikels: Array<Maybe<Newsarticle>>;
	nieuws_artikels_connection?: Maybe<NewsarticleRelationResponseCollection>;
	thema?: Maybe<Theme>;
};

export type ComponentInternalTestNieuws_ArtikelsArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentInternalTestNieuws_Artikels_ConnectionArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentLinkFieldLinkField = {
	__typename?: 'ComponentLinkFieldLinkField';
	/** @deprecated Use root level fields instead */
	attributes: ComponentLinkFieldLinkField;
	/** @deprecated Use root level fields instead */
	data: ComponentLinkFieldLinkField;
	id: Scalars['ID'];
	linkText: Scalars['String'];
	linkUrl: Scalars['String'];
};

export type ComponentModulesAccordeon = {
	__typename?: 'ComponentModulesAccordeon';
	accordeonTitle?: Maybe<Scalars['JSON']>;
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesAccordeon;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesAccordeon;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	sections: Array<Maybe<ComponentInternalAccordeonSection>>;
	sidebar?: Maybe<ComponentInternalSidebar>;
};

export type ComponentModulesAccordeonSectionsArgs = {
	filters?: InputMaybe<ComponentInternalAccordeonSectionFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesBbvmsMediaplayer = {
	__typename?: 'ComponentModulesBbvmsMediaplayer';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesBbvmsMediaplayer;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesBbvmsMediaplayer;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
	title?: Maybe<Scalars['JSON']>;
	transcript?: Maybe<Scalars['String']>;
	url?: Maybe<Scalars['String']>;
	videoId: Scalars['String'];
};

export type ComponentModulesBodyText = {
	__typename?: 'ComponentModulesBodyText';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesBodyText;
	bodyText?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesBodyText;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	sidebar?: Maybe<ComponentInternalSidebar>;
};

export type ComponentModulesBodyTextFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentModulesBodyTextFiltersInput>>>;
	bodyText?: InputMaybe<StringFilterInput>;
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsFiltersInput>;
	not?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentModulesBodyTextFiltersInput>>>;
	sidebar?: InputMaybe<ComponentInternalSidebarFiltersInput>;
};

export type ComponentModulesBodyTextInput = {
	bodyText?: InputMaybe<Scalars['String']>;
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	id?: InputMaybe<Scalars['ID']>;
	sidebar?: InputMaybe<ComponentInternalSidebarInput>;
};

export type ComponentModulesBodyTextTwoColumn = {
	__typename?: 'ComponentModulesBodyTextTwoColumn';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesBodyTextTwoColumn;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesBodyTextTwoColumn;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	leftColumn: ComponentInternalBodyTextColumn;
	rightColumn: ComponentInternalBodyTextColumn;
};

export type ComponentModulesCollections = {
	__typename?: 'ComponentModulesCollections';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesCollections;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesCollections;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	links: Array<Maybe<ComponentComponentsLink>>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentModulesCollectionsLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesCollectionsInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	description?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	links?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkInput>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesCta = {
	__typename?: 'ComponentModulesCta';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesCta;
	buttons?: Maybe<Array<Maybe<ComponentComponentsButton>>>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesCta;
	defaultModuleOptions: ComponentInternalDefaultModuleOptionsExtended;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	imageOrVideoFile?: Maybe<UploadFile>;
	imagePosition?: Maybe<Enum_Componentmodulescta_Imageposition>;
	title?: Maybe<Scalars['JSON']>;
	videoLink?: Maybe<Scalars['String']>;
};

export type ComponentModulesCtaButtonsArgs = {
	filters?: InputMaybe<ComponentComponentsButtonFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesCtaInput = {
	buttons?: InputMaybe<Array<InputMaybe<ComponentComponentsButtonInput>>>;
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsExtendedInput>;
	description?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	imageOrVideoFile?: InputMaybe<Scalars['ID']>;
	imagePosition?: InputMaybe<Enum_Componentmodulescta_Imageposition>;
	title?: InputMaybe<Scalars['JSON']>;
	videoLink?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesDownloads = {
	__typename?: 'ComponentModulesDownloads';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesDownloads;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesDownloads;
	defaultModuleOptions: ComponentInternalDefaultModuleOptionsExtended;
	downloadLinks?: Maybe<Array<Maybe<ComponentComponentsLink>>>;
	downloads: Array<Maybe<UploadFile>>;
	downloads_connection?: Maybe<UploadFileRelationResponseCollection>;
	id: Scalars['ID'];
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesDownloadsDownloadLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesDownloadsDownloadsArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesDownloadsDownloads_ConnectionArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesDownloadsFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentModulesDownloadsFiltersInput>>>;
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsExtendedFiltersInput>;
	downloadLinks?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	not?: InputMaybe<ComponentModulesDownloadsFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentModulesDownloadsFiltersInput>>>;
	title?: InputMaybe<JsonFilterInput>;
};

export type ComponentModulesDownloadsInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsExtendedInput>;
	downloadLinks?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkInput>>>;
	downloads?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['JSON']>;
};

export type ComponentModulesEventOverview = {
	__typename?: 'ComponentModulesEventOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesEventOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesEventOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	filterLabel?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
};

export type ComponentModulesExpandedHeader = {
	__typename?: 'ComponentModulesExpandedHeader';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesExpandedHeader;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesExpandedHeader;
	description?: Maybe<Scalars['String']>;
	headerButton?: Maybe<ComponentComponentsButton>;
	headerDescription?: Maybe<Scalars['String']>;
	headerImage?: Maybe<UploadFile>;
	headerTitle?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	title?: Maybe<Scalars['String']>;
};

export type ComponentModulesExpandedHeaderFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentModulesExpandedHeaderFiltersInput>>>;
	description?: InputMaybe<StringFilterInput>;
	headerButton?: InputMaybe<ComponentComponentsButtonFiltersInput>;
	headerDescription?: InputMaybe<StringFilterInput>;
	headerTitle?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentModulesExpandedHeaderFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentModulesExpandedHeaderFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesExpandedHeaderInput = {
	description?: InputMaybe<Scalars['String']>;
	headerButton?: InputMaybe<ComponentComponentsButtonInput>;
	headerDescription?: InputMaybe<Scalars['String']>;
	headerImage?: InputMaybe<Scalars['ID']>;
	headerTitle?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesFeaturedNews = {
	__typename?: 'ComponentModulesFeaturedNews';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesFeaturedNews;
	cta?: Maybe<ComponentComponentsButton>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesFeaturedNews;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	newsArticles: Array<Maybe<Newsarticle>>;
	newsArticles_connection?: Maybe<NewsarticleRelationResponseCollection>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesFeaturedNewsNewsArticlesArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedNewsNewsArticles_ConnectionArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedNewsEfroOost = {
	__typename?: 'ComponentModulesFeaturedNewsEfroOost';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesFeaturedNewsEfroOost;
	cta?: Maybe<ComponentComponentsButton>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesFeaturedNewsEfroOost;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	newsArticles: Array<Maybe<EfroOostNewsarticle>>;
	newsArticles_connection?: Maybe<EfroOostNewsarticleRelationResponseCollection>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesFeaturedNewsEfroOostNewsArticlesArgs = {
	filters?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedNewsEfroOostNewsArticles_ConnectionArgs = {
	filters?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedNewsOpOost = {
	__typename?: 'ComponentModulesFeaturedNewsOpOost';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesFeaturedNewsOpOost;
	cta?: Maybe<ComponentComponentsButton>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesFeaturedNewsOpOost;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	news: Array<Maybe<OpOostNewsarticle>>;
	news_connection?: Maybe<OpOostNewsarticleRelationResponseCollection>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesFeaturedNewsOpOostNewsArgs = {
	filters?: InputMaybe<OpOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedNewsOpOostNews_ConnectionArgs = {
	filters?: InputMaybe<OpOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedNewsRegioExpres = {
	__typename?: 'ComponentModulesFeaturedNewsRegioExpres';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesFeaturedNewsRegioExpres;
	cta?: Maybe<ComponentComponentsButton>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesFeaturedNewsRegioExpres;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	newsArticles: Array<Maybe<RegioExpresNewsarticle>>;
	newsArticles_connection?: Maybe<RegioExpresNewsarticleRelationResponseCollection>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesFeaturedNewsRegioExpresNewsArticlesArgs = {
	filters?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedNewsRegioExpresNewsArticles_ConnectionArgs = {
	filters?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedPages = {
	__typename?: 'ComponentModulesFeaturedPages';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesFeaturedPages;
	cta?: Maybe<ComponentComponentsButton>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesFeaturedPages;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	pages: Array<Maybe<Page>>;
	pages_connection?: Maybe<PageRelationResponseCollection>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesFeaturedPagesPagesArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesFeaturedPagesPages_ConnectionArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesHighlight = {
	__typename?: 'ComponentModulesHighlight';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesHighlight;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesHighlight;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	eventsTab?: Maybe<ComponentInternalHighlightEvents>;
	id: Scalars['ID'];
	mapsAndStatsTab?: Maybe<ComponentInternalHighlightMapsAndStats>;
	newsTab?: Maybe<ComponentInternalHighlightNews>;
	permitsTab?: Maybe<ComponentInternalHighlightPermits>;
	subsidiesTab?: Maybe<ComponentInternalHighlightSubsidies>;
	theme?: Maybe<Theme>;
	title?: Maybe<Scalars['JSON']>;
	topicsTab?: Maybe<ComponentInternalHighlightTopics>;
	wooTab?: Maybe<ComponentInternalHighlightWoo>;
};

export type ComponentModulesHomepageHeader = {
	__typename?: 'ComponentModulesHomepageHeader';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesHomepageHeader;
	backgroundImage?: Maybe<UploadFile>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesHomepageHeader;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	links?: Maybe<Array<Maybe<ComponentComponentsLink>>>;
	popularHeader?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentModulesHomepageHeaderLinksArgs = {
	filters?: InputMaybe<ComponentComponentsLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesHomepageHeaderInput = {
	backgroundImage?: InputMaybe<Scalars['ID']>;
	description?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	links?: InputMaybe<Array<InputMaybe<ComponentComponentsLinkInput>>>;
	popularHeader?: InputMaybe<Scalars['String']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesInConvoWithOverview = {
	__typename?: 'ComponentModulesInConvoWithOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesInConvoWithOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesInConvoWithOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	filterLabel?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
};

export type ComponentModulesInternalInternalLink = {
	__typename?: 'ComponentModulesInternalInternalLink';
	BodyTeskt?: Maybe<ComponentModulesBodyText>;
	Title?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesInternalInternalLink;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesInternalInternalLink;
	id: Scalars['ID'];
	primaryLink?: Maybe<Scalars['JSON']>;
	sublayer?: Maybe<ComponentComponentsInternalLinkSubLayer>;
};

export type ComponentModulesIntroHeader = {
	__typename?: 'ComponentModulesIntroHeader';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesIntroHeader;
	backgroundColor?: Maybe<Enum_Componentmodulesintroheader_Backgroundcolor>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesIntroHeader;
	excerpt: Scalars['String'];
	id: Scalars['ID'];
	title: Scalars['String'];
};

export type ComponentModulesIntroHeaderFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentModulesIntroHeaderFiltersInput>>>;
	backgroundColor?: InputMaybe<StringFilterInput>;
	excerpt?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentModulesIntroHeaderFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentModulesIntroHeaderFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesIntroHeaderImage = {
	__typename?: 'ComponentModulesIntroHeaderImage';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesIntroHeaderImage;
	backgroundColor?: Maybe<Enum_Componentmodulesintroheaderimage_Backgroundcolor>;
	cover?: Maybe<UploadFile>;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesIntroHeaderImage;
	excerpt?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	title: Scalars['String'];
};

export type ComponentModulesIntroHeaderImageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>>>;
	backgroundColor?: InputMaybe<StringFilterInput>;
	excerpt?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesIntroHeaderImageInput = {
	backgroundColor?: InputMaybe<Enum_Componentmodulesintroheaderimage_Backgroundcolor>;
	cover?: InputMaybe<Scalars['ID']>;
	excerpt?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesIntroHeaderInput = {
	backgroundColor?: InputMaybe<Enum_Componentmodulesintroheader_Backgroundcolor>;
	excerpt?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesLinkBox = {
	__typename?: 'ComponentModulesLinkBox';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesLinkBox;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesLinkBox;
	defaultModuleOptions: ComponentInternalDefaultModuleOptionsExtended;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	links?: Maybe<Array<Maybe<ComponentComponentsButton>>>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesLinkBoxLinksArgs = {
	filters?: InputMaybe<ComponentComponentsButtonFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesLinkBoxInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsExtendedInput>;
	description?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	links?: InputMaybe<Array<InputMaybe<ComponentComponentsButtonInput>>>;
	title?: InputMaybe<Scalars['JSON']>;
};

export type ComponentModulesMapsFiguresOverview = {
	__typename?: 'ComponentModulesMapsFiguresOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesMapsFiguresOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesMapsFiguresOverview;
	filterHeaderText: Scalars['String'];
	headerTitle: Scalars['String'];
	id: Scalars['ID'];
	kindFilterText: Scalars['String'];
	overviewTitleText: Scalars['String'];
	searchPlaceholderText: Scalars['String'];
	showAllThemesText: Scalars['String'];
	showResultsText: Scalars['String'];
	themeFilterText: Scalars['String'];
};

export type ComponentModulesMapsFiguresOverviewInput = {
	filterHeaderText?: InputMaybe<Scalars['String']>;
	headerTitle?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	kindFilterText?: InputMaybe<Scalars['String']>;
	overviewTitleText?: InputMaybe<Scalars['String']>;
	searchPlaceholderText?: InputMaybe<Scalars['String']>;
	showAllThemesText?: InputMaybe<Scalars['String']>;
	showResultsText?: InputMaybe<Scalars['String']>;
	themeFilterText?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesMedia = {
	__typename?: 'ComponentModulesMedia';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesMedia;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesMedia;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	media?: Maybe<UploadFile>;
	mediaLink?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['JSON']>;
	transcript?: Maybe<Scalars['String']>;
};

export type ComponentModulesNewsOverview = {
	__typename?: 'ComponentModulesNewsOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesNewsOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesNewsOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	filterLabel?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
};

export type ComponentModulesOpenWooRequestOverview = {
	__typename?: 'ComponentModulesOpenWooRequestOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesOpenWooRequestOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesOpenWooRequestOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	filterHeaderText: Scalars['String'];
	filterLink?: Maybe<ComponentComponentsLink>;
	headerTitle: Scalars['String'];
	id: Scalars['ID'];
};

export type ComponentModulesOpenWooRequestOverviewInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	filterHeaderText?: InputMaybe<Scalars['String']>;
	filterLink?: InputMaybe<ComponentComponentsLinkInput>;
	headerTitle?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
};

export type ComponentModulesPartners = {
	__typename?: 'ComponentModulesPartners';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesPartners;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesPartners;
	defaultModuleOptions: ComponentInternalDefaultModuleOptionsExtended;
	id: Scalars['ID'];
	logos: Array<Maybe<ComponentComponentsIconLink>>;
	title: Scalars['JSON'];
};

export type ComponentModulesPartnersLogosArgs = {
	filters?: InputMaybe<ComponentComponentsIconLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesPermitsOverview = {
	__typename?: 'ComponentModulesPermitsOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesPermitsOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesPermitsOverview;
	filterHeaderText: Scalars['String'];
	headerTitle: Scalars['String'];
	id: Scalars['ID'];
	lawFilterText: Scalars['String'];
	overviewTitleText: Scalars['String'];
	productTypeFilterText: Scalars['String'];
	searchPlaceholderText: Scalars['String'];
	showAllLawsText: Scalars['String'];
	showAllProductTypesText: Scalars['String'];
	showAllThemesText: Scalars['String'];
	showResultsText: Scalars['String'];
	themeFilterText: Scalars['String'];
};

export type ComponentModulesPhotoAlbum = {
	__typename?: 'ComponentModulesPhotoAlbum';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesPhotoAlbum;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesPhotoAlbum;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	description?: Maybe<Scalars['String']>;
	horizontal?: Maybe<Scalars['Boolean']>;
	id: Scalars['ID'];
	photos: Array<Maybe<ComponentInternalPhoto>>;
	title: Scalars['JSON'];
};

export type ComponentModulesPhotoAlbumPhotosArgs = {
	filters?: InputMaybe<ComponentInternalPhotoFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesPressReleaseOverview = {
	__typename?: 'ComponentModulesPressReleaseOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesPressReleaseOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesPressReleaseOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
};

export type ComponentModulesProjectOverview = {
	__typename?: 'ComponentModulesProjectOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesProjectOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesProjectOverview;
	defaultModuleOptions?: Maybe<ComponentInternalDefaultModuleOptions>;
	filterLabel?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
};

export type ComponentModulesRegions = {
	__typename?: 'ComponentModulesRegions';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesRegions;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesRegions;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	regions: Array<Maybe<Region>>;
	regions_connection?: Maybe<RegionRelationResponseCollection>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesRegionsRegionsArgs = {
	filters?: InputMaybe<RegionFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesRegionsRegions_ConnectionArgs = {
	filters?: InputMaybe<RegionFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesRoadMaintenanceOverview = {
	__typename?: 'ComponentModulesRoadMaintenanceOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesRoadMaintenanceOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesRoadMaintenanceOverview;
	id: Scalars['ID'];
	title: Scalars['String'];
};

export type ComponentModulesRoadMaintenanceOverviewInput = {
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesScheduling = {
	__typename?: 'ComponentModulesScheduling';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesScheduling;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesScheduling;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	firstColumnRows: Array<Maybe<ComponentInternalFirstRowItems>>;
	firstColumnTitle: Scalars['String'];
	id: Scalars['ID'];
	secondColumnRows?: Maybe<Array<Maybe<ComponentInternalSecondColumnItems>>>;
	secondColumnTitle?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesSchedulingFirstColumnRowsArgs = {
	filters?: InputMaybe<ComponentInternalFirstRowItemsFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSchedulingSecondColumnRowsArgs = {
	filters?: InputMaybe<ComponentInternalSecondColumnItemsFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSearchHeader = {
	__typename?: 'ComponentModulesSearchHeader';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesSearchHeader;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesSearchHeader;
	id: Scalars['ID'];
	searchPlaceholder?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentModulesSearchHeaderInput = {
	id?: InputMaybe<Scalars['ID']>;
	searchPlaceholder?: InputMaybe<Scalars['String']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesSearchOverview = {
	__typename?: 'ComponentModulesSearchOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesSearchOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesSearchOverview;
	id: Scalars['ID'];
	resultLabel?: Maybe<Scalars['String']>;
};

export type ComponentModulesSearchOverviewInput = {
	id?: InputMaybe<Scalars['ID']>;
	resultLabel?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesSeo = {
	__typename?: 'ComponentModulesSeo';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesSeo;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesSeo;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	noFollow?: Maybe<Scalars['Boolean']>;
	noIndex?: Maybe<Scalars['Boolean']>;
	ogDescription?: Maybe<Scalars['String']>;
	ogImage?: Maybe<UploadFile>;
	ogTitle?: Maybe<Scalars['String']>;
	ogType?: Maybe<Scalars['String']>;
	ogUrl?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentModulesSeoFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentModulesSeoFiltersInput>>>;
	description?: InputMaybe<StringFilterInput>;
	noFollow?: InputMaybe<BooleanFilterInput>;
	noIndex?: InputMaybe<BooleanFilterInput>;
	not?: InputMaybe<ComponentModulesSeoFiltersInput>;
	ogDescription?: InputMaybe<StringFilterInput>;
	ogTitle?: InputMaybe<StringFilterInput>;
	ogType?: InputMaybe<StringFilterInput>;
	ogUrl?: InputMaybe<StringFilterInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentModulesSeoFiltersInput>>>;
	title?: InputMaybe<StringFilterInput>;
};

export type ComponentModulesSeoInput = {
	description?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	noFollow?: InputMaybe<Scalars['Boolean']>;
	noIndex?: InputMaybe<Scalars['Boolean']>;
	ogDescription?: InputMaybe<Scalars['String']>;
	ogImage?: InputMaybe<Scalars['ID']>;
	ogTitle?: InputMaybe<Scalars['String']>;
	ogType?: InputMaybe<Scalars['String']>;
	ogUrl?: InputMaybe<Scalars['String']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesShare = {
	__typename?: 'ComponentModulesShare';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesShare;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesShare;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesShareFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentModulesShareFiltersInput>>>;
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsFiltersInput>;
	not?: InputMaybe<ComponentModulesShareFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentModulesShareFiltersInput>>>;
	title?: InputMaybe<JsonFilterInput>;
};

export type ComponentModulesShareInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['JSON']>;
};

export type ComponentModulesStepByStep = {
	__typename?: 'ComponentModulesStepByStep';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesStepByStep;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesStepByStep;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	stepByStepCard: Array<Maybe<ComponentInternalStepByStepCard>>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesStepByStepStepByStepCardArgs = {
	filters?: InputMaybe<ComponentInternalStepByStepCardFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSubjects = {
	__typename?: 'ComponentModulesSubjects';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesSubjects;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesSubjects;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	projects: Array<Maybe<Project>>;
	projects_connection?: Maybe<ProjectRelationResponseCollection>;
	subjects: Array<Maybe<Page>>;
	subjects_connection?: Maybe<PageRelationResponseCollection>;
	themes: Array<Maybe<Theme>>;
	themes_connection?: Maybe<ThemeRelationResponseCollection>;
	title?: Maybe<Scalars['String']>;
};

export type ComponentModulesSubjectsProjectsArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSubjectsProjects_ConnectionArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSubjectsSubjectsArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSubjectsSubjects_ConnectionArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSubjectsThemesArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSubjectsThemes_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesSubsidyOverview = {
	__typename?: 'ComponentModulesSubsidyOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesSubsidyOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesSubsidyOverview;
	filterHeaderText: Scalars['String'];
	headerTitle: Scalars['String'];
	id: Scalars['ID'];
	kindFilterText: Scalars['String'];
	overviewTitleText: Scalars['String'];
	scaleFilterText: Scalars['String'];
	searchPlaceholderText: Scalars['String'];
	showLessThemesText: Scalars['String'];
	showMoreThemesText: Scalars['String'];
	showResultsText: Scalars['String'];
	targetGroupFilterText: Scalars['String'];
	themeFilterText: Scalars['String'];
};

export type ComponentModulesTable = {
	__typename?: 'ComponentModulesTable';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesTable;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesTable;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	table?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesTestimonial = {
	__typename?: 'ComponentModulesTestimonial';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesTestimonial;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesTestimonial;
	defaultModuleOptions: ComponentInternalDefaultModuleOptionsExtended;
	id: Scalars['ID'];
	logo?: Maybe<UploadFile>;
	name: Scalars['String'];
	organization?: Maybe<Scalars['String']>;
	photo?: Maybe<UploadFile>;
	quote?: Maybe<Scalars['String']>;
	title: Scalars['JSON'];
};

export type ComponentModulesThemes = {
	__typename?: 'ComponentModulesThemes';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesThemes;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesThemes;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	themes: Array<Maybe<Theme>>;
	themes_connection?: Maybe<ThemeRelationResponseCollection>;
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesThemesThemesArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesThemesThemes_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentModulesVacanciesOverview = {
	__typename?: 'ComponentModulesVacanciesOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesVacanciesOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesVacanciesOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	title?: Maybe<Scalars['JSON']>;
};

export type ComponentModulesWobRequestOverview = {
	__typename?: 'ComponentModulesWobRequestOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesWobRequestOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesWobRequestOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	id: Scalars['ID'];
	title: Scalars['String'];
};

export type ComponentModulesWobRequestOverviewInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentModulesWooRequestOverview = {
	__typename?: 'ComponentModulesWooRequestOverview';
	/** @deprecated Use root level fields instead */
	attributes: ComponentModulesWooRequestOverview;
	/** @deprecated Use root level fields instead */
	data: ComponentModulesWooRequestOverview;
	defaultModuleOptions: ComponentInternalDefaultModuleOptions;
	filterLabel?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	title: Scalars['String'];
};

export type ComponentModulesWooRequestOverviewInput = {
	defaultModuleOptions?: InputMaybe<ComponentInternalDefaultModuleOptionsInput>;
	filterLabel?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ComponentSdgSdgLink = {
	__typename?: 'ComponentSdgSdgLink';
	/** @deprecated Use root level fields instead */
	attributes: ComponentSdgSdgLink;
	/** @deprecated Use root level fields instead */
	data: ComponentSdgSdgLink;
	id: Scalars['ID'];
	label?: Maybe<Scalars['String']>;
	url?: Maybe<Scalars['String']>;
};

export type ComponentSdgSdgLinkFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentSdgSdgLinkFiltersInput>>>;
	label?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ComponentSdgSdgLinkFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentSdgSdgLinkFiltersInput>>>;
	url?: InputMaybe<StringFilterInput>;
};

export type ComponentSdgSdgLinkInput = {
	id?: InputMaybe<Scalars['ID']>;
	label?: InputMaybe<Scalars['String']>;
	url?: InputMaybe<Scalars['String']>;
};

export type ComponentSdgSdgProductVertaling = {
	__typename?: 'ComponentSdgSdgProductVertaling';
	/** @deprecated Use root level fields instead */
	attributes: ComponentSdgSdgProductVertaling;
	bewijs?: Maybe<Scalars['String']>;
	bezwaarEnBeroep?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	data: ComponentSdgSdgProductVertaling;
	id: Scalars['ID'];
	kostenEnBetaalmethoden?: Maybe<Scalars['String']>;
	links?: Maybe<Array<Maybe<ComponentSdgSdgLink>>>;
	procedureBeschrijving?: Maybe<Scalars['String']>;
	procedureLink?: Maybe<ComponentSdgSdgLink>;
	productAanwezigToelichting?: Maybe<Scalars['String']>;
	productValtOnderToelichting?: Maybe<Scalars['String']>;
	taal?: Maybe<Enum_Componentsdgsdgproductvertaling_Taal>;
	tekst?: Maybe<Scalars['String']>;
	titel?: Maybe<Scalars['String']>;
	uitersteTermijn?: Maybe<Scalars['String']>;
	vereisten?: Maybe<Scalars['String']>;
	wtdBijGeenReactie?: Maybe<Scalars['String']>;
};

export type ComponentSdgSdgProductVertalingLinksArgs = {
	filters?: InputMaybe<ComponentSdgSdgLinkFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSdgSdgProductVertalingFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ComponentSdgSdgProductVertalingFiltersInput>>>;
	bewijs?: InputMaybe<StringFilterInput>;
	bezwaarEnBeroep?: InputMaybe<StringFilterInput>;
	kostenEnBetaalmethoden?: InputMaybe<StringFilterInput>;
	links?: InputMaybe<ComponentSdgSdgLinkFiltersInput>;
	not?: InputMaybe<ComponentSdgSdgProductVertalingFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ComponentSdgSdgProductVertalingFiltersInput>>>;
	procedureBeschrijving?: InputMaybe<StringFilterInput>;
	procedureLink?: InputMaybe<ComponentSdgSdgLinkFiltersInput>;
	productAanwezigToelichting?: InputMaybe<StringFilterInput>;
	productValtOnderToelichting?: InputMaybe<StringFilterInput>;
	taal?: InputMaybe<StringFilterInput>;
	tekst?: InputMaybe<StringFilterInput>;
	titel?: InputMaybe<StringFilterInput>;
	uitersteTermijn?: InputMaybe<StringFilterInput>;
	vereisten?: InputMaybe<StringFilterInput>;
	wtdBijGeenReactie?: InputMaybe<StringFilterInput>;
};

export type ComponentSdgSdgProductVertalingInput = {
	bewijs?: InputMaybe<Scalars['String']>;
	bezwaarEnBeroep?: InputMaybe<Scalars['String']>;
	id?: InputMaybe<Scalars['ID']>;
	kostenEnBetaalmethoden?: InputMaybe<Scalars['String']>;
	links?: InputMaybe<Array<InputMaybe<ComponentSdgSdgLinkInput>>>;
	procedureBeschrijving?: InputMaybe<Scalars['String']>;
	procedureLink?: InputMaybe<ComponentSdgSdgLinkInput>;
	productAanwezigToelichting?: InputMaybe<Scalars['String']>;
	productValtOnderToelichting?: InputMaybe<Scalars['String']>;
	taal?: InputMaybe<Enum_Componentsdgsdgproductvertaling_Taal>;
	tekst?: InputMaybe<Scalars['String']>;
	titel?: InputMaybe<Scalars['String']>;
	uitersteTermijn?: InputMaybe<Scalars['String']>;
	vereisten?: InputMaybe<Scalars['String']>;
	wtdBijGeenReactie?: InputMaybe<Scalars['String']>;
};

export type CondoleanceHomepage = {
	__typename?: 'CondoleanceHomepage';
	/** @deprecated Use root level fields instead */
	attributes: CondoleanceHomepage;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: CondoleanceHomepage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesHomepageHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<CondoleanceHomepage>>;
	localizations_connection?: Maybe<CondoleanceHomepageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<CondoleanceHomepageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CondoleanceHomepageInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesHomepageHeaderInput>;
	modules?: InputMaybe<Array<Scalars['CondoleanceHomepageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type CondoleanceHomepageModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type CondoleanceHomepageRelationResponseCollection = {
	__typename?: 'CondoleanceHomepageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<CondoleanceHomepage>;
	nodes: Array<CondoleanceHomepage>;
};

export type CondoleanceInformation = {
	__typename?: 'CondoleanceInformation';
	/** @deprecated Use root level fields instead */
	attributes: CondoleanceInformation;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: CondoleanceInformation;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	footer?: Maybe<ComponentInternalFooter>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<CondoleanceInformation>>;
	localizations_connection?: Maybe<CondoleanceInformationRelationResponseCollection>;
	navbar?: Maybe<ComponentInternalNavbar>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo?: Maybe<ComponentInternalSeo>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CondoleanceInformationInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	footer?: InputMaybe<ComponentInternalFooterInput>;
	navbar?: InputMaybe<ComponentInternalNavbarInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentInternalSeoInput>;
};

export type CondoleanceInformationRelationResponseCollection = {
	__typename?: 'CondoleanceInformationRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<CondoleanceInformation>;
	nodes: Array<CondoleanceInformation>;
};

export type CondoleancePage = {
	__typename?: 'CondoleancePage';
	/** @deprecated Use root level fields instead */
	attributes: CondoleancePage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: CondoleancePage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<CondoleancePage>>;
	localizations_connection?: Maybe<CondoleancePageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<CondoleancePageModulesDynamicZone>>>;
	parent?: Maybe<CondoleancePage>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	shortDescription?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CondoleancePageLocalizationsArgs = {
	filters?: InputMaybe<CondoleancePageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CondoleancePageLocalizations_ConnectionArgs = {
	filters?: InputMaybe<CondoleancePageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CondoleancePageTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CondoleancePageTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CondoleancePageEntityResponseCollection = {
	__typename?: 'CondoleancePageEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<CondoleancePage>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<CondoleancePage>;
	pageInfo: Pagination;
};

export type CondoleancePageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<CondoleancePageFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<CondoleancePageFiltersInput>;
	not?: InputMaybe<CondoleancePageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<CondoleancePageFiltersInput>>>;
	parent?: InputMaybe<CondoleancePageFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	shortDescription?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CondoleancePageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['CondoleancePageModulesDynamicZoneInput']>>;
	parent?: InputMaybe<Scalars['ID']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	shortDescription?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type CondoleancePageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type CondoleancePageRelationResponseCollection = {
	__typename?: 'CondoleancePageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<CondoleancePage>;
	nodes: Array<CondoleancePage>;
};

export type Contact = {
	__typename?: 'Contact';
	/** @deprecated Use root level fields instead */
	attributes: Contact;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Contact;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Contact>>;
	localizations_connection?: Maybe<ContactRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<ContactModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContactInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['ContactModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type ContactModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesLinkBox
	| ComponentModulesPartners
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type ContactRelationResponseCollection = {
	__typename?: 'ContactRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Contact>;
	nodes: Array<Contact>;
};

export type ConversationItemAttributes = {
	__typename?: 'ConversationItemAttributes';
	author?: Maybe<Scalars['String']>;
	contentTypeId?: Maybe<Scalars['String']>;
	contentTypeUid?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['String']>;
	message?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['String']>;
};

export type ConversationItemData = {
	__typename?: 'ConversationItemData';
	attributes?: Maybe<ConversationItemAttributes>;
	id?: Maybe<Scalars['Int']>;
};

export type ConversationItemMeta = {
	__typename?: 'ConversationItemMeta';
	pagination?: Maybe<ConversationItemPagination>;
};

export type ConversationItemPagination = {
	__typename?: 'ConversationItemPagination';
	page?: Maybe<Scalars['Int']>;
	pageCount?: Maybe<Scalars['Int']>;
	pageSize?: Maybe<Scalars['Int']>;
	total?: Maybe<Scalars['Int']>;
};

export type ConversationItemsResponse = {
	__typename?: 'ConversationItemsResponse';
	data?: Maybe<Array<Maybe<ConversationItemData>>>;
	meta?: Maybe<ConversationItemMeta>;
};

export type ConversationsConversationitem = {
	__typename?: 'ConversationsConversationitem';
	/** @deprecated Use root level fields instead */
	attributes: ConversationsConversationitem;
	author?: Maybe<Scalars['String']>;
	contentTypeId?: Maybe<Scalars['String']>;
	contentTypeUid?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ConversationsConversationitem;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	isNew?: Maybe<Scalars['Boolean']>;
	message?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConversationsConversationitemEntityResponse = {
	__typename?: 'ConversationsConversationitemEntityResponse';
	data?: Maybe<ConversationsConversationitem>;
};

export type ConversationsConversationitemEntityResponseCollection = {
	__typename?: 'ConversationsConversationitemEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ConversationsConversationitem>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<ConversationsConversationitem>;
	pageInfo: Pagination;
};

export type ConversationsConversationitemFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ConversationsConversationitemFiltersInput>>>;
	author?: InputMaybe<StringFilterInput>;
	contentTypeId?: InputMaybe<StringFilterInput>;
	contentTypeUid?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	isNew?: InputMaybe<BooleanFilterInput>;
	message?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ConversationsConversationitemFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ConversationsConversationitemFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ConversationsConversationitemInput = {
	author?: InputMaybe<Scalars['String']>;
	contentTypeId?: InputMaybe<Scalars['String']>;
	contentTypeUid?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	isNew?: InputMaybe<Scalars['Boolean']>;
	message?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ConversationsConversations = {
	__typename?: 'ConversationsConversations';
	/** @deprecated Use root level fields instead */
	attributes: ConversationsConversations;
	contentTypeId?: Maybe<Scalars['String']>;
	contentTypeUid?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ConversationsConversations;
	documentId: Scalars['ID'];
	enabled?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	isSingleType?: Maybe<Scalars['Boolean']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConversationsConversationsEntityResponseCollection = {
	__typename?: 'ConversationsConversationsEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ConversationsConversations>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<ConversationsConversations>;
	pageInfo: Pagination;
};

export type ConversationsConversationsFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ConversationsConversationsFiltersInput>>>;
	contentTypeId?: InputMaybe<StringFilterInput>;
	contentTypeUid?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	enabled?: InputMaybe<BooleanFilterInput>;
	isSingleType?: InputMaybe<BooleanFilterInput>;
	not?: InputMaybe<ConversationsConversationsFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ConversationsConversationsFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ConversationsConversationsInput = {
	contentTypeId?: InputMaybe<Scalars['String']>;
	contentTypeUid?: InputMaybe<Scalars['String']>;
	enabled?: InputMaybe<Scalars['Boolean']>;
	isSingleType?: InputMaybe<Scalars['Boolean']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CookiePage = {
	__typename?: 'CookiePage';
	/** @deprecated Use root level fields instead */
	attributes: CookiePage;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: CookiePage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<CookiePage>>;
	localizations_connection?: Maybe<CookiePageRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CookiePageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type CookiePageRelationResponseCollection = {
	__typename?: 'CookiePageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<CookiePage>;
	nodes: Array<CookiePage>;
};

export type DateFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
	contains?: InputMaybe<Scalars['Date']>;
	containsi?: InputMaybe<Scalars['Date']>;
	endsWith?: InputMaybe<Scalars['Date']>;
	eq?: InputMaybe<Scalars['Date']>;
	eqi?: InputMaybe<Scalars['Date']>;
	gt?: InputMaybe<Scalars['Date']>;
	gte?: InputMaybe<Scalars['Date']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
	lt?: InputMaybe<Scalars['Date']>;
	lte?: InputMaybe<Scalars['Date']>;
	ne?: InputMaybe<Scalars['Date']>;
	nei?: InputMaybe<Scalars['Date']>;
	not?: InputMaybe<DateFilterInput>;
	notContains?: InputMaybe<Scalars['Date']>;
	notContainsi?: InputMaybe<Scalars['Date']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
	startsWith?: InputMaybe<Scalars['Date']>;
};

export type DateTimeFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
	contains?: InputMaybe<Scalars['DateTime']>;
	containsi?: InputMaybe<Scalars['DateTime']>;
	endsWith?: InputMaybe<Scalars['DateTime']>;
	eq?: InputMaybe<Scalars['DateTime']>;
	eqi?: InputMaybe<Scalars['DateTime']>;
	gt?: InputMaybe<Scalars['DateTime']>;
	gte?: InputMaybe<Scalars['DateTime']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
	lt?: InputMaybe<Scalars['DateTime']>;
	lte?: InputMaybe<Scalars['DateTime']>;
	ne?: InputMaybe<Scalars['DateTime']>;
	nei?: InputMaybe<Scalars['DateTime']>;
	not?: InputMaybe<DateTimeFilterInput>;
	notContains?: InputMaybe<Scalars['DateTime']>;
	notContainsi?: InputMaybe<Scalars['DateTime']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
	startsWith?: InputMaybe<Scalars['DateTime']>;
};

export type DecisionsPage = {
	__typename?: 'DecisionsPage';
	archiveLink: ComponentComponentsLink;
	/** @deprecated Use root level fields instead */
	attributes: DecisionsPage;
	basePath?: Maybe<Scalars['String']>;
	bodyText?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: DecisionsPage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<DecisionsPage>>;
	localizations_connection?: Maybe<DecisionsPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<DecisionsPageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	sidebarArchiveTitle: Scalars['String'];
	sidebarCurrentYearTitle: Scalars['String'];
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DecisionsPageInput = {
	archiveLink?: InputMaybe<ComponentComponentsLinkInput>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['DecisionsPageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	sidebarArchiveTitle?: InputMaybe<Scalars['String']>;
	sidebarCurrentYearTitle?: InputMaybe<Scalars['String']>;
	title?: InputMaybe<Scalars['String']>;
};

export type DecisionsPageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| Error;

export type DecisionsPageRelationResponseCollection = {
	__typename?: 'DecisionsPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<DecisionsPage>;
	nodes: Array<DecisionsPage>;
};

export type DeleteMutationResponse = {
	__typename?: 'DeleteMutationResponse';
	documentId: Scalars['ID'];
};

export type DownloadsPage = {
	__typename?: 'DownloadsPage';
	/** @deprecated Use root level fields instead */
	attributes: DownloadsPage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: DownloadsPage;
	documentId: Scalars['ID'];
	downloads: Array<Maybe<ComponentModulesDownloads>>;
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	introHeader: ComponentModulesIntroHeaderImage;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<DownloadsPage>>;
	localizations_connection?: Maybe<DownloadsPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<DownloadsPageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DownloadsPageDownloadsArgs = {
	filters?: InputMaybe<ComponentModulesDownloadsFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DownloadsPageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	downloads?: InputMaybe<Array<InputMaybe<ComponentModulesDownloadsInput>>>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	introHeader?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['DownloadsPageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type DownloadsPageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| Error;

export type DownloadsPageRelationResponseCollection = {
	__typename?: 'DownloadsPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<DownloadsPage>;
	nodes: Array<DownloadsPage>;
};

export type Enum_Componentcomponentsbutton_Variant = 'primary' | 'secondary' | 'tertiary';

export type Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor = 'darkblue' | 'grey' | 'white';

export type Enum_Componentinternaldefaultmoduleoptionsextended_Padding = 'large' | 'medium' | 'none' | 'small';

export type Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor = 'grey' | 'white';

export type Enum_Componentinternaldefaultmoduleoptions_Padding = 'large' | 'medium' | 'none' | 'small';

export type Enum_Componentmodulesbbvmsmediaplayer_Playout = 'Website' | 'Website_klein';

export type Enum_Componentmodulescta_Imageposition = 'left' | 'right';

export type Enum_Componentmodulesintroheaderimage_Backgroundcolor = 'grey' | 'white';

export type Enum_Componentmodulesintroheader_Backgroundcolor = 'grey' | 'white';

export type Enum_Componentsdgsdgproductvertaling_Taal = 'en' | 'nl';

export type Enum_Internallinkslinkreference_Targettype = 'external' | 'internal';

export type Enum_Redirectsredirect_Type =
	| 'found_302'
	| 'gone_410'
	| 'moved_permanently_301'
	| 'temporary_redirect_307'
	| 'unavailable_for_legal_reasons_451';

export type Enum_Schedulerscheduler_Type = 'archive' | 'publish';

export type EfroOostHomepage = {
	__typename?: 'EfroOostHomepage';
	/** @deprecated Use root level fields instead */
	attributes: EfroOostHomepage;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostHomepage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesHomepageHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostHomepage>>;
	localizations_connection?: Maybe<EfroOostHomepageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<EfroOostHomepageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostHomepageInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesHomepageHeaderInput>;
	modules?: InputMaybe<Array<Scalars['EfroOostHomepageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type EfroOostHomepageModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsEfroOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type EfroOostHomepageRelationResponseCollection = {
	__typename?: 'EfroOostHomepageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostHomepage>;
	nodes: Array<EfroOostHomepage>;
};

export type EfroOostInConvoWithArticle = {
	__typename?: 'EfroOostInConvoWithArticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: EfroOostInConvoWithArticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostInConvoWithArticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostInConvoWithArticle>>;
	localizations_connection?: Maybe<EfroOostInConvoWithArticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<EfroOostInConvoWithArticleModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostInConvoWithArticleLocalizationsArgs = {
	filters?: InputMaybe<EfroOostInConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostInConvoWithArticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<EfroOostInConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostInConvoWithArticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostInConvoWithArticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostInConvoWithArticleEntityResponseCollection = {
	__typename?: 'EfroOostInConvoWithArticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostInConvoWithArticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<EfroOostInConvoWithArticle>;
	pageInfo: Pagination;
};

export type EfroOostInConvoWithArticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<EfroOostInConvoWithArticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<EfroOostInConvoWithArticleFiltersInput>;
	not?: InputMaybe<EfroOostInConvoWithArticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<EfroOostInConvoWithArticleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EfroOostInConvoWithArticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['EfroOostInConvoWithArticleModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type EfroOostInConvoWithArticleModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type EfroOostInConvoWithArticleRelationResponseCollection = {
	__typename?: 'EfroOostInConvoWithArticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostInConvoWithArticle>;
	nodes: Array<EfroOostInConvoWithArticle>;
};

export type EfroOostInConvoWithDetail = {
	__typename?: 'EfroOostInConvoWithDetail';
	/** @deprecated Use root level fields instead */
	attributes: EfroOostInConvoWithDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostInConvoWithDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostInConvoWithDetail>>;
	localizations_connection?: Maybe<EfroOostInConvoWithDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<EfroOostInConvoWithDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostInConvoWithDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['EfroOostInConvoWithDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EfroOostInConvoWithDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type EfroOostInConvoWithDetailRelationResponseCollection = {
	__typename?: 'EfroOostInConvoWithDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostInConvoWithDetail>;
	nodes: Array<EfroOostInConvoWithDetail>;
};

export type EfroOostInConvoWithOverview = {
	__typename?: 'EfroOostInConvoWithOverview';
	/** @deprecated Use root level fields instead */
	attributes: EfroOostInConvoWithOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostInConvoWithOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostInConvoWithOverview>>;
	localizations_connection?: Maybe<EfroOostInConvoWithOverviewRelationResponseCollection>;
	modules: Array<Maybe<EfroOostInConvoWithOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostInConvoWithOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['EfroOostInConvoWithOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type EfroOostInConvoWithOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesInConvoWithOverview
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type EfroOostInConvoWithOverviewRelationResponseCollection = {
	__typename?: 'EfroOostInConvoWithOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostInConvoWithOverview>;
	nodes: Array<EfroOostInConvoWithOverview>;
};

export type EfroOostInformation = {
	__typename?: 'EfroOostInformation';
	/** @deprecated Use root level fields instead */
	attributes: EfroOostInformation;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostInformation;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	footer?: Maybe<ComponentInternalFooter>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostInformation>>;
	localizations_connection?: Maybe<EfroOostInformationRelationResponseCollection>;
	navbar?: Maybe<ComponentInternalNavbar>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo?: Maybe<ComponentInternalSeo>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostInformationInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	footer?: InputMaybe<ComponentInternalFooterInput>;
	navbar?: InputMaybe<ComponentInternalNavbarInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentInternalSeoInput>;
};

export type EfroOostInformationRelationResponseCollection = {
	__typename?: 'EfroOostInformationRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostInformation>;
	nodes: Array<EfroOostInformation>;
};

export type EfroOostNewsDetail = {
	__typename?: 'EfroOostNewsDetail';
	/** @deprecated Use root level fields instead */
	attributes: EfroOostNewsDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostNewsDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostNewsDetail>>;
	localizations_connection?: Maybe<EfroOostNewsDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<EfroOostNewsDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostNewsDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['EfroOostNewsDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EfroOostNewsDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsEfroOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type EfroOostNewsDetailRelationResponseCollection = {
	__typename?: 'EfroOostNewsDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostNewsDetail>;
	nodes: Array<EfroOostNewsDetail>;
};

export type EfroOostNewsOverview = {
	__typename?: 'EfroOostNewsOverview';
	/** @deprecated Use root level fields instead */
	attributes: EfroOostNewsOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostNewsOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostNewsOverview>>;
	localizations_connection?: Maybe<EfroOostNewsOverviewRelationResponseCollection>;
	modules: Array<Maybe<EfroOostNewsOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostNewsOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['EfroOostNewsOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type EfroOostNewsOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesNewsOverview
	| ComponentModulesPhotoAlbum
	| Error;

export type EfroOostNewsOverviewRelationResponseCollection = {
	__typename?: 'EfroOostNewsOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostNewsOverview>;
	nodes: Array<EfroOostNewsOverview>;
};

export type EfroOostNewsarticle = {
	__typename?: 'EfroOostNewsarticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: EfroOostNewsarticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostNewsarticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostNewsarticle>>;
	localizations_connection?: Maybe<EfroOostNewsarticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<EfroOostNewsarticleModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostNewsarticleLocalizationsArgs = {
	filters?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostNewsarticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostNewsarticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostNewsarticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostNewsarticleEntityResponseCollection = {
	__typename?: 'EfroOostNewsarticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostNewsarticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<EfroOostNewsarticle>;
	pageInfo: Pagination;
};

export type EfroOostNewsarticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<EfroOostNewsarticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	not?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<EfroOostNewsarticleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EfroOostNewsarticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['EfroOostNewsarticleModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type EfroOostNewsarticleModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsEfroOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesShare
	| ComponentModulesTestimonial
	| Error;

export type EfroOostNewsarticleRelationResponseCollection = {
	__typename?: 'EfroOostNewsarticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostNewsarticle>;
	nodes: Array<EfroOostNewsarticle>;
};

export type EfroOostPage = {
	__typename?: 'EfroOostPage';
	/** @deprecated Use root level fields instead */
	attributes: EfroOostPage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EfroOostPage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EfroOostPage>>;
	localizations_connection?: Maybe<EfroOostPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<EfroOostPageModulesDynamicZone>>>;
	parent?: Maybe<EfroOostPage>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	qqqq?: Maybe<Scalars['String']>;
	seo: ComponentModulesSeo;
	shortDescription?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EfroOostPageLocalizationsArgs = {
	filters?: InputMaybe<EfroOostPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostPageLocalizations_ConnectionArgs = {
	filters?: InputMaybe<EfroOostPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostPageTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostPageTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EfroOostPageEntityResponseCollection = {
	__typename?: 'EfroOostPageEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostPage>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<EfroOostPage>;
	pageInfo: Pagination;
};

export type EfroOostPageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<EfroOostPageFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<EfroOostPageFiltersInput>;
	not?: InputMaybe<EfroOostPageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<EfroOostPageFiltersInput>>>;
	parent?: InputMaybe<EfroOostPageFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	qqqq?: InputMaybe<StringFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	shortDescription?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EfroOostPageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['EfroOostPageModulesDynamicZoneInput']>>;
	parent?: InputMaybe<Scalars['ID']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	qqqq?: InputMaybe<Scalars['String']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	shortDescription?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type EfroOostPageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsEfroOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesShare
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type EfroOostPageRelationResponseCollection = {
	__typename?: 'EfroOostPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EfroOostPage>;
	nodes: Array<EfroOostPage>;
};

export type Error = {
	__typename?: 'Error';
	code: Scalars['String'];
	message?: Maybe<Scalars['String']>;
};

export type Event = {
	__typename?: 'Event';
	/** @deprecated Use root level fields instead */
	attributes: Event;
	basePath: Scalars['String'];
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Event;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	from: Scalars['DateTime'];
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Event>>;
	localizations_connection?: Maybe<EventRelationResponseCollection>;
	location: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	share?: Maybe<ComponentModulesShare>;
	theme: Array<Maybe<Theme>>;
	theme_connection?: Maybe<ThemeRelationResponseCollection>;
	title: Scalars['String'];
	until: Scalars['DateTime'];
	updatedAt?: Maybe<Scalars['DateTime']>;
	url: Scalars['String'];
};

export type EventLocalizationsArgs = {
	filters?: InputMaybe<EventFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventLocalizations_ConnectionArgs = {
	filters?: InputMaybe<EventFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventThemeArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventTheme_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EventEntityResponseCollection = {
	__typename?: 'EventEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Event>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Event>;
	pageInfo: Pagination;
};

export type EventFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	from?: InputMaybe<DateTimeFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<EventFiltersInput>;
	location?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<EventFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	share?: InputMaybe<ComponentModulesShareFiltersInput>;
	theme?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	until?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	url?: InputMaybe<StringFilterInput>;
};

export type EventInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	from?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	location?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	share?: InputMaybe<ComponentModulesShareInput>;
	theme?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
	until?: InputMaybe<Scalars['DateTime']>;
	url?: InputMaybe<Scalars['String']>;
};

export type EventOverview = {
	__typename?: 'EventOverview';
	/** @deprecated Use root level fields instead */
	attributes: EventOverview;
	basePath: Scalars['String'];
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: EventOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<EventOverview>>;
	localizations_connection?: Maybe<EventOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<EventOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EventOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['EventOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type EventOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesEventOverview
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type EventOverviewRelationResponseCollection = {
	__typename?: 'EventOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<EventOverview>;
	nodes: Array<EventOverview>;
};

export type EventRelationResponseCollection = {
	__typename?: 'EventRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Event>;
	nodes: Array<Event>;
};

export type FileInfoInput = {
	alternativeText?: InputMaybe<Scalars['String']>;
	caption?: InputMaybe<Scalars['String']>;
	name?: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
	contains?: InputMaybe<Scalars['Float']>;
	containsi?: InputMaybe<Scalars['Float']>;
	endsWith?: InputMaybe<Scalars['Float']>;
	eq?: InputMaybe<Scalars['Float']>;
	eqi?: InputMaybe<Scalars['Float']>;
	gt?: InputMaybe<Scalars['Float']>;
	gte?: InputMaybe<Scalars['Float']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
	lt?: InputMaybe<Scalars['Float']>;
	lte?: InputMaybe<Scalars['Float']>;
	ne?: InputMaybe<Scalars['Float']>;
	nei?: InputMaybe<Scalars['Float']>;
	not?: InputMaybe<FloatFilterInput>;
	notContains?: InputMaybe<Scalars['Float']>;
	notContainsi?: InputMaybe<Scalars['Float']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
	startsWith?: InputMaybe<Scalars['Float']>;
};

export type GenericMorph =
	| AgendaPage
	| AuditLogAuditLog
	| ComponentComponentsButton
	| ComponentComponentsIconLink
	| ComponentComponentsIconLinkGroup
	| ComponentComponentsInternalLinkSubLayer
	| ComponentComponentsLink
	| ComponentComponentsLinkGroup
	| ComponentComponentsSubject
	| ComponentInternalAboutMaintenance
	| ComponentInternalAccordeonItem
	| ComponentInternalAccordeonSection
	| ComponentInternalBodyTextColumn
	| ComponentInternalDefaultModuleOptions
	| ComponentInternalDefaultModuleOptionsExtended
	| ComponentInternalEmptyState
	| ComponentInternalFirstRowItems
	| ComponentInternalFooter
	| ComponentInternalHighlightEvents
	| ComponentInternalHighlightMapsAndStats
	| ComponentInternalHighlightNews
	| ComponentInternalHighlightPermits
	| ComponentInternalHighlightSubsidies
	| ComponentInternalHighlightTopics
	| ComponentInternalHighlightWoo
	| ComponentInternalNavbar
	| ComponentInternalNewsletter
	| ComponentInternalPhoto
	| ComponentInternalSecondColumnItems
	| ComponentInternalSeo
	| ComponentInternalSidebar
	| ComponentInternalStepByStepCard
	| ComponentInternalTest
	| ComponentLinkFieldLinkField
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCollections
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesEventOverview
	| ComponentModulesExpandedHeader
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedNewsEfroOost
	| ComponentModulesFeaturedNewsOpOost
	| ComponentModulesFeaturedNewsRegioExpres
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesHomepageHeader
	| ComponentModulesInConvoWithOverview
	| ComponentModulesInternalInternalLink
	| ComponentModulesIntroHeader
	| ComponentModulesIntroHeaderImage
	| ComponentModulesLinkBox
	| ComponentModulesMapsFiguresOverview
	| ComponentModulesMedia
	| ComponentModulesNewsOverview
	| ComponentModulesOpenWooRequestOverview
	| ComponentModulesPartners
	| ComponentModulesPermitsOverview
	| ComponentModulesPhotoAlbum
	| ComponentModulesPressReleaseOverview
	| ComponentModulesProjectOverview
	| ComponentModulesRegions
	| ComponentModulesRoadMaintenanceOverview
	| ComponentModulesScheduling
	| ComponentModulesSearchHeader
	| ComponentModulesSearchOverview
	| ComponentModulesSeo
	| ComponentModulesShare
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesSubsidyOverview
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| ComponentModulesThemes
	| ComponentModulesVacanciesOverview
	| ComponentModulesWobRequestOverview
	| ComponentModulesWooRequestOverview
	| ComponentSdgSdgLink
	| ComponentSdgSdgProductVertaling
	| CondoleanceHomepage
	| CondoleanceInformation
	| CondoleancePage
	| Contact
	| ConversationsConversationitem
	| ConversationsConversations
	| CookiePage
	| DecisionsPage
	| DownloadsPage
	| EfroOostHomepage
	| EfroOostInConvoWithArticle
	| EfroOostInConvoWithDetail
	| EfroOostInConvoWithOverview
	| EfroOostInformation
	| EfroOostNewsDetail
	| EfroOostNewsOverview
	| EfroOostNewsarticle
	| EfroOostPage
	| Event
	| EventOverview
	| GeolinkHomepage
	| GeolinkInformation
	| GeolinkPage
	| HomePage
	| I18NLocale
	| InConvoWithArticle
	| InConvoWithDetail
	| InConvoWithOverview
	| InternalLinksLinkReference
	| Login
	| MapsFigure
	| MapsFiguresOverview
	| NewsDetail
	| NewsOverview
	| Newsarticle
	| Newsletter
	| NewsletterArchiveOverview
	| NewsletterInternal
	| NewsletterPublic
	| NotFoundPage
	| NotesNote
	| OpOostHomepage
	| OpOostInConvoWithArticle
	| OpOostInConvoWithDetail
	| OpOostInConvoWithOverview
	| OpOostInformation
	| OpOostNewsDetail
	| OpOostNewsOverview
	| OpOostNewsarticle
	| OpOostPage
	| OpenGelderlandHomepage
	| OpenGelderlandInformation
	| OpenGelderlandWooOverview
	| Page
	| PageInformation
	| PasswordProtectionPasswordPage
	| PasswordProtectionPasswordProtection
	| Permit
	| PermitDetail
	| PermitLaw
	| PermitProductType
	| PermitsOverview
	| PressRelease
	| PressReleaseDetail
	| PressReleaseOverview
	| PrivacyPolicy
	| Project
	| ProjectDetail
	| ProjectOverview
	| RecordLockingOpenEntity
	| RecycleBinRecycleBinItem
	| RedirectsRedirect
	| RegioExpresHomepage
	| RegioExpresInConvoOverview
	| RegioExpresInConvoWithArticle
	| RegioExpresInConvoWithDetail
	| RegioExpresInformation
	| RegioExpresNewsDetail
	| RegioExpresNewsOverview
	| RegioExpresNewsarticle
	| RegioExpresPage
	| Region
	| RegionDetail
	| RegionOverview
	| ReviewWorkflowsWorkflow
	| ReviewWorkflowsWorkflowStage
	| RoadMaintenance
	| RoadMaintenanceDetail
	| RoadMaintenanceOverview
	| SchedulerScheduler
	| SdgLocatie
	| SdgSdg
	| SdgUplLijst
	| SearchOverview
	| Sitemap
	| Subsidy
	| SubsidyDetail
	| SubsidyKind
	| SubsidyOverview
	| SubsidyScale
	| Tag
	| TargetGroup
	| Theme
	| ThemeDetail
	| ThemeOverview
	| Upl
	| UploadFile
	| UsersPermissionsPermission
	| UsersPermissionsRole
	| UsersPermissionsUser
	| VacancyDetail
	| VacancyInternalDetail
	| VacancyInternalOverview
	| VacancyOverview
	| VersioningHistory
	| WobRequest
	| WobRequestOverview
	| WooCategory
	| WooDocumentDetail
	| WooRequest
	| WooRequestOverview
	| WorkAt;

export type GeolinkHomepage = {
	__typename?: 'GeolinkHomepage';
	/** @deprecated Use root level fields instead */
	attributes: GeolinkHomepage;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: GeolinkHomepage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesHomepageHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<GeolinkHomepage>>;
	localizations_connection?: Maybe<GeolinkHomepageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<GeolinkHomepageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GeolinkHomepageInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesHomepageHeaderInput>;
	modules?: InputMaybe<Array<Scalars['GeolinkHomepageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type GeolinkHomepageModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type GeolinkHomepageRelationResponseCollection = {
	__typename?: 'GeolinkHomepageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<GeolinkHomepage>;
	nodes: Array<GeolinkHomepage>;
};

export type GeolinkInformation = {
	__typename?: 'GeolinkInformation';
	/** @deprecated Use root level fields instead */
	attributes: GeolinkInformation;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: GeolinkInformation;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	footer?: Maybe<ComponentInternalFooter>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<GeolinkInformation>>;
	localizations_connection?: Maybe<GeolinkInformationRelationResponseCollection>;
	navbar?: Maybe<ComponentInternalNavbar>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo?: Maybe<ComponentInternalSeo>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GeolinkInformationInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	footer?: InputMaybe<ComponentInternalFooterInput>;
	navbar?: InputMaybe<ComponentInternalNavbarInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentInternalSeoInput>;
};

export type GeolinkInformationRelationResponseCollection = {
	__typename?: 'GeolinkInformationRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<GeolinkInformation>;
	nodes: Array<GeolinkInformation>;
};

export type GeolinkPage = {
	__typename?: 'GeolinkPage';
	/** @deprecated Use root level fields instead */
	attributes: GeolinkPage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: GeolinkPage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<GeolinkPage>>;
	localizations_connection?: Maybe<GeolinkPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<GeolinkPageModulesDynamicZone>>>;
	parent?: Maybe<GeolinkPage>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	shortDescription?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GeolinkPageLocalizationsArgs = {
	filters?: InputMaybe<GeolinkPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GeolinkPageLocalizations_ConnectionArgs = {
	filters?: InputMaybe<GeolinkPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GeolinkPageTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GeolinkPageTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GeolinkPageEntityResponseCollection = {
	__typename?: 'GeolinkPageEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<GeolinkPage>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<GeolinkPage>;
	pageInfo: Pagination;
};

export type GeolinkPageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<GeolinkPageFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<GeolinkPageFiltersInput>;
	not?: InputMaybe<GeolinkPageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<GeolinkPageFiltersInput>>>;
	parent?: InputMaybe<GeolinkPageFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	shortDescription?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type GeolinkPageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['GeolinkPageModulesDynamicZoneInput']>>;
	parent?: InputMaybe<Scalars['ID']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	shortDescription?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type GeolinkPageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type GeolinkPageRelationResponseCollection = {
	__typename?: 'GeolinkPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<GeolinkPage>;
	nodes: Array<GeolinkPage>;
};

export type HomePage = {
	__typename?: 'HomePage';
	/** @deprecated Use root level fields instead */
	attributes: HomePage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: HomePage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesHomepageHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<HomePage>>;
	localizations_connection?: Maybe<HomePageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<HomePageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HomePageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesHomepageHeaderInput>;
	modules?: InputMaybe<Array<Scalars['HomePageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type HomePageModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesSubjects
	| ComponentModulesTestimonial
	| ComponentModulesThemes
	| Error;

export type HomePageRelationResponseCollection = {
	__typename?: 'HomePageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<HomePage>;
	nodes: Array<HomePage>;
};

export type I18NLocale = {
	__typename?: 'I18NLocale';
	/** @deprecated Use root level fields instead */
	attributes: I18NLocale;
	code?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: I18NLocale;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	name?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntityResponseCollection = {
	__typename?: 'I18NLocaleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<I18NLocale>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<I18NLocale>;
	pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
	code?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<I18NLocaleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	contains?: InputMaybe<Scalars['ID']>;
	containsi?: InputMaybe<Scalars['ID']>;
	endsWith?: InputMaybe<Scalars['ID']>;
	eq?: InputMaybe<Scalars['ID']>;
	eqi?: InputMaybe<Scalars['ID']>;
	gt?: InputMaybe<Scalars['ID']>;
	gte?: InputMaybe<Scalars['ID']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	lt?: InputMaybe<Scalars['ID']>;
	lte?: InputMaybe<Scalars['ID']>;
	ne?: InputMaybe<Scalars['ID']>;
	nei?: InputMaybe<Scalars['ID']>;
	not?: InputMaybe<IdFilterInput>;
	notContains?: InputMaybe<Scalars['ID']>;
	notContainsi?: InputMaybe<Scalars['ID']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	startsWith?: InputMaybe<Scalars['ID']>;
};

export type InConvoWithArticle = {
	__typename?: 'InConvoWithArticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: InConvoWithArticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: InConvoWithArticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<InConvoWithArticle>>;
	localizations_connection?: Maybe<InConvoWithArticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<InConvoWithArticleModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InConvoWithArticleLocalizationsArgs = {
	filters?: InputMaybe<InConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InConvoWithArticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<InConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InConvoWithArticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InConvoWithArticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InConvoWithArticleEntityResponseCollection = {
	__typename?: 'InConvoWithArticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<InConvoWithArticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<InConvoWithArticle>;
	pageInfo: Pagination;
};

export type InConvoWithArticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<InConvoWithArticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<InConvoWithArticleFiltersInput>;
	not?: InputMaybe<InConvoWithArticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<InConvoWithArticleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InConvoWithArticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['InConvoWithArticleModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type InConvoWithArticleModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesShare
	| ComponentModulesTestimonial
	| Error;

export type InConvoWithArticleRelationResponseCollection = {
	__typename?: 'InConvoWithArticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<InConvoWithArticle>;
	nodes: Array<InConvoWithArticle>;
};

export type InConvoWithDetail = {
	__typename?: 'InConvoWithDetail';
	/** @deprecated Use root level fields instead */
	attributes: InConvoWithDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: InConvoWithDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<InConvoWithDetail>>;
	localizations_connection?: Maybe<InConvoWithDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<InConvoWithDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InConvoWithDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['InConvoWithDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InConvoWithDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type InConvoWithDetailRelationResponseCollection = {
	__typename?: 'InConvoWithDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<InConvoWithDetail>;
	nodes: Array<InConvoWithDetail>;
};

export type InConvoWithOverview = {
	__typename?: 'InConvoWithOverview';
	/** @deprecated Use root level fields instead */
	attributes: InConvoWithOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: InConvoWithOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<InConvoWithOverview>>;
	localizations_connection?: Maybe<InConvoWithOverviewRelationResponseCollection>;
	modules: Array<Maybe<InConvoWithOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InConvoWithOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['InConvoWithOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type InConvoWithOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesInConvoWithOverview
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type InConvoWithOverviewRelationResponseCollection = {
	__typename?: 'InConvoWithOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<InConvoWithOverview>;
	nodes: Array<InConvoWithOverview>;
};

export type IntFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
	contains?: InputMaybe<Scalars['Int']>;
	containsi?: InputMaybe<Scalars['Int']>;
	endsWith?: InputMaybe<Scalars['Int']>;
	eq?: InputMaybe<Scalars['Int']>;
	eqi?: InputMaybe<Scalars['Int']>;
	gt?: InputMaybe<Scalars['Int']>;
	gte?: InputMaybe<Scalars['Int']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
	lt?: InputMaybe<Scalars['Int']>;
	lte?: InputMaybe<Scalars['Int']>;
	ne?: InputMaybe<Scalars['Int']>;
	nei?: InputMaybe<Scalars['Int']>;
	not?: InputMaybe<IntFilterInput>;
	notContains?: InputMaybe<Scalars['Int']>;
	notContainsi?: InputMaybe<Scalars['Int']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
	startsWith?: InputMaybe<Scalars['Int']>;
};

export type InternalLinksLinkReference = {
	__typename?: 'InternalLinksLinkReference';
	/** @deprecated Use root level fields instead */
	attributes: InternalLinksLinkReference;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: InternalLinksLinkReference;
	documentId: Scalars['ID'];
	fieldName: Scalars['String'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	linkId?: Maybe<Scalars['String']>;
	linkText?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	sourceDocumentId?: Maybe<Scalars['String']>;
	sourceId: Scalars['Int'];
	sourceLocale?: Maybe<Scalars['String']>;
	sourceUid: Scalars['String'];
	targetDocumentId?: Maybe<Scalars['String']>;
	targetId?: Maybe<Scalars['Int']>;
	targetType: Enum_Internallinkslinkreference_Targettype;
	targetUid?: Maybe<Scalars['String']>;
	targetUrl: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InternalLinksLinkReferenceEntityResponseCollection = {
	__typename?: 'InternalLinksLinkReferenceEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<InternalLinksLinkReference>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<InternalLinksLinkReference>;
	pageInfo: Pagination;
};

export type InternalLinksLinkReferenceFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<InternalLinksLinkReferenceFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	fieldName?: InputMaybe<StringFilterInput>;
	linkId?: InputMaybe<StringFilterInput>;
	linkText?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<InternalLinksLinkReferenceFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<InternalLinksLinkReferenceFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	sourceDocumentId?: InputMaybe<StringFilterInput>;
	sourceId?: InputMaybe<IntFilterInput>;
	sourceLocale?: InputMaybe<StringFilterInput>;
	sourceUid?: InputMaybe<StringFilterInput>;
	targetDocumentId?: InputMaybe<StringFilterInput>;
	targetId?: InputMaybe<IntFilterInput>;
	targetType?: InputMaybe<StringFilterInput>;
	targetUid?: InputMaybe<StringFilterInput>;
	targetUrl?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InternalLinksLinkReferenceInput = {
	fieldName?: InputMaybe<Scalars['String']>;
	linkId?: InputMaybe<Scalars['String']>;
	linkText?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	sourceDocumentId?: InputMaybe<Scalars['String']>;
	sourceId?: InputMaybe<Scalars['Int']>;
	sourceLocale?: InputMaybe<Scalars['String']>;
	sourceUid?: InputMaybe<Scalars['String']>;
	targetDocumentId?: InputMaybe<Scalars['String']>;
	targetId?: InputMaybe<Scalars['Int']>;
	targetType?: InputMaybe<Enum_Internallinkslinkreference_Targettype>;
	targetUid?: InputMaybe<Scalars['String']>;
	targetUrl?: InputMaybe<Scalars['String']>;
};

export type InternalNewsletterWithSubscriptions = {
	__typename?: 'InternalNewsletterWithSubscriptions';
	page?: Maybe<NewsletterInternal>;
	subscriptions?: Maybe<Array<Maybe<NewsletterData>>>;
};

export type JsonFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
	contains?: InputMaybe<Scalars['JSON']>;
	containsi?: InputMaybe<Scalars['JSON']>;
	endsWith?: InputMaybe<Scalars['JSON']>;
	eq?: InputMaybe<Scalars['JSON']>;
	eqi?: InputMaybe<Scalars['JSON']>;
	gt?: InputMaybe<Scalars['JSON']>;
	gte?: InputMaybe<Scalars['JSON']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
	lt?: InputMaybe<Scalars['JSON']>;
	lte?: InputMaybe<Scalars['JSON']>;
	ne?: InputMaybe<Scalars['JSON']>;
	nei?: InputMaybe<Scalars['JSON']>;
	not?: InputMaybe<JsonFilterInput>;
	notContains?: InputMaybe<Scalars['JSON']>;
	notContainsi?: InputMaybe<Scalars['JSON']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
	startsWith?: InputMaybe<Scalars['JSON']>;
};

export type Login = {
	__typename?: 'Login';
	/** @deprecated Use root level fields instead */
	attributes: Login;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Login;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Login>>;
	localizations_connection?: Maybe<LoginRelationResponseCollection>;
	modules: Array<Maybe<LoginModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LoginInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['LoginModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LoginModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesVacanciesOverview
	| Error;

export type LoginRelationResponseCollection = {
	__typename?: 'LoginRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Login>;
	nodes: Array<Login>;
};

export type MapsFigure = {
	__typename?: 'MapsFigure';
	/** @deprecated Use root level fields instead */
	attributes: MapsFigure;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: MapsFigure;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	link: Scalars['JSON'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<MapsFigure>>;
	localizations_connection?: Maybe<MapsFigureRelationResponseCollection>;
	media?: Maybe<UploadFile>;
	name: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	themes: Array<Maybe<Theme>>;
	themes_connection?: Maybe<ThemeRelationResponseCollection>;
	type: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MapsFigureLocalizationsArgs = {
	filters?: InputMaybe<MapsFigureFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MapsFigureLocalizations_ConnectionArgs = {
	filters?: InputMaybe<MapsFigureFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MapsFigureTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MapsFigureTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MapsFigureThemesArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MapsFigureThemes_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MapsFigureEntityResponseCollection = {
	__typename?: 'MapsFigureEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<MapsFigure>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<MapsFigure>;
	pageInfo: Pagination;
};

export type MapsFigureFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<MapsFigureFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	keywords?: InputMaybe<StringFilterInput>;
	link?: InputMaybe<JsonFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<MapsFigureFiltersInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<MapsFigureFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<MapsFigureFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	themes?: InputMaybe<ThemeFiltersInput>;
	type?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MapsFigureInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	keywords?: InputMaybe<Scalars['String']>;
	link?: InputMaybe<Scalars['JSON']>;
	media?: InputMaybe<Scalars['ID']>;
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	themes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	type?: InputMaybe<Scalars['String']>;
};

export type MapsFigureRelationResponseCollection = {
	__typename?: 'MapsFigureRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<MapsFigure>;
	nodes: Array<MapsFigure>;
};

export type MapsFiguresOverview = {
	__typename?: 'MapsFiguresOverview';
	/** @deprecated Use root level fields instead */
	attributes: MapsFiguresOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: MapsFiguresOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<MapsFiguresOverview>>;
	localizations_connection?: Maybe<MapsFiguresOverviewRelationResponseCollection>;
	mapsFiguresOverview: ComponentModulesMapsFiguresOverview;
	modules?: Maybe<Array<Maybe<MapsFiguresOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MapsFiguresOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	mapsFiguresOverview?: InputMaybe<ComponentModulesMapsFiguresOverviewInput>;
	modules?: InputMaybe<Array<Scalars['MapsFiguresOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type MapsFiguresOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesThemes
	| Error;

export type MapsFiguresOverviewRelationResponseCollection = {
	__typename?: 'MapsFiguresOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<MapsFiguresOverview>;
	nodes: Array<MapsFiguresOverview>;
};

export type MediaLibraryResult = {
	__typename?: 'MediaLibraryResult';
	alternativeText?: Maybe<Scalars['String']>;
	documentId?: Maybe<Scalars['String']>;
	ext?: Maybe<Scalars['String']>;
	height?: Maybe<Scalars['Int']>;
	id: Scalars['String'];
	mime?: Maybe<Scalars['String']>;
	name?: Maybe<Scalars['String']>;
	size?: Maybe<Scalars['Float']>;
	url?: Maybe<Scalars['String']>;
	width?: Maybe<Scalars['Int']>;
};

export type Mutation = {
	__typename?: 'Mutation';
	addComment?: Maybe<ConversationsConversationitemEntityResponse>;
	addUserToNewsletters?: Maybe<Array<Maybe<NewsletterSubscriptions>>>;
	/** Change user password. Confirm with the current password. */
	changePassword?: Maybe<UsersPermissionsLoginPayload>;
	createAuditLogAuditLog?: Maybe<AuditLogAuditLog>;
	createCondoleancePage?: Maybe<CondoleancePage>;
	createConversationsConversationitem?: Maybe<ConversationsConversationitem>;
	createConversationsConversations?: Maybe<ConversationsConversations>;
	createEfroOostInConvoWithArticle?: Maybe<EfroOostInConvoWithArticle>;
	createEfroOostNewsarticle?: Maybe<EfroOostNewsarticle>;
	createEfroOostPage?: Maybe<EfroOostPage>;
	createEvent?: Maybe<Event>;
	createGeolinkPage?: Maybe<GeolinkPage>;
	createInConvoWithArticle?: Maybe<InConvoWithArticle>;
	createInternalLinksLinkReference?: Maybe<InternalLinksLinkReference>;
	createMapsFigure?: Maybe<MapsFigure>;
	createNewsarticle?: Maybe<Newsarticle>;
	createNotesNote?: Maybe<NotesNote>;
	createOpOostInConvoWithArticle?: Maybe<OpOostInConvoWithArticle>;
	createOpOostNewsarticle?: Maybe<OpOostNewsarticle>;
	createOpOostPage?: Maybe<OpOostPage>;
	createPage?: Maybe<Page>;
	createPasswordProtectionPasswordProtection?: Maybe<PasswordProtectionPasswordProtection>;
	createPermit?: Maybe<Permit>;
	createPermitLaw?: Maybe<PermitLaw>;
	createPermitProductType?: Maybe<PermitProductType>;
	createPressRelease?: Maybe<PressRelease>;
	createProject?: Maybe<Project>;
	createRecordLockingOpenEntity?: Maybe<RecordLockingOpenEntity>;
	createRecycleBinRecycleBinItem?: Maybe<RecycleBinRecycleBinItem>;
	createRedirectsRedirect?: Maybe<RedirectsRedirect>;
	createRegioExpresInConvoWithArticle?: Maybe<RegioExpresInConvoWithArticle>;
	createRegioExpresNewsarticle?: Maybe<RegioExpresNewsarticle>;
	createRegioExpresPage?: Maybe<RegioExpresPage>;
	createRegion?: Maybe<Region>;
	createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
	createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
	createRoadMaintenance?: Maybe<RoadMaintenance>;
	createSchedulerScheduler?: Maybe<SchedulerScheduler>;
	createSdgLocatie?: Maybe<SdgLocatie>;
	createSdgSdg?: Maybe<SdgSdg>;
	createSdgUplLijst?: Maybe<SdgUplLijst>;
	createSubsidy?: Maybe<Subsidy>;
	createSubsidyKind?: Maybe<SubsidyKind>;
	createSubsidyScale?: Maybe<SubsidyScale>;
	createTag?: Maybe<Tag>;
	createTargetGroup?: Maybe<TargetGroup>;
	createTheme?: Maybe<Theme>;
	createUpl?: Maybe<Upl>;
	/** Create a new role */
	createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
	/** Create a new user */
	createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
	createVersioningHistory?: Maybe<VersioningHistory>;
	createWobRequest?: Maybe<WobRequest>;
	createWooCategory?: Maybe<WooCategory>;
	createWooRequest?: Maybe<WooRequest>;
	deleteAgendaPage?: Maybe<DeleteMutationResponse>;
	deleteAuditLogAuditLog?: Maybe<DeleteMutationResponse>;
	deleteCondoleanceHomepage?: Maybe<DeleteMutationResponse>;
	deleteCondoleanceInformation?: Maybe<DeleteMutationResponse>;
	deleteCondoleancePage?: Maybe<DeleteMutationResponse>;
	deleteContact?: Maybe<DeleteMutationResponse>;
	deleteConversationsConversationitem?: Maybe<DeleteMutationResponse>;
	deleteConversationsConversations?: Maybe<DeleteMutationResponse>;
	deleteCookiePage?: Maybe<DeleteMutationResponse>;
	deleteDecisionsPage?: Maybe<DeleteMutationResponse>;
	deleteDownloadsPage?: Maybe<DeleteMutationResponse>;
	deleteEfroOostHomepage?: Maybe<DeleteMutationResponse>;
	deleteEfroOostInConvoWithArticle?: Maybe<DeleteMutationResponse>;
	deleteEfroOostInConvoWithDetail?: Maybe<DeleteMutationResponse>;
	deleteEfroOostInConvoWithOverview?: Maybe<DeleteMutationResponse>;
	deleteEfroOostInformation?: Maybe<DeleteMutationResponse>;
	deleteEfroOostNewsDetail?: Maybe<DeleteMutationResponse>;
	deleteEfroOostNewsOverview?: Maybe<DeleteMutationResponse>;
	deleteEfroOostNewsarticle?: Maybe<DeleteMutationResponse>;
	deleteEfroOostPage?: Maybe<DeleteMutationResponse>;
	deleteEvent?: Maybe<DeleteMutationResponse>;
	deleteEventOverview?: Maybe<DeleteMutationResponse>;
	deleteGeolinkHomepage?: Maybe<DeleteMutationResponse>;
	deleteGeolinkInformation?: Maybe<DeleteMutationResponse>;
	deleteGeolinkPage?: Maybe<DeleteMutationResponse>;
	deleteHomePage?: Maybe<DeleteMutationResponse>;
	deleteInConvoWithArticle?: Maybe<DeleteMutationResponse>;
	deleteInConvoWithDetail?: Maybe<DeleteMutationResponse>;
	deleteInConvoWithOverview?: Maybe<DeleteMutationResponse>;
	deleteInternalLinksLinkReference?: Maybe<DeleteMutationResponse>;
	deleteLogin?: Maybe<DeleteMutationResponse>;
	deleteMapsFigure?: Maybe<DeleteMutationResponse>;
	deleteMapsFiguresOverview?: Maybe<DeleteMutationResponse>;
	deleteNewsDetail?: Maybe<DeleteMutationResponse>;
	deleteNewsOverview?: Maybe<DeleteMutationResponse>;
	deleteNewsarticle?: Maybe<DeleteMutationResponse>;
	deleteNewsletter?: Maybe<DeleteMutationResponse>;
	deleteNewsletterArchiveOverview?: Maybe<DeleteMutationResponse>;
	deleteNewsletterInternal?: Maybe<DeleteMutationResponse>;
	deleteNewsletterPublic?: Maybe<DeleteMutationResponse>;
	deleteNotFoundPage?: Maybe<DeleteMutationResponse>;
	deleteNotesNote?: Maybe<DeleteMutationResponse>;
	deleteOpOostHomepage?: Maybe<DeleteMutationResponse>;
	deleteOpOostInConvoWithArticle?: Maybe<DeleteMutationResponse>;
	deleteOpOostInConvoWithDetail?: Maybe<DeleteMutationResponse>;
	deleteOpOostInConvoWithOverview?: Maybe<DeleteMutationResponse>;
	deleteOpOostInformation?: Maybe<DeleteMutationResponse>;
	deleteOpOostNewsDetail?: Maybe<DeleteMutationResponse>;
	deleteOpOostNewsOverview?: Maybe<DeleteMutationResponse>;
	deleteOpOostNewsarticle?: Maybe<DeleteMutationResponse>;
	deleteOpOostPage?: Maybe<DeleteMutationResponse>;
	deleteOpenGelderlandHomepage?: Maybe<DeleteMutationResponse>;
	deleteOpenGelderlandInformation?: Maybe<DeleteMutationResponse>;
	deleteOpenGelderlandWooOverview?: Maybe<DeleteMutationResponse>;
	deletePage?: Maybe<DeleteMutationResponse>;
	deletePageInformation?: Maybe<DeleteMutationResponse>;
	deletePasswordProtectionPasswordPage?: Maybe<DeleteMutationResponse>;
	deletePasswordProtectionPasswordProtection?: Maybe<DeleteMutationResponse>;
	deletePermit?: Maybe<DeleteMutationResponse>;
	deletePermitDetail?: Maybe<DeleteMutationResponse>;
	deletePermitLaw?: Maybe<DeleteMutationResponse>;
	deletePermitProductType?: Maybe<DeleteMutationResponse>;
	deletePermitsOverview?: Maybe<DeleteMutationResponse>;
	deletePressRelease?: Maybe<DeleteMutationResponse>;
	deletePressReleaseDetail?: Maybe<DeleteMutationResponse>;
	deletePressReleaseOverview?: Maybe<DeleteMutationResponse>;
	deletePrivacyPolicy?: Maybe<DeleteMutationResponse>;
	deleteProject?: Maybe<DeleteMutationResponse>;
	deleteProjectDetail?: Maybe<DeleteMutationResponse>;
	deleteProjectOverview?: Maybe<DeleteMutationResponse>;
	deleteRecordLockingOpenEntity?: Maybe<DeleteMutationResponse>;
	deleteRecycleBinRecycleBinItem?: Maybe<DeleteMutationResponse>;
	deleteRedirectsRedirect?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresHomepage?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresInConvoOverview?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresInConvoWithArticle?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresInConvoWithDetail?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresInformation?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresNewsDetail?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresNewsOverview?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresNewsarticle?: Maybe<DeleteMutationResponse>;
	deleteRegioExpresPage?: Maybe<DeleteMutationResponse>;
	deleteRegion?: Maybe<DeleteMutationResponse>;
	deleteRegionDetail?: Maybe<DeleteMutationResponse>;
	deleteRegionOverview?: Maybe<DeleteMutationResponse>;
	deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
	deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
	deleteRoadMaintenance?: Maybe<DeleteMutationResponse>;
	deleteRoadMaintenanceDetail?: Maybe<DeleteMutationResponse>;
	deleteRoadMaintenanceOverview?: Maybe<DeleteMutationResponse>;
	deleteSchedulerScheduler?: Maybe<DeleteMutationResponse>;
	deleteSdgLocatie?: Maybe<DeleteMutationResponse>;
	deleteSdgSdg?: Maybe<DeleteMutationResponse>;
	deleteSdgUplLijst?: Maybe<DeleteMutationResponse>;
	deleteSearchOverview?: Maybe<DeleteMutationResponse>;
	deleteSitemap?: Maybe<DeleteMutationResponse>;
	deleteSubsidy?: Maybe<DeleteMutationResponse>;
	deleteSubsidyDetail?: Maybe<DeleteMutationResponse>;
	deleteSubsidyKind?: Maybe<DeleteMutationResponse>;
	deleteSubsidyOverview?: Maybe<DeleteMutationResponse>;
	deleteSubsidyScale?: Maybe<DeleteMutationResponse>;
	deleteTag?: Maybe<DeleteMutationResponse>;
	deleteTargetGroup?: Maybe<DeleteMutationResponse>;
	deleteTheme?: Maybe<DeleteMutationResponse>;
	deleteThemeDetail?: Maybe<DeleteMutationResponse>;
	deleteThemeOverview?: Maybe<DeleteMutationResponse>;
	deleteUpl?: Maybe<DeleteMutationResponse>;
	deleteUploadFile?: Maybe<UploadFile>;
	/** Delete an existing role */
	deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
	/** Delete an existing user */
	deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
	deleteVacancyDetail?: Maybe<DeleteMutationResponse>;
	deleteVacancyInternalDetail?: Maybe<DeleteMutationResponse>;
	deleteVacancyInternalOverview?: Maybe<DeleteMutationResponse>;
	deleteVacancyOverview?: Maybe<DeleteMutationResponse>;
	deleteVersioningHistory?: Maybe<DeleteMutationResponse>;
	deleteWobRequest?: Maybe<DeleteMutationResponse>;
	deleteWobRequestOverview?: Maybe<DeleteMutationResponse>;
	deleteWooCategory?: Maybe<DeleteMutationResponse>;
	deleteWooDocumentDetail?: Maybe<DeleteMutationResponse>;
	deleteWooRequest?: Maybe<DeleteMutationResponse>;
	deleteWooRequestOverview?: Maybe<DeleteMutationResponse>;
	deleteWorkAt?: Maybe<DeleteMutationResponse>;
	/** Confirm an email users email address */
	emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
	/** Request a reset password token */
	forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
	login: UsersPermissionsLoginPayload;
	/** Register a user */
	register: UsersPermissionsLoginPayload;
	/** Reset user password. Confirm with a code (resetToken from forgotPassword) */
	resetPassword?: Maybe<UsersPermissionsLoginPayload>;
	updateAgendaPage?: Maybe<AgendaPage>;
	updateAuditLogAuditLog?: Maybe<AuditLogAuditLog>;
	updateCondoleanceHomepage?: Maybe<CondoleanceHomepage>;
	updateCondoleanceInformation?: Maybe<CondoleanceInformation>;
	updateCondoleancePage?: Maybe<CondoleancePage>;
	updateContact?: Maybe<Contact>;
	updateConversationsConversationitem?: Maybe<ConversationsConversationitem>;
	updateConversationsConversations?: Maybe<ConversationsConversations>;
	updateCookiePage?: Maybe<CookiePage>;
	updateDecisionsPage?: Maybe<DecisionsPage>;
	updateDownloadsPage?: Maybe<DownloadsPage>;
	updateEfroOostHomepage?: Maybe<EfroOostHomepage>;
	updateEfroOostInConvoWithArticle?: Maybe<EfroOostInConvoWithArticle>;
	updateEfroOostInConvoWithDetail?: Maybe<EfroOostInConvoWithDetail>;
	updateEfroOostInConvoWithOverview?: Maybe<EfroOostInConvoWithOverview>;
	updateEfroOostInformation?: Maybe<EfroOostInformation>;
	updateEfroOostNewsDetail?: Maybe<EfroOostNewsDetail>;
	updateEfroOostNewsOverview?: Maybe<EfroOostNewsOverview>;
	updateEfroOostNewsarticle?: Maybe<EfroOostNewsarticle>;
	updateEfroOostPage?: Maybe<EfroOostPage>;
	updateEvent?: Maybe<Event>;
	updateEventOverview?: Maybe<EventOverview>;
	updateGeolinkHomepage?: Maybe<GeolinkHomepage>;
	updateGeolinkInformation?: Maybe<GeolinkInformation>;
	updateGeolinkPage?: Maybe<GeolinkPage>;
	updateHomePage?: Maybe<HomePage>;
	updateInConvoWithArticle?: Maybe<InConvoWithArticle>;
	updateInConvoWithDetail?: Maybe<InConvoWithDetail>;
	updateInConvoWithOverview?: Maybe<InConvoWithOverview>;
	updateInternalLinksLinkReference?: Maybe<InternalLinksLinkReference>;
	updateLogin?: Maybe<Login>;
	updateMapsFigure?: Maybe<MapsFigure>;
	updateMapsFiguresOverview?: Maybe<MapsFiguresOverview>;
	updateNewsDetail?: Maybe<NewsDetail>;
	updateNewsOverview?: Maybe<NewsOverview>;
	updateNewsarticle?: Maybe<Newsarticle>;
	updateNewsletter?: Maybe<Newsletter>;
	updateNewsletterArchiveOverview?: Maybe<NewsletterArchiveOverview>;
	updateNewsletterInternal?: Maybe<NewsletterInternal>;
	updateNewsletterPublic?: Maybe<NewsletterPublic>;
	updateNotFoundPage?: Maybe<NotFoundPage>;
	updateNotesNote?: Maybe<NotesNote>;
	updateOpOostHomepage?: Maybe<OpOostHomepage>;
	updateOpOostInConvoWithArticle?: Maybe<OpOostInConvoWithArticle>;
	updateOpOostInConvoWithDetail?: Maybe<OpOostInConvoWithDetail>;
	updateOpOostInConvoWithOverview?: Maybe<OpOostInConvoWithOverview>;
	updateOpOostInformation?: Maybe<OpOostInformation>;
	updateOpOostNewsDetail?: Maybe<OpOostNewsDetail>;
	updateOpOostNewsOverview?: Maybe<OpOostNewsOverview>;
	updateOpOostNewsarticle?: Maybe<OpOostNewsarticle>;
	updateOpOostPage?: Maybe<OpOostPage>;
	updateOpenGelderlandHomepage?: Maybe<OpenGelderlandHomepage>;
	updateOpenGelderlandInformation?: Maybe<OpenGelderlandInformation>;
	updateOpenGelderlandWooOverview?: Maybe<OpenGelderlandWooOverview>;
	updatePage?: Maybe<Page>;
	updatePageInformation?: Maybe<PageInformation>;
	updatePasswordProtectionPasswordPage?: Maybe<PasswordProtectionPasswordPage>;
	updatePasswordProtectionPasswordProtection?: Maybe<PasswordProtectionPasswordProtection>;
	updatePermit?: Maybe<Permit>;
	updatePermitDetail?: Maybe<PermitDetail>;
	updatePermitLaw?: Maybe<PermitLaw>;
	updatePermitProductType?: Maybe<PermitProductType>;
	updatePermitsOverview?: Maybe<PermitsOverview>;
	updatePressRelease?: Maybe<PressRelease>;
	updatePressReleaseDetail?: Maybe<PressReleaseDetail>;
	updatePressReleaseOverview?: Maybe<PressReleaseOverview>;
	updatePrivacyPolicy?: Maybe<PrivacyPolicy>;
	updateProject?: Maybe<Project>;
	updateProjectDetail?: Maybe<ProjectDetail>;
	updateProjectOverview?: Maybe<ProjectOverview>;
	updateRecordLockingOpenEntity?: Maybe<RecordLockingOpenEntity>;
	updateRecycleBinRecycleBinItem?: Maybe<RecycleBinRecycleBinItem>;
	updateRedirectsRedirect?: Maybe<RedirectsRedirect>;
	updateRegioExpresHomepage?: Maybe<RegioExpresHomepage>;
	updateRegioExpresInConvoOverview?: Maybe<RegioExpresInConvoOverview>;
	updateRegioExpresInConvoWithArticle?: Maybe<RegioExpresInConvoWithArticle>;
	updateRegioExpresInConvoWithDetail?: Maybe<RegioExpresInConvoWithDetail>;
	updateRegioExpresInformation?: Maybe<RegioExpresInformation>;
	updateRegioExpresNewsDetail?: Maybe<RegioExpresNewsDetail>;
	updateRegioExpresNewsOverview?: Maybe<RegioExpresNewsOverview>;
	updateRegioExpresNewsarticle?: Maybe<RegioExpresNewsarticle>;
	updateRegioExpresPage?: Maybe<RegioExpresPage>;
	updateRegion?: Maybe<Region>;
	updateRegionDetail?: Maybe<RegionDetail>;
	updateRegionOverview?: Maybe<RegionOverview>;
	updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
	updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
	updateRoadMaintenance?: Maybe<RoadMaintenance>;
	updateRoadMaintenanceDetail?: Maybe<RoadMaintenanceDetail>;
	updateRoadMaintenanceOverview?: Maybe<RoadMaintenanceOverview>;
	updateSchedulerScheduler?: Maybe<SchedulerScheduler>;
	updateSdgLocatie?: Maybe<SdgLocatie>;
	updateSdgSdg?: Maybe<SdgSdg>;
	updateSdgUplLijst?: Maybe<SdgUplLijst>;
	updateSearchOverview?: Maybe<SearchOverview>;
	updateSitemap?: Maybe<Sitemap>;
	updateSubsidy?: Maybe<Subsidy>;
	updateSubsidyDetail?: Maybe<SubsidyDetail>;
	updateSubsidyKind?: Maybe<SubsidyKind>;
	updateSubsidyOverview?: Maybe<SubsidyOverview>;
	updateSubsidyScale?: Maybe<SubsidyScale>;
	updateTag?: Maybe<Tag>;
	updateTargetGroup?: Maybe<TargetGroup>;
	updateTheme?: Maybe<Theme>;
	updateThemeDetail?: Maybe<ThemeDetail>;
	updateThemeOverview?: Maybe<ThemeOverview>;
	updateUpl?: Maybe<Upl>;
	updateUploadFile: UploadFile;
	updateUserNewsletterSubscription?: Maybe<Array<Maybe<NewsletterSubscriptions>>>;
	/** Update an existing role */
	updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
	/** Update an existing user */
	updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
	updateVacancyDetail?: Maybe<VacancyDetail>;
	updateVacancyInternalDetail?: Maybe<VacancyInternalDetail>;
	updateVacancyInternalOverview?: Maybe<VacancyInternalOverview>;
	updateVacancyOverview?: Maybe<VacancyOverview>;
	updateVersioningHistory?: Maybe<VersioningHistory>;
	updateWobRequest?: Maybe<WobRequest>;
	updateWobRequestOverview?: Maybe<WobRequestOverview>;
	updateWooCategory?: Maybe<WooCategory>;
	updateWooDocumentDetail?: Maybe<WooDocumentDetail>;
	updateWooRequest?: Maybe<WooRequest>;
	updateWooRequestOverview?: Maybe<WooRequestOverview>;
	updateWorkAt?: Maybe<WorkAt>;
};

export type MutationAddCommentArgs = {
	author?: InputMaybe<Scalars['String']>;
	contentTypeId?: InputMaybe<Scalars['String']>;
	contentTypeUid?: InputMaybe<Scalars['String']>;
	message?: InputMaybe<Scalars['String']>;
};

export type MutationAddUserToNewslettersArgs = {
	campaignId: Scalars['String'];
	email: Scalars['String'];
	newsletters: Array<InputMaybe<NewslettersListInput>>;
};

export type MutationChangePasswordArgs = {
	currentPassword: Scalars['String'];
	password: Scalars['String'];
	passwordConfirmation: Scalars['String'];
};

export type MutationCreateAuditLogAuditLogArgs = {
	data: AuditLogAuditLogInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateCondoleancePageArgs = {
	data: CondoleancePageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateConversationsConversationitemArgs = {
	data: ConversationsConversationitemInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateConversationsConversationsArgs = {
	data: ConversationsConversationsInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateEfroOostInConvoWithArticleArgs = {
	data: EfroOostInConvoWithArticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateEfroOostNewsarticleArgs = {
	data: EfroOostNewsarticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateEfroOostPageArgs = {
	data: EfroOostPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateEventArgs = {
	data: EventInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateGeolinkPageArgs = {
	data: GeolinkPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateInConvoWithArticleArgs = {
	data: InConvoWithArticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateInternalLinksLinkReferenceArgs = {
	data: InternalLinksLinkReferenceInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateMapsFigureArgs = {
	data: MapsFigureInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateNewsarticleArgs = {
	data: NewsarticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateNotesNoteArgs = {
	data: NotesNoteInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateOpOostInConvoWithArticleArgs = {
	data: OpOostInConvoWithArticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateOpOostNewsarticleArgs = {
	data: OpOostNewsarticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateOpOostPageArgs = {
	data: OpOostPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePageArgs = {
	data: PageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePasswordProtectionPasswordProtectionArgs = {
	data: PasswordProtectionPasswordProtectionInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePermitArgs = {
	data: PermitInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePermitLawArgs = {
	data: PermitLawInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePermitProductTypeArgs = {
	data: PermitProductTypeInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePressReleaseArgs = {
	data: PressReleaseInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateProjectArgs = {
	data: ProjectInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRecordLockingOpenEntityArgs = {
	data: RecordLockingOpenEntityInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRecycleBinRecycleBinItemArgs = {
	data: RecycleBinRecycleBinItemInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRedirectsRedirectArgs = {
	data: RedirectsRedirectInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRegioExpresInConvoWithArticleArgs = {
	data: RegioExpresInConvoWithArticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRegioExpresNewsarticleArgs = {
	data: RegioExpresNewsarticleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRegioExpresPageArgs = {
	data: RegioExpresPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRegionArgs = {
	data: RegionInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowArgs = {
	data: ReviewWorkflowsWorkflowInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
	data: ReviewWorkflowsWorkflowStageInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateRoadMaintenanceArgs = {
	data: RoadMaintenanceInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSchedulerSchedulerArgs = {
	data: SchedulerSchedulerInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSdgLocatieArgs = {
	data: SdgLocatieInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSdgSdgArgs = {
	data: SdgSdgInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSdgUplLijstArgs = {
	data: SdgUplLijstInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSubsidyArgs = {
	data: SubsidyInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSubsidyKindArgs = {
	data: SubsidyKindInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateSubsidyScaleArgs = {
	data: SubsidyScaleInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateTagArgs = {
	data: TagInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateTargetGroupArgs = {
	data: TargetGroupInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateThemeArgs = {
	data: ThemeInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateUplArgs = {
	data: UplInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateUsersPermissionsRoleArgs = {
	data: UsersPermissionsRoleInput;
};

export type MutationCreateUsersPermissionsUserArgs = {
	data: UsersPermissionsUserInput;
};

export type MutationCreateVersioningHistoryArgs = {
	data: VersioningHistoryInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateWobRequestArgs = {
	data: WobRequestInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateWooCategoryArgs = {
	data: WooCategoryInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateWooRequestArgs = {
	data: WooRequestInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationDeleteAgendaPageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteAuditLogAuditLogArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteCondoleanceHomepageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteCondoleanceInformationArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteCondoleancePageArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteContactArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteConversationsConversationitemArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteConversationsConversationsArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteCookiePageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteDecisionsPageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteDownloadsPageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostHomepageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostInConvoWithDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostInConvoWithOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostInformationArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostNewsDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostNewsOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostNewsarticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEfroOostPageArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEventArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteEventOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteGeolinkHomepageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteGeolinkInformationArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteGeolinkPageArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteHomePageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteInConvoWithDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteInConvoWithOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteInternalLinksLinkReferenceArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteLoginArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteMapsFigureArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteMapsFiguresOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNewsDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNewsOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNewsarticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNewsletterArchiveOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNewsletterInternalArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNewsletterPublicArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNotFoundPageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteNotesNoteArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteOpOostHomepageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostInConvoWithDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostInConvoWithOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostInformationArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostNewsDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostNewsOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostNewsarticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpOostPageArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpenGelderlandHomepageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpenGelderlandInformationArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteOpenGelderlandWooOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePageArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePageInformationArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePasswordProtectionPasswordPageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePasswordProtectionPasswordProtectionArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeletePermitArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePermitDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePermitLawArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePermitProductTypeArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePermitsOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePressReleaseArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePressReleaseDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePressReleaseOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeletePrivacyPolicyArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteProjectArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteProjectDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteProjectOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRecordLockingOpenEntityArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteRecycleBinRecycleBinItemArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteRedirectsRedirectArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteRegioExpresHomepageArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresInConvoOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresInConvoWithDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresInformationArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresNewsDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresNewsOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresNewsarticleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegioExpresPageArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegionArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegionDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRegionOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteReviewWorkflowsWorkflowArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteRoadMaintenanceArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRoadMaintenanceDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteRoadMaintenanceOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteSchedulerSchedulerArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteSdgLocatieArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteSdgSdgArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteSdgUplLijstArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteSearchOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteSitemapArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteSubsidyArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteSubsidyDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteSubsidyKindArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteSubsidyOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteSubsidyScaleArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteTagArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteTargetGroupArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteThemeArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteThemeDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteThemeOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteUplArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteUploadFileArgs = {
	id: Scalars['ID'];
};

export type MutationDeleteUsersPermissionsRoleArgs = {
	id: Scalars['ID'];
};

export type MutationDeleteUsersPermissionsUserArgs = {
	id: Scalars['ID'];
};

export type MutationDeleteVacancyDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteVacancyInternalDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteVacancyInternalOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteVacancyOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteVersioningHistoryArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteWobRequestArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteWobRequestOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteWooCategoryArgs = {
	documentId: Scalars['ID'];
};

export type MutationDeleteWooDocumentDetailArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteWooRequestArgs = {
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteWooRequestOverviewArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationDeleteWorkAtArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type MutationEmailConfirmationArgs = {
	confirmation: Scalars['String'];
};

export type MutationForgotPasswordArgs = {
	email: Scalars['String'];
};

export type MutationLoginArgs = {
	input: UsersPermissionsLoginInput;
};

export type MutationRegisterArgs = {
	input: UsersPermissionsRegisterInput;
};

export type MutationResetPasswordArgs = {
	code: Scalars['String'];
	password: Scalars['String'];
	passwordConfirmation: Scalars['String'];
};

export type MutationUpdateAgendaPageArgs = {
	data: AgendaPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateAuditLogAuditLogArgs = {
	data: AuditLogAuditLogInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCondoleanceHomepageArgs = {
	data: CondoleanceHomepageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCondoleanceInformationArgs = {
	data: CondoleanceInformationInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCondoleancePageArgs = {
	data: CondoleancePageInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateContactArgs = {
	data: ContactInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateConversationsConversationitemArgs = {
	data: ConversationsConversationitemInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateConversationsConversationsArgs = {
	data: ConversationsConversationsInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCookiePageArgs = {
	data: CookiePageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateDecisionsPageArgs = {
	data: DecisionsPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateDownloadsPageArgs = {
	data: DownloadsPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostHomepageArgs = {
	data: EfroOostHomepageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostInConvoWithArticleArgs = {
	data: EfroOostInConvoWithArticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostInConvoWithDetailArgs = {
	data: EfroOostInConvoWithDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostInConvoWithOverviewArgs = {
	data: EfroOostInConvoWithOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostInformationArgs = {
	data: EfroOostInformationInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostNewsDetailArgs = {
	data: EfroOostNewsDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostNewsOverviewArgs = {
	data: EfroOostNewsOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostNewsarticleArgs = {
	data: EfroOostNewsarticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEfroOostPageArgs = {
	data: EfroOostPageInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEventArgs = {
	data: EventInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateEventOverviewArgs = {
	data: EventOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateGeolinkHomepageArgs = {
	data: GeolinkHomepageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateGeolinkInformationArgs = {
	data: GeolinkInformationInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateGeolinkPageArgs = {
	data: GeolinkPageInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateHomePageArgs = {
	data: HomePageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateInConvoWithArticleArgs = {
	data: InConvoWithArticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateInConvoWithDetailArgs = {
	data: InConvoWithDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateInConvoWithOverviewArgs = {
	data: InConvoWithOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateInternalLinksLinkReferenceArgs = {
	data: InternalLinksLinkReferenceInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLoginArgs = {
	data: LoginInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateMapsFigureArgs = {
	data: MapsFigureInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateMapsFiguresOverviewArgs = {
	data: MapsFiguresOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsDetailArgs = {
	data: NewsDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsOverviewArgs = {
	data: NewsOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsarticleArgs = {
	data: NewsarticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsletterArgs = {
	data: NewsletterInput;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsletterArchiveOverviewArgs = {
	data: NewsletterArchiveOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsletterInternalArgs = {
	data: NewsletterInternalInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsletterPublicArgs = {
	data: NewsletterPublicInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNotFoundPageArgs = {
	data: NotFoundPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNotesNoteArgs = {
	data: NotesNoteInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostHomepageArgs = {
	data: OpOostHomepageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostInConvoWithArticleArgs = {
	data: OpOostInConvoWithArticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostInConvoWithDetailArgs = {
	data: OpOostInConvoWithDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostInConvoWithOverviewArgs = {
	data: OpOostInConvoWithOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostInformationArgs = {
	data: OpOostInformationInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostNewsDetailArgs = {
	data: OpOostNewsDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostNewsOverviewArgs = {
	data: OpOostNewsOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostNewsarticleArgs = {
	data: OpOostNewsarticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpOostPageArgs = {
	data: OpOostPageInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpenGelderlandHomepageArgs = {
	data: OpenGelderlandHomepageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpenGelderlandInformationArgs = {
	data: OpenGelderlandInformationInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateOpenGelderlandWooOverviewArgs = {
	data: OpenGelderlandWooOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePageArgs = {
	data: PageInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePageInformationArgs = {
	data: PageInformationInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePasswordProtectionPasswordPageArgs = {
	data: PasswordProtectionPasswordPageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePasswordProtectionPasswordProtectionArgs = {
	data: PasswordProtectionPasswordProtectionInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePermitArgs = {
	data: PermitInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePermitDetailArgs = {
	data: PermitDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePermitLawArgs = {
	data: PermitLawInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePermitProductTypeArgs = {
	data: PermitProductTypeInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePermitsOverviewArgs = {
	data: PermitsOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePressReleaseArgs = {
	data: PressReleaseInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePressReleaseDetailArgs = {
	data: PressReleaseDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePressReleaseOverviewArgs = {
	data: PressReleaseOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePrivacyPolicyArgs = {
	data: PrivacyPolicyInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateProjectArgs = {
	data: ProjectInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateProjectDetailArgs = {
	data: ProjectDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateProjectOverviewArgs = {
	data: ProjectOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRecordLockingOpenEntityArgs = {
	data: RecordLockingOpenEntityInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRecycleBinRecycleBinItemArgs = {
	data: RecycleBinRecycleBinItemInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRedirectsRedirectArgs = {
	data: RedirectsRedirectInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresHomepageArgs = {
	data: RegioExpresHomepageInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresInConvoOverviewArgs = {
	data: RegioExpresInConvoOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresInConvoWithArticleArgs = {
	data: RegioExpresInConvoWithArticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresInConvoWithDetailArgs = {
	data: RegioExpresInConvoWithDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresInformationArgs = {
	data: RegioExpresInformationInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresNewsDetailArgs = {
	data: RegioExpresNewsDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresNewsOverviewArgs = {
	data: RegioExpresNewsOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresNewsarticleArgs = {
	data: RegioExpresNewsarticleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegioExpresPageArgs = {
	data: RegioExpresPageInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegionArgs = {
	data: RegionInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegionDetailArgs = {
	data: RegionDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRegionOverviewArgs = {
	data: RegionOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowArgs = {
	data: ReviewWorkflowsWorkflowInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
	data: ReviewWorkflowsWorkflowStageInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRoadMaintenanceArgs = {
	data: RoadMaintenanceInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRoadMaintenanceDetailArgs = {
	data: RoadMaintenanceDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateRoadMaintenanceOverviewArgs = {
	data: RoadMaintenanceOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSchedulerSchedulerArgs = {
	data: SchedulerSchedulerInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSdgLocatieArgs = {
	data: SdgLocatieInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSdgSdgArgs = {
	data: SdgSdgInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSdgUplLijstArgs = {
	data: SdgUplLijstInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSearchOverviewArgs = {
	data: SearchOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSitemapArgs = {
	data: SitemapInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSubsidyArgs = {
	data: SubsidyInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSubsidyDetailArgs = {
	data: SubsidyDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSubsidyKindArgs = {
	data: SubsidyKindInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSubsidyOverviewArgs = {
	data: SubsidyOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateSubsidyScaleArgs = {
	data: SubsidyScaleInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTagArgs = {
	data: TagInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTargetGroupArgs = {
	data: TargetGroupInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateThemeArgs = {
	data: ThemeInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateThemeDetailArgs = {
	data: ThemeDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateThemeOverviewArgs = {
	data: ThemeOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateUplArgs = {
	data: UplInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateUploadFileArgs = {
	id: Scalars['ID'];
	info?: InputMaybe<FileInfoInput>;
};

export type MutationUpdateUserNewsletterSubscriptionArgs = {
	campaignId: Scalars['String'];
	email: Scalars['String'];
	newsletters: Array<InputMaybe<NewslettersListInput>>;
	userId: Scalars['String'];
};

export type MutationUpdateUsersPermissionsRoleArgs = {
	data: UsersPermissionsRoleInput;
	id: Scalars['ID'];
};

export type MutationUpdateUsersPermissionsUserArgs = {
	data: UsersPermissionsUserInput;
	id: Scalars['ID'];
};

export type MutationUpdateVacancyDetailArgs = {
	data: VacancyDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateVacancyInternalDetailArgs = {
	data: VacancyInternalDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateVacancyInternalOverviewArgs = {
	data: VacancyInternalOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateVacancyOverviewArgs = {
	data: VacancyOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateVersioningHistoryArgs = {
	data: VersioningHistoryInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWobRequestArgs = {
	data: WobRequestInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWobRequestOverviewArgs = {
	data: WobRequestOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWooCategoryArgs = {
	data: WooCategoryInput;
	documentId: Scalars['ID'];
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWooDocumentDetailArgs = {
	data: WooDocumentDetailInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWooRequestArgs = {
	data: WooRequestInput;
	documentId: Scalars['ID'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWooRequestOverviewArgs = {
	data: WooRequestOverviewInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateWorkAtArgs = {
	data: WorkAtInput;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
};

export type NewsDetail = {
	__typename?: 'NewsDetail';
	/** @deprecated Use root level fields instead */
	attributes: NewsDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: NewsDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<NewsDetail>>;
	localizations_connection?: Maybe<NewsDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<NewsDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['NewsDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type NewsDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesShare
	| ComponentModulesSubjects
	| Error;

export type NewsDetailRelationResponseCollection = {
	__typename?: 'NewsDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<NewsDetail>;
	nodes: Array<NewsDetail>;
};

export type NewsOverview = {
	__typename?: 'NewsOverview';
	/** @deprecated Use root level fields instead */
	attributes: NewsOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: NewsOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<NewsOverview>>;
	localizations_connection?: Maybe<NewsOverviewRelationResponseCollection>;
	modules: Array<Maybe<NewsOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['NewsOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type NewsOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesNewsOverview
	| ComponentModulesPhotoAlbum
	| Error;

export type NewsOverviewRelationResponseCollection = {
	__typename?: 'NewsOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<NewsOverview>;
	nodes: Array<NewsOverview>;
};

export type Newsarticle = {
	__typename?: 'Newsarticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: Newsarticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	contactPerson?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Newsarticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Newsarticle>>;
	localizations_connection?: Maybe<NewsarticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<NewsarticleModulesDynamicZone>>>;
	project: Array<Maybe<Project>>;
	project_connection?: Maybe<ProjectRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	theme: Array<Maybe<Theme>>;
	theme_connection?: Maybe<ThemeRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsarticleLocalizationsArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleProjectArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleProject_ConnectionArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleThemeArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleTheme_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsarticleData = {
	__typename?: 'NewsarticleData';
	contactPerson: Scalars['String'];
};

export type NewsarticleEntityResponseCollection = {
	__typename?: 'NewsarticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Newsarticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Newsarticle>;
	pageInfo: Pagination;
};

export type NewsarticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<NewsarticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	contactPerson?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<NewsarticleFiltersInput>;
	not?: InputMaybe<NewsarticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<NewsarticleFiltersInput>>>;
	project?: InputMaybe<ProjectFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	theme?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NewsarticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	contactPerson?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['NewsarticleModulesDynamicZoneInput']>>;
	project?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	theme?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type NewsarticleModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesShare
	| ComponentModulesTestimonial
	| Error;

export type NewsarticleRelationResponseCollection = {
	__typename?: 'NewsarticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Newsarticle>;
	nodes: Array<Newsarticle>;
};

export type Newsletter = {
	__typename?: 'Newsletter';
	/** @deprecated Use root level fields instead */
	attributes: Newsletter;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Newsletter;
	documentId: Scalars['ID'];
	expireTime?: Maybe<Scalars['DateTime']>;
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	name: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	token: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsletterArchiveOverview = {
	__typename?: 'NewsletterArchiveOverview';
	/** @deprecated Use root level fields instead */
	attributes: NewsletterArchiveOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: NewsletterArchiveOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<NewsletterArchiveOverview>>;
	localizations_connection?: Maybe<NewsletterArchiveOverviewRelationResponseCollection>;
	modules: Array<Maybe<NewsletterArchiveOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsletterArchiveOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['NewsletterArchiveOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type NewsletterArchiveOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesPermitsOverview
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| Error;

export type NewsletterArchiveOverviewRelationResponseCollection = {
	__typename?: 'NewsletterArchiveOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<NewsletterArchiveOverview>;
	nodes: Array<NewsletterArchiveOverview>;
};

export type NewsletterCampaign = {
	__typename?: 'NewsletterCampaign';
	id: Scalars['String'];
	name?: Maybe<Scalars['String']>;
};

export type NewsletterContact = {
	__typename?: 'NewsletterContact';
	active?: Maybe<Scalars['Boolean']>;
	campaigns?: Maybe<Array<Maybe<CampaignNewsletterContact>>>;
	newsletters?: Maybe<Array<Maybe<CampaignNewsletterField>>>;
};

export type NewsletterContactData = {
	__typename?: 'NewsletterContactData';
	create_date: Scalars['String'];
	custom?: Maybe<Array<Maybe<NewsletterField>>>;
	email: Scalars['String'];
	id: Scalars['String'];
	lang?: Maybe<Scalars['String']>;
	mobile_nr?: Maybe<Scalars['String']>;
};

export type NewsletterData = {
	__typename?: 'NewsletterData';
	campaign?: Maybe<NewsletterCampaign>;
	newsletters?: Maybe<Array<Maybe<NewslettersList>>>;
};

export type NewsletterField = {
	__typename?: 'NewsletterField';
	field: Scalars['String'];
	value?: Maybe<Scalars['String']>;
};

export type NewsletterInput = {
	expireTime?: InputMaybe<Scalars['DateTime']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	token?: InputMaybe<Scalars['String']>;
};

export type NewsletterInternal = {
	__typename?: 'NewsletterInternal';
	/** @deprecated Use root level fields instead */
	attributes: NewsletterInternal;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: NewsletterInternal;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<NewsletterInternal>>;
	localizations_connection?: Maybe<NewsletterInternalRelationResponseCollection>;
	newsletter: ComponentInternalNewsletter;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsletterInternalInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	newsletter?: InputMaybe<ComponentInternalNewsletterInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type NewsletterInternalRelationResponseCollection = {
	__typename?: 'NewsletterInternalRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<NewsletterInternal>;
	nodes: Array<NewsletterInternal>;
};

export type NewsletterPublic = {
	__typename?: 'NewsletterPublic';
	/** @deprecated Use root level fields instead */
	attributes: NewsletterPublic;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: NewsletterPublic;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<NewsletterPublic>>;
	localizations_connection?: Maybe<NewsletterPublicRelationResponseCollection>;
	newsletter: ComponentInternalNewsletter;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsletterPublicInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	newsletter?: InputMaybe<ComponentInternalNewsletterInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type NewsletterPublicRelationResponseCollection = {
	__typename?: 'NewsletterPublicRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<NewsletterPublic>;
	nodes: Array<NewsletterPublic>;
};

export type NewsletterSubscriptions = {
	__typename?: 'NewsletterSubscriptions';
	campaign: Scalars['String'];
	succeeded: Scalars['Boolean'];
};

export type NewslettersList = {
	__typename?: 'NewslettersList';
	description?: Maybe<Scalars['String']>;
	field: Scalars['String'];
	value?: Maybe<Scalars['String']>;
};

export type NewslettersListInput = {
	field: Scalars['String'];
	value?: InputMaybe<Scalars['String']>;
};

export type NotFoundPage = {
	__typename?: 'NotFoundPage';
	/** @deprecated Use root level fields instead */
	attributes: NotFoundPage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	cta: ComponentModulesCta;
	/** @deprecated Use root level fields instead */
	data: NotFoundPage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	links: ComponentModulesLinkBox;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<NotFoundPage>>;
	localizations_connection?: Maybe<NotFoundPageRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotFoundPageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	cta?: InputMaybe<ComponentModulesCtaInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	links?: InputMaybe<ComponentModulesLinkBoxInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type NotFoundPageRelationResponseCollection = {
	__typename?: 'NotFoundPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<NotFoundPage>;
	nodes: Array<NotFoundPage>;
};

export type NoteSearchResult = {
	__typename?: 'NoteSearchResult';
	authorMemo?: Maybe<Scalars['String']>;
	authorPage?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	documentId: Scalars['String'];
	id: Scalars['String'];
	note?: Maybe<Scalars['String']>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotesByPageResult = {
	__typename?: 'NotesByPageResult';
	authorMemo?: Maybe<Scalars['String']>;
	authorPage?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	id?: Maybe<Scalars['Int']>;
	linkedPages?: Maybe<Scalars['JSON']>;
	note?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotesNote = {
	__typename?: 'NotesNote';
	/** @deprecated Use root level fields instead */
	attributes: NotesNote;
	authorMemo?: Maybe<Scalars['String']>;
	authorPage?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: NotesNote;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	linkedPages?: Maybe<Scalars['JSON']>;
	note?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotesNoteEntityResponseCollection = {
	__typename?: 'NotesNoteEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<NotesNote>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<NotesNote>;
	pageInfo: Pagination;
};

export type NotesNoteFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<NotesNoteFiltersInput>>>;
	authorMemo?: InputMaybe<StringFilterInput>;
	authorPage?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	linkedPages?: InputMaybe<JsonFilterInput>;
	not?: InputMaybe<NotesNoteFiltersInput>;
	note?: InputMaybe<StringFilterInput>;
	or?: InputMaybe<Array<InputMaybe<NotesNoteFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NotesNoteInput = {
	authorMemo?: InputMaybe<Scalars['String']>;
	authorPage?: InputMaybe<Scalars['String']>;
	linkedPages?: InputMaybe<Scalars['JSON']>;
	note?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	title?: InputMaybe<Scalars['String']>;
};

export type OpOostHomepage = {
	__typename?: 'OpOostHomepage';
	/** @deprecated Use root level fields instead */
	attributes: OpOostHomepage;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostHomepage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesHomepageHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostHomepage>>;
	localizations_connection?: Maybe<OpOostHomepageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpOostHomepageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostHomepageInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesHomepageHeaderInput>;
	modules?: InputMaybe<Array<Scalars['OpOostHomepageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type OpOostHomepageModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsOpOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type OpOostHomepageRelationResponseCollection = {
	__typename?: 'OpOostHomepageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostHomepage>;
	nodes: Array<OpOostHomepage>;
};

export type OpOostInConvoWithArticle = {
	__typename?: 'OpOostInConvoWithArticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: OpOostInConvoWithArticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostInConvoWithArticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostInConvoWithArticle>>;
	localizations_connection?: Maybe<OpOostInConvoWithArticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpOostInConvoWithArticleModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostInConvoWithArticleLocalizationsArgs = {
	filters?: InputMaybe<OpOostInConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostInConvoWithArticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<OpOostInConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostInConvoWithArticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostInConvoWithArticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostInConvoWithArticleEntityResponseCollection = {
	__typename?: 'OpOostInConvoWithArticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostInConvoWithArticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<OpOostInConvoWithArticle>;
	pageInfo: Pagination;
};

export type OpOostInConvoWithArticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<OpOostInConvoWithArticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<OpOostInConvoWithArticleFiltersInput>;
	not?: InputMaybe<OpOostInConvoWithArticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<OpOostInConvoWithArticleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type OpOostInConvoWithArticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['OpOostInConvoWithArticleModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type OpOostInConvoWithArticleModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type OpOostInConvoWithArticleRelationResponseCollection = {
	__typename?: 'OpOostInConvoWithArticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostInConvoWithArticle>;
	nodes: Array<OpOostInConvoWithArticle>;
};

export type OpOostInConvoWithDetail = {
	__typename?: 'OpOostInConvoWithDetail';
	/** @deprecated Use root level fields instead */
	attributes: OpOostInConvoWithDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostInConvoWithDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostInConvoWithDetail>>;
	localizations_connection?: Maybe<OpOostInConvoWithDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpOostInConvoWithDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostInConvoWithDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['OpOostInConvoWithDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OpOostInConvoWithDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type OpOostInConvoWithDetailRelationResponseCollection = {
	__typename?: 'OpOostInConvoWithDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostInConvoWithDetail>;
	nodes: Array<OpOostInConvoWithDetail>;
};

export type OpOostInConvoWithOverview = {
	__typename?: 'OpOostInConvoWithOverview';
	/** @deprecated Use root level fields instead */
	attributes: OpOostInConvoWithOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostInConvoWithOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostInConvoWithOverview>>;
	localizations_connection?: Maybe<OpOostInConvoWithOverviewRelationResponseCollection>;
	modules: Array<Maybe<OpOostInConvoWithOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostInConvoWithOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['OpOostInConvoWithOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type OpOostInConvoWithOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesInConvoWithOverview
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type OpOostInConvoWithOverviewRelationResponseCollection = {
	__typename?: 'OpOostInConvoWithOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostInConvoWithOverview>;
	nodes: Array<OpOostInConvoWithOverview>;
};

export type OpOostInformation = {
	__typename?: 'OpOostInformation';
	/** @deprecated Use root level fields instead */
	attributes: OpOostInformation;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostInformation;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	footer?: Maybe<ComponentInternalFooter>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostInformation>>;
	localizations_connection?: Maybe<OpOostInformationRelationResponseCollection>;
	navbar?: Maybe<ComponentInternalNavbar>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo?: Maybe<ComponentInternalSeo>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostInformationInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	footer?: InputMaybe<ComponentInternalFooterInput>;
	navbar?: InputMaybe<ComponentInternalNavbarInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentInternalSeoInput>;
};

export type OpOostInformationRelationResponseCollection = {
	__typename?: 'OpOostInformationRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostInformation>;
	nodes: Array<OpOostInformation>;
};

export type OpOostNewsDetail = {
	__typename?: 'OpOostNewsDetail';
	/** @deprecated Use root level fields instead */
	attributes: OpOostNewsDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostNewsDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostNewsDetail>>;
	localizations_connection?: Maybe<OpOostNewsDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpOostNewsDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostNewsDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['OpOostNewsDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OpOostNewsDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsOpOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type OpOostNewsDetailRelationResponseCollection = {
	__typename?: 'OpOostNewsDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostNewsDetail>;
	nodes: Array<OpOostNewsDetail>;
};

export type OpOostNewsOverview = {
	__typename?: 'OpOostNewsOverview';
	/** @deprecated Use root level fields instead */
	attributes: OpOostNewsOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostNewsOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostNewsOverview>>;
	localizations_connection?: Maybe<OpOostNewsOverviewRelationResponseCollection>;
	modules: Array<Maybe<OpOostNewsOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostNewsOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['OpOostNewsOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type OpOostNewsOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesNewsOverview
	| ComponentModulesPhotoAlbum
	| Error;

export type OpOostNewsOverviewRelationResponseCollection = {
	__typename?: 'OpOostNewsOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostNewsOverview>;
	nodes: Array<OpOostNewsOverview>;
};

export type OpOostNewsarticle = {
	__typename?: 'OpOostNewsarticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: OpOostNewsarticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostNewsarticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostNewsarticle>>;
	localizations_connection?: Maybe<OpOostNewsarticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpOostNewsarticleModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostNewsarticleLocalizationsArgs = {
	filters?: InputMaybe<OpOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostNewsarticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<OpOostNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostNewsarticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostNewsarticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostNewsarticleEntityResponseCollection = {
	__typename?: 'OpOostNewsarticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostNewsarticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<OpOostNewsarticle>;
	pageInfo: Pagination;
};

export type OpOostNewsarticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<OpOostNewsarticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<OpOostNewsarticleFiltersInput>;
	not?: InputMaybe<OpOostNewsarticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<OpOostNewsarticleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type OpOostNewsarticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['OpOostNewsarticleModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type OpOostNewsarticleModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsOpOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesShare
	| ComponentModulesTestimonial
	| Error;

export type OpOostNewsarticleRelationResponseCollection = {
	__typename?: 'OpOostNewsarticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostNewsarticle>;
	nodes: Array<OpOostNewsarticle>;
};

export type OpOostPage = {
	__typename?: 'OpOostPage';
	/** @deprecated Use root level fields instead */
	attributes: OpOostPage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpOostPage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpOostPage>>;
	localizations_connection?: Maybe<OpOostPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpOostPageModulesDynamicZone>>>;
	parent?: Maybe<OpOostPage>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	shortDescription?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpOostPageLocalizationsArgs = {
	filters?: InputMaybe<OpOostPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostPageLocalizations_ConnectionArgs = {
	filters?: InputMaybe<OpOostPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostPageTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostPageTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type OpOostPageEntityResponseCollection = {
	__typename?: 'OpOostPageEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostPage>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<OpOostPage>;
	pageInfo: Pagination;
};

export type OpOostPageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<OpOostPageFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<OpOostPageFiltersInput>;
	not?: InputMaybe<OpOostPageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<OpOostPageFiltersInput>>>;
	parent?: InputMaybe<OpOostPageFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	shortDescription?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type OpOostPageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['OpOostPageModulesDynamicZoneInput']>>;
	parent?: InputMaybe<Scalars['ID']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	shortDescription?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type OpOostPageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsOpOost
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesShare
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type OpOostPageRelationResponseCollection = {
	__typename?: 'OpOostPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpOostPage>;
	nodes: Array<OpOostPage>;
};

export type OpenGelderlandHomepage = {
	__typename?: 'OpenGelderlandHomepage';
	/** @deprecated Use root level fields instead */
	attributes: OpenGelderlandHomepage;
	collections: ComponentModulesCollections;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpenGelderlandHomepage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpenGelderlandHomepage>>;
	localizations_connection?: Maybe<OpenGelderlandHomepageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpenGelderlandHomepageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpenGelderlandHomepageInput = {
	collections?: InputMaybe<ComponentModulesCollectionsInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['OpenGelderlandHomepageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type OpenGelderlandHomepageModulesDynamicZone = ComponentModulesCta | Error;

export type OpenGelderlandHomepageRelationResponseCollection = {
	__typename?: 'OpenGelderlandHomepageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpenGelderlandHomepage>;
	nodes: Array<OpenGelderlandHomepage>;
};

export type OpenGelderlandInformation = {
	__typename?: 'OpenGelderlandInformation';
	/** @deprecated Use root level fields instead */
	attributes: OpenGelderlandInformation;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpenGelderlandInformation;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	footer?: Maybe<ComponentInternalFooter>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpenGelderlandInformation>>;
	localizations_connection?: Maybe<OpenGelderlandInformationRelationResponseCollection>;
	navbar?: Maybe<ComponentInternalNavbar>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo?: Maybe<ComponentInternalSeo>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OpenGelderlandInformationInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	footer?: InputMaybe<ComponentInternalFooterInput>;
	navbar?: InputMaybe<ComponentInternalNavbarInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentInternalSeoInput>;
};

export type OpenGelderlandInformationRelationResponseCollection = {
	__typename?: 'OpenGelderlandInformationRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpenGelderlandInformation>;
	nodes: Array<OpenGelderlandInformation>;
};

export type OpenGelderlandWooOverview = {
	__typename?: 'OpenGelderlandWooOverview';
	/** @deprecated Use root level fields instead */
	attributes: OpenGelderlandWooOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: OpenGelderlandWooOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<OpenGelderlandWooOverview>>;
	localizations_connection?: Maybe<OpenGelderlandWooOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<OpenGelderlandWooOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
	woo_overview: ComponentModulesOpenWooRequestOverview;
};

export type OpenGelderlandWooOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['OpenGelderlandWooOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	woo_overview?: InputMaybe<ComponentModulesOpenWooRequestOverviewInput>;
};

export type OpenGelderlandWooOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| Error;

export type OpenGelderlandWooOverviewRelationResponseCollection = {
	__typename?: 'OpenGelderlandWooOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<OpenGelderlandWooOverview>;
	nodes: Array<OpenGelderlandWooOverview>;
};

export type Page = {
	__typename?: 'Page';
	/** @deprecated Use root level fields instead */
	attributes: Page;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Page;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Page>>;
	localizations_connection?: Maybe<PageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<PageModulesDynamicZone>>>;
	parent?: Maybe<Page>;
	project?: Maybe<Project>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	region?: Maybe<Region>;
	seo: ComponentModulesSeo;
	shortDescription?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	theme?: Maybe<Theme>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PageLocalizationsArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageLocalizations_ConnectionArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageEntityResponseCollection = {
	__typename?: 'PageEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Page>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Page>;
	pageInfo: Pagination;
};

export type PageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<PageFiltersInput>;
	not?: InputMaybe<PageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
	parent?: InputMaybe<PageFiltersInput>;
	project?: InputMaybe<ProjectFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	region?: InputMaybe<RegionFiltersInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	shortDescription?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	theme?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageInformation = {
	__typename?: 'PageInformation';
	/** @deprecated Use root level fields instead */
	attributes: PageInformation;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PageInformation;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	footer?: Maybe<ComponentInternalFooter>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PageInformation>>;
	localizations_connection?: Maybe<PageInformationRelationResponseCollection>;
	navbar?: Maybe<ComponentInternalNavbar>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo?: Maybe<ComponentInternalSeo>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PageInformationInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	footer?: InputMaybe<ComponentInternalFooterInput>;
	navbar?: InputMaybe<ComponentInternalNavbarInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentInternalSeoInput>;
};

export type PageInformationRelationResponseCollection = {
	__typename?: 'PageInformationRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PageInformation>;
	nodes: Array<PageInformation>;
};

export type PageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['PageModulesDynamicZoneInput']>>;
	parent?: InputMaybe<Scalars['ID']>;
	project?: InputMaybe<Scalars['ID']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	region?: InputMaybe<Scalars['ID']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	shortDescription?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	theme?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type PageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesScheduling
	| ComponentModulesShare
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| ComponentModulesThemes
	| Error;

export type PageRelationResponseCollection = {
	__typename?: 'PageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Page>;
	nodes: Array<Page>;
};

export type Pagination = {
	__typename?: 'Pagination';
	page: Scalars['Int'];
	pageCount: Scalars['Int'];
	pageSize: Scalars['Int'];
	total: Scalars['Int'];
};

export type PaginationArg = {
	limit?: InputMaybe<Scalars['Int']>;
	page?: InputMaybe<Scalars['Int']>;
	pageSize?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
};

export type PasswordProtectionPasswordPage = {
	__typename?: 'PasswordProtectionPasswordPage';
	/** @deprecated Use root level fields instead */
	attributes: PasswordProtectionPasswordPage;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PasswordProtectionPasswordPage;
	documentId: Scalars['ID'];
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PasswordProtectionPasswordPage>>;
	localizations_connection?: Maybe<PasswordProtectionPasswordPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<PasswordProtectionPasswordPageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PasswordProtectionPasswordPageInput = {
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['PasswordProtectionPasswordPageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PasswordProtectionPasswordPageModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesSubjects
	| ComponentModulesTestimonial
	| ComponentModulesThemes
	| Error;

export type PasswordProtectionPasswordPageRelationResponseCollection = {
	__typename?: 'PasswordProtectionPasswordPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PasswordProtectionPasswordPage>;
	nodes: Array<PasswordProtectionPasswordPage>;
};

export type PasswordProtectionPasswordProtection = {
	__typename?: 'PasswordProtectionPasswordProtection';
	/** @deprecated Use root level fields instead */
	attributes: PasswordProtectionPasswordProtection;
	contentType: Scalars['String'];
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PasswordProtectionPasswordProtection;
	documentId: Scalars['ID'];
	enabled?: Maybe<Scalars['Boolean']>;
	entryId: Scalars['String'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PasswordProtectionPasswordProtectionEntityResponseCollection = {
	__typename?: 'PasswordProtectionPasswordProtectionEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PasswordProtectionPasswordProtection>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<PasswordProtectionPasswordProtection>;
	pageInfo: Pagination;
};

export type PasswordProtectionPasswordProtectionFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<PasswordProtectionPasswordProtectionFiltersInput>>>;
	contentType?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	enabled?: InputMaybe<BooleanFilterInput>;
	entryId?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<PasswordProtectionPasswordProtectionFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<PasswordProtectionPasswordProtectionFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PasswordProtectionPasswordProtectionInput = {
	contentType?: InputMaybe<Scalars['String']>;
	enabled?: InputMaybe<Scalars['Boolean']>;
	entryId?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PasswordStatusResult = {
	__typename?: 'PasswordStatusResult';
	documentId?: Maybe<Scalars['String']>;
	enabled?: Maybe<Scalars['Boolean']>;
	exists: Scalars['Boolean'];
	protected: Scalars['Boolean'];
};

export type Permit = {
	__typename?: 'Permit';
	/** @deprecated Use root level fields instead */
	attributes: Permit;
	audience: Scalars['String'];
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Permit;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	hideFromOverview: Scalars['Boolean'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Permit>>;
	localizations_connection?: Maybe<PermitRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<PermitModulesDynamicZone>>>;
	onlineRequest?: Maybe<Scalars['Boolean']>;
	permitLaws: Array<Maybe<PermitLaw>>;
	permitLaws_connection?: Maybe<PermitLawRelationResponseCollection>;
	permitProductTypes: Array<Maybe<PermitProductType>>;
	permitProductTypes_connection?: Maybe<PermitProductTypeRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	themes: Array<Maybe<Theme>>;
	themes_connection?: Maybe<ThemeRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
	upls: Array<Maybe<Upl>>;
	upls_connection?: Maybe<UplRelationResponseCollection>;
};

export type PermitLocalizationsArgs = {
	filters?: InputMaybe<PermitFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitLocalizations_ConnectionArgs = {
	filters?: InputMaybe<PermitFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitPermitLawsArgs = {
	filters?: InputMaybe<PermitLawFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitPermitLaws_ConnectionArgs = {
	filters?: InputMaybe<PermitLawFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitPermitProductTypesArgs = {
	filters?: InputMaybe<PermitProductTypeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitPermitProductTypes_ConnectionArgs = {
	filters?: InputMaybe<PermitProductTypeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitThemesArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitThemes_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitUplsArgs = {
	filters?: InputMaybe<UplFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitUpls_ConnectionArgs = {
	filters?: InputMaybe<UplFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitDetail = {
	__typename?: 'PermitDetail';
	/** @deprecated Use root level fields instead */
	attributes: PermitDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PermitDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PermitDetail>>;
	localizations_connection?: Maybe<PermitDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<PermitDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermitDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['PermitDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PermitDetailModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| Error;

export type PermitDetailRelationResponseCollection = {
	__typename?: 'PermitDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PermitDetail>;
	nodes: Array<PermitDetail>;
};

export type PermitEntityResponseCollection = {
	__typename?: 'PermitEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Permit>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Permit>;
	pageInfo: Pagination;
};

export type PermitFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<PermitFiltersInput>>>;
	audience?: InputMaybe<StringFilterInput>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	hideFromOverview?: InputMaybe<BooleanFilterInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<PermitFiltersInput>;
	not?: InputMaybe<PermitFiltersInput>;
	onlineRequest?: InputMaybe<BooleanFilterInput>;
	or?: InputMaybe<Array<InputMaybe<PermitFiltersInput>>>;
	permitLaws?: InputMaybe<PermitLawFiltersInput>;
	permitProductTypes?: InputMaybe<PermitProductTypeFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	themes?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	upls?: InputMaybe<UplFiltersInput>;
};

export type PermitInput = {
	audience?: InputMaybe<Scalars['String']>;
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	hideFromOverview?: InputMaybe<Scalars['Boolean']>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['PermitModulesDynamicZoneInput']>>;
	onlineRequest?: InputMaybe<Scalars['Boolean']>;
	permitLaws?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	permitProductTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	themes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
	upls?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type PermitLaw = {
	__typename?: 'PermitLaw';
	/** @deprecated Use root level fields instead */
	attributes: PermitLaw;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PermitLaw;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PermitLaw>>;
	localizations_connection?: Maybe<PermitLawRelationResponseCollection>;
	name: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermitLawLocalizationsArgs = {
	filters?: InputMaybe<PermitLawFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitLawLocalizations_ConnectionArgs = {
	filters?: InputMaybe<PermitLawFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitLawEntityResponseCollection = {
	__typename?: 'PermitLawEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PermitLaw>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<PermitLaw>;
	pageInfo: Pagination;
};

export type PermitLawFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<PermitLawFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<PermitLawFiltersInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<PermitLawFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<PermitLawFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PermitLawInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PermitLawRelationResponseCollection = {
	__typename?: 'PermitLawRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PermitLaw>;
	nodes: Array<PermitLaw>;
};

export type PermitModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type PermitProductType = {
	__typename?: 'PermitProductType';
	/** @deprecated Use root level fields instead */
	attributes: PermitProductType;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PermitProductType;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PermitProductType>>;
	localizations_connection?: Maybe<PermitProductTypeRelationResponseCollection>;
	name: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermitProductTypeLocalizationsArgs = {
	filters?: InputMaybe<PermitProductTypeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitProductTypeLocalizations_ConnectionArgs = {
	filters?: InputMaybe<PermitProductTypeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PermitProductTypeEntityResponseCollection = {
	__typename?: 'PermitProductTypeEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PermitProductType>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<PermitProductType>;
	pageInfo: Pagination;
};

export type PermitProductTypeFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<PermitProductTypeFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<PermitProductTypeFiltersInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<PermitProductTypeFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<PermitProductTypeFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PermitProductTypeInput = {
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PermitProductTypeRelationResponseCollection = {
	__typename?: 'PermitProductTypeRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PermitProductType>;
	nodes: Array<PermitProductType>;
};

export type PermitRelationResponseCollection = {
	__typename?: 'PermitRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Permit>;
	nodes: Array<Permit>;
};

export type PermitsOverview = {
	__typename?: 'PermitsOverview';
	/** @deprecated Use root level fields instead */
	attributes: PermitsOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PermitsOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PermitsOverview>>;
	localizations_connection?: Maybe<PermitsOverviewRelationResponseCollection>;
	modules: Array<Maybe<PermitsOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PermitsOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['PermitsOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type PermitsOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesPermitsOverview
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| Error;

export type PermitsOverviewRelationResponseCollection = {
	__typename?: 'PermitsOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PermitsOverview>;
	nodes: Array<PermitsOverview>;
};

export type PressRelease = {
	__typename?: 'PressRelease';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: PressRelease;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	contactPerson?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PressRelease;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PressRelease>>;
	localizations_connection?: Maybe<PressReleaseRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<PressReleaseModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	theme: Array<Maybe<Theme>>;
	theme_connection?: Maybe<ThemeRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PressReleaseLocalizationsArgs = {
	filters?: InputMaybe<PressReleaseFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PressReleaseLocalizations_ConnectionArgs = {
	filters?: InputMaybe<PressReleaseFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PressReleaseTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PressReleaseTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PressReleaseThemeArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PressReleaseTheme_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PressReleaseData = {
	__typename?: 'PressReleaseData';
	contactPerson: Scalars['String'];
};

export type PressReleaseDetail = {
	__typename?: 'PressReleaseDetail';
	/** @deprecated Use root level fields instead */
	attributes: PressReleaseDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PressReleaseDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PressReleaseDetail>>;
	localizations_connection?: Maybe<PressReleaseDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<PressReleaseDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PressReleaseDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['PressReleaseDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PressReleaseDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesSubjects
	| Error;

export type PressReleaseDetailRelationResponseCollection = {
	__typename?: 'PressReleaseDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PressReleaseDetail>;
	nodes: Array<PressReleaseDetail>;
};

export type PressReleaseEntityResponseCollection = {
	__typename?: 'PressReleaseEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PressRelease>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<PressRelease>;
	pageInfo: Pagination;
};

export type PressReleaseFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<PressReleaseFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	contactPerson?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<PressReleaseFiltersInput>;
	not?: InputMaybe<PressReleaseFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<PressReleaseFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	theme?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PressReleaseInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	contactPerson?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['PressReleaseModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	theme?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type PressReleaseModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type PressReleaseOverview = {
	__typename?: 'PressReleaseOverview';
	/** @deprecated Use root level fields instead */
	attributes: PressReleaseOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PressReleaseOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PressReleaseOverview>>;
	localizations_connection?: Maybe<PressReleaseOverviewRelationResponseCollection>;
	modules: Array<Maybe<PressReleaseOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PressReleaseOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['PressReleaseOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type PressReleaseOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesPressReleaseOverview
	| Error;

export type PressReleaseOverviewRelationResponseCollection = {
	__typename?: 'PressReleaseOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PressReleaseOverview>;
	nodes: Array<PressReleaseOverview>;
};

export type PressReleaseRelationResponseCollection = {
	__typename?: 'PressReleaseRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PressRelease>;
	nodes: Array<PressRelease>;
};

export type PrivacyPolicy = {
	__typename?: 'PrivacyPolicy';
	/** @deprecated Use root level fields instead */
	attributes: PrivacyPolicy;
	basePath?: Maybe<Scalars['String']>;
	bodytext: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: PrivacyPolicy;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<PrivacyPolicy>>;
	localizations_connection?: Maybe<PrivacyPolicyRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrivacyPolicyInput = {
	basePath?: InputMaybe<Scalars['String']>;
	bodytext?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type PrivacyPolicyRelationResponseCollection = {
	__typename?: 'PrivacyPolicyRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<PrivacyPolicy>;
	nodes: Array<PrivacyPolicy>;
};

export type Project = {
	__typename?: 'Project';
	/** @deprecated Use root level fields instead */
	attributes: Project;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Project;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Project>>;
	localizations_connection?: Maybe<ProjectRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<ProjectModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	shortDescription?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	theme?: Maybe<Theme>;
	title?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectLocalizationsArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProjectLocalizations_ConnectionArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProjectDetail = {
	__typename?: 'ProjectDetail';
	/** @deprecated Use root level fields instead */
	attributes: ProjectDetail;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ProjectDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<ProjectDetail>>;
	localizations_connection?: Maybe<ProjectDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<ProjectDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectDetailInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['ProjectDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProjectDetailModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type ProjectDetailRelationResponseCollection = {
	__typename?: 'ProjectDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ProjectDetail>;
	nodes: Array<ProjectDetail>;
};

export type ProjectEntityResponseCollection = {
	__typename?: 'ProjectEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Project>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Project>;
	pageInfo: Pagination;
};

export type ProjectFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ProjectFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<ProjectFiltersInput>;
	not?: InputMaybe<ProjectFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ProjectFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	shortDescription?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	theme?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProjectInput = {
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['ProjectModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	shortDescription?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	theme?: InputMaybe<Scalars['ID']>;
	title?: InputMaybe<Scalars['String']>;
};

export type ProjectModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type ProjectOverview = {
	__typename?: 'ProjectOverview';
	/** @deprecated Use root level fields instead */
	attributes: ProjectOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ProjectOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<ProjectOverview>>;
	localizations_connection?: Maybe<ProjectOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<ProjectOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['ProjectOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type ProjectOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesProjectOverview
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type ProjectOverviewRelationResponseCollection = {
	__typename?: 'ProjectOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ProjectOverview>;
	nodes: Array<ProjectOverview>;
};

export type ProjectRelationResponseCollection = {
	__typename?: 'ProjectRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Project>;
	nodes: Array<Project>;
};

export type PublicNewsletterPage = {
	__typename?: 'PublicNewsletterPage';
	page?: Maybe<NewsletterPublic>;
};

export type PublicationFilter =
	| 'HAS_PUBLISHED_VERSION'
	| 'HAS_PUBLISHED_VERSION_DOCUMENT'
	| 'MODIFIED'
	| 'NEVER_PUBLISHED'
	| 'NEVER_PUBLISHED_DOCUMENT'
	| 'PUBLISHED_WITHOUT_DRAFT'
	| 'PUBLISHED_WITH_DRAFT'
	| 'UNMODIFIED';

export type PublicationStatus = 'DRAFT' | 'PUBLISHED';

export type Query = {
	__typename?: 'Query';
	agendaPage?: Maybe<AgendaPage>;
	auditLogAuditLog?: Maybe<AuditLogAuditLog>;
	auditLogAuditLogs: Array<Maybe<AuditLogAuditLog>>;
	auditLogAuditLogs_connection?: Maybe<AuditLogAuditLogEntityResponseCollection>;
	condoleanceHomepage?: Maybe<CondoleanceHomepage>;
	condoleanceInformation?: Maybe<CondoleanceInformation>;
	condoleancePage?: Maybe<CondoleancePage>;
	/** Retrieve a single CondoleancePage by slug */
	condoleancePageBySlug?: Maybe<CondoleancePage>;
	condoleancePages: Array<Maybe<CondoleancePage>>;
	condoleancePages_connection?: Maybe<CondoleancePageEntityResponseCollection>;
	contact?: Maybe<Contact>;
	conversationsConversationitem?: Maybe<ConversationsConversationitem>;
	conversationsConversationitems: Array<Maybe<ConversationsConversationitem>>;
	conversationsConversationitems_connection?: Maybe<ConversationsConversationitemEntityResponseCollection>;
	conversationsConversations: Array<Maybe<ConversationsConversations>>;
	conversationsConversations_connection?: Maybe<ConversationsConversationsEntityResponseCollection>;
	cookiePage?: Maybe<CookiePage>;
	countDocumentsPerCategory?: Maybe<Array<Maybe<WooCategoryCount>>>;
	decisionsPage?: Maybe<DecisionsPage>;
	downloadsPage?: Maybe<DownloadsPage>;
	efroOostHomepage?: Maybe<EfroOostHomepage>;
	efroOostInConvoWithArticle?: Maybe<EfroOostInConvoWithArticle>;
	/** Retrieve a single EfroOostInConvoWithArticle by slug */
	efroOostInConvoWithArticleBySlug?: Maybe<EfroOostInConvoWithArticle>;
	efroOostInConvoWithArticles: Array<Maybe<EfroOostInConvoWithArticle>>;
	efroOostInConvoWithArticles_connection?: Maybe<EfroOostInConvoWithArticleEntityResponseCollection>;
	efroOostInConvoWithDetail?: Maybe<EfroOostInConvoWithDetail>;
	efroOostInConvoWithOverview?: Maybe<EfroOostInConvoWithOverview>;
	efroOostInformation?: Maybe<EfroOostInformation>;
	efroOostNewsDetail?: Maybe<EfroOostNewsDetail>;
	efroOostNewsOverview?: Maybe<EfroOostNewsOverview>;
	efroOostNewsarticle?: Maybe<EfroOostNewsarticle>;
	/** Retrieve a single EfroOostNewsarticle by slug */
	efroOostNewsarticleBySlug?: Maybe<EfroOostNewsarticle>;
	efroOostNewsarticles: Array<Maybe<EfroOostNewsarticle>>;
	efroOostNewsarticles_connection?: Maybe<EfroOostNewsarticleEntityResponseCollection>;
	efroOostPage?: Maybe<EfroOostPage>;
	/** Retrieve a single EfroOostPage by slug */
	efroOostPageBySlug?: Maybe<EfroOostPage>;
	efroOostPages: Array<Maybe<EfroOostPage>>;
	efroOostPages_connection?: Maybe<EfroOostPageEntityResponseCollection>;
	event?: Maybe<Event>;
	eventOverview?: Maybe<EventOverview>;
	events: Array<Maybe<Event>>;
	events_connection?: Maybe<EventEntityResponseCollection>;
	findAllSlugs?: Maybe<Array<Maybe<SlugItem>>>;
	findSitemapList?: Maybe<Array<Maybe<SitemapPage>>>;
	geolinkHomepage?: Maybe<GeolinkHomepage>;
	geolinkInformation?: Maybe<GeolinkInformation>;
	geolinkPage?: Maybe<GeolinkPage>;
	/** Retrieve a single GeolinkPage by slug */
	geolinkPageBySlug?: Maybe<GeolinkPage>;
	geolinkPages: Array<Maybe<GeolinkPage>>;
	geolinkPages_connection?: Maybe<GeolinkPageEntityResponseCollection>;
	getCommentsEnabled?: Maybe<Scalars['Boolean']>;
	getConversationItems?: Maybe<ConversationItemsResponse>;
	getManyNewsletters?: Maybe<Array<Maybe<NewsletterData>>>;
	getNewsLetterCampaigns?: Maybe<Array<Maybe<NewsletterCampaign>>>;
	getNewsarticleContactPersonById?: Maybe<NewsarticleData>;
	getPressReleaseContactPersonById?: Maybe<PressReleaseData>;
	homePage?: Maybe<HomePage>;
	i18NLocale?: Maybe<I18NLocale>;
	i18NLocales: Array<Maybe<I18NLocale>>;
	i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
	inConvoWithArticle?: Maybe<InConvoWithArticle>;
	/** Retrieve a single InConvoWithArticle by slug */
	inConvoWithArticleBySlug?: Maybe<InConvoWithArticle>;
	inConvoWithArticles: Array<Maybe<InConvoWithArticle>>;
	inConvoWithArticles_connection?: Maybe<InConvoWithArticleEntityResponseCollection>;
	inConvoWithDetail?: Maybe<InConvoWithDetail>;
	inConvoWithOverview?: Maybe<InConvoWithOverview>;
	internalLinksLinkReference?: Maybe<InternalLinksLinkReference>;
	internalLinksLinkReferences: Array<Maybe<InternalLinksLinkReference>>;
	internalLinksLinkReferences_connection?: Maybe<InternalLinksLinkReferenceEntityResponseCollection>;
	internalNewsletterWithSubscriptions?: Maybe<Array<Maybe<InternalNewsletterWithSubscriptions>>>;
	login?: Maybe<Login>;
	mapsFigure?: Maybe<MapsFigure>;
	mapsFigures: Array<Maybe<MapsFigure>>;
	mapsFiguresOverview?: Maybe<MapsFiguresOverview>;
	mapsFigures_connection?: Maybe<MapsFigureEntityResponseCollection>;
	me?: Maybe<UsersPermissionsMe>;
	newsDetail?: Maybe<NewsDetail>;
	newsOverview?: Maybe<NewsOverview>;
	newsarticle?: Maybe<Newsarticle>;
	/** Retrieve a single Newsarticle by slug */
	newsarticleBySlug?: Maybe<Newsarticle>;
	newsarticles: Array<Maybe<Newsarticle>>;
	newsarticles_connection?: Maybe<NewsarticleEntityResponseCollection>;
	newsletter?: Maybe<Newsletter>;
	newsletterArchiveOverview?: Maybe<NewsletterArchiveOverview>;
	newsletterContact?: Maybe<NewsletterContact>;
	newsletterInternal?: Maybe<NewsletterInternal>;
	newsletterPublic?: Maybe<NewsletterPublic>;
	notFoundPage?: Maybe<NotFoundPage>;
	/** Find notes related to a specific entity by documentId */
	notesByDocumentId?: Maybe<Array<Maybe<NotesByPageResult>>>;
	/** Find notes related to a specific entity by slug */
	notesByPage?: Maybe<Array<Maybe<NotesByPageResult>>>;
	notesNote?: Maybe<NotesNote>;
	notesNotes: Array<Maybe<NotesNote>>;
	notesNotes_connection?: Maybe<NotesNoteEntityResponseCollection>;
	opOostHomepage?: Maybe<OpOostHomepage>;
	opOostInConvoWithArticle?: Maybe<OpOostInConvoWithArticle>;
	/** Retrieve a single OpOostInConvoWithArticle by slug */
	opOostInConvoWithArticleBySlug?: Maybe<OpOostInConvoWithArticle>;
	opOostInConvoWithArticles: Array<Maybe<OpOostInConvoWithArticle>>;
	opOostInConvoWithArticles_connection?: Maybe<OpOostInConvoWithArticleEntityResponseCollection>;
	opOostInConvoWithDetail?: Maybe<OpOostInConvoWithDetail>;
	opOostInConvoWithOverview?: Maybe<OpOostInConvoWithOverview>;
	opOostInformation?: Maybe<OpOostInformation>;
	opOostNewsDetail?: Maybe<OpOostNewsDetail>;
	opOostNewsOverview?: Maybe<OpOostNewsOverview>;
	opOostNewsarticle?: Maybe<OpOostNewsarticle>;
	/** Retrieve a single OpOostNewsarticle by slug */
	opOostNewsarticleBySlug?: Maybe<OpOostNewsarticle>;
	opOostNewsarticles: Array<Maybe<OpOostNewsarticle>>;
	opOostNewsarticles_connection?: Maybe<OpOostNewsarticleEntityResponseCollection>;
	opOostPage?: Maybe<OpOostPage>;
	/** Retrieve a single OpOostPage by slug */
	opOostPageBySlug?: Maybe<OpOostPage>;
	opOostPages: Array<Maybe<OpOostPage>>;
	opOostPages_connection?: Maybe<OpOostPageEntityResponseCollection>;
	openGelderlandHomepage?: Maybe<OpenGelderlandHomepage>;
	openGelderlandInformation?: Maybe<OpenGelderlandInformation>;
	openGelderlandWooOverview?: Maybe<OpenGelderlandWooOverview>;
	page?: Maybe<Page>;
	/** Retrieve a single Page by slug */
	pageBySlug?: Maybe<Page>;
	pageInformation?: Maybe<PageInformation>;
	pages: Array<Maybe<Page>>;
	pages_connection?: Maybe<PageEntityResponseCollection>;
	passwordProtectionPasswordPage?: Maybe<PasswordProtectionPasswordPage>;
	passwordProtectionPasswordProtection?: Maybe<PasswordProtectionPasswordProtection>;
	passwordProtectionPasswordProtections: Array<Maybe<PasswordProtectionPasswordProtection>>;
	passwordProtectionPasswordProtections_connection?: Maybe<PasswordProtectionPasswordProtectionEntityResponseCollection>;
	passwordStatusBySlug?: Maybe<PasswordStatusResult>;
	permit?: Maybe<Permit>;
	/** Retrieve a single Permit by slug */
	permitBySlug?: Maybe<Permit>;
	permitDetail?: Maybe<PermitDetail>;
	permitLaw?: Maybe<PermitLaw>;
	permitLaws: Array<Maybe<PermitLaw>>;
	permitLaws_connection?: Maybe<PermitLawEntityResponseCollection>;
	permitProductType?: Maybe<PermitProductType>;
	permitProductTypes: Array<Maybe<PermitProductType>>;
	permitProductTypes_connection?: Maybe<PermitProductTypeEntityResponseCollection>;
	permits: Array<Maybe<Permit>>;
	permitsOverview?: Maybe<PermitsOverview>;
	permits_connection?: Maybe<PermitEntityResponseCollection>;
	pressRelease?: Maybe<PressRelease>;
	/** Retrieve a single PressRelease by slug */
	pressReleaseBySlug?: Maybe<PressRelease>;
	pressReleaseDetail?: Maybe<PressReleaseDetail>;
	pressReleaseOverview?: Maybe<PressReleaseOverview>;
	pressReleases: Array<Maybe<PressRelease>>;
	pressReleases_connection?: Maybe<PressReleaseEntityResponseCollection>;
	privacyPolicy?: Maybe<PrivacyPolicy>;
	project?: Maybe<Project>;
	/** Retrieve a single Project by slug */
	projectBySlug?: Maybe<Project>;
	projectDetail?: Maybe<ProjectDetail>;
	projectOverview?: Maybe<ProjectOverview>;
	projects: Array<Maybe<Project>>;
	projects_connection?: Maybe<ProjectEntityResponseCollection>;
	publicNewsletterPage?: Maybe<Array<Maybe<PublicNewsletterPage>>>;
	recordLockingOpenEntities: Array<Maybe<RecordLockingOpenEntity>>;
	recordLockingOpenEntities_connection?: Maybe<RecordLockingOpenEntityEntityResponseCollection>;
	recordLockingOpenEntity?: Maybe<RecordLockingOpenEntity>;
	recycleBinRecycleBinItem?: Maybe<RecycleBinRecycleBinItem>;
	recycleBinRecycleBinItems: Array<Maybe<RecycleBinRecycleBinItem>>;
	recycleBinRecycleBinItems_connection?: Maybe<RecycleBinRecycleBinItemEntityResponseCollection>;
	redirectsRedirect?: Maybe<RedirectsRedirect>;
	redirectsRedirects: Array<Maybe<RedirectsRedirect>>;
	redirectsRedirects_connection?: Maybe<RedirectsRedirectEntityResponseCollection>;
	regioExpresHomepage?: Maybe<RegioExpresHomepage>;
	regioExpresInConvoOverview?: Maybe<RegioExpresInConvoOverview>;
	regioExpresInConvoWithArticle?: Maybe<RegioExpresInConvoWithArticle>;
	/** Retrieve a single RegioExpresInConvoWithArticle by slug */
	regioExpresInConvoWithArticleBySlug?: Maybe<RegioExpresInConvoWithArticle>;
	regioExpresInConvoWithArticles: Array<Maybe<RegioExpresInConvoWithArticle>>;
	regioExpresInConvoWithArticles_connection?: Maybe<RegioExpresInConvoWithArticleEntityResponseCollection>;
	regioExpresInConvoWithDetail?: Maybe<RegioExpresInConvoWithDetail>;
	regioExpresInformation?: Maybe<RegioExpresInformation>;
	regioExpresNewsDetail?: Maybe<RegioExpresNewsDetail>;
	regioExpresNewsOverview?: Maybe<RegioExpresNewsOverview>;
	regioExpresNewsarticle?: Maybe<RegioExpresNewsarticle>;
	/** Retrieve a single RegioExpresNewsarticle by slug */
	regioExpresNewsarticleBySlug?: Maybe<RegioExpresNewsarticle>;
	regioExpresNewsarticles: Array<Maybe<RegioExpresNewsarticle>>;
	regioExpresNewsarticles_connection?: Maybe<RegioExpresNewsarticleEntityResponseCollection>;
	regioExpresPage?: Maybe<RegioExpresPage>;
	/** Retrieve a single RegioExpresPage by slug */
	regioExpresPageBySlug?: Maybe<RegioExpresPage>;
	regioExpresPages: Array<Maybe<RegioExpresPage>>;
	regioExpresPages_connection?: Maybe<RegioExpresPageEntityResponseCollection>;
	region?: Maybe<Region>;
	/** Retrieve a single Region by slug */
	regionBySlug?: Maybe<Region>;
	regionDetail?: Maybe<RegionDetail>;
	regionOverview?: Maybe<RegionOverview>;
	regions: Array<Maybe<Region>>;
	regions_connection?: Maybe<RegionEntityResponseCollection>;
	reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
	reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
	reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
	reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
	reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
	reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
	roadMaintenance?: Maybe<RoadMaintenance>;
	/** Retrieve a single RoadMaintenance by slug */
	roadMaintenanceBySlug?: Maybe<RoadMaintenance>;
	roadMaintenanceDetail?: Maybe<RoadMaintenanceDetail>;
	roadMaintenanceOverview?: Maybe<RoadMaintenanceOverview>;
	roadMaintenances: Array<Maybe<RoadMaintenance>>;
	roadMaintenances_connection?: Maybe<RoadMaintenanceEntityResponseCollection>;
	schedulerScheduler?: Maybe<SchedulerScheduler>;
	schedulerSchedulers: Array<Maybe<SchedulerScheduler>>;
	schedulerSchedulers_connection?: Maybe<SchedulerSchedulerEntityResponseCollection>;
	sdgLocatie?: Maybe<SdgLocatie>;
	sdgLocaties: Array<Maybe<SdgLocatie>>;
	sdgLocaties_connection?: Maybe<SdgLocatieEntityResponseCollection>;
	sdgSdg?: Maybe<SdgSdg>;
	sdgSdgs: Array<Maybe<SdgSdg>>;
	sdgSdgs_connection?: Maybe<SdgSdgEntityResponseCollection>;
	sdgUplLijst?: Maybe<SdgUplLijst>;
	sdgUplLijsts: Array<Maybe<SdgUplLijst>>;
	sdgUplLijsts_connection?: Maybe<SdgUplLijstEntityResponseCollection>;
	searchCollectionTypes?: Maybe<Array<Maybe<SearchResult>>>;
	searchMediaLibrary?: Maybe<Array<Maybe<MediaLibraryResult>>>;
	/** Search notes across title, note content, author (memo), and author (page) fields */
	searchNotes?: Maybe<Array<Maybe<NoteSearchResult>>>;
	searchOverview?: Maybe<SearchOverview>;
	searchWooRequests?: Maybe<Array<Maybe<SearchResult>>>;
	sitemap?: Maybe<Sitemap>;
	slugConfig?: Maybe<SlugConfig>;
	subsidies: Array<Maybe<Subsidy>>;
	subsidies_connection?: Maybe<SubsidyEntityResponseCollection>;
	subsidy?: Maybe<Subsidy>;
	/** Retrieve a single Subsidy by slug */
	subsidyBySlug?: Maybe<Subsidy>;
	subsidyDetail?: Maybe<SubsidyDetail>;
	subsidyKind?: Maybe<SubsidyKind>;
	subsidyKinds: Array<Maybe<SubsidyKind>>;
	subsidyKinds_connection?: Maybe<SubsidyKindEntityResponseCollection>;
	subsidyOverview?: Maybe<SubsidyOverview>;
	subsidyScale?: Maybe<SubsidyScale>;
	subsidyScales: Array<Maybe<SubsidyScale>>;
	subsidyScales_connection?: Maybe<SubsidyScaleEntityResponseCollection>;
	tag?: Maybe<Tag>;
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagEntityResponseCollection>;
	targetGroup?: Maybe<TargetGroup>;
	targetGroups: Array<Maybe<TargetGroup>>;
	targetGroups_connection?: Maybe<TargetGroupEntityResponseCollection>;
	theme?: Maybe<Theme>;
	/** Retrieve a single Theme by slug */
	themeBySlug?: Maybe<Theme>;
	themeDetail?: Maybe<ThemeDetail>;
	themeOverview?: Maybe<ThemeOverview>;
	themes: Array<Maybe<Theme>>;
	themes_connection?: Maybe<ThemeEntityResponseCollection>;
	upl?: Maybe<Upl>;
	uploadFile?: Maybe<UploadFile>;
	uploadFiles: Array<Maybe<UploadFile>>;
	uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
	upls: Array<Maybe<Upl>>;
	upls_connection?: Maybe<UplEntityResponseCollection>;
	usersPermissionsRole?: Maybe<UsersPermissionsRole>;
	usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
	usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
	usersPermissionsUser?: Maybe<UsersPermissionsUser>;
	usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
	usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
	vacancyDetail?: Maybe<VacancyDetail>;
	vacancyInternalDetail?: Maybe<VacancyInternalDetail>;
	vacancyInternalOverview?: Maybe<VacancyInternalOverview>;
	vacancyOverview?: Maybe<VacancyOverview>;
	versioningHistory: Array<Maybe<VersioningHistory>>;
	versioningHistory_connection?: Maybe<VersioningHistoryEntityResponseCollection>;
	wobRequest?: Maybe<WobRequest>;
	wobRequestOverview?: Maybe<WobRequestOverview>;
	wobRequests: Array<Maybe<WobRequest>>;
	wobRequests_connection?: Maybe<WobRequestEntityResponseCollection>;
	wooCategories: Array<Maybe<WooCategory>>;
	wooCategories_connection?: Maybe<WooCategoryEntityResponseCollection>;
	wooCategory?: Maybe<WooCategory>;
	wooDocumentDetail?: Maybe<WooDocumentDetail>;
	wooRequest?: Maybe<WooRequest>;
	/** Retrieve a single WooRequest by slug */
	wooRequestBySlug?: Maybe<WooRequest>;
	wooRequestOverview?: Maybe<WooRequestOverview>;
	wooRequests: Array<Maybe<WooRequest>>;
	wooRequests_connection?: Maybe<WooRequestEntityResponseCollection>;
	workAt?: Maybe<WorkAt>;
};

export type QueryAgendaPageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryAuditLogAuditLogArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryAuditLogAuditLogsArgs = {
	filters?: InputMaybe<AuditLogAuditLogFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryAuditLogAuditLogs_ConnectionArgs = {
	filters?: InputMaybe<AuditLogAuditLogFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryCondoleanceHomepageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryCondoleanceInformationArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryCondoleancePageArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryCondoleancePageBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryCondoleancePagesArgs = {
	filters?: InputMaybe<CondoleancePageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryCondoleancePages_ConnectionArgs = {
	filters?: InputMaybe<CondoleancePageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryContactArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryConversationsConversationitemArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryConversationsConversationitemsArgs = {
	filters?: InputMaybe<ConversationsConversationitemFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryConversationsConversationitems_ConnectionArgs = {
	filters?: InputMaybe<ConversationsConversationitemFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryConversationsConversationsArgs = {
	filters?: InputMaybe<ConversationsConversationsFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryConversationsConversations_ConnectionArgs = {
	filters?: InputMaybe<ConversationsConversationsFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryCookiePageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryDecisionsPageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryDownloadsPageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostHomepageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostInConvoWithArticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostInConvoWithArticlesArgs = {
	filters?: InputMaybe<EfroOostInConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostInConvoWithArticles_ConnectionArgs = {
	filters?: InputMaybe<EfroOostInConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostInConvoWithDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostInConvoWithOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostInformationArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostNewsDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostNewsOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostNewsarticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostNewsarticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostNewsarticlesArgs = {
	filters?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostNewsarticles_ConnectionArgs = {
	filters?: InputMaybe<EfroOostNewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostPageArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostPageBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostPagesArgs = {
	filters?: InputMaybe<EfroOostPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEfroOostPages_ConnectionArgs = {
	filters?: InputMaybe<EfroOostPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEventArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEventOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEventsArgs = {
	filters?: InputMaybe<EventFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryEvents_ConnectionArgs = {
	filters?: InputMaybe<EventFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryFindAllSlugsArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	status?: InputMaybe<PublicationStatus>;
	uid: Scalars['String'];
};

export type QueryFindSitemapListArgs = {
	_domain?: InputMaybe<Scalars['String']>;
	_locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};

export type QueryGeolinkHomepageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryGeolinkInformationArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryGeolinkPageArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryGeolinkPageBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryGeolinkPagesArgs = {
	filters?: InputMaybe<GeolinkPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryGeolinkPages_ConnectionArgs = {
	filters?: InputMaybe<GeolinkPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryGetCommentsEnabledArgs = {
	contentTypeId?: InputMaybe<Scalars['String']>;
	contentTypeUid?: InputMaybe<Scalars['String']>;
};

export type QueryGetConversationItemsArgs = {
	contentTypeId?: InputMaybe<Scalars['String']>;
	contentTypeUid?: InputMaybe<Scalars['String']>;
	page?: InputMaybe<Scalars['Int']>;
	pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryGetNewsarticleContactPersonByIdArgs = {
	id: Scalars['String'];
};

export type QueryGetPressReleaseContactPersonByIdArgs = {
	id: Scalars['String'];
};

export type QueryHomePageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocaleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocalesArgs = {
	filters?: InputMaybe<I18NLocaleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocales_ConnectionArgs = {
	filters?: InputMaybe<I18NLocaleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInConvoWithArticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInConvoWithArticlesArgs = {
	filters?: InputMaybe<InConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInConvoWithArticles_ConnectionArgs = {
	filters?: InputMaybe<InConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInConvoWithDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInConvoWithOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInternalLinksLinkReferenceArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInternalLinksLinkReferencesArgs = {
	filters?: InputMaybe<InternalLinksLinkReferenceFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInternalLinksLinkReferences_ConnectionArgs = {
	filters?: InputMaybe<InternalLinksLinkReferenceFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryInternalNewsletterWithSubscriptionsArgs = {
	_locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	_publicationState?: InputMaybe<PublicationStatus>;
};

export type QueryLoginArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryMapsFigureArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryMapsFiguresArgs = {
	filters?: InputMaybe<MapsFigureFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryMapsFiguresOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryMapsFigures_ConnectionArgs = {
	filters?: InputMaybe<MapsFigureFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsarticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsarticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsarticlesArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsarticles_ConnectionArgs = {
	filters?: InputMaybe<NewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsletterArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsletterArchiveOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsletterContactArgs = {
	email: Scalars['String'];
};

export type QueryNewsletterInternalArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsletterPublicArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNotFoundPageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNotesByDocumentIdArgs = {
	documentId: Scalars['String'];
};

export type QueryNotesByPageArgs = {
	contentType?: InputMaybe<Scalars['String']>;
	slug: Scalars['String'];
};

export type QueryNotesNoteArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNotesNotesArgs = {
	filters?: InputMaybe<NotesNoteFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryNotesNotes_ConnectionArgs = {
	filters?: InputMaybe<NotesNoteFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostHomepageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostInConvoWithArticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostInConvoWithArticlesArgs = {
	filters?: InputMaybe<OpOostInConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostInConvoWithArticles_ConnectionArgs = {
	filters?: InputMaybe<OpOostInConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostInConvoWithDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostInConvoWithOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostInformationArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostNewsDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostNewsOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostNewsarticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostNewsarticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostNewsarticlesArgs = {
	filters?: InputMaybe<OpOostNewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostNewsarticles_ConnectionArgs = {
	filters?: InputMaybe<OpOostNewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostPageArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostPageBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostPagesArgs = {
	filters?: InputMaybe<OpOostPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpOostPages_ConnectionArgs = {
	filters?: InputMaybe<OpOostPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpenGelderlandHomepageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpenGelderlandInformationArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryOpenGelderlandWooOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPageArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPageBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPageInformationArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPagesArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPages_ConnectionArgs = {
	filters?: InputMaybe<PageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPasswordProtectionPasswordPageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPasswordProtectionPasswordProtectionArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPasswordProtectionPasswordProtectionsArgs = {
	filters?: InputMaybe<PasswordProtectionPasswordProtectionFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPasswordProtectionPasswordProtections_ConnectionArgs = {
	filters?: InputMaybe<PasswordProtectionPasswordProtectionFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPasswordStatusBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
	uid: Scalars['String'];
};

export type QueryPermitArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitLawArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitLawsArgs = {
	filters?: InputMaybe<PermitLawFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitLaws_ConnectionArgs = {
	filters?: InputMaybe<PermitLawFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitProductTypeArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitProductTypesArgs = {
	filters?: InputMaybe<PermitProductTypeFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitProductTypes_ConnectionArgs = {
	filters?: InputMaybe<PermitProductTypeFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitsArgs = {
	filters?: InputMaybe<PermitFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermitsOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPermits_ConnectionArgs = {
	filters?: InputMaybe<PermitFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPressReleaseArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPressReleaseBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPressReleaseDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPressReleaseOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPressReleasesArgs = {
	filters?: InputMaybe<PressReleaseFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPressReleases_ConnectionArgs = {
	filters?: InputMaybe<PressReleaseFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPrivacyPolicyArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryProjectArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryProjectBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryProjectDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryProjectOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryProjectsArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryProjects_ConnectionArgs = {
	filters?: InputMaybe<ProjectFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryPublicNewsletterPageArgs = {
	_locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	_publicationState?: InputMaybe<PublicationStatus>;
};

export type QueryRecordLockingOpenEntitiesArgs = {
	filters?: InputMaybe<RecordLockingOpenEntityFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRecordLockingOpenEntities_ConnectionArgs = {
	filters?: InputMaybe<RecordLockingOpenEntityFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRecordLockingOpenEntityArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRecycleBinRecycleBinItemArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRecycleBinRecycleBinItemsArgs = {
	filters?: InputMaybe<RecycleBinRecycleBinItemFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRecycleBinRecycleBinItems_ConnectionArgs = {
	filters?: InputMaybe<RecycleBinRecycleBinItemFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRedirectsRedirectArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRedirectsRedirectsArgs = {
	filters?: InputMaybe<RedirectsRedirectFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRedirectsRedirects_ConnectionArgs = {
	filters?: InputMaybe<RedirectsRedirectFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresHomepageArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresInConvoOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresInConvoWithArticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresInConvoWithArticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresInConvoWithArticlesArgs = {
	filters?: InputMaybe<RegioExpresInConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresInConvoWithArticles_ConnectionArgs = {
	filters?: InputMaybe<RegioExpresInConvoWithArticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresInConvoWithDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresInformationArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresNewsDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresNewsOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresNewsarticleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresNewsarticleBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresNewsarticlesArgs = {
	filters?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresNewsarticles_ConnectionArgs = {
	filters?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresPageArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresPageBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresPagesArgs = {
	filters?: InputMaybe<RegioExpresPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegioExpresPages_ConnectionArgs = {
	filters?: InputMaybe<RegioExpresPageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegionArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegionBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegionDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegionOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegionsArgs = {
	filters?: InputMaybe<RegionFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRegions_ConnectionArgs = {
	filters?: InputMaybe<RegionFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStageArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStagesArgs = {
	filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
	filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowsArgs = {
	filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
	filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRoadMaintenanceArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRoadMaintenanceBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRoadMaintenanceDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRoadMaintenanceOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRoadMaintenancesArgs = {
	filters?: InputMaybe<RoadMaintenanceFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryRoadMaintenances_ConnectionArgs = {
	filters?: InputMaybe<RoadMaintenanceFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySchedulerSchedulerArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySchedulerSchedulersArgs = {
	filters?: InputMaybe<SchedulerSchedulerFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySchedulerSchedulers_ConnectionArgs = {
	filters?: InputMaybe<SchedulerSchedulerFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgLocatieArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgLocatiesArgs = {
	filters?: InputMaybe<SdgLocatieFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgLocaties_ConnectionArgs = {
	filters?: InputMaybe<SdgLocatieFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgSdgArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgSdgsArgs = {
	filters?: InputMaybe<SdgSdgFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgSdgs_ConnectionArgs = {
	filters?: InputMaybe<SdgSdgFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgUplLijstArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgUplLijstsArgs = {
	filters?: InputMaybe<SdgUplLijstFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySdgUplLijsts_ConnectionArgs = {
	filters?: InputMaybe<SdgUplLijstFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySearchCollectionTypesArgs = {
	createdAtAfter?: InputMaybe<Scalars['String']>;
	createdAtBefore?: InputMaybe<Scalars['String']>;
	domain?: InputMaybe<Scalars['String']>;
	locale?: InputMaybe<Scalars['String']>;
	searchQuery: Scalars['String'];
	sort?: InputMaybe<Scalars['String']>;
};

export type QuerySearchMediaLibraryArgs = {
	limit?: InputMaybe<Scalars['Int']>;
	searchQuery: Scalars['String'];
};

export type QuerySearchNotesArgs = {
	limit?: InputMaybe<Scalars['Int']>;
	searchQuery: Scalars['String'];
};

export type QuerySearchOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySearchWooRequestsArgs = {
	limit?: InputMaybe<Scalars['Int']>;
	locale?: InputMaybe<Scalars['String']>;
	searchQuery: Scalars['String'];
};

export type QuerySitemapArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySlugConfigArgs = {
	uid?: InputMaybe<Scalars['String']>;
};

export type QuerySubsidiesArgs = {
	filters?: InputMaybe<SubsidyFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidies_ConnectionArgs = {
	filters?: InputMaybe<SubsidyFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyKindArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyKindsArgs = {
	filters?: InputMaybe<SubsidyKindFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyKinds_ConnectionArgs = {
	filters?: InputMaybe<SubsidyKindFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyScaleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyScalesArgs = {
	filters?: InputMaybe<SubsidyScaleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QuerySubsidyScales_ConnectionArgs = {
	filters?: InputMaybe<SubsidyScaleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryTagArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryTargetGroupArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryTargetGroupsArgs = {
	filters?: InputMaybe<TargetGroupFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryTargetGroups_ConnectionArgs = {
	filters?: InputMaybe<TargetGroupFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryThemeArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryThemeBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryThemeDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryThemeOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryThemesArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryThemes_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUplArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFileArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFilesArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFiles_ConnectionArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUplsArgs = {
	filters?: InputMaybe<UplFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUpls_ConnectionArgs = {
	filters?: InputMaybe<UplFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRoleArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRolesArgs = {
	filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRoles_ConnectionArgs = {
	filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUserArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUsersArgs = {
	filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUsers_ConnectionArgs = {
	filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryVacancyDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryVacancyInternalDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryVacancyInternalOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryVacancyOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryVersioningHistoryArgs = {
	filters?: InputMaybe<VersioningHistoryFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryVersioningHistory_ConnectionArgs = {
	filters?: InputMaybe<VersioningHistoryFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWobRequestArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWobRequestOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWobRequestsArgs = {
	filters?: InputMaybe<WobRequestFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWobRequests_ConnectionArgs = {
	filters?: InputMaybe<WobRequestFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooCategoriesArgs = {
	filters?: InputMaybe<WooCategoryFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooCategories_ConnectionArgs = {
	filters?: InputMaybe<WooCategoryFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooCategoryArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooDocumentDetailArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooRequestArgs = {
	documentId: Scalars['ID'];
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooRequestBySlugArgs = {
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooRequestOverviewArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooRequestsArgs = {
	filters?: InputMaybe<WooRequestFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWooRequests_ConnectionArgs = {
	filters?: InputMaybe<WooRequestFiltersInput>;
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	pagination?: InputMaybe<PaginationArg>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	status?: InputMaybe<PublicationStatus>;
};

export type QueryWorkAtArgs = {
	hasPublishedVersion?: InputMaybe<Scalars['Boolean']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationFilter?: InputMaybe<PublicationFilter>;
	status?: InputMaybe<PublicationStatus>;
};

export type RecordLockingOpenEntity = {
	__typename?: 'RecordLockingOpenEntity';
	/** @deprecated Use root level fields instead */
	attributes: RecordLockingOpenEntity;
	connectionId?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RecordLockingOpenEntity;
	documentId: Scalars['ID'];
	entityDocumentId?: Maybe<Scalars['String']>;
	entityId?: Maybe<Scalars['String']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
	user?: Maybe<Scalars['String']>;
};

export type RecordLockingOpenEntityEntityResponseCollection = {
	__typename?: 'RecordLockingOpenEntityEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RecordLockingOpenEntity>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<RecordLockingOpenEntity>;
	pageInfo: Pagination;
};

export type RecordLockingOpenEntityFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<RecordLockingOpenEntityFiltersInput>>>;
	connectionId?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	entityDocumentId?: InputMaybe<StringFilterInput>;
	entityId?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<RecordLockingOpenEntityFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RecordLockingOpenEntityFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	user?: InputMaybe<StringFilterInput>;
};

export type RecordLockingOpenEntityInput = {
	connectionId?: InputMaybe<Scalars['String']>;
	entityDocumentId?: InputMaybe<Scalars['String']>;
	entityId?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	user?: InputMaybe<Scalars['String']>;
};

export type RecycleBinRecycleBinItem = {
	__typename?: 'RecycleBinRecycleBinItem';
	/** @deprecated Use root level fields instead */
	attributes: RecycleBinRecycleBinItem;
	contentTypeId: Scalars['Int'];
	createdAt?: Maybe<Scalars['DateTime']>;
	data: Scalars['JSON'];
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	model: Scalars['JSON'];
	originalDocumentId: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	title?: Maybe<Scalars['String']>;
	uid: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RecycleBinRecycleBinItemEntityResponseCollection = {
	__typename?: 'RecycleBinRecycleBinItemEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RecycleBinRecycleBinItem>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<RecycleBinRecycleBinItem>;
	pageInfo: Pagination;
};

export type RecycleBinRecycleBinItemFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<RecycleBinRecycleBinItemFiltersInput>>>;
	contentTypeId?: InputMaybe<IntFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	data?: InputMaybe<JsonFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	model?: InputMaybe<JsonFilterInput>;
	not?: InputMaybe<RecycleBinRecycleBinItemFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RecycleBinRecycleBinItemFiltersInput>>>;
	originalDocumentId?: InputMaybe<StringFilterInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	title?: InputMaybe<StringFilterInput>;
	uid?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RecycleBinRecycleBinItemInput = {
	contentTypeId?: InputMaybe<Scalars['Int']>;
	data?: InputMaybe<Scalars['JSON']>;
	model?: InputMaybe<Scalars['JSON']>;
	originalDocumentId?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	title?: InputMaybe<Scalars['String']>;
	uid?: InputMaybe<Scalars['String']>;
};

export type RedirectsRedirect = {
	__typename?: 'RedirectsRedirect';
	/** @deprecated Use root level fields instead */
	attributes: RedirectsRedirect;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RedirectsRedirect;
	documentId: Scalars['ID'];
	from: Scalars['String'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	isGenerated?: Maybe<Scalars['Boolean']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	to: Scalars['String'];
	type: Enum_Redirectsredirect_Type;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RedirectsRedirectEntityResponseCollection = {
	__typename?: 'RedirectsRedirectEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RedirectsRedirect>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<RedirectsRedirect>;
	pageInfo: Pagination;
};

export type RedirectsRedirectFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<RedirectsRedirectFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	from?: InputMaybe<StringFilterInput>;
	isGenerated?: InputMaybe<BooleanFilterInput>;
	not?: InputMaybe<RedirectsRedirectFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RedirectsRedirectFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	to?: InputMaybe<StringFilterInput>;
	type?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RedirectsRedirectInput = {
	from?: InputMaybe<Scalars['String']>;
	isGenerated?: InputMaybe<Scalars['Boolean']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	to?: InputMaybe<Scalars['String']>;
	type?: InputMaybe<Enum_Redirectsredirect_Type>;
};

export type RegioExpresHomepage = {
	__typename?: 'RegioExpresHomepage';
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresHomepage;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresHomepage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesHomepageHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresHomepage>>;
	localizations_connection?: Maybe<RegioExpresHomepageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegioExpresHomepageModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresHomepageInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesHomepageHeaderInput>;
	modules?: InputMaybe<Array<Scalars['RegioExpresHomepageModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	title?: InputMaybe<Scalars['String']>;
};

export type RegioExpresHomepageModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsRegioExpres
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type RegioExpresHomepageRelationResponseCollection = {
	__typename?: 'RegioExpresHomepageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresHomepage>;
	nodes: Array<RegioExpresHomepage>;
};

export type RegioExpresInConvoOverview = {
	__typename?: 'RegioExpresInConvoOverview';
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresInConvoOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresInConvoOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresInConvoOverview>>;
	localizations_connection?: Maybe<RegioExpresInConvoOverviewRelationResponseCollection>;
	modules: Array<Maybe<RegioExpresInConvoOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresInConvoOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['RegioExpresInConvoOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type RegioExpresInConvoOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesInConvoWithOverview
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type RegioExpresInConvoOverviewRelationResponseCollection = {
	__typename?: 'RegioExpresInConvoOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresInConvoOverview>;
	nodes: Array<RegioExpresInConvoOverview>;
};

export type RegioExpresInConvoWithArticle = {
	__typename?: 'RegioExpresInConvoWithArticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresInConvoWithArticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresInConvoWithArticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresInConvoWithArticle>>;
	localizations_connection?: Maybe<RegioExpresInConvoWithArticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegioExpresInConvoWithArticleModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresInConvoWithArticleLocalizationsArgs = {
	filters?: InputMaybe<RegioExpresInConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresInConvoWithArticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<RegioExpresInConvoWithArticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresInConvoWithArticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresInConvoWithArticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresInConvoWithArticleEntityResponseCollection = {
	__typename?: 'RegioExpresInConvoWithArticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresInConvoWithArticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<RegioExpresInConvoWithArticle>;
	pageInfo: Pagination;
};

export type RegioExpresInConvoWithArticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<RegioExpresInConvoWithArticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<RegioExpresInConvoWithArticleFiltersInput>;
	not?: InputMaybe<RegioExpresInConvoWithArticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RegioExpresInConvoWithArticleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RegioExpresInConvoWithArticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['RegioExpresInConvoWithArticleModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type RegioExpresInConvoWithArticleModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesTestimonial
	| Error;

export type RegioExpresInConvoWithArticleRelationResponseCollection = {
	__typename?: 'RegioExpresInConvoWithArticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresInConvoWithArticle>;
	nodes: Array<RegioExpresInConvoWithArticle>;
};

export type RegioExpresInConvoWithDetail = {
	__typename?: 'RegioExpresInConvoWithDetail';
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresInConvoWithDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresInConvoWithDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresInConvoWithDetail>>;
	localizations_connection?: Maybe<RegioExpresInConvoWithDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegioExpresInConvoWithDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresInConvoWithDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['RegioExpresInConvoWithDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RegioExpresInConvoWithDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type RegioExpresInConvoWithDetailRelationResponseCollection = {
	__typename?: 'RegioExpresInConvoWithDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresInConvoWithDetail>;
	nodes: Array<RegioExpresInConvoWithDetail>;
};

export type RegioExpresInformation = {
	__typename?: 'RegioExpresInformation';
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresInformation;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresInformation;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	footer?: Maybe<ComponentInternalFooter>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresInformation>>;
	localizations_connection?: Maybe<RegioExpresInformationRelationResponseCollection>;
	navbar?: Maybe<ComponentInternalNavbar>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo?: Maybe<ComponentInternalSeo>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresInformationInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	footer?: InputMaybe<ComponentInternalFooterInput>;
	navbar?: InputMaybe<ComponentInternalNavbarInput>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentInternalSeoInput>;
};

export type RegioExpresInformationRelationResponseCollection = {
	__typename?: 'RegioExpresInformationRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresInformation>;
	nodes: Array<RegioExpresInformation>;
};

export type RegioExpresNewsDetail = {
	__typename?: 'RegioExpresNewsDetail';
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresNewsDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresNewsDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresNewsDetail>>;
	localizations_connection?: Maybe<RegioExpresNewsDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegioExpresNewsDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresNewsDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['RegioExpresNewsDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RegioExpresNewsDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsRegioExpres
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| Error;

export type RegioExpresNewsDetailRelationResponseCollection = {
	__typename?: 'RegioExpresNewsDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresNewsDetail>;
	nodes: Array<RegioExpresNewsDetail>;
};

export type RegioExpresNewsOverview = {
	__typename?: 'RegioExpresNewsOverview';
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresNewsOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresNewsOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresNewsOverview>>;
	localizations_connection?: Maybe<RegioExpresNewsOverviewRelationResponseCollection>;
	modules: Array<Maybe<RegioExpresNewsOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresNewsOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['RegioExpresNewsOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type RegioExpresNewsOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesNewsOverview
	| ComponentModulesPhotoAlbum
	| Error;

export type RegioExpresNewsOverviewRelationResponseCollection = {
	__typename?: 'RegioExpresNewsOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresNewsOverview>;
	nodes: Array<RegioExpresNewsOverview>;
};

export type RegioExpresNewsarticle = {
	__typename?: 'RegioExpresNewsarticle';
	allowedOnHomePage?: Maybe<Scalars['Boolean']>;
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresNewsarticle;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresNewsarticle;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresNewsarticle>>;
	localizations_connection?: Maybe<RegioExpresNewsarticleRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegioExpresNewsarticleModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresNewsarticleLocalizationsArgs = {
	filters?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresNewsarticleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresNewsarticleTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresNewsarticleTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresNewsarticleEntityResponseCollection = {
	__typename?: 'RegioExpresNewsarticleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresNewsarticle>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<RegioExpresNewsarticle>;
	pageInfo: Pagination;
};

export type RegioExpresNewsarticleFiltersInput = {
	allowedOnHomePage?: InputMaybe<BooleanFilterInput>;
	and?: InputMaybe<Array<InputMaybe<RegioExpresNewsarticleFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	not?: InputMaybe<RegioExpresNewsarticleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RegioExpresNewsarticleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RegioExpresNewsarticleInput = {
	allowedOnHomePage?: InputMaybe<Scalars['Boolean']>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['RegioExpresNewsarticleModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type RegioExpresNewsarticleModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsRegioExpres
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesShare
	| ComponentModulesTestimonial
	| Error;

export type RegioExpresNewsarticleRelationResponseCollection = {
	__typename?: 'RegioExpresNewsarticleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresNewsarticle>;
	nodes: Array<RegioExpresNewsarticle>;
};

export type RegioExpresPage = {
	__typename?: 'RegioExpresPage';
	/** @deprecated Use root level fields instead */
	attributes: RegioExpresPage;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegioExpresPage;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeaderImage;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegioExpresPage>>;
	localizations_connection?: Maybe<RegioExpresPageRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegioExpresPageModulesDynamicZone>>>;
	parent?: Maybe<RegioExpresPage>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	shortDescription?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegioExpresPageLocalizationsArgs = {
	filters?: InputMaybe<RegioExpresPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresPageLocalizations_ConnectionArgs = {
	filters?: InputMaybe<RegioExpresPageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresPageTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresPageTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegioExpresPageEntityResponseCollection = {
	__typename?: 'RegioExpresPageEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresPage>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<RegioExpresPage>;
	pageInfo: Pagination;
};

export type RegioExpresPageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<RegioExpresPageFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<RegioExpresPageFiltersInput>;
	not?: InputMaybe<RegioExpresPageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RegioExpresPageFiltersInput>>>;
	parent?: InputMaybe<RegioExpresPageFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	shortDescription?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RegioExpresPageInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderImageInput>;
	modules?: InputMaybe<Array<Scalars['RegioExpresPageModulesDynamicZoneInput']>>;
	parent?: InputMaybe<Scalars['ID']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	shortDescription?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type RegioExpresPageModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNewsRegioExpres
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPartners
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesShare
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| ComponentModulesTestimonial
	| Error;

export type RegioExpresPageRelationResponseCollection = {
	__typename?: 'RegioExpresPageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegioExpresPage>;
	nodes: Array<RegioExpresPage>;
};

export type Region = {
	__typename?: 'Region';
	/** @deprecated Use root level fields instead */
	attributes: Region;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Region;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header?: Maybe<ComponentModulesExpandedHeader>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Region>>;
	localizations_connection?: Maybe<RegionRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegionModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegionLocalizationsArgs = {
	filters?: InputMaybe<RegionFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegionLocalizations_ConnectionArgs = {
	filters?: InputMaybe<RegionFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegionTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegionTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RegionDetail = {
	__typename?: 'RegionDetail';
	/** @deprecated Use root level fields instead */
	attributes: RegionDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegionDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegionDetail>>;
	localizations_connection?: Maybe<RegionDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegionDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegionDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['RegionDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RegionDetailModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesThemes
	| Error;

export type RegionDetailRelationResponseCollection = {
	__typename?: 'RegionDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegionDetail>;
	nodes: Array<RegionDetail>;
};

export type RegionEntityResponseCollection = {
	__typename?: 'RegionEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Region>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Region>;
	pageInfo: Pagination;
};

export type RegionFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<RegionFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesExpandedHeaderFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<RegionFiltersInput>;
	not?: InputMaybe<RegionFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RegionFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RegionInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesExpandedHeaderInput>;
	modules?: InputMaybe<Array<Scalars['RegionModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type RegionModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesNewsOverview
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesThemes
	| Error;

export type RegionOverview = {
	__typename?: 'RegionOverview';
	/** @deprecated Use root level fields instead */
	attributes: RegionOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RegionOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RegionOverview>>;
	localizations_connection?: Maybe<RegionOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RegionOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegionOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['RegionOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type RegionOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesThemes
	| Error;

export type RegionOverviewRelationResponseCollection = {
	__typename?: 'RegionOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RegionOverview>;
	nodes: Array<RegionOverview>;
};

export type RegionRelationResponseCollection = {
	__typename?: 'RegionRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Region>;
	nodes: Array<Region>;
};

export type ResponseCollectionMeta = {
	__typename?: 'ResponseCollectionMeta';
	pagination: Pagination;
};

export type ReviewWorkflowsWorkflow = {
	__typename?: 'ReviewWorkflowsWorkflow';
	/** @deprecated Use root level fields instead */
	attributes: ReviewWorkflowsWorkflow;
	contentTypes: Scalars['JSON'];
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ReviewWorkflowsWorkflow;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	name: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
	stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
	stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewWorkflowsWorkflowStagesArgs = {
	filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
	filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
	__typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ReviewWorkflowsWorkflow>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<ReviewWorkflowsWorkflow>;
	pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
	contentTypes?: InputMaybe<JsonFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
	stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
	contentTypes?: InputMaybe<Scalars['JSON']>;
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	stageRequiredToPublish?: InputMaybe<Scalars['ID']>;
	stages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
	__typename?: 'ReviewWorkflowsWorkflowStage';
	/** @deprecated Use root level fields instead */
	attributes: ReviewWorkflowsWorkflowStage;
	color?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ReviewWorkflowsWorkflowStage;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	name?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
	workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
	__typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ReviewWorkflowsWorkflowStage>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<ReviewWorkflowsWorkflowStage>;
	pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
	color?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
	color?: InputMaybe<Scalars['String']>;
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	workflow?: InputMaybe<Scalars['ID']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
	__typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ReviewWorkflowsWorkflowStage>;
	nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type RoadMaintenance = {
	__typename?: 'RoadMaintenance';
	aboutMaintenance: ComponentInternalAboutMaintenance;
	/** @deprecated Use root level fields instead */
	attributes: RoadMaintenance;
	basePath?: Maybe<Scalars['String']>;
	bodyText: ComponentModulesBodyText;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RoadMaintenance;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RoadMaintenance>>;
	localizations_connection?: Maybe<RoadMaintenanceRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RoadMaintenanceModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	roadMaintenanceStatus?: Maybe<Scalars['String']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RoadMaintenanceLocalizationsArgs = {
	filters?: InputMaybe<RoadMaintenanceFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RoadMaintenanceLocalizations_ConnectionArgs = {
	filters?: InputMaybe<RoadMaintenanceFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RoadMaintenanceDetail = {
	__typename?: 'RoadMaintenanceDetail';
	/** @deprecated Use root level fields instead */
	attributes: RoadMaintenanceDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RoadMaintenanceDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RoadMaintenanceDetail>>;
	localizations_connection?: Maybe<RoadMaintenanceDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RoadMaintenanceDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RoadMaintenanceDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['RoadMaintenanceDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RoadMaintenanceDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| Error;

export type RoadMaintenanceDetailRelationResponseCollection = {
	__typename?: 'RoadMaintenanceDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RoadMaintenanceDetail>;
	nodes: Array<RoadMaintenanceDetail>;
};

export type RoadMaintenanceEntityResponseCollection = {
	__typename?: 'RoadMaintenanceEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RoadMaintenance>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<RoadMaintenance>;
	pageInfo: Pagination;
};

export type RoadMaintenanceFiltersInput = {
	aboutMaintenance?: InputMaybe<ComponentInternalAboutMaintenanceFiltersInput>;
	and?: InputMaybe<Array<InputMaybe<RoadMaintenanceFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	bodyText?: InputMaybe<ComponentModulesBodyTextFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderFiltersInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<RoadMaintenanceFiltersInput>;
	not?: InputMaybe<RoadMaintenanceFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<RoadMaintenanceFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	roadMaintenanceStatus?: InputMaybe<StringFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RoadMaintenanceInput = {
	aboutMaintenance?: InputMaybe<ComponentInternalAboutMaintenanceInput>;
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['RoadMaintenanceModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	roadMaintenanceStatus?: InputMaybe<Scalars['String']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	title?: InputMaybe<Scalars['String']>;
};

export type RoadMaintenanceModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesScheduling
	| ComponentModulesShare
	| ComponentModulesStepByStep
	| ComponentModulesTable
	| Error;

export type RoadMaintenanceOverview = {
	__typename?: 'RoadMaintenanceOverview';
	/** @deprecated Use root level fields instead */
	attributes: RoadMaintenanceOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: RoadMaintenanceOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	list: ComponentModulesRoadMaintenanceOverview;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<RoadMaintenanceOverview>>;
	localizations_connection?: Maybe<RoadMaintenanceOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<RoadMaintenanceOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RoadMaintenanceOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	list?: InputMaybe<ComponentModulesRoadMaintenanceOverviewInput>;
	modules?: InputMaybe<Array<Scalars['RoadMaintenanceOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type RoadMaintenanceOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| Error;

export type RoadMaintenanceOverviewRelationResponseCollection = {
	__typename?: 'RoadMaintenanceOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RoadMaintenanceOverview>;
	nodes: Array<RoadMaintenanceOverview>;
};

export type RoadMaintenanceRelationResponseCollection = {
	__typename?: 'RoadMaintenanceRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<RoadMaintenance>;
	nodes: Array<RoadMaintenance>;
};

export type SchedulerScheduler = {
	__typename?: 'SchedulerScheduler';
	/** @deprecated Use root level fields instead */
	attributes: SchedulerScheduler;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SchedulerScheduler;
	datetime?: Maybe<Scalars['DateTime']>;
	documentId: Scalars['ID'];
	entryId: Scalars['String'];
	error?: Maybe<Scalars['String']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	processing?: Maybe<Scalars['String']>;
	processingAt?: Maybe<Scalars['DateTime']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	type: Enum_Schedulerscheduler_Type;
	uid: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SchedulerSchedulerEntityResponseCollection = {
	__typename?: 'SchedulerSchedulerEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SchedulerScheduler>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<SchedulerScheduler>;
	pageInfo: Pagination;
};

export type SchedulerSchedulerFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<SchedulerSchedulerFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	datetime?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	entryId?: InputMaybe<StringFilterInput>;
	error?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<SchedulerSchedulerFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<SchedulerSchedulerFiltersInput>>>;
	processing?: InputMaybe<StringFilterInput>;
	processingAt?: InputMaybe<DateTimeFilterInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	type?: InputMaybe<StringFilterInput>;
	uid?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SchedulerSchedulerInput = {
	datetime?: InputMaybe<Scalars['DateTime']>;
	entryId?: InputMaybe<Scalars['String']>;
	error?: InputMaybe<Scalars['String']>;
	processing?: InputMaybe<Scalars['String']>;
	processingAt?: InputMaybe<Scalars['DateTime']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	type?: InputMaybe<Enum_Schedulerscheduler_Type>;
	uid?: InputMaybe<Scalars['String']>;
};

export type SdgLocatie = {
	__typename?: 'SdgLocatie';
	/** @deprecated Use root level fields instead */
	attributes: SdgLocatie;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SdgLocatie;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	land: Scalars['String'];
	naam: Scalars['String'];
	nummer: Scalars['String'];
	openingstijdDinsdag?: Maybe<Scalars['String']>;
	openingstijdDonderdag?: Maybe<Scalars['String']>;
	openingstijdMaandag?: Maybe<Scalars['String']>;
	openingstijdVrijdag?: Maybe<Scalars['String']>;
	openingstijdWoensdag?: Maybe<Scalars['String']>;
	openingstijdZaterdag?: Maybe<Scalars['String']>;
	openingstijdZondag?: Maybe<Scalars['String']>;
	openingstijdenOpmerking?: Maybe<Scalars['String']>;
	organisatie: Scalars['JSON'];
	plaats: Scalars['String'];
	postcode: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	straat: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
	url?: Maybe<Scalars['String']>;
};

export type SdgLocatieEntityResponseCollection = {
	__typename?: 'SdgLocatieEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SdgLocatie>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<SdgLocatie>;
	pageInfo: Pagination;
};

export type SdgLocatieFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<SdgLocatieFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	land?: InputMaybe<StringFilterInput>;
	naam?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<SdgLocatieFiltersInput>;
	nummer?: InputMaybe<StringFilterInput>;
	openingstijdDinsdag?: InputMaybe<StringFilterInput>;
	openingstijdDonderdag?: InputMaybe<StringFilterInput>;
	openingstijdMaandag?: InputMaybe<StringFilterInput>;
	openingstijdVrijdag?: InputMaybe<StringFilterInput>;
	openingstijdWoensdag?: InputMaybe<StringFilterInput>;
	openingstijdZaterdag?: InputMaybe<StringFilterInput>;
	openingstijdZondag?: InputMaybe<StringFilterInput>;
	openingstijdenOpmerking?: InputMaybe<StringFilterInput>;
	or?: InputMaybe<Array<InputMaybe<SdgLocatieFiltersInput>>>;
	organisatie?: InputMaybe<JsonFilterInput>;
	plaats?: InputMaybe<StringFilterInput>;
	postcode?: InputMaybe<StringFilterInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	straat?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	url?: InputMaybe<StringFilterInput>;
};

export type SdgLocatieInput = {
	land?: InputMaybe<Scalars['String']>;
	naam?: InputMaybe<Scalars['String']>;
	nummer?: InputMaybe<Scalars['String']>;
	openingstijdDinsdag?: InputMaybe<Scalars['String']>;
	openingstijdDonderdag?: InputMaybe<Scalars['String']>;
	openingstijdMaandag?: InputMaybe<Scalars['String']>;
	openingstijdVrijdag?: InputMaybe<Scalars['String']>;
	openingstijdWoensdag?: InputMaybe<Scalars['String']>;
	openingstijdZaterdag?: InputMaybe<Scalars['String']>;
	openingstijdZondag?: InputMaybe<Scalars['String']>;
	openingstijdenOpmerking?: InputMaybe<Scalars['String']>;
	organisatie?: InputMaybe<Scalars['JSON']>;
	plaats?: InputMaybe<Scalars['String']>;
	postcode?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	straat?: InputMaybe<Scalars['String']>;
	url?: InputMaybe<Scalars['String']>;
};

export type SdgLocatieRelationResponseCollection = {
	__typename?: 'SdgLocatieRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SdgLocatie>;
	nodes: Array<SdgLocatie>;
};

export type SdgSdg = {
	__typename?: 'SdgSdg';
	/** @deprecated Use root level fields instead */
	attributes: SdgSdg;
	bevoegdeOrganisatie?: Maybe<Scalars['JSON']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SdgSdg;
	documentId: Scalars['ID'];
	doelgroepBedrijf?: Maybe<Scalars['Boolean']>;
	doelgroepBurger?: Maybe<Scalars['Boolean']>;
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locaties: Array<Maybe<SdgLocatie>>;
	locaties_connection?: Maybe<SdgLocatieRelationResponseCollection>;
	productAanwezig: Scalars['Boolean'];
	productValtOnder?: Maybe<SdgSdg>;
	publicatieDatum: Scalars['Date'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	titel?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
	upl?: Maybe<Scalars['String']>;
	verantwoordelijkeOrganisatie: Scalars['JSON'];
	vertalingen?: Maybe<Array<Maybe<ComponentSdgSdgProductVertaling>>>;
};

export type SdgSdgLocatiesArgs = {
	filters?: InputMaybe<SdgLocatieFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SdgSdgLocaties_ConnectionArgs = {
	filters?: InputMaybe<SdgLocatieFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SdgSdgVertalingenArgs = {
	filters?: InputMaybe<ComponentSdgSdgProductVertalingFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SdgSdgEntityResponseCollection = {
	__typename?: 'SdgSdgEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SdgSdg>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<SdgSdg>;
	pageInfo: Pagination;
};

export type SdgSdgFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<SdgSdgFiltersInput>>>;
	bevoegdeOrganisatie?: InputMaybe<JsonFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	doelgroepBedrijf?: InputMaybe<BooleanFilterInput>;
	doelgroepBurger?: InputMaybe<BooleanFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	locaties?: InputMaybe<SdgLocatieFiltersInput>;
	not?: InputMaybe<SdgSdgFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<SdgSdgFiltersInput>>>;
	productAanwezig?: InputMaybe<BooleanFilterInput>;
	productValtOnder?: InputMaybe<SdgSdgFiltersInput>;
	publicatieDatum?: InputMaybe<DateFilterInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	titel?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	upl?: InputMaybe<StringFilterInput>;
	verantwoordelijkeOrganisatie?: InputMaybe<JsonFilterInput>;
	vertalingen?: InputMaybe<ComponentSdgSdgProductVertalingFiltersInput>;
};

export type SdgSdgInput = {
	bevoegdeOrganisatie?: InputMaybe<Scalars['JSON']>;
	doelgroepBedrijf?: InputMaybe<Scalars['Boolean']>;
	doelgroepBurger?: InputMaybe<Scalars['Boolean']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	locaties?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	productAanwezig?: InputMaybe<Scalars['Boolean']>;
	productValtOnder?: InputMaybe<Scalars['ID']>;
	publicatieDatum?: InputMaybe<Scalars['Date']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	titel?: InputMaybe<Scalars['String']>;
	upl?: InputMaybe<Scalars['String']>;
	verantwoordelijkeOrganisatie?: InputMaybe<Scalars['JSON']>;
	vertalingen?: InputMaybe<Array<InputMaybe<ComponentSdgSdgProductVertalingInput>>>;
};

export type SdgUplLijst = {
	__typename?: 'SdgUplLijst';
	/** @deprecated Use root level fields instead */
	attributes: SdgUplLijst;
	bedrijf?: Maybe<Scalars['Boolean']>;
	burger?: Maybe<Scalars['Boolean']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SdgUplLijst;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	uniformeProductnaam?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
	uri?: Maybe<Scalars['String']>;
};

export type SdgUplLijstEntityResponseCollection = {
	__typename?: 'SdgUplLijstEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SdgUplLijst>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<SdgUplLijst>;
	pageInfo: Pagination;
};

export type SdgUplLijstFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<SdgUplLijstFiltersInput>>>;
	bedrijf?: InputMaybe<BooleanFilterInput>;
	burger?: InputMaybe<BooleanFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	not?: InputMaybe<SdgUplLijstFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<SdgUplLijstFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	uniformeProductnaam?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	uri?: InputMaybe<StringFilterInput>;
};

export type SdgUplLijstInput = {
	bedrijf?: InputMaybe<Scalars['Boolean']>;
	burger?: InputMaybe<Scalars['Boolean']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	uniformeProductnaam?: InputMaybe<Scalars['String']>;
	uri?: InputMaybe<Scalars['String']>;
};

export type SearchOverview = {
	__typename?: 'SearchOverview';
	Zoekresultaten: ComponentModulesSearchOverview;
	/** @deprecated Use root level fields instead */
	attributes: SearchOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SearchOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<SearchOverview>>;
	localizations_connection?: Maybe<SearchOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<SearchOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	searchHeader?: Maybe<ComponentModulesSearchHeader>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SearchOverviewInput = {
	Zoekresultaten?: InputMaybe<ComponentModulesSearchOverviewInput>;
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['SearchOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	searchHeader?: InputMaybe<ComponentModulesSearchHeaderInput>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type SearchOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| Error;

export type SearchOverviewRelationResponseCollection = {
	__typename?: 'SearchOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SearchOverview>;
	nodes: Array<SearchOverview>;
};

export type SearchResult = {
	__typename?: 'SearchResult';
	createdAt?: Maybe<Scalars['String']>;
	excerpt?: Maybe<Scalars['String']>;
	fullPath?: Maybe<Scalars['String']>;
	id: Scalars['String'];
	searchSortKey?: Maybe<Scalars['String']>;
	title: Scalars['String'];
};

export type Sitemap = {
	__typename?: 'Sitemap';
	/** @deprecated Use root level fields instead */
	attributes: Sitemap;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Sitemap;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Sitemap>>;
	localizations_connection?: Maybe<SitemapRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<SitemapModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SitemapInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['SitemapModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type SitemapModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| Error;

export type SitemapPage = {
	__typename?: 'SitemapPage';
	slug?: Maybe<Scalars['String']>;
	title?: Maybe<Scalars['String']>;
	updated_at?: Maybe<Scalars['String']>;
};

export type SitemapRelationResponseCollection = {
	__typename?: 'SitemapRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Sitemap>;
	nodes: Array<Sitemap>;
};

export type SlugConfig = {
	__typename?: 'SlugConfig';
	/** The base path for the slug configuration. */
	basePath?: Maybe<Scalars['String']>;
};

export type SlugItem = {
	__typename?: 'SlugItem';
	/** The slug of the document */
	documentId: Scalars['String'];
	/** The UID of the content type */
	locale?: Maybe<Scalars['String']>;
	/** The slug of the document */
	slug: Scalars['String'];
};

export type StringFilterInput = {
	and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	contains?: InputMaybe<Scalars['String']>;
	containsi?: InputMaybe<Scalars['String']>;
	endsWith?: InputMaybe<Scalars['String']>;
	eq?: InputMaybe<Scalars['String']>;
	eqi?: InputMaybe<Scalars['String']>;
	gt?: InputMaybe<Scalars['String']>;
	gte?: InputMaybe<Scalars['String']>;
	in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	lt?: InputMaybe<Scalars['String']>;
	lte?: InputMaybe<Scalars['String']>;
	ne?: InputMaybe<Scalars['String']>;
	nei?: InputMaybe<Scalars['String']>;
	not?: InputMaybe<StringFilterInput>;
	notContains?: InputMaybe<Scalars['String']>;
	notContainsi?: InputMaybe<Scalars['String']>;
	notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	notNull?: InputMaybe<Scalars['Boolean']>;
	null?: InputMaybe<Scalars['Boolean']>;
	or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
	startsWith?: InputMaybe<Scalars['String']>;
};

export type Subsidy = {
	__typename?: 'Subsidy';
	/** @deprecated Use root level fields instead */
	attributes: Subsidy;
	audience: Scalars['String'];
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Subsidy;
	documentId: Scalars['ID'];
	endDate?: Maybe<Scalars['DateTime']>;
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header: ComponentModulesIntroHeader;
	hideFromOverview: Scalars['Boolean'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Subsidy>>;
	localizations_connection?: Maybe<SubsidyRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<SubsidyModulesDynamicZone>>>;
	onlineRequest?: Maybe<Scalars['Boolean']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	subsidyCeiling?: Maybe<Scalars['String']>;
	subsidy_kinds: Array<Maybe<SubsidyKind>>;
	subsidy_kinds_connection?: Maybe<SubsidyKindRelationResponseCollection>;
	subsidy_scales: Array<Maybe<SubsidyScale>>;
	subsidy_scales_connection?: Maybe<SubsidyScaleRelationResponseCollection>;
	subsidystatus: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	targetGroupText?: Maybe<Scalars['String']>;
	target_groups: Array<Maybe<TargetGroup>>;
	target_groups_connection?: Maybe<TargetGroupRelationResponseCollection>;
	themes: Array<Maybe<Theme>>;
	themes_connection?: Maybe<ThemeRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
	upls: Array<Maybe<Upl>>;
	upls_connection?: Maybe<UplRelationResponseCollection>;
};

export type SubsidyLocalizationsArgs = {
	filters?: InputMaybe<SubsidyFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyLocalizations_ConnectionArgs = {
	filters?: InputMaybe<SubsidyFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidySubsidy_KindsArgs = {
	filters?: InputMaybe<SubsidyKindFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidySubsidy_Kinds_ConnectionArgs = {
	filters?: InputMaybe<SubsidyKindFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidySubsidy_ScalesArgs = {
	filters?: InputMaybe<SubsidyScaleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidySubsidy_Scales_ConnectionArgs = {
	filters?: InputMaybe<SubsidyScaleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyTarget_GroupsArgs = {
	filters?: InputMaybe<TargetGroupFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyTarget_Groups_ConnectionArgs = {
	filters?: InputMaybe<TargetGroupFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyThemesArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyThemes_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyUplsArgs = {
	filters?: InputMaybe<UplFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyUpls_ConnectionArgs = {
	filters?: InputMaybe<UplFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyDetail = {
	__typename?: 'SubsidyDetail';
	/** @deprecated Use root level fields instead */
	attributes: SubsidyDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SubsidyDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<SubsidyDetail>>;
	localizations_connection?: Maybe<SubsidyDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<SubsidyDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	showInOverview?: Maybe<Scalars['Boolean']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubsidyDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['SubsidyDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	showInOverview?: InputMaybe<Scalars['Boolean']>;
};

export type SubsidyDetailModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesThemes
	| Error;

export type SubsidyDetailRelationResponseCollection = {
	__typename?: 'SubsidyDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SubsidyDetail>;
	nodes: Array<SubsidyDetail>;
};

export type SubsidyEntityResponseCollection = {
	__typename?: 'SubsidyEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Subsidy>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Subsidy>;
	pageInfo: Pagination;
};

export type SubsidyFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<SubsidyFiltersInput>>>;
	audience?: InputMaybe<StringFilterInput>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	endDate?: InputMaybe<DateTimeFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesIntroHeaderFiltersInput>;
	hideFromOverview?: InputMaybe<BooleanFilterInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<SubsidyFiltersInput>;
	not?: InputMaybe<SubsidyFiltersInput>;
	onlineRequest?: InputMaybe<BooleanFilterInput>;
	or?: InputMaybe<Array<InputMaybe<SubsidyFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	subsidyCeiling?: InputMaybe<StringFilterInput>;
	subsidy_kinds?: InputMaybe<SubsidyKindFiltersInput>;
	subsidy_scales?: InputMaybe<SubsidyScaleFiltersInput>;
	subsidystatus?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	targetGroupText?: InputMaybe<StringFilterInput>;
	target_groups?: InputMaybe<TargetGroupFiltersInput>;
	themes?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	upls?: InputMaybe<UplFiltersInput>;
};

export type SubsidyInput = {
	audience?: InputMaybe<Scalars['String']>;
	basePath?: InputMaybe<Scalars['String']>;
	endDate?: InputMaybe<Scalars['DateTime']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	hideFromOverview?: InputMaybe<Scalars['Boolean']>;
	keywords?: InputMaybe<Scalars['String']>;
	modules?: InputMaybe<Array<Scalars['SubsidyModulesDynamicZoneInput']>>;
	onlineRequest?: InputMaybe<Scalars['Boolean']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	subsidyCeiling?: InputMaybe<Scalars['String']>;
	subsidy_kinds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	subsidy_scales?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	subsidystatus?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	targetGroupText?: InputMaybe<Scalars['String']>;
	target_groups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	themes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
	upls?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SubsidyKind = {
	__typename?: 'SubsidyKind';
	/** @deprecated Use root level fields instead */
	attributes: SubsidyKind;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SubsidyKind;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<SubsidyKind>>;
	localizations_connection?: Maybe<SubsidyKindRelationResponseCollection>;
	name?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubsidyKindLocalizationsArgs = {
	filters?: InputMaybe<SubsidyKindFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyKindLocalizations_ConnectionArgs = {
	filters?: InputMaybe<SubsidyKindFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyKindEntityResponseCollection = {
	__typename?: 'SubsidyKindEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SubsidyKind>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<SubsidyKind>;
	pageInfo: Pagination;
};

export type SubsidyKindFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<SubsidyKindFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<SubsidyKindFiltersInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<SubsidyKindFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<SubsidyKindFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubsidyKindInput = {
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubsidyKindRelationResponseCollection = {
	__typename?: 'SubsidyKindRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SubsidyKind>;
	nodes: Array<SubsidyKind>;
};

export type SubsidyModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesThemes
	| Error;

export type SubsidyOverview = {
	__typename?: 'SubsidyOverview';
	/** @deprecated Use root level fields instead */
	attributes: SubsidyOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SubsidyOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<SubsidyOverview>>;
	localizations_connection?: Maybe<SubsidyOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<SubsidyOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubsidyOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['SubsidyOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type SubsidyOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesSubjects
	| ComponentModulesSubsidyOverview
	| ComponentModulesThemes
	| Error;

export type SubsidyOverviewRelationResponseCollection = {
	__typename?: 'SubsidyOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SubsidyOverview>;
	nodes: Array<SubsidyOverview>;
};

export type SubsidyRelationResponseCollection = {
	__typename?: 'SubsidyRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Subsidy>;
	nodes: Array<Subsidy>;
};

export type SubsidyScale = {
	__typename?: 'SubsidyScale';
	/** @deprecated Use root level fields instead */
	attributes: SubsidyScale;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: SubsidyScale;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<SubsidyScale>>;
	localizations_connection?: Maybe<SubsidyScaleRelationResponseCollection>;
	name?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubsidyScaleLocalizationsArgs = {
	filters?: InputMaybe<SubsidyScaleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyScaleLocalizations_ConnectionArgs = {
	filters?: InputMaybe<SubsidyScaleFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubsidyScaleEntityResponseCollection = {
	__typename?: 'SubsidyScaleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SubsidyScale>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<SubsidyScale>;
	pageInfo: Pagination;
};

export type SubsidyScaleFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<SubsidyScaleFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<SubsidyScaleFiltersInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<SubsidyScaleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<SubsidyScaleFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubsidyScaleInput = {
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SubsidyScaleRelationResponseCollection = {
	__typename?: 'SubsidyScaleRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<SubsidyScale>;
	nodes: Array<SubsidyScale>;
};

export type Tag = {
	__typename?: 'Tag';
	/** @deprecated Use root level fields instead */
	attributes: Tag;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Tag;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Tag>>;
	localizations_connection?: Maybe<TagRelationResponseCollection>;
	name: Scalars['String'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagLocalizationsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TagLocalizations_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TagEntityResponseCollection = {
	__typename?: 'TagEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Tag>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Tag>;
	pageInfo: Pagination;
};

export type TagFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<TagFiltersInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<TagFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<TagFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TagInput = {
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TagRelationResponseCollection = {
	__typename?: 'TagRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Tag>;
	nodes: Array<Tag>;
};

export type TargetGroup = {
	__typename?: 'TargetGroup';
	/** @deprecated Use root level fields instead */
	attributes: TargetGroup;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: TargetGroup;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<TargetGroup>>;
	localizations_connection?: Maybe<TargetGroupRelationResponseCollection>;
	name?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TargetGroupLocalizationsArgs = {
	filters?: InputMaybe<TargetGroupFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TargetGroupLocalizations_ConnectionArgs = {
	filters?: InputMaybe<TargetGroupFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TargetGroupEntityResponseCollection = {
	__typename?: 'TargetGroupEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<TargetGroup>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<TargetGroup>;
	pageInfo: Pagination;
};

export type TargetGroupFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<TargetGroupFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<TargetGroupFiltersInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<TargetGroupFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<TargetGroupFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TargetGroupInput = {
	name?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TargetGroupRelationResponseCollection = {
	__typename?: 'TargetGroupRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<TargetGroup>;
	nodes: Array<TargetGroup>;
};

export type Theme = {
	__typename?: 'Theme';
	/** @deprecated Use root level fields instead */
	attributes: Theme;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Theme;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	header?: Maybe<ComponentModulesExpandedHeader>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<Theme>>;
	localizations_connection?: Maybe<ThemeRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<ThemeModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	slug: Scalars['String'];
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ThemeLocalizationsArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThemeLocalizations_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThemeTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThemeTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ThemeDetail = {
	__typename?: 'ThemeDetail';
	/** @deprecated Use root level fields instead */
	attributes: ThemeDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ThemeDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<ThemeDetail>>;
	localizations_connection?: Maybe<ThemeDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<ThemeDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ThemeDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['ThemeDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ThemeDetailModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesThemes
	| Error;

export type ThemeDetailRelationResponseCollection = {
	__typename?: 'ThemeDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ThemeDetail>;
	nodes: Array<ThemeDetail>;
};

export type ThemeEntityResponseCollection = {
	__typename?: 'ThemeEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Theme>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Theme>;
	pageInfo: Pagination;
};

export type ThemeFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<ThemeFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	header?: InputMaybe<ComponentModulesExpandedHeaderFiltersInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<ThemeFiltersInput>;
	not?: InputMaybe<ThemeFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<ThemeFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	seo?: InputMaybe<ComponentModulesSeoFiltersInput>;
	slug?: InputMaybe<StringFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ThemeInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	header?: InputMaybe<ComponentModulesExpandedHeaderInput>;
	modules?: InputMaybe<Array<Scalars['ThemeModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
	slug?: InputMaybe<Scalars['String']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
};

export type ThemeModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesNewsOverview
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesThemes
	| Error;

export type ThemeOverview = {
	__typename?: 'ThemeOverview';
	/** @deprecated Use root level fields instead */
	attributes: ThemeOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: ThemeOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<ThemeOverview>>;
	localizations_connection?: Maybe<ThemeOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<ThemeOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ThemeOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['ThemeOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type ThemeOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesRegions
	| ComponentModulesScheduling
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| ComponentModulesTable
	| ComponentModulesThemes
	| Error;

export type ThemeOverviewRelationResponseCollection = {
	__typename?: 'ThemeOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<ThemeOverview>;
	nodes: Array<ThemeOverview>;
};

export type ThemeRelationResponseCollection = {
	__typename?: 'ThemeRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Theme>;
	nodes: Array<Theme>;
};

export type Upl = {
	__typename?: 'Upl';
	URI?: Maybe<Scalars['String']>;
	UniformeProductnaam?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	attributes: Upl;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: Upl;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UplEntityResponseCollection = {
	__typename?: 'UplEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Upl>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<Upl>;
	pageInfo: Pagination;
};

export type UplFiltersInput = {
	URI?: InputMaybe<StringFilterInput>;
	UniformeProductnaam?: InputMaybe<StringFilterInput>;
	and?: InputMaybe<Array<InputMaybe<UplFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	not?: InputMaybe<UplFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<UplFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UplInput = {
	URI?: InputMaybe<Scalars['String']>;
	UniformeProductnaam?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UplRelationResponseCollection = {
	__typename?: 'UplRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<Upl>;
	nodes: Array<Upl>;
};

export type UploadFile = {
	__typename?: 'UploadFile';
	alternativeText?: Maybe<Scalars['String']>;
	/** @deprecated Use root level fields instead */
	attributes: UploadFile;
	caption?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: UploadFile;
	documentId: Scalars['ID'];
	ext?: Maybe<Scalars['String']>;
	focalPoint?: Maybe<Scalars['JSON']>;
	formats?: Maybe<Scalars['JSON']>;
	hash: Scalars['String'];
	height?: Maybe<Scalars['Int']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	mime: Scalars['String'];
	name: Scalars['String'];
	previewUrl?: Maybe<Scalars['String']>;
	provider: Scalars['String'];
	provider_metadata?: Maybe<Scalars['JSON']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	related?: Maybe<Array<Maybe<GenericMorph>>>;
	size: Scalars['Float'];
	updatedAt?: Maybe<Scalars['DateTime']>;
	url: Scalars['String'];
	width?: Maybe<Scalars['Int']>;
};

export type UploadFileEntityResponseCollection = {
	__typename?: 'UploadFileEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<UploadFile>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<UploadFile>;
	pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
	alternativeText?: InputMaybe<StringFilterInput>;
	and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
	caption?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	ext?: InputMaybe<StringFilterInput>;
	focalPoint?: InputMaybe<JsonFilterInput>;
	formats?: InputMaybe<JsonFilterInput>;
	hash?: InputMaybe<StringFilterInput>;
	height?: InputMaybe<IntFilterInput>;
	mime?: InputMaybe<StringFilterInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<UploadFileFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
	previewUrl?: InputMaybe<StringFilterInput>;
	provider?: InputMaybe<StringFilterInput>;
	provider_metadata?: InputMaybe<JsonFilterInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	size?: InputMaybe<FloatFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	url?: InputMaybe<StringFilterInput>;
	width?: InputMaybe<IntFilterInput>;
};

export type UploadFileRelationResponseCollection = {
	__typename?: 'UploadFileRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<UploadFile>;
	nodes: Array<UploadFile>;
};

export type UsersPermissionsCreateRolePayload = {
	__typename?: 'UsersPermissionsCreateRolePayload';
	ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
	__typename?: 'UsersPermissionsDeleteRolePayload';
	ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
	identifier: Scalars['String'];
	password: Scalars['String'];
	provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
	__typename?: 'UsersPermissionsLoginPayload';
	jwt?: Maybe<Scalars['String']>;
	user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
	__typename?: 'UsersPermissionsMe';
	blocked?: Maybe<Scalars['Boolean']>;
	confirmed?: Maybe<Scalars['Boolean']>;
	documentId: Scalars['ID'];
	email?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	role?: Maybe<UsersPermissionsMeRole>;
	username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
	__typename?: 'UsersPermissionsMeRole';
	description?: Maybe<Scalars['String']>;
	id: Scalars['ID'];
	name: Scalars['String'];
	type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
	__typename?: 'UsersPermissionsPasswordPayload';
	ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
	__typename?: 'UsersPermissionsPermission';
	action: Scalars['String'];
	/** @deprecated Use root level fields instead */
	attributes: UsersPermissionsPermission;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: UsersPermissionsPermission;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	role?: Maybe<UsersPermissionsRole>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionFiltersInput = {
	action?: InputMaybe<StringFilterInput>;
	and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
	__typename?: 'UsersPermissionsPermissionRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<UsersPermissionsPermission>;
	nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
	email: Scalars['String'];
	password: Scalars['String'];
	username: Scalars['String'];
};

export type UsersPermissionsRole = {
	__typename?: 'UsersPermissionsRole';
	/** @deprecated Use root level fields instead */
	attributes: UsersPermissionsRole;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: UsersPermissionsRole;
	description?: Maybe<Scalars['String']>;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	name: Scalars['String'];
	permissions: Array<Maybe<UsersPermissionsPermission>>;
	permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	type?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
	users: Array<Maybe<UsersPermissionsUser>>;
	users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};

export type UsersPermissionsRolePermissionsArgs = {
	filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRolePermissions_ConnectionArgs = {
	filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleUsersArgs = {
	filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleUsers_ConnectionArgs = {
	filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
	__typename?: 'UsersPermissionsRoleEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<UsersPermissionsRole>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<UsersPermissionsRole>;
	pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	description?: InputMaybe<StringFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	name?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
	permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	type?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
	description?: InputMaybe<Scalars['String']>;
	name?: InputMaybe<Scalars['String']>;
	permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	type?: InputMaybe<Scalars['String']>;
	users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
	__typename?: 'UsersPermissionsUpdateRolePayload';
	ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
	__typename?: 'UsersPermissionsUser';
	/** @deprecated Use root level fields instead */
	attributes: UsersPermissionsUser;
	blocked?: Maybe<Scalars['Boolean']>;
	confirmed?: Maybe<Scalars['Boolean']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: UsersPermissionsUser;
	documentId: Scalars['ID'];
	email: Scalars['String'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	provider?: Maybe<Scalars['String']>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	role?: Maybe<UsersPermissionsRole>;
	updatedAt?: Maybe<Scalars['DateTime']>;
	username: Scalars['String'];
};

export type UsersPermissionsUserEntityResponse = {
	__typename?: 'UsersPermissionsUserEntityResponse';
	data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
	__typename?: 'UsersPermissionsUserEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<UsersPermissionsUser>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<UsersPermissionsUser>;
	pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
	blocked?: InputMaybe<BooleanFilterInput>;
	confirmed?: InputMaybe<BooleanFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	email?: InputMaybe<StringFilterInput>;
	not?: InputMaybe<UsersPermissionsUserFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
	provider?: InputMaybe<StringFilterInput>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
	blocked?: InputMaybe<Scalars['Boolean']>;
	confirmed?: InputMaybe<Scalars['Boolean']>;
	email?: InputMaybe<Scalars['String']>;
	password?: InputMaybe<Scalars['String']>;
	provider?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	role?: InputMaybe<Scalars['ID']>;
	username?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
	__typename?: 'UsersPermissionsUserRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<UsersPermissionsUser>;
	nodes: Array<UsersPermissionsUser>;
};

export type VacancyDetail = {
	__typename?: 'VacancyDetail';
	/** @deprecated Use root level fields instead */
	attributes: VacancyDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: VacancyDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<VacancyDetail>>;
	localizations_connection?: Maybe<VacancyDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<VacancyDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	share?: Maybe<ComponentModulesShare>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VacancyDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['VacancyDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	share?: InputMaybe<ComponentModulesShareInput>;
};

export type VacancyDetailModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesSubjects
	| Error;

export type VacancyDetailRelationResponseCollection = {
	__typename?: 'VacancyDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<VacancyDetail>;
	nodes: Array<VacancyDetail>;
};

export type VacancyInternalDetail = {
	__typename?: 'VacancyInternalDetail';
	/** @deprecated Use root level fields instead */
	attributes: VacancyInternalDetail;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: VacancyInternalDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<VacancyInternalDetail>>;
	localizations_connection?: Maybe<VacancyInternalDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<VacancyInternalDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VacancyInternalDetailInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['VacancyInternalDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type VacancyInternalDetailModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesFeaturedNews
	| ComponentModulesFeaturedPages
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesSubjects
	| Error;

export type VacancyInternalDetailRelationResponseCollection = {
	__typename?: 'VacancyInternalDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<VacancyInternalDetail>;
	nodes: Array<VacancyInternalDetail>;
};

export type VacancyInternalOverview = {
	__typename?: 'VacancyInternalOverview';
	/** @deprecated Use root level fields instead */
	attributes: VacancyInternalOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: VacancyInternalOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<VacancyInternalOverview>>;
	localizations_connection?: Maybe<VacancyInternalOverviewRelationResponseCollection>;
	modules: Array<Maybe<VacancyInternalOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VacancyInternalOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['VacancyInternalOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type VacancyInternalOverviewModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesVacanciesOverview
	| Error;

export type VacancyInternalOverviewRelationResponseCollection = {
	__typename?: 'VacancyInternalOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<VacancyInternalOverview>;
	nodes: Array<VacancyInternalOverview>;
};

export type VacancyOverview = {
	__typename?: 'VacancyOverview';
	/** @deprecated Use root level fields instead */
	attributes: VacancyOverview;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: VacancyOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<VacancyOverview>>;
	localizations_connection?: Maybe<VacancyOverviewRelationResponseCollection>;
	modules: Array<Maybe<VacancyOverviewModulesDynamicZone>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VacancyOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['VacancyOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type VacancyOverviewModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesVacanciesOverview
	| Error;

export type VacancyOverviewRelationResponseCollection = {
	__typename?: 'VacancyOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<VacancyOverview>;
	nodes: Array<VacancyOverview>;
};

export type VersioningHistory = {
	__typename?: 'VersioningHistory';
	/** @deprecated Use root level fields instead */
	attributes: VersioningHistory;
	contentType?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	data?: Maybe<Scalars['JSON']>;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	relatedDocumentId?: Maybe<Scalars['String']>;
	schema?: Maybe<Scalars['JSON']>;
	status?: Maybe<Scalars['String']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type VersioningHistoryEntityResponseCollection = {
	__typename?: 'VersioningHistoryEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<VersioningHistory>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<VersioningHistory>;
	pageInfo: Pagination;
};

export type VersioningHistoryFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<VersioningHistoryFiltersInput>>>;
	contentType?: InputMaybe<StringFilterInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	data?: InputMaybe<JsonFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	not?: InputMaybe<VersioningHistoryFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<VersioningHistoryFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	relatedDocumentId?: InputMaybe<StringFilterInput>;
	schema?: InputMaybe<JsonFilterInput>;
	status?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type VersioningHistoryInput = {
	contentType?: InputMaybe<Scalars['String']>;
	data?: InputMaybe<Scalars['JSON']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	relatedDocumentId?: InputMaybe<Scalars['String']>;
	schema?: InputMaybe<Scalars['JSON']>;
	status?: InputMaybe<Scalars['String']>;
};

export type WobRequest = {
	__typename?: 'WobRequest';
	/** @deprecated Use root level fields instead */
	attributes: WobRequest;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: WobRequest;
	date?: Maybe<Scalars['Date']>;
	documentId: Scalars['ID'];
	files: Array<Maybe<UploadFile>>;
	files_connection?: Maybe<UploadFileRelationResponseCollection>;
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<WobRequest>>;
	localizations_connection?: Maybe<WobRequestRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	tags: Array<Maybe<Tag>>;
	tags_connection?: Maybe<TagRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
	zip?: Maybe<Scalars['JSON']>;
};

export type WobRequestFilesArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WobRequestFiles_ConnectionArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WobRequestLocalizationsArgs = {
	filters?: InputMaybe<WobRequestFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WobRequestLocalizations_ConnectionArgs = {
	filters?: InputMaybe<WobRequestFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WobRequestTagsArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WobRequestTags_ConnectionArgs = {
	filters?: InputMaybe<TagFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WobRequestEntityResponseCollection = {
	__typename?: 'WobRequestEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WobRequest>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<WobRequest>;
	pageInfo: Pagination;
};

export type WobRequestFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<WobRequestFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	date?: InputMaybe<DateFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<WobRequestFiltersInput>;
	not?: InputMaybe<WobRequestFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<WobRequestFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	tags?: InputMaybe<TagFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	zip?: InputMaybe<JsonFilterInput>;
};

export type WobRequestInput = {
	date?: InputMaybe<Scalars['Date']>;
	files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
	zip?: InputMaybe<Scalars['JSON']>;
};

export type WobRequestOverview = {
	__typename?: 'WobRequestOverview';
	/** @deprecated Use root level fields instead */
	attributes: WobRequestOverview;
	basePath?: Maybe<Scalars['String']>;
	bodyText?: Maybe<ComponentModulesBodyText>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: WobRequestOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	list: ComponentModulesWobRequestOverview;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<WobRequestOverview>>;
	localizations_connection?: Maybe<WobRequestOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<WobRequestOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WobRequestOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	list?: InputMaybe<ComponentModulesWobRequestOverviewInput>;
	modules?: InputMaybe<Array<Scalars['WobRequestOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type WobRequestOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| Error;

export type WobRequestOverviewRelationResponseCollection = {
	__typename?: 'WobRequestOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WobRequestOverview>;
	nodes: Array<WobRequestOverview>;
};

export type WobRequestRelationResponseCollection = {
	__typename?: 'WobRequestRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WobRequest>;
	nodes: Array<WobRequest>;
};

export type WooCategory = {
	__typename?: 'WooCategory';
	/** @deprecated Use root level fields instead */
	attributes: WooCategory;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: WooCategory;
	documentId: Scalars['ID'];
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	publishedAt?: Maybe<Scalars['DateTime']>;
	resource: Scalars['String'];
	sitemap: Scalars['String'];
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WooCategoryCount = {
	__typename?: 'WooCategoryCount';
	count?: Maybe<Scalars['Int']>;
	sitemap?: Maybe<Scalars['String']>;
};

export type WooCategoryEntityResponseCollection = {
	__typename?: 'WooCategoryEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WooCategory>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<WooCategory>;
	pageInfo: Pagination;
};

export type WooCategoryFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<WooCategoryFiltersInput>>>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	not?: InputMaybe<WooCategoryFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<WooCategoryFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	resource?: InputMaybe<StringFilterInput>;
	sitemap?: InputMaybe<StringFilterInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type WooCategoryInput = {
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	resource?: InputMaybe<Scalars['String']>;
	sitemap?: InputMaybe<Scalars['String']>;
	title?: InputMaybe<Scalars['String']>;
};

export type WooDocumentDetail = {
	__typename?: 'WooDocumentDetail';
	/** @deprecated Use root level fields instead */
	attributes: WooDocumentDetail;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: WooDocumentDetail;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<WooDocumentDetail>>;
	localizations_connection?: Maybe<WooDocumentDetailRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<WooDocumentDetailModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WooDocumentDetailInput = {
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	modules?: InputMaybe<Array<Scalars['WooDocumentDetailModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WooDocumentDetailModulesDynamicZone =
	| ComponentModulesBbvmsMediaplayer
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesLinkBox
	| ComponentModulesShare
	| Error;

export type WooDocumentDetailRelationResponseCollection = {
	__typename?: 'WooDocumentDetailRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WooDocumentDetail>;
	nodes: Array<WooDocumentDetail>;
};

export type WooRequest = {
	__typename?: 'WooRequest';
	/** @deprecated Use root level fields instead */
	attributes: WooRequest;
	basePath?: Maybe<Scalars['String']>;
	caseNumber?: Maybe<Scalars['String']>;
	category?: Maybe<WooCategory>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: WooRequest;
	description?: Maybe<Scalars['String']>;
	documentId: Scalars['ID'];
	endDate?: Maybe<Scalars['Date']>;
	files: Array<Maybe<UploadFile>>;
	files_connection: UploadFileRelationResponseCollection;
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	fullPath?: Maybe<Scalars['String']>;
	fullSlug?: Maybe<Scalars['String']>;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	keywords?: Maybe<Scalars['String']>;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<WooRequest>>;
	localizations_connection?: Maybe<WooRequestRelationResponseCollection>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	publisher?: Maybe<Scalars['String']>;
	shortTitle?: Maybe<Scalars['String']>;
	slug: Scalars['String'];
	startDate: Scalars['Date'];
	themes: Array<Maybe<Theme>>;
	themes_connection?: Maybe<ThemeRelationResponseCollection>;
	title: Scalars['String'];
	updatedAt?: Maybe<Scalars['DateTime']>;
	zip?: Maybe<Scalars['JSON']>;
};

export type WooRequestFilesArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WooRequestFiles_ConnectionArgs = {
	filters?: InputMaybe<UploadFileFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WooRequestLocalizationsArgs = {
	filters?: InputMaybe<WooRequestFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WooRequestLocalizations_ConnectionArgs = {
	filters?: InputMaybe<WooRequestFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WooRequestThemesArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WooRequestThemes_ConnectionArgs = {
	filters?: InputMaybe<ThemeFiltersInput>;
	pagination?: InputMaybe<PaginationArg>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WooRequestEntityResponseCollection = {
	__typename?: 'WooRequestEntityResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WooRequest>;
	/** @deprecated Use the `pageInfo` field instead */
	meta: ResponseCollectionMeta;
	nodes: Array<WooRequest>;
	pageInfo: Pagination;
};

export type WooRequestFiltersInput = {
	and?: InputMaybe<Array<InputMaybe<WooRequestFiltersInput>>>;
	basePath?: InputMaybe<StringFilterInput>;
	caseNumber?: InputMaybe<StringFilterInput>;
	category?: InputMaybe<WooCategoryFiltersInput>;
	createdAt?: InputMaybe<DateTimeFilterInput>;
	description?: InputMaybe<StringFilterInput>;
	documentId?: InputMaybe<IdFilterInput>;
	endDate?: InputMaybe<DateFilterInput>;
	firstPublishedAt?: InputMaybe<DateTimeFilterInput>;
	fullPath?: InputMaybe<StringFilterInput>;
	fullSlug?: InputMaybe<StringFilterInput>;
	keywords?: InputMaybe<StringFilterInput>;
	locale?: InputMaybe<StringFilterInput>;
	localizations?: InputMaybe<WooRequestFiltersInput>;
	not?: InputMaybe<WooRequestFiltersInput>;
	or?: InputMaybe<Array<InputMaybe<WooRequestFiltersInput>>>;
	publishedAt?: InputMaybe<DateTimeFilterInput>;
	publisher?: InputMaybe<StringFilterInput>;
	shortTitle?: InputMaybe<StringFilterInput>;
	slug?: InputMaybe<StringFilterInput>;
	startDate?: InputMaybe<DateFilterInput>;
	themes?: InputMaybe<ThemeFiltersInput>;
	title?: InputMaybe<StringFilterInput>;
	updatedAt?: InputMaybe<DateTimeFilterInput>;
	zip?: InputMaybe<JsonFilterInput>;
};

export type WooRequestInput = {
	basePath?: InputMaybe<Scalars['String']>;
	caseNumber?: InputMaybe<Scalars['String']>;
	category?: InputMaybe<Scalars['ID']>;
	description?: InputMaybe<Scalars['String']>;
	endDate?: InputMaybe<Scalars['Date']>;
	files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	fullPath?: InputMaybe<Scalars['String']>;
	fullSlug?: InputMaybe<Scalars['String']>;
	keywords?: InputMaybe<Scalars['String']>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	publisher?: InputMaybe<Scalars['String']>;
	shortTitle?: InputMaybe<Scalars['String']>;
	slug?: InputMaybe<Scalars['String']>;
	startDate?: InputMaybe<Scalars['Date']>;
	themes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
	title?: InputMaybe<Scalars['String']>;
	zip?: InputMaybe<Scalars['JSON']>;
};

export type WooRequestOverview = {
	__typename?: 'WooRequestOverview';
	/** @deprecated Use root level fields instead */
	attributes: WooRequestOverview;
	basePath?: Maybe<Scalars['String']>;
	bodyText?: Maybe<ComponentModulesBodyText>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: WooRequestOverview;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	list: ComponentModulesWooRequestOverview;
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<WooRequestOverview>>;
	localizations_connection?: Maybe<WooRequestOverviewRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<WooRequestOverviewModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WooRequestOverviewInput = {
	basePath?: InputMaybe<Scalars['String']>;
	bodyText?: InputMaybe<ComponentModulesBodyTextInput>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	list?: InputMaybe<ComponentModulesWooRequestOverviewInput>;
	modules?: InputMaybe<Array<Scalars['WooRequestOverviewModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type WooRequestOverviewModulesDynamicZone =
	| ComponentModulesAccordeon
	| ComponentModulesBodyText
	| ComponentModulesBodyTextTwoColumn
	| ComponentModulesCta
	| ComponentModulesDownloads
	| ComponentModulesHighlight
	| ComponentModulesLinkBox
	| ComponentModulesMedia
	| ComponentModulesPhotoAlbum
	| ComponentModulesStepByStep
	| ComponentModulesSubjects
	| Error;

export type WooRequestOverviewRelationResponseCollection = {
	__typename?: 'WooRequestOverviewRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WooRequestOverview>;
	nodes: Array<WooRequestOverview>;
};

export type WooRequestRelationResponseCollection = {
	__typename?: 'WooRequestRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WooRequest>;
	nodes: Array<WooRequest>;
};

export type WorkAt = {
	__typename?: 'WorkAt';
	/** @deprecated Use root level fields instead */
	attributes: WorkAt;
	basePath?: Maybe<Scalars['String']>;
	createdAt?: Maybe<Scalars['DateTime']>;
	/** @deprecated Use root level fields instead */
	data: WorkAt;
	documentId: Scalars['ID'];
	firstPublishedAt?: Maybe<Scalars['DateTime']>;
	header: ComponentModulesIntroHeader;
	/** @deprecated Use `documentId` instead */
	id: Scalars['ID'];
	locale?: Maybe<Scalars['String']>;
	localizations: Array<Maybe<WorkAt>>;
	localizations_connection?: Maybe<WorkAtRelationResponseCollection>;
	modules?: Maybe<Array<Maybe<WorkAtModulesDynamicZone>>>;
	publishedAt?: Maybe<Scalars['DateTime']>;
	seo: ComponentModulesSeo;
	updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WorkAtInput = {
	basePath?: InputMaybe<Scalars['String']>;
	firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
	header?: InputMaybe<ComponentModulesIntroHeaderInput>;
	modules?: InputMaybe<Array<Scalars['WorkAtModulesDynamicZoneInput']>>;
	publishedAt?: InputMaybe<Scalars['DateTime']>;
	seo?: InputMaybe<ComponentModulesSeoInput>;
};

export type WorkAtModulesDynamicZone =
	| ComponentModulesBodyText
	| ComponentModulesCta
	| ComponentModulesLinkBox
	| ComponentModulesPartners
	| Error;

export type WorkAtRelationResponseCollection = {
	__typename?: 'WorkAtRelationResponseCollection';
	/** @deprecated Use `nodes` field instead */
	data: Array<WorkAt>;
	nodes: Array<WorkAt>;
};

export type AddUserToNewslettersMutationVariables = Exact<{
	campaignId: Scalars['String'];
	email: Scalars['String'];
	newsletters: Array<InputMaybe<NewslettersListInput>> | InputMaybe<NewslettersListInput>;
}>;

export type AddUserToNewslettersMutation = {
	__typename?: 'Mutation';
	addUserToNewsletters?: Array<{ __typename?: 'NewsletterSubscriptions'; campaign: string; succeeded: boolean }>;
};

export type UpdateUserNewsletterSubscriptionMutationVariables = Exact<{
	campaignId: Scalars['String'];
	userId: Scalars['String'];
	email: Scalars['String'];
	newsletters: Array<InputMaybe<NewslettersListInput>> | InputMaybe<NewslettersListInput>;
}>;

export type UpdateUserNewsletterSubscriptionMutation = {
	__typename?: 'Mutation';
	updateUserNewsletterSubscription?: Array<{
		__typename?: 'NewsletterSubscriptions';
		campaign: string;
		succeeded: boolean;
	}>;
};

export type GetCommentsQueryVariables = Exact<{
	id?: InputMaybe<Scalars['String']>;
	uid?: InputMaybe<Scalars['String']>;
	page?: InputMaybe<Scalars['Int']>;
	pageSize?: InputMaybe<Scalars['Int']>;
}>;

export type GetCommentsQuery = {
	__typename?: 'Query';
	getCommentsEnabled?: boolean;
	conversationsConversationitems?: {
		__typename?: 'ConversationItemsResponse';
		data?: Array<{
			__typename?: 'ConversationItemData';
			id?: number;
			attributes?: {
				__typename?: 'ConversationItemAttributes';
				contentTypeUid?: string;
				contentTypeId?: string;
				author?: string;
				message?: string;
				createdAt?: string;
				updatedAt?: string;
				publishedAt?: string;
			};
		}>;
		meta?: {
			__typename?: 'ConversationItemMeta';
			pagination?: {
				__typename?: 'ConversationItemPagination';
				total?: number;
				page?: number;
				pageSize?: number;
				pageCount?: number;
			};
		};
	};
};

export type AddCommentMutationVariables = Exact<{
	contentTypeUid?: InputMaybe<Scalars['String']>;
	contentTypeId?: InputMaybe<Scalars['String']>;
	author?: InputMaybe<Scalars['String']>;
	message?: InputMaybe<Scalars['String']>;
}>;

export type AddCommentMutation = {
	__typename?: 'Mutation';
	addComment?: {
		__typename?: 'ConversationsConversationitemEntityResponse';
		data?: {
			__typename?: 'ConversationsConversationitem';
			attributes: {
				__typename: 'ConversationsConversationitem';
				contentTypeId?: string;
				contentTypeUid?: string;
				message?: string;
				author?: string;
				publishedAt?: any;
			};
		};
	};
};

export type GetCondoleancePageSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCondoleancePageSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetEfroOostInConvoWithArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEfroOostInConvoWithArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetEfroOostInConvoWithArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetEfroOostInConvoWithArticlesQuery = {
	__typename?: 'Query';
	efroOostInConvoWithArticles_connection?: {
		__typename?: 'EfroOostInConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'EfroOostInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetEfroOostNewsArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEfroOostNewsArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetEfroOostNewsArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetEfroOostNewsArticlesQuery = {
	__typename?: 'Query';
	efroOostNewsarticles_connection?: {
		__typename?: 'EfroOostNewsarticleEntityResponseCollection';
		data: Array<{
			__typename?: 'EfroOostNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostNewsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetEfroOostPageSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEfroOostPageSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetEventsQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	themeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetEventsQuery = {
	__typename?: 'Query';
	events_connection?: {
		__typename?: 'EventEntityResponseCollection';
		data: Array<{
			__typename?: 'Event';
			documentId: string;
			attributes: {
				__typename: 'Event';
				title: string;
				url: string;
				location: string;
				from: any;
				until: any;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				theme: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				share?: {
					__typename?: 'ComponentModulesShare';
					title?: any;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetNotesByDocumentIdQueryVariables = Exact<{
	documentId: Scalars['String'];
}>;

export type GetNotesByDocumentIdQuery = {
	__typename?: 'Query';
	notesByDocumentId?: Array<{
		__typename?: 'NotesByPageResult';
		id?: number;
		title?: string;
		note?: string;
		authorMemo?: string;
		authorPage?: string;
		linkedPages?: any;
		createdAt?: any;
		updatedAt?: any;
	}>;
};

export type GetGeolinkPageSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetGeolinkPageSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GlobalSearchQueryVariables = Exact<{
	sort?: InputMaybe<Scalars['String']>;
	searchValue: Scalars['String'];
	createdAtBefore?: InputMaybe<Scalars['String']>;
	createdAtAfter?: InputMaybe<Scalars['String']>;
	domain?: InputMaybe<Scalars['String']>;
}>;

export type GlobalSearchQuery = {
	__typename?: 'Query';
	searchCollectionTypes?: Array<{
		__typename?: 'SearchResult';
		id: string;
		title: string;
		excerpt?: string;
		createdAt?: string;
		fullPath?: string;
		searchSortKey?: string;
	}>;
};

export type GlobalSearchWooRequestsQueryVariables = Exact<{
	searchValue: Scalars['String'];
	locale?: InputMaybe<Scalars['String']>;
	limit?: InputMaybe<Scalars['Int']>;
}>;

export type GlobalSearchWooRequestsQuery = {
	__typename?: 'Query';
	searchWooRequests?: Array<{
		__typename?: 'SearchResult';
		id: string;
		title: string;
		createdAt?: string;
		fullPath?: string;
	}>;
};

export type GetHighlightQueryVariables = Exact<{ [key: string]: never }>;

export type GetHighlightQuery = {
	__typename?: 'Query';
	newsarticles: Array<{
		__typename?: 'Newsarticle';
		data: {
			__typename?: 'Newsarticle';
			documentId: string;
			attributes: {
				__typename: 'Newsarticle';
				firstPublishedAt?: any;
				title: string;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
	subsidies: Array<{
		__typename?: 'Subsidy';
		data: {
			__typename?: 'Subsidy';
			documentId: string;
			attributes: {
				__typename: 'Subsidy';
				slug: string;
				header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
			};
		};
	}>;
	permits: Array<{
		__typename?: 'Permit';
		data: {
			__typename?: 'Permit';
			documentId: string;
			attributes: { __typename: 'Permit'; slug: string; title: string };
		};
	}>;
	mapsFigures: Array<{
		__typename?: 'MapsFigure';
		data: {
			__typename?: 'MapsFigure';
			documentId: string;
			attributes: { __typename: 'MapsFigure'; slug: any; title: string };
		};
	}>;
	wooRequests: Array<{
		__typename?: 'WooRequest';
		data: {
			__typename?: 'WooRequest';
			documentId: string;
			attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
		};
	}>;
	events: Array<{
		__typename?: 'Event';
		data: {
			__typename?: 'Event';
			documentId: string;
			attributes: {
				__typename: 'Event';
				title: string;
				url: string;
				location: string;
				from: any;
				until: any;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				theme: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				share?: {
					__typename?: 'ComponentModulesShare';
					title?: any;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
};

export type GetHighlightWithThemeQueryVariables = Exact<{
	themeId?: InputMaybe<Scalars['ID']>;
}>;

export type GetHighlightWithThemeQuery = {
	__typename?: 'Query';
	newsarticles: Array<{
		__typename?: 'Newsarticle';
		data: {
			__typename?: 'Newsarticle';
			documentId: string;
			attributes: {
				__typename: 'Newsarticle';
				firstPublishedAt?: any;
				title: string;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
	subsidies: Array<{
		__typename?: 'Subsidy';
		data: {
			__typename?: 'Subsidy';
			documentId: string;
			attributes: {
				__typename: 'Subsidy';
				slug: string;
				header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
			};
		};
	}>;
	permits: Array<{
		__typename?: 'Permit';
		data: {
			__typename?: 'Permit';
			documentId: string;
			attributes: { __typename: 'Permit'; slug: string; title: string };
		};
	}>;
	mapsFigures: Array<{
		__typename?: 'MapsFigure';
		data: {
			__typename?: 'MapsFigure';
			documentId: string;
			attributes: { __typename: 'MapsFigure'; slug: any; title: string };
		};
	}>;
	wooRequests: Array<{
		__typename?: 'WooRequest';
		data: {
			__typename?: 'WooRequest';
			documentId: string;
			attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
		};
	}>;
	events: Array<{
		__typename?: 'Event';
		data: {
			__typename?: 'Event';
			documentId: string;
			attributes: {
				__typename: 'Event';
				title: string;
				url: string;
				location: string;
				from: any;
				until: any;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				theme: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				share?: {
					__typename?: 'ComponentModulesShare';
					title?: any;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
};

export type GetInConvoWithArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetInConvoWithArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetInConvoWithArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetInConvoWithArticlesQuery = {
	__typename?: 'Query';
	inConvoWithArticles_connection?: {
		__typename?: 'InConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'InConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'InConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesShare' }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetLoginQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetLoginQuery = {
	__typename?: 'Query';
	login?: {
		__typename?: 'Login';
		data: {
			__typename?: 'Login';
			documentId: string;
			attributes: {
				__typename?: 'Login';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'ComponentModulesVacanciesOverview' }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetNewsArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNewsArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetNewsArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	themeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
	projectId?: InputMaybe<Scalars['ID']>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetNewsArticlesQuery = {
	__typename?: 'Query';
	newsarticles_connection?: {
		__typename?: 'NewsarticleEntityResponseCollection';
		data: Array<{
			__typename?: 'Newsarticle';
			documentId: string;
			attributes: {
				__typename?: 'Newsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetNewsArticleContactPersonQueryVariables = Exact<{
	id: Scalars['String'];
}>;

export type GetNewsArticleContactPersonQuery = {
	__typename?: 'Query';
	getNewsarticleContactPersonById?: { __typename?: 'NewsarticleData'; contactPerson: string };
};

export type GetManyNewslettersQueryVariables = Exact<{ [key: string]: never }>;

export type GetManyNewslettersQuery = {
	__typename?: 'Query';
	getManyNewsletters?: Array<{
		__typename?: 'NewsletterData';
		campaign?: { __typename?: 'NewsletterCampaign'; id: string; name?: string };
		newsletters?: Array<{ __typename?: 'NewslettersList'; field: string; description?: string }>;
	}>;
};

export type GetNewsletterContactQueryVariables = Exact<{
	email: Scalars['String'];
}>;

export type GetNewsletterContactQuery = {
	__typename?: 'Query';
	newsletterContact?: {
		__typename?: 'NewsletterContact';
		active?: boolean;
		campaigns?: Array<{
			__typename?: 'CampaignNewsletterContact';
			id: string;
			contact?: {
				__typename?: 'NewsletterContactData';
				id: string;
				email: string;
				create_date: string;
				custom?: Array<{ __typename?: 'NewsletterField'; field: string; value?: string }>;
			};
		}>;
		newsletters?: Array<{
			__typename?: 'CampaignNewsletterField';
			campaignId?: string;
			newsletter?: string;
			value?: string;
		}>;
	};
};

export type NewsletterFieldFieldsFragment = { __typename?: 'NewsletterField'; field: string; value?: string };

export type NewsletterContactDataFieldsFragment = {
	__typename?: 'NewsletterContactData';
	id: string;
	email: string;
	create_date: string;
	custom?: Array<{ __typename?: 'NewsletterField'; field: string; value?: string }>;
};

export type CampaignNewsletterContactFieldsFragment = {
	__typename?: 'CampaignNewsletterContact';
	id: string;
	contact?: {
		__typename?: 'NewsletterContactData';
		id: string;
		email: string;
		create_date: string;
		custom?: Array<{ __typename?: 'NewsletterField'; field: string; value?: string }>;
	};
};

export type CampaignNewsletterFieldFieldsFragment = {
	__typename?: 'CampaignNewsletterField';
	campaignId?: string;
	newsletter?: string;
	value?: string;
};

export type GetNotificationBarQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetNotificationBarQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			attributes: {
				__typename?: 'PageInformation';
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationLink?: any;
					notificationMessage?: string;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string }>;
				};
			};
		};
	};
};

export type GetOpOostInConvoWithArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOpOostInConvoWithArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetOpOostInConvoWithArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetOpOostInConvoWithArticlesQuery = {
	__typename?: 'Query';
	opOostInConvoWithArticles_connection?: {
		__typename?: 'OpOostInConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'OpOostInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetOpOostNewsArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOpOostNewsArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetOpOostNewsArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetOpOostNewsArticlesQuery = {
	__typename?: 'Query';
	opOostNewsarticles_connection?: {
		__typename?: 'OpOostNewsarticleEntityResponseCollection';
		data: Array<{
			__typename?: 'OpOostNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'OpOostNewsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetOpOostPageSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOpOostPageSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetPageSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPageSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type PasswordStatusQueryVariables = Exact<{
	uid: Scalars['String'];
	slug: Scalars['String'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type PasswordStatusQuery = {
	__typename?: 'Query';
	passwordStatusBySlug?: {
		__typename?: 'PasswordStatusResult';
		exists: boolean;
		protected: boolean;
		enabled?: boolean;
		documentId?: string;
	};
};

export type GetPermitSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPermitSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetPressReleaseSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPressReleaseSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetPressReleasesQueryVariables = Exact<{
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPressReleasesQuery = {
	__typename?: 'Query';
	pressReleases_connection?: {
		__typename?: 'PressReleaseEntityResponseCollection';
		data: Array<{
			__typename?: 'PressRelease';
			documentId: string;
			attributes: {
				__typename?: 'PressRelease';
				title: string;
				locale?: string;
				firstPublishedAt?: any;
				slug: string;
				allowedOnHomePage?: boolean;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				theme: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesFeaturedNews' }
					| { __typename?: 'ComponentModulesFeaturedPages' }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetPressReleaseContactPersonQueryVariables = Exact<{
	id: Scalars['String'];
}>;

export type GetPressReleaseContactPersonQuery = {
	__typename?: 'Query';
	getPressReleaseContactPersonById?: { __typename?: 'PressReleaseData'; contactPerson: string };
};

export type GetProjectSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProjectSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetProjectsQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	themeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetProjectsQuery = {
	__typename?: 'Query';
	projects_connection?: {
		__typename?: 'ProjectEntityResponseCollection';
		data: Array<{
			__typename?: 'Project';
			documentId: string;
			attributes: {
				__typename?: 'Project';
				title?: string;
				firstPublishedAt?: any;
				updatedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetRegioExpresInConvoWithArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRegioExpresInConvoWithArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetRegioExpresInConvoWithArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetRegioExpresInConvoWithArticlesQuery = {
	__typename?: 'Query';
	regioExpresInConvoWithArticles_connection?: {
		__typename?: 'RegioExpresInConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'RegioExpresInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetRegioExpresNewsArticleSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRegioExpresNewsArticleSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetRegioExpresNewsArticlesQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	showOnHomePage?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetRegioExpresNewsArticlesQuery = {
	__typename?: 'Query';
	regioExpresNewsarticles_connection?: {
		__typename?: 'RegioExpresNewsarticleEntityResponseCollection';
		data: Array<{
			__typename?: 'RegioExpresNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresNewsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetRegioexpresPageSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRegioexpresPageSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetRegionSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRegionSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetRegionsQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetRegionsQuery = {
	__typename?: 'Query';
	regions: Array<{
		__typename?: 'Region';
		data: {
			__typename?: 'Region';
			documentId: string;
			attributes: {
				__typename: 'Region';
				title?: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	}>;
};

export type GetRoadMaintenancesSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRoadMaintenancesSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; locale?: string; slug: string }>;
};

export type GetRoadMaintenancesQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRoadMaintenancesQuery = {
	__typename?: 'Query';
	roadMaintenances_connection?: {
		__typename?: 'RoadMaintenanceEntityResponseCollection';
		data: Array<{
			__typename?: 'RoadMaintenance';
			documentId: string;
			attributes: {
				__typename: 'RoadMaintenance';
				title: string;
				slug: string;
				locale?: string;
				roadMaintenanceStatus?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				aboutMaintenance: {
					__typename: 'ComponentInternalAboutMaintenance';
					startDate?: any;
					endDate?: any;
					contractor?: string;
					contractorWebsite?: string;
					detour?: string;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GlobalSearchNotesQueryVariables = Exact<{
	searchValue: Scalars['String'];
	limit?: InputMaybe<Scalars['Int']>;
}>;

export type GlobalSearchNotesQuery = {
	__typename?: 'Query';
	searchNotes?: Array<{
		__typename?: 'NoteSearchResult';
		id: string;
		documentId: string;
		title: string;
		note?: string;
		authorMemo?: string;
		authorPage?: string;
		createdAt?: any;
		updatedAt?: any;
	}>;
};

export type GetFullSitemapQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	domain?: InputMaybe<Scalars['String']>;
}>;

export type GetFullSitemapQuery = {
	__typename?: 'Query';
	findSitemapList?: Array<{ __typename?: 'SitemapPage'; slug?: string; title?: string; updated_at?: string }>;
};

export type GetSubsidyFiltersQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetSubsidyFiltersQuery = {
	__typename?: 'Query';
	subsidyKinds_connection?: {
		__typename?: 'SubsidyKindEntityResponseCollection';
		data: Array<{
			__typename?: 'SubsidyKind';
			documentId: string;
			attributes: { __typename?: 'SubsidyKind'; name?: string; locale?: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	subsidyScales_connection?: {
		__typename?: 'SubsidyScaleEntityResponseCollection';
		data: Array<{
			__typename?: 'SubsidyScale';
			documentId: string;
			attributes: { __typename?: 'SubsidyScale'; name?: string; locale?: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	subsidyGroups?: {
		__typename?: 'TargetGroupEntityResponseCollection';
		data: Array<{
			__typename?: 'TargetGroup';
			documentId: string;
			attributes: { __typename?: 'TargetGroup'; name?: string; locale?: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetSubsidySlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSubsidySlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetTagsQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetTagsQuery = {
	__typename?: 'Query';
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
};

export type GetThemeSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetThemeSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetThemesQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetThemesQuery = {
	__typename?: 'Query';
	themes: Array<{
		__typename?: 'Theme';
		data: {
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	}>;
};

export type GetWobRequestsQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetWobRequestsQuery = {
	__typename?: 'Query';
	wobRequests_connection?: {
		__typename?: 'WobRequestEntityResponseCollection';
		data: Array<{
			__typename?: 'WobRequest';
			documentId: string;
			attributes: { __typename?: 'WobRequest'; title: string; createdAt?: any; date?: any; zip?: any };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetWooCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetWooCategoriesQuery = {
	__typename?: 'Query';
	wooCategories: Array<{
		__typename?: 'WooCategory';
		data: { __typename?: 'WooCategory'; documentId: string; attributes: { __typename?: 'WooCategory'; title: string } };
	}>;
};

export type GetWooRequestSlugsQueryVariables = Exact<{ [key: string]: never }>;

export type GetWooRequestSlugsQuery = {
	__typename?: 'Query';
	findAllSlugs?: Array<{ __typename?: 'SlugItem'; slug: string; locale?: string }>;
};

export type GetWooRequestsQueryVariables = Exact<{
	publicationState?: InputMaybe<PublicationStatus>;
	limit?: InputMaybe<Scalars['Int']>;
	start?: InputMaybe<Scalars['Int']>;
	sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
	themeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
	categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	searchValue?: InputMaybe<Scalars['String']>;
}>;

export type GetWooRequestsQuery = {
	__typename?: 'Query';
	wooRequests_connection?: {
		__typename?: 'WooRequestEntityResponseCollection';
		data: Array<{
			__typename?: 'WooRequest';
			documentId: string;
			attributes: {
				__typename?: 'WooRequest';
				title: string;
				shortTitle?: string;
				description?: string;
				keywords?: string;
				publisher?: string;
				caseNumber?: string;
				slug: string;
				locale?: string;
				zip?: any;
				publishedAt?: any;
				createdAt?: any;
				updatedAt?: any;
				startDate: any;
				endDate?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				category?: {
					__typename?: 'WooCategory';
					data: {
						__typename?: 'WooCategory';
						documentId: string;
						attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
					};
				};
				files: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
					};
				}>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetAgendaPageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetAgendaPageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	agendaPage?: {
		__typename?: 'AgendaPage';
		data: {
			__typename?: 'AgendaPage';
			documentId: string;
			attributes: {
				__typename: 'AgendaPage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetCondoleanceHomepageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetCondoleanceHomepageQuery = {
	__typename?: 'Query';
	condoleanceInformation?: {
		__typename?: 'CondoleanceInformation';
		data: {
			__typename?: 'CondoleanceInformation';
			documentId: string;
			attributes: {
				__typename?: 'CondoleanceInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	condoleanceHomepage?: {
		__typename?: 'CondoleanceHomepage';
		data: {
			__typename?: 'CondoleanceHomepage';
			documentId: string;
			attributes: {
				__typename?: 'CondoleanceHomepage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesHomepageHeader';
					id: string;
					description?: string;
					popularHeader?: string;
					homepageTitle?: string;
					backgroundImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetCondoleancePageQueryVariables = Exact<{
	slug: Scalars['String'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetCondoleancePageQuery = {
	__typename?: 'Query';
	condoleanceInformation?: {
		__typename?: 'CondoleanceInformation';
		data: {
			__typename?: 'CondoleanceInformation';
			documentId: string;
			attributes: {
				__typename?: 'CondoleanceInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	condoleancePageBySlug?: {
		__typename?: 'CondoleancePage';
		data: {
			__typename?: 'CondoleancePage';
			documentId: string;
			attributes: {
				__typename?: 'CondoleancePage';
				title: string;
				slug: string;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetContactQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetContactQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	contact?: {
		__typename?: 'Contact';
		data: {
			__typename?: 'Contact';
			documentId: string;
			attributes: {
				__typename: 'Contact';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'ComponentModulesScheduling' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetCookiePageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetCookiePageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	cookiePage?: {
		__typename?: 'CookiePage';
		data: {
			__typename?: 'CookiePage';
			documentId: string;
			attributes: {
				__typename: 'CookiePage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetDecisionsPageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetDecisionsPageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	decisionsPage?: {
		__typename?: 'DecisionsPage';
		data: {
			__typename?: 'DecisionsPage';
			documentId: string;
			attributes: {
				__typename: 'DecisionsPage';
				locale?: string;
				bodyText?: string;
				sidebarCurrentYearTitle: string;
				sidebarArchiveTitle: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				archiveLink: { __typename?: 'ComponentComponentsLink'; title: string; description?: string; href: any };
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetDownloadsPageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetDownloadsPageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	downloadsPage?: {
		__typename?: 'DownloadsPage';
		data: {
			__typename?: 'DownloadsPage';
			documentId: string;
			attributes: {
				__typename: 'DownloadsPage';
				locale?: string;
				introHeader: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				downloads: Array<{
					__typename?: 'ComponentModulesDownloads';
					downloadsTitle?: any;
					downloads: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								name: string;
								size: number;
								ext?: string;
								caption?: string;
							};
						};
					}>;
					downloadLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
						extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
						extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
					};
				}>;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesScheduling' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetEfroOostHomepageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetEfroOostHomepageQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	efroOostHomepage?: {
		__typename?: 'EfroOostHomepage';
		data: {
			__typename?: 'EfroOostHomepage';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostHomepage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesHomepageHeader';
					id: string;
					description?: string;
					popularHeader?: string;
					homepageTitle?: string;
					backgroundImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNewsEfroOost';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'EfroOostNewsarticle';
								data: {
									__typename?: 'EfroOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'EfroOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetEfroOostInConvoWithDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetEfroOostInConvoWithDetailQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	efroOostInConvoWithDetail?: {
		__typename?: 'EfroOostInConvoWithDetail';
		data: {
			__typename?: 'EfroOostInConvoWithDetail';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInConvoWithDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	efroOostInConvoWithArticleBySlug?: {
		__typename?: 'EfroOostInConvoWithArticle';
		data: {
			__typename?: 'EfroOostInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetEfroOostInConvoWithOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetEfroOostInConvoWithOverviewQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	efroOostInConvoWithOverview?: {
		__typename?: 'EfroOostInConvoWithOverview';
		data: {
			__typename?: 'EfroOostInConvoWithOverview';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInConvoWithOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesInConvoWithOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	efroOostInConvoWithArticles_connection?: {
		__typename?: 'EfroOostInConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'EfroOostInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetEfroOostNewsDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetEfroOostNewsDetailQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	efroOostNewsDetail?: {
		__typename?: 'EfroOostNewsDetail';
		data: {
			__typename?: 'EfroOostNewsDetail';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostNewsDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNewsEfroOost';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'EfroOostNewsarticle';
								data: {
									__typename?: 'EfroOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'EfroOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	efroOostNewsarticleBySlug?: {
		__typename?: 'EfroOostNewsarticle';
		data: {
			__typename?: 'EfroOostNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostNewsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNewsEfroOost';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'EfroOostNewsarticle';
								data: {
									__typename?: 'EfroOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'EfroOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetEfroOostNewsOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetEfroOostNewsOverviewQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	efroOostNewsOverview?: {
		__typename?: 'EfroOostNewsOverview';
		data: {
			__typename?: 'EfroOostNewsOverview';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostNewsOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesNewsOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetEfroOostPageQueryVariables = Exact<{
	slug: Scalars['String'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetEfroOostPageQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	efroOostPageBySlug?: {
		__typename?: 'EfroOostPage';
		data: {
			__typename?: 'EfroOostPage';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostPage';
				title: string;
				slug: string;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNewsEfroOost';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'EfroOostNewsarticle';
								data: {
									__typename?: 'EfroOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'EfroOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetEventOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetEventOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	eventOverview?: {
		__typename?: 'EventOverview';
		data: {
			__typename?: 'EventOverview';
			documentId: string;
			attributes: {
				__typename?: 'EventOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesEventOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	themes_connection?: {
		__typename?: 'ThemeEntityResponseCollection';
		data: Array<{
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetGeoLinkPageQueryVariables = Exact<{
	slug: Scalars['String'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetGeoLinkPageQuery = {
	__typename?: 'Query';
	geolinkInformation?: {
		__typename?: 'GeolinkInformation';
		data: {
			__typename?: 'GeolinkInformation';
			documentId: string;
			attributes: {
				__typename?: 'GeolinkInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	geolinkPageBySlug?: {
		__typename?: 'GeolinkPage';
		data: {
			__typename?: 'GeolinkPage';
			documentId: string;
			attributes: {
				__typename?: 'GeolinkPage';
				title: string;
				slug: string;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesCta' }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetGeolinkHomepageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetGeolinkHomepageQuery = {
	__typename?: 'Query';
	geolinkInformation?: {
		__typename?: 'GeolinkInformation';
		data: {
			__typename?: 'GeolinkInformation';
			documentId: string;
			attributes: {
				__typename?: 'GeolinkInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	geolinkHomepage?: {
		__typename?: 'GeolinkHomepage';
		data: {
			__typename?: 'GeolinkHomepage';
			documentId: string;
			attributes: {
				__typename?: 'GeolinkHomepage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesHomepageHeader';
					id: string;
					description?: string;
					popularHeader?: string;
					homepageTitle?: string;
					backgroundImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetHomePageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetHomePageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	homePage?: {
		__typename?: 'HomePage';
		data: {
			__typename?: 'HomePage';
			documentId: string;
			attributes: {
				__typename?: 'HomePage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesHomepageHeader';
					id: string;
					description?: string;
					popularHeader?: string;
					homepageTitle?: string;
					backgroundImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesRegions';
							title?: any;
							regions: Array<{
								__typename?: 'Region';
								data: {
									__typename?: 'Region';
									documentId: string;
									attributes: {
										__typename: 'Region';
										title?: string;
										slug: string;
										locale?: string;
										header?: {
											__typename?: 'ComponentModulesExpandedHeader';
											headerTitle?: string;
											headerDescription?: string;
											title?: string;
											description?: string;
											headerButton?: {
												__typename?: 'ComponentComponentsButton';
												title?: string;
												variant: Enum_Componentcomponentsbutton_Variant;
												href: any;
												iconLeft?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
												iconRight?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
											};
											headerImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														name: string;
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										seo: {
											__typename?: 'ComponentModulesSeo';
											title?: string;
											description?: string;
											noIndex?: boolean;
											noFollow?: boolean;
											ogTitle?: string;
											ogDescription?: string;
											ogType?: string;
											ogUrl?: string;
											ogImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										};
										modules?: Array<
											| {
													__typename: 'ComponentModulesAccordeon';
													accordeonTitle?: any;
													sections: Array<{
														__typename: 'ComponentInternalAccordeonSection';
														accordeonSectionName?: string;
														items: Array<{
															__typename: 'ComponentInternalAccordeonItem';
															itemTitle: string;
															description?: string;
														}>;
													}>;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesBbvmsMediaplayer';
													videoId: string;
													playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
													url?: string;
													title?: any;
													description?: string;
													transcript?: string;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyText';
													bodyText?: string;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyTextTwoColumn';
													leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesCta';
													description?: string;
													imagePosition?: Enum_Componentmodulescta_Imageposition;
													videoLink?: string;
													ctaTitle?: any;
													buttons?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
													}>;
													imageOrVideoFile?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																name: string;
																alternativeText?: string;
																caption?: string;
																url: string;
																mime: string;
																formats?: any;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesDownloads';
													downloadsTitle?: any;
													downloads: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																url: string;
																name: string;
																size: number;
																ext?: string;
																caption?: string;
															};
														};
													}>;
													downloadLinks?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedNews';
													featuredNewsTitle?: any;
													items: Array<{
														__typename?: 'Newsarticle';
														data: {
															__typename?: 'Newsarticle';
															documentId: string;
															attributes: {
																__typename: 'Newsarticle';
																firstPublishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
																bodyText: {
																	__typename?: 'ComponentModulesBodyText';
																	bodyText?: string;
																	sidebar?: {
																		__typename?: 'ComponentInternalSidebar';
																		title?: any;
																		links?: Array<{
																			__typename?: 'ComponentComponentsLink';
																			title: string;
																			href: any;
																			description?: string;
																		}>;
																		files: Array<{
																			__typename?: 'UploadFile';
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					ext?: string;
																					mime: string;
																					size: number;
																					url: string;
																					alternativeText?: string;
																					hash: string;
																					name: string;
																					caption?: string;
																				};
																			};
																		}>;
																	};
																	defaultModuleOptions: {
																		__typename?: 'ComponentInternalDefaultModuleOptions';
																		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedPages';
													featuredPagesTitle?: any;
													items: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename: 'Page';
																publishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesHighlight';
													id: string;
													title?: any;
													theme?: {
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string };
														};
													};
													newsTab?: {
														__typename?: 'ComponentInternalHighlightNews';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													eventsTab?: {
														__typename?: 'ComponentInternalHighlightEvents';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													permitsTab?: {
														__typename?: 'ComponentInternalHighlightPermits';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Permit';
															data: {
																__typename?: 'Permit';
																attributes: { __typename: 'Permit'; slug: string; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													wooTab?: {
														__typename?: 'ComponentInternalHighlightWoo';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'WooRequest';
															data: {
																__typename?: 'WooRequest';
																attributes: {
																	__typename: 'WooRequest';
																	title: string;
																	startDate: any;
																	zip?: any;
																	createdAt?: any;
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													mapsAndStatsTab?: {
														__typename?: 'ComponentInternalHighlightMapsAndStats';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'MapsFigure';
															data: {
																__typename?: 'MapsFigure';
																attributes: { __typename: 'MapsFigure'; slug: any; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													topicsTab?: {
														__typename?: 'ComponentInternalHighlightTopics';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													subsidiesTab?: {
														__typename?: 'ComponentInternalHighlightSubsidies';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Subsidy';
															data: {
																__typename?: 'Subsidy';
																attributes: {
																	__typename: 'Subsidy';
																	slug: string;
																	header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesLinkBox';
													title?: any;
													description?: string;
													linkBoxLinks?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesMedia';
													transcript?: string;
													mediaLink?: string;
													mediaTitle?: any;
													mediaDescription?: string;
													media?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																size: number;
																ext?: string;
																url: string;
																alternativeText?: string;
																formats?: any;
																mime: string;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesNewsOverview' }
											| {
													__typename: 'ComponentModulesPhotoAlbum';
													id: string;
													description?: string;
													horizontal?: boolean;
													jsonTitle: any;
													photos: Array<{
														__typename: 'ComponentInternalPhoto';
														id: string;
														title: string;
														description?: string;
														photo: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	width?: number;
																	height?: number;
																	caption?: string;
																	formats?: any;
																	size: number;
																	ext?: string;
																	mime: string;
																};
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesRegions' }
											| {
													__typename: 'ComponentModulesStepByStep';
													title?: any;
													stepByStepCard: Array<{
														__typename: 'ComponentInternalStepByStepCard';
														cardTitle: string;
														cardDescription?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesSubjects';
													id: string;
													description?: string;
													overviewTitle?: string;
													subjects: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename?: 'Page';
																title: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													projects: Array<{
														__typename?: 'Project';
														data: {
															__typename?: 'Project';
															documentId: string;
															attributes: {
																__typename?: 'Project';
																title?: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													themes: Array<{
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string; slug: string };
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesThemes' }
											| { __typename?: 'Error' }
										>;
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesThemes';
							title?: any;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: {
										__typename?: 'Theme';
										title: string;
										slug: string;
										header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetInConvoWithDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetInConvoWithDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	inConvoWithDetail?: {
		__typename?: 'InConvoWithDetail';
		data: {
			__typename?: 'InConvoWithDetail';
			documentId: string;
			attributes: {
				__typename?: 'InConvoWithDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	inConvoWithArticleBySlug?: {
		__typename?: 'InConvoWithArticle';
		data: {
			__typename?: 'InConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'InConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesShare' }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetInConvoWithOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetInConvoWithOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	inConvoWithOverview?: {
		__typename?: 'InConvoWithOverview';
		data: {
			__typename?: 'InConvoWithOverview';
			documentId: string;
			attributes: {
				__typename?: 'InConvoWithOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesInConvoWithOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	inConvoWithArticles_connection?: {
		__typename?: 'InConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'InConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'InConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesShare' }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetMapsFiguresOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetMapsFiguresOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	mapsFiguresOverview?: {
		__typename?: 'MapsFiguresOverview';
		data: {
			__typename?: 'MapsFiguresOverview';
			documentId: string;
			attributes: {
				__typename?: 'MapsFiguresOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				mapsFiguresOverview: {
					__typename?: 'ComponentModulesMapsFiguresOverview';
					id: string;
					showResultsText: string;
					headerTitle: string;
					searchPlaceholderText: string;
					themeFilterText: string;
					kindFilterText: string;
					showAllThemesText: string;
					overviewTitleText: string;
					filterHeaderText: string;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'ComponentModulesRegions' }
					| { __typename: 'ComponentModulesScheduling' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'ComponentModulesThemes' }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	themes_connection?: {
		__typename?: 'ThemeEntityResponseCollection';
		data: Array<{
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetNewsDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetNewsDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	newsDetail?: {
		__typename?: 'NewsDetail';
		data: {
			__typename?: 'NewsDetail';
			documentId: string;
			attributes: {
				__typename?: 'NewsDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	newsarticleBySlug?: {
		__typename?: 'Newsarticle';
		data: {
			__typename?: 'Newsarticle';
			documentId: string;
			attributes: {
				__typename?: 'Newsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetNewsOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetNewsOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	newsOverview?: {
		__typename?: 'NewsOverview';
		data: {
			__typename?: 'NewsOverview';
			documentId: string;
			attributes: {
				__typename?: 'NewsOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesNewsOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	themes_connection?: {
		__typename?: 'ThemeEntityResponseCollection';
		data: Array<{
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetArchiveNewsletterOverviewPageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetArchiveNewsletterOverviewPageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename: 'PageInformation';
			id: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	newsletterArchiveOverview?: {
		__typename?: 'NewsletterArchiveOverview';
		data: {
			__typename: 'NewsletterArchiveOverview';
			documentId: string;
			attributes: {
				__typename?: 'NewsletterArchiveOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPermitsOverview';
							id: string;
							headerTitle: string;
							searchPlaceholderText: string;
							themeFilterText: string;
							lawFilterText: string;
							productTypeFilterText: string;
							showAllThemesText: string;
							showAllLawsText: string;
							showAllProductTypesText: string;
							overviewTitleText: string;
							showResultsText: string;
							filterHeaderText: string;
					  }
					| { __typename: 'ComponentModulesPhotoAlbum' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetInternalNewsletterPageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetInternalNewsletterPageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename: 'PageInformation';
			id: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	internalNewsletterWithSubscriptions?: Array<{
		__typename?: 'InternalNewsletterWithSubscriptions';
		page?: {
			__typename?: 'NewsletterInternal';
			header: {
				__typename?: 'ComponentModulesIntroHeader';
				title: string;
				excerpt: string;
				backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
			};
			newsletter: {
				__typename?: 'ComponentInternalNewsletter';
				title?: string;
				fieldLabel?: string;
				fieldPlaceholder?: string;
				submitButton?: {
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
			};
			seo: {
				__typename?: 'ComponentModulesSeo';
				title?: string;
				description?: string;
				noIndex?: boolean;
				noFollow?: boolean;
				ogTitle?: string;
				ogDescription?: string;
				ogType?: string;
				ogUrl?: string;
				ogImage?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
		};
	}>;
};

export type GetPublicNewsletterPageCondoleanceQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPublicNewsletterPageCondoleanceQuery = {
	__typename?: 'Query';
	condoleanceInformation?: {
		__typename?: 'CondoleanceInformation';
		data: {
			__typename?: 'CondoleanceInformation';
			documentId: string;
			attributes: {
				__typename?: 'CondoleanceInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	publicNewsletterPage?: Array<{
		__typename?: 'PublicNewsletterPage';
		page?: {
			__typename?: 'NewsletterPublic';
			header: {
				__typename?: 'ComponentModulesIntroHeader';
				title: string;
				excerpt: string;
				backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
			};
			newsletter: {
				__typename?: 'ComponentInternalNewsletter';
				title?: string;
				fieldLabel?: string;
				fieldPlaceholder?: string;
				submitButton?: {
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
			};
			seo: {
				__typename?: 'ComponentModulesSeo';
				title?: string;
				description?: string;
				noIndex?: boolean;
				noFollow?: boolean;
				ogTitle?: string;
				ogDescription?: string;
				ogType?: string;
				ogUrl?: string;
				ogImage?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
		};
	}>;
};

export type GetPublicNewsletterPageOfroOostQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPublicNewsletterPageOfroOostQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	publicNewsletterPage?: Array<{
		__typename?: 'PublicNewsletterPage';
		page?: {
			__typename?: 'NewsletterPublic';
			header: {
				__typename?: 'ComponentModulesIntroHeader';
				title: string;
				excerpt: string;
				backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
			};
			newsletter: {
				__typename?: 'ComponentInternalNewsletter';
				title?: string;
				fieldLabel?: string;
				fieldPlaceholder?: string;
				submitButton?: {
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
			};
			seo: {
				__typename?: 'ComponentModulesSeo';
				title?: string;
				description?: string;
				noIndex?: boolean;
				noFollow?: boolean;
				ogTitle?: string;
				ogDescription?: string;
				ogType?: string;
				ogUrl?: string;
				ogImage?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
		};
	}>;
};

export type GetPublicNewsletterPageGeolinkQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPublicNewsletterPageGeolinkQuery = {
	__typename?: 'Query';
	geolinkInformation?: {
		__typename?: 'GeolinkInformation';
		data: {
			__typename?: 'GeolinkInformation';
			documentId: string;
			attributes: {
				__typename?: 'GeolinkInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	publicNewsletterPage?: Array<{
		__typename?: 'PublicNewsletterPage';
		page?: {
			__typename?: 'NewsletterPublic';
			header: {
				__typename?: 'ComponentModulesIntroHeader';
				title: string;
				excerpt: string;
				backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
			};
			newsletter: {
				__typename?: 'ComponentInternalNewsletter';
				title?: string;
				fieldLabel?: string;
				fieldPlaceholder?: string;
				submitButton?: {
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
			};
			seo: {
				__typename?: 'ComponentModulesSeo';
				title?: string;
				description?: string;
				noIndex?: boolean;
				noFollow?: boolean;
				ogTitle?: string;
				ogDescription?: string;
				ogType?: string;
				ogUrl?: string;
				ogImage?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
		};
	}>;
};

export type GetPublicNewsletterPageOpOostQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPublicNewsletterPageOpOostQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	publicNewsletterPage?: Array<{
		__typename?: 'PublicNewsletterPage';
		page?: {
			__typename?: 'NewsletterPublic';
			header: {
				__typename?: 'ComponentModulesIntroHeader';
				title: string;
				excerpt: string;
				backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
			};
			newsletter: {
				__typename?: 'ComponentInternalNewsletter';
				title?: string;
				fieldLabel?: string;
				fieldPlaceholder?: string;
				submitButton?: {
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
			};
			seo: {
				__typename?: 'ComponentModulesSeo';
				title?: string;
				description?: string;
				noIndex?: boolean;
				noFollow?: boolean;
				ogTitle?: string;
				ogDescription?: string;
				ogType?: string;
				ogUrl?: string;
				ogImage?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
		};
	}>;
};

export type GetPublicNewsletterPageRegioExpresQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPublicNewsletterPageRegioExpresQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	publicNewsletterPage?: Array<{
		__typename?: 'PublicNewsletterPage';
		page?: {
			__typename?: 'NewsletterPublic';
			header: {
				__typename?: 'ComponentModulesIntroHeader';
				title: string;
				excerpt: string;
				backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
			};
			newsletter: {
				__typename?: 'ComponentInternalNewsletter';
				title?: string;
				fieldLabel?: string;
				fieldPlaceholder?: string;
				submitButton?: {
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
			};
			seo: {
				__typename?: 'ComponentModulesSeo';
				title?: string;
				description?: string;
				noIndex?: boolean;
				noFollow?: boolean;
				ogTitle?: string;
				ogDescription?: string;
				ogType?: string;
				ogUrl?: string;
				ogImage?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
		};
	}>;
};

export type GetPublicNewsletterPageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPublicNewsletterPageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename: 'PageInformation';
			id: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	publicNewsletterPage?: Array<{
		__typename?: 'PublicNewsletterPage';
		page?: {
			__typename?: 'NewsletterPublic';
			header: {
				__typename?: 'ComponentModulesIntroHeader';
				title: string;
				excerpt: string;
				backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
			};
			newsletter: {
				__typename?: 'ComponentInternalNewsletter';
				title?: string;
				fieldLabel?: string;
				fieldPlaceholder?: string;
				submitButton?: {
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
			};
			seo: {
				__typename?: 'ComponentModulesSeo';
				title?: string;
				description?: string;
				noIndex?: boolean;
				noFollow?: boolean;
				ogTitle?: string;
				ogDescription?: string;
				ogType?: string;
				ogUrl?: string;
				ogImage?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
		};
	}>;
};

export type GetNotFoundQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetNotFoundQuery = {
	__typename?: 'Query';
	notFoundPage?: {
		__typename?: 'NotFoundPage';
		data: {
			__typename?: 'NotFoundPage';
			documentId: string;
			attributes: {
				__typename: 'NotFoundPage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				links: {
					__typename?: 'ComponentModulesLinkBox';
					title?: any;
					description?: string;
					linkBoxLinks?: Array<{
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
						};
					}>;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
						extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
						extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
					};
				};
				cta: {
					__typename?: 'ComponentModulesCta';
					description?: string;
					imagePosition?: Enum_Componentmodulescta_Imageposition;
					videoLink?: string;
					ctaTitle?: any;
					buttons?: Array<{
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					}>;
					imageOrVideoFile?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								caption?: string;
								url: string;
								mime: string;
								formats?: any;
							};
						};
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
						extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
						extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
					};
				};
			};
		};
	};
};

export type GetOpOostHomepageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpOostHomepageQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	opOostHomepage?: {
		__typename?: 'OpOostHomepage';
		data: {
			__typename?: 'OpOostHomepage';
			documentId: string;
			attributes: {
				__typename?: 'OpOostHomepage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesHomepageHeader';
					id: string;
					description?: string;
					popularHeader?: string;
					homepageTitle?: string;
					backgroundImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNewsOpOost';
							featuredNewsTitle?: any;
							news: Array<{
								__typename?: 'OpOostNewsarticle';
								data: {
									__typename?: 'OpOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'OpOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetOpOostInConvoWithDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpOostInConvoWithDetailQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	opOostInConvoWithDetail?: {
		__typename?: 'OpOostInConvoWithDetail';
		data: {
			__typename?: 'OpOostInConvoWithDetail';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInConvoWithDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	opOostInConvoWithArticleBySlug?: {
		__typename?: 'OpOostInConvoWithArticle';
		data: {
			__typename?: 'OpOostInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetOpOostInConvoWithOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpOostInConvoWithOverviewQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	opOostInConvoWithOverview?: {
		__typename?: 'OpOostInConvoWithOverview';
		data: {
			__typename?: 'OpOostInConvoWithOverview';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInConvoWithOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesInConvoWithOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	opOostInConvoWithArticles_connection?: {
		__typename?: 'OpOostInConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'OpOostInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetOpOostNewsDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpOostNewsDetailQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	opOostNewsDetail?: {
		__typename?: 'OpOostNewsDetail';
		data: {
			__typename?: 'OpOostNewsDetail';
			documentId: string;
			attributes: {
				__typename?: 'OpOostNewsDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNewsOpOost';
							featuredNewsTitle?: any;
							news: Array<{
								__typename?: 'OpOostNewsarticle';
								data: {
									__typename?: 'OpOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'OpOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	opOostNewsarticleBySlug?: {
		__typename?: 'OpOostNewsarticle';
		data: {
			__typename?: 'OpOostNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'OpOostNewsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNewsOpOost';
							featuredNewsTitle?: any;
							news: Array<{
								__typename?: 'OpOostNewsarticle';
								data: {
									__typename?: 'OpOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'OpOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetOpOostNewsOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpOostNewsOverviewQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	opOostNewsOverview?: {
		__typename?: 'OpOostNewsOverview';
		data: {
			__typename?: 'OpOostNewsOverview';
			documentId: string;
			attributes: {
				__typename?: 'OpOostNewsOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesNewsOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetOpOostPageQueryVariables = Exact<{
	slug: Scalars['String'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpOostPageQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	opOostPageBySlug?: {
		__typename?: 'OpOostPage';
		data: {
			__typename?: 'OpOostPage';
			documentId: string;
			attributes: {
				__typename?: 'OpOostPage';
				title: string;
				slug: string;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNewsOpOost';
							featuredNewsTitle?: any;
							news: Array<{
								__typename?: 'OpOostNewsarticle';
								data: {
									__typename?: 'OpOostNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'OpOostNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetOpenGelderlandHomepageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpenGelderlandHomepageQuery = {
	__typename?: 'Query';
	openGelderlandInformation?: {
		__typename?: 'OpenGelderlandInformation';
		data: {
			__typename?: 'OpenGelderlandInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpenGelderlandInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	openGelderlandHomepage?: {
		__typename?: 'OpenGelderlandHomepage';
		data: {
			__typename?: 'OpenGelderlandHomepage';
			documentId: string;
			attributes: {
				__typename?: 'OpenGelderlandHomepage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				collections: {
					__typename?: 'ComponentModulesCollections';
					id: string;
					description?: string;
					overviewTitle?: string;
					links: Array<{
						__typename?: 'ComponentComponentsLink';
						id: string;
						title: string;
						href: any;
						description?: string;
					}>;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetPageInformationCondoleanceQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPageInformationCondoleanceQuery = {
	__typename?: 'Query';
	condoleanceInformation?: {
		__typename?: 'CondoleanceInformation';
		data: {
			__typename?: 'CondoleanceInformation';
			documentId: string;
			attributes: {
				__typename?: 'CondoleanceInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetPageInformationEfroOostQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPageInformationEfroOostQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetPageInformationGelderlandQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPageInformationGelderlandQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetPageInformationGeolinkQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPageInformationGeolinkQuery = {
	__typename?: 'Query';
	geolinkInformation?: {
		__typename?: 'GeolinkInformation';
		data: {
			__typename?: 'GeolinkInformation';
			documentId: string;
			attributes: {
				__typename?: 'GeolinkInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetPageInformationOpOostQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPageInformationOpOostQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetPageInformationRegioExpresQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPageInformationRegioExpresQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
};

export type GetPageQueryVariables = Exact<{
	slug: Scalars['String'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	pageBySlug?: {
		__typename?: 'Page';
		data: {
			__typename?: 'Page';
			documentId: string;
			attributes: {
				__typename?: 'Page';
				documentId: string;
				title: string;
				slug: string;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesRegions';
							title?: any;
							regions: Array<{
								__typename?: 'Region';
								data: {
									__typename?: 'Region';
									documentId: string;
									attributes: {
										__typename: 'Region';
										title?: string;
										slug: string;
										locale?: string;
										header?: {
											__typename?: 'ComponentModulesExpandedHeader';
											headerTitle?: string;
											headerDescription?: string;
											title?: string;
											description?: string;
											headerButton?: {
												__typename?: 'ComponentComponentsButton';
												title?: string;
												variant: Enum_Componentcomponentsbutton_Variant;
												href: any;
												iconLeft?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
												iconRight?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
											};
											headerImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														name: string;
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										seo: {
											__typename?: 'ComponentModulesSeo';
											title?: string;
											description?: string;
											noIndex?: boolean;
											noFollow?: boolean;
											ogTitle?: string;
											ogDescription?: string;
											ogType?: string;
											ogUrl?: string;
											ogImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										};
										modules?: Array<
											| {
													__typename: 'ComponentModulesAccordeon';
													accordeonTitle?: any;
													sections: Array<{
														__typename: 'ComponentInternalAccordeonSection';
														accordeonSectionName?: string;
														items: Array<{
															__typename: 'ComponentInternalAccordeonItem';
															itemTitle: string;
															description?: string;
														}>;
													}>;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesBbvmsMediaplayer';
													videoId: string;
													playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
													url?: string;
													title?: any;
													description?: string;
													transcript?: string;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyText';
													bodyText?: string;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyTextTwoColumn';
													leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesCta';
													description?: string;
													imagePosition?: Enum_Componentmodulescta_Imageposition;
													videoLink?: string;
													ctaTitle?: any;
													buttons?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
													}>;
													imageOrVideoFile?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																name: string;
																alternativeText?: string;
																caption?: string;
																url: string;
																mime: string;
																formats?: any;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesDownloads';
													downloadsTitle?: any;
													downloads: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																url: string;
																name: string;
																size: number;
																ext?: string;
																caption?: string;
															};
														};
													}>;
													downloadLinks?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedNews';
													featuredNewsTitle?: any;
													items: Array<{
														__typename?: 'Newsarticle';
														data: {
															__typename?: 'Newsarticle';
															documentId: string;
															attributes: {
																__typename: 'Newsarticle';
																firstPublishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
																bodyText: {
																	__typename?: 'ComponentModulesBodyText';
																	bodyText?: string;
																	sidebar?: {
																		__typename?: 'ComponentInternalSidebar';
																		title?: any;
																		links?: Array<{
																			__typename?: 'ComponentComponentsLink';
																			title: string;
																			href: any;
																			description?: string;
																		}>;
																		files: Array<{
																			__typename?: 'UploadFile';
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					ext?: string;
																					mime: string;
																					size: number;
																					url: string;
																					alternativeText?: string;
																					hash: string;
																					name: string;
																					caption?: string;
																				};
																			};
																		}>;
																	};
																	defaultModuleOptions: {
																		__typename?: 'ComponentInternalDefaultModuleOptions';
																		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedPages';
													featuredPagesTitle?: any;
													items: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename: 'Page';
																publishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesHighlight';
													id: string;
													title?: any;
													theme?: {
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string };
														};
													};
													newsTab?: {
														__typename?: 'ComponentInternalHighlightNews';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													eventsTab?: {
														__typename?: 'ComponentInternalHighlightEvents';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													permitsTab?: {
														__typename?: 'ComponentInternalHighlightPermits';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Permit';
															data: {
																__typename?: 'Permit';
																attributes: { __typename: 'Permit'; slug: string; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													wooTab?: {
														__typename?: 'ComponentInternalHighlightWoo';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'WooRequest';
															data: {
																__typename?: 'WooRequest';
																attributes: {
																	__typename: 'WooRequest';
																	title: string;
																	startDate: any;
																	zip?: any;
																	createdAt?: any;
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													mapsAndStatsTab?: {
														__typename?: 'ComponentInternalHighlightMapsAndStats';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'MapsFigure';
															data: {
																__typename?: 'MapsFigure';
																attributes: { __typename: 'MapsFigure'; slug: any; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													topicsTab?: {
														__typename?: 'ComponentInternalHighlightTopics';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													subsidiesTab?: {
														__typename?: 'ComponentInternalHighlightSubsidies';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Subsidy';
															data: {
																__typename?: 'Subsidy';
																attributes: {
																	__typename: 'Subsidy';
																	slug: string;
																	header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesLinkBox';
													title?: any;
													description?: string;
													linkBoxLinks?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesMedia';
													transcript?: string;
													mediaLink?: string;
													mediaTitle?: any;
													mediaDescription?: string;
													media?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																size: number;
																ext?: string;
																url: string;
																alternativeText?: string;
																formats?: any;
																mime: string;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesNewsOverview' }
											| {
													__typename: 'ComponentModulesPhotoAlbum';
													id: string;
													description?: string;
													horizontal?: boolean;
													jsonTitle: any;
													photos: Array<{
														__typename: 'ComponentInternalPhoto';
														id: string;
														title: string;
														description?: string;
														photo: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	width?: number;
																	height?: number;
																	caption?: string;
																	formats?: any;
																	size: number;
																	ext?: string;
																	mime: string;
																};
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesRegions' }
											| {
													__typename: 'ComponentModulesStepByStep';
													title?: any;
													stepByStepCard: Array<{
														__typename: 'ComponentInternalStepByStepCard';
														cardTitle: string;
														cardDescription?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesSubjects';
													id: string;
													description?: string;
													overviewTitle?: string;
													subjects: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename?: 'Page';
																title: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													projects: Array<{
														__typename?: 'Project';
														data: {
															__typename?: 'Project';
															documentId: string;
															attributes: {
																__typename?: 'Project';
																title?: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													themes: Array<{
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string; slug: string };
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesThemes' }
											| { __typename?: 'Error' }
										>;
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesThemes';
							title?: any;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: {
										__typename?: 'Theme';
										title: string;
										slug: string;
										header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetPasswordPageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetPasswordPageQuery = {
	__typename?: 'Query';
	passwordProtectionPasswordPage?: {
		__typename?: 'PasswordProtectionPasswordPage';
		data: {
			__typename?: 'PasswordProtectionPasswordPage';
			documentId: string;
			attributes: {
				__typename: 'PasswordProtectionPasswordPage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesRegions';
							title?: any;
							regions: Array<{
								__typename?: 'Region';
								data: {
									__typename?: 'Region';
									documentId: string;
									attributes: {
										__typename: 'Region';
										title?: string;
										slug: string;
										locale?: string;
										header?: {
											__typename?: 'ComponentModulesExpandedHeader';
											headerTitle?: string;
											headerDescription?: string;
											title?: string;
											description?: string;
											headerButton?: {
												__typename?: 'ComponentComponentsButton';
												title?: string;
												variant: Enum_Componentcomponentsbutton_Variant;
												href: any;
												iconLeft?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
												iconRight?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
											};
											headerImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														name: string;
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										seo: {
											__typename?: 'ComponentModulesSeo';
											title?: string;
											description?: string;
											noIndex?: boolean;
											noFollow?: boolean;
											ogTitle?: string;
											ogDescription?: string;
											ogType?: string;
											ogUrl?: string;
											ogImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										};
										modules?: Array<
											| {
													__typename: 'ComponentModulesAccordeon';
													accordeonTitle?: any;
													sections: Array<{
														__typename: 'ComponentInternalAccordeonSection';
														accordeonSectionName?: string;
														items: Array<{
															__typename: 'ComponentInternalAccordeonItem';
															itemTitle: string;
															description?: string;
														}>;
													}>;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesBbvmsMediaplayer';
													videoId: string;
													playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
													url?: string;
													title?: any;
													description?: string;
													transcript?: string;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyText';
													bodyText?: string;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyTextTwoColumn';
													leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesCta';
													description?: string;
													imagePosition?: Enum_Componentmodulescta_Imageposition;
													videoLink?: string;
													ctaTitle?: any;
													buttons?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
													}>;
													imageOrVideoFile?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																name: string;
																alternativeText?: string;
																caption?: string;
																url: string;
																mime: string;
																formats?: any;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesDownloads';
													downloadsTitle?: any;
													downloads: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																url: string;
																name: string;
																size: number;
																ext?: string;
																caption?: string;
															};
														};
													}>;
													downloadLinks?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedNews';
													featuredNewsTitle?: any;
													items: Array<{
														__typename?: 'Newsarticle';
														data: {
															__typename?: 'Newsarticle';
															documentId: string;
															attributes: {
																__typename: 'Newsarticle';
																firstPublishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
																bodyText: {
																	__typename?: 'ComponentModulesBodyText';
																	bodyText?: string;
																	sidebar?: {
																		__typename?: 'ComponentInternalSidebar';
																		title?: any;
																		links?: Array<{
																			__typename?: 'ComponentComponentsLink';
																			title: string;
																			href: any;
																			description?: string;
																		}>;
																		files: Array<{
																			__typename?: 'UploadFile';
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					ext?: string;
																					mime: string;
																					size: number;
																					url: string;
																					alternativeText?: string;
																					hash: string;
																					name: string;
																					caption?: string;
																				};
																			};
																		}>;
																	};
																	defaultModuleOptions: {
																		__typename?: 'ComponentInternalDefaultModuleOptions';
																		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedPages';
													featuredPagesTitle?: any;
													items: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename: 'Page';
																publishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesHighlight';
													id: string;
													title?: any;
													theme?: {
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string };
														};
													};
													newsTab?: {
														__typename?: 'ComponentInternalHighlightNews';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													eventsTab?: {
														__typename?: 'ComponentInternalHighlightEvents';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													permitsTab?: {
														__typename?: 'ComponentInternalHighlightPermits';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Permit';
															data: {
																__typename?: 'Permit';
																attributes: { __typename: 'Permit'; slug: string; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													wooTab?: {
														__typename?: 'ComponentInternalHighlightWoo';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'WooRequest';
															data: {
																__typename?: 'WooRequest';
																attributes: {
																	__typename: 'WooRequest';
																	title: string;
																	startDate: any;
																	zip?: any;
																	createdAt?: any;
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													mapsAndStatsTab?: {
														__typename?: 'ComponentInternalHighlightMapsAndStats';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'MapsFigure';
															data: {
																__typename?: 'MapsFigure';
																attributes: { __typename: 'MapsFigure'; slug: any; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													topicsTab?: {
														__typename?: 'ComponentInternalHighlightTopics';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													subsidiesTab?: {
														__typename?: 'ComponentInternalHighlightSubsidies';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Subsidy';
															data: {
																__typename?: 'Subsidy';
																attributes: {
																	__typename: 'Subsidy';
																	slug: string;
																	header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesLinkBox';
													title?: any;
													description?: string;
													linkBoxLinks?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesMedia';
													transcript?: string;
													mediaLink?: string;
													mediaTitle?: any;
													mediaDescription?: string;
													media?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																size: number;
																ext?: string;
																url: string;
																alternativeText?: string;
																formats?: any;
																mime: string;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesNewsOverview' }
											| {
													__typename: 'ComponentModulesPhotoAlbum';
													id: string;
													description?: string;
													horizontal?: boolean;
													jsonTitle: any;
													photos: Array<{
														__typename: 'ComponentInternalPhoto';
														id: string;
														title: string;
														description?: string;
														photo: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	width?: number;
																	height?: number;
																	caption?: string;
																	formats?: any;
																	size: number;
																	ext?: string;
																	mime: string;
																};
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesRegions' }
											| {
													__typename: 'ComponentModulesStepByStep';
													title?: any;
													stepByStepCard: Array<{
														__typename: 'ComponentInternalStepByStepCard';
														cardTitle: string;
														cardDescription?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesSubjects';
													id: string;
													description?: string;
													overviewTitle?: string;
													subjects: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename?: 'Page';
																title: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													projects: Array<{
														__typename?: 'Project';
														data: {
															__typename?: 'Project';
															documentId: string;
															attributes: {
																__typename?: 'Project';
																title?: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													themes: Array<{
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string; slug: string };
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesThemes' }
											| { __typename?: 'Error' }
										>;
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesThemes';
							title?: any;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: {
										__typename?: 'Theme';
										title: string;
										slug: string;
										header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetPermitDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPermitDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	permitDetail?: {
		__typename?: 'PermitDetail';
		data: {
			__typename?: 'PermitDetail';
			documentId: string;
			attributes: {
				__typename?: 'PermitDetail';
				locale?: string;
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	permitBySlug?: {
		__typename?: 'Permit';
		data: {
			__typename?: 'Permit';
			documentId: string;
			attributes: {
				__typename?: 'Permit';
				publishedAt?: any;
				updatedAt?: any;
				title: string;
				slug: string;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				permitLaws: Array<{
					__typename?: 'PermitLaw';
					data: {
						__typename?: 'PermitLaw';
						documentId: string;
						attributes: { __typename?: 'PermitLaw'; name: string };
					};
				}>;
				permitProductTypes: Array<{
					__typename?: 'PermitProductType';
					data: {
						__typename?: 'PermitProductType';
						documentId: string;
						attributes: { __typename?: 'PermitProductType'; name: string };
					};
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetPermitsOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPermitsOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	permitsOverview?: {
		__typename?: 'PermitsOverview';
		data: {
			__typename?: 'PermitsOverview';
			documentId: string;
			attributes: {
				__typename?: 'PermitsOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPermitsOverview';
							id: string;
							headerTitle: string;
							searchPlaceholderText: string;
							themeFilterText: string;
							lawFilterText: string;
							productTypeFilterText: string;
							showAllThemesText: string;
							showAllLawsText: string;
							showAllProductTypesText: string;
							overviewTitleText: string;
							showResultsText: string;
							filterHeaderText: string;
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	permitLaws_connection?: {
		__typename?: 'PermitLawEntityResponseCollection';
		data: Array<{
			__typename?: 'PermitLaw';
			documentId: string;
			attributes: { __typename?: 'PermitLaw'; name: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	permitProductTypes_connection?: {
		__typename?: 'PermitProductTypeEntityResponseCollection';
		data: Array<{
			__typename?: 'PermitProductType';
			documentId: string;
			attributes: { __typename?: 'PermitProductType'; name: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	themes_connection?: {
		__typename?: 'ThemeEntityResponseCollection';
		data: Array<{
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetPressReleaseDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
	slug: Scalars['String'];
}>;

export type GetPressReleaseDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	pressReleaseDetail?: {
		__typename?: 'PressReleaseDetail';
		data: {
			__typename?: 'PressReleaseDetail';
			documentId: string;
			attributes: {
				__typename: 'PressReleaseDetail';
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
	pressReleaseBySlug?: {
		__typename?: 'PressRelease';
		data: {
			__typename?: 'PressRelease';
			documentId: string;
			attributes: {
				__typename?: 'PressRelease';
				title: string;
				locale?: string;
				firstPublishedAt?: any;
				slug: string;
				allowedOnHomePage?: boolean;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				theme: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesFeaturedNews' }
					| { __typename?: 'ComponentModulesFeaturedPages' }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetPressReleaseOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPressReleaseOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	pressReleaseOverview?: {
		__typename?: 'PressReleaseOverview';
		data: {
			__typename?: 'PressReleaseOverview';
			documentId: string;
			attributes: {
				__typename?: 'PressReleaseOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'ComponentModulesLinkBox' }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPressReleaseOverview';
							id: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	pressReleases_connection?: {
		__typename?: 'PressReleaseEntityResponseCollection';
		data: Array<{
			__typename?: 'PressRelease';
			documentId: string;
			attributes: {
				__typename?: 'PressRelease';
				title: string;
				locale?: string;
				firstPublishedAt?: any;
				slug: string;
				allowedOnHomePage?: boolean;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				theme: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesFeaturedNews' }
					| { __typename?: 'ComponentModulesFeaturedPages' }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetPrivacyPolicyQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetPrivacyPolicyQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	privacyPolicy?: {
		__typename?: 'PrivacyPolicy';
		data: {
			__typename?: 'PrivacyPolicy';
			documentId: string;
			attributes: {
				__typename: 'PrivacyPolicy';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				bodytext: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	};
};

export type GetProjectDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetProjectDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	projectDetail?: {
		__typename?: 'ProjectDetail';
		data: {
			__typename?: 'ProjectDetail';
			documentId: string;
			attributes: {
				__typename?: 'ProjectDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	projectBySlug?: {
		__typename?: 'Project';
		data: {
			__typename?: 'Project';
			documentId: string;
			attributes: {
				__typename?: 'Project';
				title?: string;
				firstPublishedAt?: any;
				updatedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetProjectOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetProjectOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	projectOverview?: {
		__typename?: 'ProjectOverview';
		data: {
			__typename?: 'ProjectOverview';
			documentId: string;
			attributes: {
				__typename?: 'ProjectOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| { __typename: 'ComponentModulesAccordeon' }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'ComponentModulesPartners' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesProjectOverview';
							id: string;
							filterLabel?: string;
							extendedDefaultModuleOptions?: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'ComponentModulesScheduling' }
					| { __typename: 'ComponentModulesStepByStep' }
					| { __typename: 'ComponentModulesSubjects' }
					| { __typename: 'ComponentModulesTable' }
					| { __typename: 'ComponentModulesTestimonial' }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	themes_connection?: {
		__typename?: 'ThemeEntityResponseCollection';
		data: Array<{
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetRegioExpresHomepageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRegioExpresHomepageQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regioExpresHomepage?: {
		__typename?: 'RegioExpresHomepage';
		data: {
			__typename?: 'RegioExpresHomepage';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresHomepage';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesHomepageHeader';
					id: string;
					description?: string;
					popularHeader?: string;
					homepageTitle?: string;
					backgroundImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNewsRegioExpres';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'RegioExpresNewsarticle';
								data: {
									__typename?: 'RegioExpresNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'RegioExpresNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetRegioExpresInConvoWithDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRegioExpresInConvoWithDetailQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regioExpresInConvoWithDetail?: {
		__typename?: 'RegioExpresInConvoWithDetail';
		data: {
			__typename?: 'RegioExpresInConvoWithDetail';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInConvoWithDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	regioExpresInConvoWithArticleBySlug?: {
		__typename?: 'RegioExpresInConvoWithArticle';
		data: {
			__typename?: 'RegioExpresInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetRegioExpresInConvoWithOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRegioExpresInConvoWithOverviewQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regioExpresInConvoOverview?: {
		__typename?: 'RegioExpresInConvoOverview';
		data: {
			__typename?: 'RegioExpresInConvoOverview';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInConvoOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesInConvoWithOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	regioExpresInConvoWithArticles_connection?: {
		__typename?: 'RegioExpresInConvoWithArticleEntityResponseCollection';
		data: Array<{
			__typename?: 'RegioExpresInConvoWithArticle';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInConvoWithArticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetRegioExpresNewsDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRegioExpresNewsDetailQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regioExpresNewsDetail?: {
		__typename?: 'RegioExpresNewsDetail';
		data: {
			__typename?: 'RegioExpresNewsDetail';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresNewsDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNewsRegioExpres';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'RegioExpresNewsarticle';
								data: {
									__typename?: 'RegioExpresNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'RegioExpresNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	regioExpresNewsarticleBySlug?: {
		__typename?: 'RegioExpresNewsarticle';
		data: {
			__typename?: 'RegioExpresNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresNewsarticle';
				title: string;
				firstPublishedAt?: any;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				tags: Array<{
					__typename?: 'Tag';
					data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNewsRegioExpres';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'RegioExpresNewsarticle';
								data: {
									__typename?: 'RegioExpresNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'RegioExpresNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetRegioExpresNewsOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRegioExpresNewsOverviewQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regioExpresNewsOverview?: {
		__typename?: 'RegioExpresNewsOverview';
		data: {
			__typename?: 'RegioExpresNewsOverview';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresNewsOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesNewsOverview';
							id: string;
							filterLabel?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetRegioExpresPageQueryVariables = Exact<{
	slug: Scalars['String'];
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRegioExpresPageQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regioExpresPageBySlug?: {
		__typename?: 'RegioExpresPage';
		data: {
			__typename?: 'RegioExpresPage';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresPage';
				title: string;
				slug: string;
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNewsRegioExpres';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'RegioExpresNewsarticle';
								data: {
									__typename?: 'RegioExpresNewsarticle';
									documentId: string;
									attributes: {
										__typename?: 'RegioExpresNewsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTestimonial';
							id: string;
							quote?: string;
							name: string;
							organization?: string;
							quoteTitle: any;
							photo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							logo?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetRegionDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
	slug: Scalars['String'];
}>;

export type GetRegionDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regionDetail?: {
		__typename?: 'RegionDetail';
		data: {
			__typename?: 'RegionDetail';
			documentId: string;
			attributes: {
				__typename: 'RegionDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
	regionBySlug?: {
		__typename?: 'Region';
		data: {
			__typename?: 'Region';
			documentId: string;
			attributes: {
				__typename: 'Region';
				title?: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type RegionDetailFieldsFragment = {
	__typename: 'RegionDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesRegions' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesThemes' }
		| { __typename?: 'Error' }
	>;
};

export type GetRegionOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRegionOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regionOverview?: {
		__typename?: 'RegionOverview';
		data: {
			__typename?: 'RegionOverview';
			documentId: string;
			attributes: {
				__typename?: 'RegionOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesRegions';
							title?: any;
							regions: Array<{
								__typename?: 'Region';
								data: {
									__typename?: 'Region';
									documentId: string;
									attributes: {
										__typename: 'Region';
										title?: string;
										slug: string;
										locale?: string;
										header?: {
											__typename?: 'ComponentModulesExpandedHeader';
											headerTitle?: string;
											headerDescription?: string;
											title?: string;
											description?: string;
											headerButton?: {
												__typename?: 'ComponentComponentsButton';
												title?: string;
												variant: Enum_Componentcomponentsbutton_Variant;
												href: any;
												iconLeft?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
												iconRight?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
											};
											headerImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														name: string;
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										seo: {
											__typename?: 'ComponentModulesSeo';
											title?: string;
											description?: string;
											noIndex?: boolean;
											noFollow?: boolean;
											ogTitle?: string;
											ogDescription?: string;
											ogType?: string;
											ogUrl?: string;
											ogImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										};
										modules?: Array<
											| {
													__typename: 'ComponentModulesAccordeon';
													accordeonTitle?: any;
													sections: Array<{
														__typename: 'ComponentInternalAccordeonSection';
														accordeonSectionName?: string;
														items: Array<{
															__typename: 'ComponentInternalAccordeonItem';
															itemTitle: string;
															description?: string;
														}>;
													}>;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesBbvmsMediaplayer';
													videoId: string;
													playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
													url?: string;
													title?: any;
													description?: string;
													transcript?: string;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyText';
													bodyText?: string;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyTextTwoColumn';
													leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesCta';
													description?: string;
													imagePosition?: Enum_Componentmodulescta_Imageposition;
													videoLink?: string;
													ctaTitle?: any;
													buttons?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
													}>;
													imageOrVideoFile?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																name: string;
																alternativeText?: string;
																caption?: string;
																url: string;
																mime: string;
																formats?: any;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesDownloads';
													downloadsTitle?: any;
													downloads: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																url: string;
																name: string;
																size: number;
																ext?: string;
																caption?: string;
															};
														};
													}>;
													downloadLinks?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedNews';
													featuredNewsTitle?: any;
													items: Array<{
														__typename?: 'Newsarticle';
														data: {
															__typename?: 'Newsarticle';
															documentId: string;
															attributes: {
																__typename: 'Newsarticle';
																firstPublishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
																bodyText: {
																	__typename?: 'ComponentModulesBodyText';
																	bodyText?: string;
																	sidebar?: {
																		__typename?: 'ComponentInternalSidebar';
																		title?: any;
																		links?: Array<{
																			__typename?: 'ComponentComponentsLink';
																			title: string;
																			href: any;
																			description?: string;
																		}>;
																		files: Array<{
																			__typename?: 'UploadFile';
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					ext?: string;
																					mime: string;
																					size: number;
																					url: string;
																					alternativeText?: string;
																					hash: string;
																					name: string;
																					caption?: string;
																				};
																			};
																		}>;
																	};
																	defaultModuleOptions: {
																		__typename?: 'ComponentInternalDefaultModuleOptions';
																		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedPages';
													featuredPagesTitle?: any;
													items: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename: 'Page';
																publishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesHighlight';
													id: string;
													title?: any;
													theme?: {
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string };
														};
													};
													newsTab?: {
														__typename?: 'ComponentInternalHighlightNews';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													eventsTab?: {
														__typename?: 'ComponentInternalHighlightEvents';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													permitsTab?: {
														__typename?: 'ComponentInternalHighlightPermits';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Permit';
															data: {
																__typename?: 'Permit';
																attributes: { __typename: 'Permit'; slug: string; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													wooTab?: {
														__typename?: 'ComponentInternalHighlightWoo';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'WooRequest';
															data: {
																__typename?: 'WooRequest';
																attributes: {
																	__typename: 'WooRequest';
																	title: string;
																	startDate: any;
																	zip?: any;
																	createdAt?: any;
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													mapsAndStatsTab?: {
														__typename?: 'ComponentInternalHighlightMapsAndStats';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'MapsFigure';
															data: {
																__typename?: 'MapsFigure';
																attributes: { __typename: 'MapsFigure'; slug: any; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													topicsTab?: {
														__typename?: 'ComponentInternalHighlightTopics';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													subsidiesTab?: {
														__typename?: 'ComponentInternalHighlightSubsidies';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Subsidy';
															data: {
																__typename?: 'Subsidy';
																attributes: {
																	__typename: 'Subsidy';
																	slug: string;
																	header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesLinkBox';
													title?: any;
													description?: string;
													linkBoxLinks?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesMedia';
													transcript?: string;
													mediaLink?: string;
													mediaTitle?: any;
													mediaDescription?: string;
													media?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																size: number;
																ext?: string;
																url: string;
																alternativeText?: string;
																formats?: any;
																mime: string;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesNewsOverview' }
											| {
													__typename: 'ComponentModulesPhotoAlbum';
													id: string;
													description?: string;
													horizontal?: boolean;
													jsonTitle: any;
													photos: Array<{
														__typename: 'ComponentInternalPhoto';
														id: string;
														title: string;
														description?: string;
														photo: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	width?: number;
																	height?: number;
																	caption?: string;
																	formats?: any;
																	size: number;
																	ext?: string;
																	mime: string;
																};
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesRegions' }
											| {
													__typename: 'ComponentModulesStepByStep';
													title?: any;
													stepByStepCard: Array<{
														__typename: 'ComponentInternalStepByStepCard';
														cardTitle: string;
														cardDescription?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesSubjects';
													id: string;
													description?: string;
													overviewTitle?: string;
													subjects: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename?: 'Page';
																title: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													projects: Array<{
														__typename?: 'Project';
														data: {
															__typename?: 'Project';
															documentId: string;
															attributes: {
																__typename?: 'Project';
																title?: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													themes: Array<{
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string; slug: string };
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesThemes' }
											| { __typename?: 'Error' }
										>;
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesScheduling' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesTable' }
					| {
							__typename?: 'ComponentModulesThemes';
							title?: any;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: {
										__typename?: 'Theme';
										title: string;
										slug: string;
										header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type RegionOverviewSingleFieldsFragment = {
	__typename?: 'RegionOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesRegions';
				title?: any;
				regions: Array<{
					__typename?: 'Region';
					data: {
						__typename?: 'Region';
						documentId: string;
						attributes: {
							__typename: 'Region';
							title?: string;
							slug: string;
							locale?: string;
							header?: {
								__typename?: 'ComponentModulesExpandedHeader';
								headerTitle?: string;
								headerDescription?: string;
								title?: string;
								description?: string;
								headerButton?: {
									__typename?: 'ComponentComponentsButton';
									title?: string;
									variant: Enum_Componentcomponentsbutton_Variant;
									href: any;
									iconLeft?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
									iconRight?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
								};
								headerImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											name: string;
											url: string;
											alternativeText?: string;
											formats?: any;
										};
									};
								};
							};
							seo: {
								__typename?: 'ComponentModulesSeo';
								title?: string;
								description?: string;
								noIndex?: boolean;
								noFollow?: boolean;
								ogTitle?: string;
								ogDescription?: string;
								ogType?: string;
								ogUrl?: string;
								ogImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							};
							modules?: Array<
								| {
										__typename: 'ComponentModulesAccordeon';
										accordeonTitle?: any;
										sections: Array<{
											__typename: 'ComponentInternalAccordeonSection';
											accordeonSectionName?: string;
											items: Array<{
												__typename: 'ComponentInternalAccordeonItem';
												itemTitle: string;
												description?: string;
											}>;
										}>;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesBbvmsMediaplayer';
										videoId: string;
										playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
										url?: string;
										title?: any;
										description?: string;
										transcript?: string;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyText';
										bodyText?: string;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyTextTwoColumn';
										leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesCta';
										description?: string;
										imagePosition?: Enum_Componentmodulescta_Imageposition;
										videoLink?: string;
										ctaTitle?: any;
										buttons?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										}>;
										imageOrVideoFile?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													name: string;
													alternativeText?: string;
													caption?: string;
													url: string;
													mime: string;
													formats?: any;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesDownloads';
										downloadsTitle?: any;
										downloads: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													url: string;
													name: string;
													size: number;
													ext?: string;
													caption?: string;
												};
											};
										}>;
										downloadLinks?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedNews';
										featuredNewsTitle?: any;
										items: Array<{
											__typename?: 'Newsarticle';
											data: {
												__typename?: 'Newsarticle';
												documentId: string;
												attributes: {
													__typename: 'Newsarticle';
													firstPublishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													bodyText: {
														__typename?: 'ComponentModulesBodyText';
														bodyText?: string;
														sidebar?: {
															__typename?: 'ComponentInternalSidebar';
															title?: any;
															links?: Array<{
																__typename?: 'ComponentComponentsLink';
																title: string;
																href: any;
																description?: string;
															}>;
															files: Array<{
																__typename?: 'UploadFile';
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		ext?: string;
																		mime: string;
																		size: number;
																		url: string;
																		alternativeText?: string;
																		hash: string;
																		name: string;
																		caption?: string;
																	};
																};
															}>;
														};
														defaultModuleOptions: {
															__typename?: 'ComponentInternalDefaultModuleOptions';
															backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
															padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedPages';
										featuredPagesTitle?: any;
										items: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: {
													__typename: 'Page';
													publishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesHighlight';
										id: string;
										title?: any;
										theme?: {
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string };
											};
										};
										newsTab?: {
											__typename?: 'ComponentInternalHighlightNews';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										eventsTab?: {
											__typename?: 'ComponentInternalHighlightEvents';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										permitsTab?: {
											__typename?: 'ComponentInternalHighlightPermits';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Permit';
												data: {
													__typename?: 'Permit';
													attributes: { __typename: 'Permit'; slug: string; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										wooTab?: {
											__typename?: 'ComponentInternalHighlightWoo';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'WooRequest';
												data: {
													__typename?: 'WooRequest';
													attributes: {
														__typename: 'WooRequest';
														title: string;
														startDate: any;
														zip?: any;
														createdAt?: any;
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										mapsAndStatsTab?: {
											__typename?: 'ComponentInternalHighlightMapsAndStats';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'MapsFigure';
												data: {
													__typename?: 'MapsFigure';
													attributes: { __typename: 'MapsFigure'; slug: any; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										topicsTab?: {
											__typename?: 'ComponentInternalHighlightTopics';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										subsidiesTab?: {
											__typename?: 'ComponentInternalHighlightSubsidies';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Subsidy';
												data: {
													__typename?: 'Subsidy';
													attributes: {
														__typename: 'Subsidy';
														slug: string;
														header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesLinkBox';
										title?: any;
										description?: string;
										linkBoxLinks?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesMedia';
										transcript?: string;
										mediaLink?: string;
										mediaTitle?: any;
										mediaDescription?: string;
										media?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													size: number;
													ext?: string;
													url: string;
													alternativeText?: string;
													formats?: any;
													mime: string;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesNewsOverview' }
								| {
										__typename: 'ComponentModulesPhotoAlbum';
										id: string;
										description?: string;
										horizontal?: boolean;
										jsonTitle: any;
										photos: Array<{
											__typename: 'ComponentInternalPhoto';
											id: string;
											title: string;
											description?: string;
											photo: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														width?: number;
														height?: number;
														caption?: string;
														formats?: any;
														size: number;
														ext?: string;
														mime: string;
													};
												};
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesRegions' }
								| {
										__typename: 'ComponentModulesStepByStep';
										title?: any;
										stepByStepCard: Array<{
											__typename: 'ComponentInternalStepByStepCard';
											cardTitle: string;
											cardDescription?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesSubjects';
										id: string;
										description?: string;
										overviewTitle?: string;
										subjects: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
											};
										}>;
										projects: Array<{
											__typename?: 'Project';
											data: {
												__typename?: 'Project';
												documentId: string;
												attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
											};
										}>;
										themes: Array<{
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string; slug: string };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesThemes' }
								| { __typename?: 'Error' }
							>;
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesTable' }
		| {
				__typename?: 'ComponentModulesThemes';
				title?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: {
							__typename?: 'Theme';
							title: string;
							slug: string;
							header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type GetRoadMaintenanceDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRoadMaintenanceDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	roadMaintenanceDetail?: {
		__typename?: 'RoadMaintenanceDetail';
		data: {
			__typename?: 'RoadMaintenanceDetail';
			documentId: string;
			attributes: {
				__typename?: 'RoadMaintenanceDetail';
				locale?: string;
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename: 'ComponentModulesScheduling' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	roadMaintenanceBySlug?: {
		__typename?: 'RoadMaintenance';
		data: {
			__typename?: 'RoadMaintenance';
			documentId: string;
			attributes: {
				__typename: 'RoadMaintenance';
				title: string;
				slug: string;
				locale?: string;
				roadMaintenanceStatus?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				aboutMaintenance: {
					__typename: 'ComponentInternalAboutMaintenance';
					startDate?: any;
					endDate?: any;
					contractor?: string;
					contractorWebsite?: string;
					detour?: string;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetRoadMaintenanceOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetRoadMaintenanceOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	roadMaintenanceOverview?: {
		__typename?: 'RoadMaintenanceOverview';
		data: {
			__typename?: 'RoadMaintenanceOverview';
			documentId: string;
			attributes: {
				__typename?: 'RoadMaintenanceOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				list: { __typename: 'ComponentModulesRoadMaintenanceOverview'; id: string; title: string };
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'ComponentModulesPhotoAlbum' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	themes_connection?: {
		__typename?: 'ThemeEntityResponseCollection';
		data: Array<{
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetSearchOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetSearchOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	searchOverview?: {
		__typename?: 'SearchOverview';
		data: {
			__typename?: 'SearchOverview';
			documentId: string;
			attributes: {
				__typename?: 'SearchOverview';
				searchHeader?: {
					__typename?: 'ComponentModulesSearchHeader';
					id: string;
					title?: string;
					searchPlaceholder?: string;
				};
				Zoekresultaten: { __typename?: 'ComponentModulesSearchOverview'; id: string; resultLabel?: string };
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetLocalSitemapCondoleanceQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetLocalSitemapCondoleanceQuery = {
	__typename?: 'Query';
	condoleanceInformation?: {
		__typename?: 'CondoleanceInformation';
		data: {
			__typename?: 'CondoleanceInformation';
			documentId: string;
			attributes: {
				__typename?: 'CondoleanceInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	sitemap?: {
		__typename?: 'Sitemap';
		data: {
			__typename?: 'Sitemap';
			documentId: string;
			attributes: {
				__typename?: 'Sitemap';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetLocalSitemapEfroOostQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetLocalSitemapEfroOostQuery = {
	__typename?: 'Query';
	efroOostInformation?: {
		__typename?: 'EfroOostInformation';
		data: {
			__typename?: 'EfroOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	sitemap?: {
		__typename?: 'Sitemap';
		data: {
			__typename?: 'Sitemap';
			documentId: string;
			attributes: {
				__typename?: 'Sitemap';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetLocalSitemapGeolinkQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetLocalSitemapGeolinkQuery = {
	__typename?: 'Query';
	geolinkInformation?: {
		__typename?: 'GeolinkInformation';
		data: {
			__typename?: 'GeolinkInformation';
			documentId: string;
			attributes: {
				__typename?: 'GeolinkInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	sitemap?: {
		__typename?: 'Sitemap';
		data: {
			__typename?: 'Sitemap';
			documentId: string;
			attributes: {
				__typename?: 'Sitemap';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetLocalSitemapOpOostQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetLocalSitemapOpOostQuery = {
	__typename?: 'Query';
	opOostInformation?: {
		__typename?: 'OpOostInformation';
		data: {
			__typename?: 'OpOostInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpOostInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	sitemap?: {
		__typename?: 'Sitemap';
		data: {
			__typename?: 'Sitemap';
			documentId: string;
			attributes: {
				__typename?: 'Sitemap';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetLocalSitemapRegioExpresQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetLocalSitemapRegioExpresQuery = {
	__typename?: 'Query';
	regioExpresInformation?: {
		__typename?: 'RegioExpresInformation';
		data: {
			__typename?: 'RegioExpresInformation';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	sitemap?: {
		__typename?: 'Sitemap';
		data: {
			__typename?: 'Sitemap';
			documentId: string;
			attributes: {
				__typename?: 'Sitemap';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetLocalSitemapQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
}>;

export type GetLocalSitemapQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	sitemap?: {
		__typename?: 'Sitemap';
		data: {
			__typename?: 'Sitemap';
			documentId: string;
			attributes: {
				__typename?: 'Sitemap';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetSubsidyDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetSubsidyDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	subsidyDetail?: {
		__typename?: 'SubsidyDetail';
		data: {
			__typename?: 'SubsidyDetail';
			documentId: string;
			attributes: {
				__typename?: 'SubsidyDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesPhotoAlbum' }
					| { __typename?: 'ComponentModulesRegions' }
					| { __typename?: 'ComponentModulesScheduling' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
	subsidyBySlug?: {
		__typename?: 'Subsidy';
		data: {
			__typename?: 'Subsidy';
			documentId: string;
			attributes: {
				__typename?: 'Subsidy';
				title: string;
				slug: string;
				subsidyCeiling?: string;
				subsidystatus: string;
				updatedAt?: any;
				endDate?: any;
				targetGroupText?: string;
				hideFromOverview: boolean;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				subsidy_scales: Array<{
					__typename?: 'SubsidyScale';
					data: {
						__typename?: 'SubsidyScale';
						documentId: string;
						attributes: { __typename?: 'SubsidyScale'; name?: string };
					};
				}>;
				subsidy_kinds: Array<{
					__typename?: 'SubsidyKind';
					data: {
						__typename?: 'SubsidyKind';
						documentId: string;
						attributes: { __typename?: 'SubsidyKind'; name?: string };
					};
				}>;
				target_groups: Array<{
					__typename?: 'TargetGroup';
					data: {
						__typename?: 'TargetGroup';
						documentId: string;
						attributes: { __typename?: 'TargetGroup'; name?: string };
					};
				}>;
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesScheduling';
							title?: any;
							firstColumnTitle: string;
							secondColumnTitle?: string;
							firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
							secondColumnRows?: Array<{
								__typename: 'ComponentInternalSecondColumnItems';
								id: string;
								bodyText?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesTable';
							table?: string;
							tableTitle?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type GetSubsidyOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetSubsidyOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	subsidyOverview?: {
		__typename?: 'SubsidyOverview';
		data: {
			__typename?: 'SubsidyOverview';
			documentId: string;
			attributes: {
				__typename?: 'SubsidyOverview';
				locale?: string;
				publishedAt?: any;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| { __typename?: 'ComponentModulesAccordeon' }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesDownloads' }
					| { __typename?: 'ComponentModulesFeaturedNews' }
					| { __typename?: 'ComponentModulesFeaturedPages' }
					| { __typename?: 'ComponentModulesHighlight' }
					| { __typename?: 'ComponentModulesLinkBox' }
					| { __typename?: 'ComponentModulesMedia' }
					| { __typename?: 'ComponentModulesPhotoAlbum' }
					| { __typename?: 'ComponentModulesRegions' }
					| { __typename?: 'ComponentModulesSubjects' }
					| {
							__typename?: 'ComponentModulesSubsidyOverview';
							id: string;
							showResultsText: string;
							headerTitle: string;
							searchPlaceholderText: string;
							themeFilterText: string;
							showMoreThemesText: string;
							showLessThemesText: string;
							targetGroupFilterText: string;
							kindFilterText: string;
							scaleFilterText: string;
							overviewTitleText: string;
							filterHeaderText: string;
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
	kinds?: {
		__typename?: 'SubsidyKindEntityResponseCollection';
		data: Array<{
			__typename?: 'SubsidyKind';
			documentId: string;
			attributes: { __typename?: 'SubsidyKind'; name?: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	scales?: {
		__typename?: 'SubsidyScaleEntityResponseCollection';
		data: Array<{
			__typename?: 'SubsidyScale';
			documentId: string;
			attributes: { __typename?: 'SubsidyScale'; name?: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	groups?: {
		__typename?: 'TargetGroupEntityResponseCollection';
		data: Array<{
			__typename?: 'TargetGroup';
			documentId: string;
			attributes: { __typename?: 'TargetGroup'; name?: string };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	themes: Array<{
		__typename?: 'Theme';
		data: {
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	}>;
	themes_connection?: {
		__typename?: 'ThemeEntityResponseCollection';
		data: Array<{
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetThemeDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
	slug: Scalars['String'];
}>;

export type GetThemeDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	themeDetail?: {
		__typename?: 'ThemeDetail';
		data: {
			__typename?: 'ThemeDetail';
			documentId: string;
			attributes: {
				__typename: 'ThemeDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
	themeBySlug?: {
		__typename?: 'Theme';
		data: {
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename: 'Theme';
				documentId: string;
				title: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type ThemeDetailFieldsFragment = {
	__typename: 'ThemeDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesRegions' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesThemes' }
		| { __typename?: 'Error' }
	>;
};

export type GetThemeOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetThemeOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	themeOverview?: {
		__typename?: 'ThemeOverview';
		data: {
			__typename?: 'ThemeOverview';
			documentId: string;
			attributes: {
				__typename?: 'ThemeOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesRegions';
							title?: any;
							regions: Array<{
								__typename?: 'Region';
								data: {
									__typename?: 'Region';
									documentId: string;
									attributes: {
										__typename: 'Region';
										title?: string;
										slug: string;
										locale?: string;
										header?: {
											__typename?: 'ComponentModulesExpandedHeader';
											headerTitle?: string;
											headerDescription?: string;
											title?: string;
											description?: string;
											headerButton?: {
												__typename?: 'ComponentComponentsButton';
												title?: string;
												variant: Enum_Componentcomponentsbutton_Variant;
												href: any;
												iconLeft?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
												iconRight?: {
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: { __typename?: 'UploadFile'; url: string; name: string };
													};
												};
											};
											headerImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														name: string;
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										seo: {
											__typename?: 'ComponentModulesSeo';
											title?: string;
											description?: string;
											noIndex?: boolean;
											noFollow?: boolean;
											ogTitle?: string;
											ogDescription?: string;
											ogType?: string;
											ogUrl?: string;
											ogImage?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										};
										modules?: Array<
											| {
													__typename: 'ComponentModulesAccordeon';
													accordeonTitle?: any;
													sections: Array<{
														__typename: 'ComponentInternalAccordeonSection';
														accordeonSectionName?: string;
														items: Array<{
															__typename: 'ComponentInternalAccordeonItem';
															itemTitle: string;
															description?: string;
														}>;
													}>;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesBbvmsMediaplayer';
													videoId: string;
													playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
													url?: string;
													title?: any;
													description?: string;
													transcript?: string;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyText';
													bodyText?: string;
													sidebar?: {
														__typename?: 'ComponentInternalSidebar';
														title?: any;
														links?: Array<{
															__typename?: 'ComponentComponentsLink';
															title: string;
															href: any;
															description?: string;
														}>;
														files: Array<{
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	ext?: string;
																	mime: string;
																	size: number;
																	url: string;
																	alternativeText?: string;
																	hash: string;
																	name: string;
																	caption?: string;
																};
															};
														}>;
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesBodyTextTwoColumn';
													leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesCta';
													description?: string;
													imagePosition?: Enum_Componentmodulescta_Imageposition;
													videoLink?: string;
													ctaTitle?: any;
													buttons?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: { __typename?: 'UploadFile'; url: string; name: string };
															};
														};
													}>;
													imageOrVideoFile?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																name: string;
																alternativeText?: string;
																caption?: string;
																url: string;
																mime: string;
																formats?: any;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesDownloads';
													downloadsTitle?: any;
													downloads: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																url: string;
																name: string;
																size: number;
																ext?: string;
																caption?: string;
															};
														};
													}>;
													downloadLinks?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedNews';
													featuredNewsTitle?: any;
													items: Array<{
														__typename?: 'Newsarticle';
														data: {
															__typename?: 'Newsarticle';
															documentId: string;
															attributes: {
																__typename: 'Newsarticle';
																firstPublishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
																bodyText: {
																	__typename?: 'ComponentModulesBodyText';
																	bodyText?: string;
																	sidebar?: {
																		__typename?: 'ComponentInternalSidebar';
																		title?: any;
																		links?: Array<{
																			__typename?: 'ComponentComponentsLink';
																			title: string;
																			href: any;
																			description?: string;
																		}>;
																		files: Array<{
																			__typename?: 'UploadFile';
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					ext?: string;
																					mime: string;
																					size: number;
																					url: string;
																					alternativeText?: string;
																					hash: string;
																					name: string;
																					caption?: string;
																				};
																			};
																		}>;
																	};
																	defaultModuleOptions: {
																		__typename?: 'ComponentInternalDefaultModuleOptions';
																		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesFeaturedPages';
													featuredPagesTitle?: any;
													items: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename: 'Page';
																publishedAt?: any;
																title: string;
																slug: string;
																header: {
																	__typename?: 'ComponentModulesIntroHeaderImage';
																	title: string;
																	excerpt?: string;
																	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																	cover?: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																		data: {
																			__typename?: 'UploadFile';
																			documentId: string;
																			attributes: {
																				__typename?: 'UploadFile';
																				url: string;
																				alternativeText?: string;
																				formats?: any;
																			};
																		};
																	};
																};
															};
														};
													}>;
													cta?: {
														__typename?: 'ComponentComponentsButton';
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														ctaTitle?: string;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename: 'ComponentModulesHighlight';
													id: string;
													title?: any;
													theme?: {
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string };
														};
													};
													newsTab?: {
														__typename?: 'ComponentInternalHighlightNews';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													eventsTab?: {
														__typename?: 'ComponentInternalHighlightEvents';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													permitsTab?: {
														__typename?: 'ComponentInternalHighlightPermits';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Permit';
															data: {
																__typename?: 'Permit';
																attributes: { __typename: 'Permit'; slug: string; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													wooTab?: {
														__typename?: 'ComponentInternalHighlightWoo';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'WooRequest';
															data: {
																__typename?: 'WooRequest';
																attributes: {
																	__typename: 'WooRequest';
																	title: string;
																	startDate: any;
																	zip?: any;
																	createdAt?: any;
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													mapsAndStatsTab?: {
														__typename?: 'ComponentInternalHighlightMapsAndStats';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'MapsFigure';
															data: {
																__typename?: 'MapsFigure';
																attributes: { __typename: 'MapsFigure'; slug: any; title: string };
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													topicsTab?: {
														__typename?: 'ComponentInternalHighlightTopics';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Newsarticle';
															data: {
																__typename?: 'Newsarticle';
																attributes: {
																	__typename: 'Newsarticle';
																	firstPublishedAt?: any;
																	title: string;
																	slug: string;
																	header: {
																		__typename?: 'ComponentModulesIntroHeaderImage';
																		title: string;
																		excerpt?: string;
																		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
																		cover?: {
																			__typename?: 'UploadFile';
																			url: string;
																			alternativeText?: string;
																			formats?: any;
																			data: {
																				__typename?: 'UploadFile';
																				documentId: string;
																				attributes: {
																					__typename?: 'UploadFile';
																					url: string;
																					alternativeText?: string;
																					formats?: any;
																				};
																			};
																		};
																	};
																	bodyText: {
																		__typename?: 'ComponentModulesBodyText';
																		bodyText?: string;
																		sidebar?: {
																			__typename?: 'ComponentInternalSidebar';
																			title?: any;
																			links?: Array<{
																				__typename?: 'ComponentComponentsLink';
																				title: string;
																				href: any;
																				description?: string;
																			}>;
																			files: Array<{
																				__typename?: 'UploadFile';
																				data: {
																					__typename?: 'UploadFile';
																					documentId: string;
																					attributes: {
																						__typename?: 'UploadFile';
																						ext?: string;
																						mime: string;
																						size: number;
																						url: string;
																						alternativeText?: string;
																						hash: string;
																						name: string;
																						caption?: string;
																					};
																				};
																			}>;
																		};
																		defaultModuleOptions: {
																			__typename?: 'ComponentInternalDefaultModuleOptions';
																			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
																		};
																	};
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													subsidiesTab?: {
														__typename?: 'ComponentInternalHighlightSubsidies';
														id: string;
														title?: string;
														buttonTitle?: string;
														buttonHref?: any;
														items: Array<{
															__typename?: 'Subsidy';
															data: {
																__typename?: 'Subsidy';
																attributes: {
																	__typename: 'Subsidy';
																	slug: string;
																	header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
																};
															};
														}>;
														empty?: {
															__typename?: 'ComponentInternalEmptyState';
															message?: string;
															title?: string;
															href?: string;
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesLinkBox';
													title?: any;
													description?: string;
													linkBoxLinks?: Array<{
														__typename?: 'ComponentComponentsButton';
														title?: string;
														variant: Enum_Componentcomponentsbutton_Variant;
														href: any;
														iconLeft?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
														iconRight?: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																attributes: { __typename?: 'UploadFile'; url: string };
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
														extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
														extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesMedia';
													transcript?: string;
													mediaLink?: string;
													mediaTitle?: any;
													mediaDescription?: string;
													media?: {
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																size: number;
																ext?: string;
																url: string;
																alternativeText?: string;
																formats?: any;
																mime: string;
															};
														};
													};
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesNewsOverview' }
											| {
													__typename: 'ComponentModulesPhotoAlbum';
													id: string;
													description?: string;
													horizontal?: boolean;
													jsonTitle: any;
													photos: Array<{
														__typename: 'ComponentInternalPhoto';
														id: string;
														title: string;
														description?: string;
														photo: {
															__typename?: 'UploadFile';
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	width?: number;
																	height?: number;
																	caption?: string;
																	formats?: any;
																	size: number;
																	ext?: string;
																	mime: string;
																};
															};
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesRegions' }
											| {
													__typename: 'ComponentModulesStepByStep';
													title?: any;
													stepByStepCard: Array<{
														__typename: 'ComponentInternalStepByStepCard';
														cardTitle: string;
														cardDescription?: string;
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| {
													__typename?: 'ComponentModulesSubjects';
													id: string;
													description?: string;
													overviewTitle?: string;
													subjects: Array<{
														__typename?: 'Page';
														data: {
															__typename?: 'Page';
															documentId: string;
															attributes: {
																__typename?: 'Page';
																title: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													projects: Array<{
														__typename?: 'Project';
														data: {
															__typename?: 'Project';
															documentId: string;
															attributes: {
																__typename?: 'Project';
																title?: string;
																slug: string;
																shortDescription?: string;
															};
														};
													}>;
													themes: Array<{
														__typename?: 'Theme';
														data: {
															__typename?: 'Theme';
															documentId: string;
															attributes: { __typename?: 'Theme'; title: string; slug: string };
														};
													}>;
													defaultModuleOptions: {
														__typename?: 'ComponentInternalDefaultModuleOptions';
														backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
														padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
													};
											  }
											| { __typename?: 'ComponentModulesThemes' }
											| { __typename?: 'Error' }
										>;
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesScheduling' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesTable' }
					| {
							__typename?: 'ComponentModulesThemes';
							title?: any;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: {
										__typename?: 'Theme';
										title: string;
										slug: string;
										header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type ThemeOverviewSingleFieldsFragment = {
	__typename?: 'ThemeOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesRegions';
				title?: any;
				regions: Array<{
					__typename?: 'Region';
					data: {
						__typename?: 'Region';
						documentId: string;
						attributes: {
							__typename: 'Region';
							title?: string;
							slug: string;
							locale?: string;
							header?: {
								__typename?: 'ComponentModulesExpandedHeader';
								headerTitle?: string;
								headerDescription?: string;
								title?: string;
								description?: string;
								headerButton?: {
									__typename?: 'ComponentComponentsButton';
									title?: string;
									variant: Enum_Componentcomponentsbutton_Variant;
									href: any;
									iconLeft?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
									iconRight?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
								};
								headerImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											name: string;
											url: string;
											alternativeText?: string;
											formats?: any;
										};
									};
								};
							};
							seo: {
								__typename?: 'ComponentModulesSeo';
								title?: string;
								description?: string;
								noIndex?: boolean;
								noFollow?: boolean;
								ogTitle?: string;
								ogDescription?: string;
								ogType?: string;
								ogUrl?: string;
								ogImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							};
							modules?: Array<
								| {
										__typename: 'ComponentModulesAccordeon';
										accordeonTitle?: any;
										sections: Array<{
											__typename: 'ComponentInternalAccordeonSection';
											accordeonSectionName?: string;
											items: Array<{
												__typename: 'ComponentInternalAccordeonItem';
												itemTitle: string;
												description?: string;
											}>;
										}>;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesBbvmsMediaplayer';
										videoId: string;
										playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
										url?: string;
										title?: any;
										description?: string;
										transcript?: string;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyText';
										bodyText?: string;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyTextTwoColumn';
										leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesCta';
										description?: string;
										imagePosition?: Enum_Componentmodulescta_Imageposition;
										videoLink?: string;
										ctaTitle?: any;
										buttons?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										}>;
										imageOrVideoFile?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													name: string;
													alternativeText?: string;
													caption?: string;
													url: string;
													mime: string;
													formats?: any;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesDownloads';
										downloadsTitle?: any;
										downloads: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													url: string;
													name: string;
													size: number;
													ext?: string;
													caption?: string;
												};
											};
										}>;
										downloadLinks?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedNews';
										featuredNewsTitle?: any;
										items: Array<{
											__typename?: 'Newsarticle';
											data: {
												__typename?: 'Newsarticle';
												documentId: string;
												attributes: {
													__typename: 'Newsarticle';
													firstPublishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													bodyText: {
														__typename?: 'ComponentModulesBodyText';
														bodyText?: string;
														sidebar?: {
															__typename?: 'ComponentInternalSidebar';
															title?: any;
															links?: Array<{
																__typename?: 'ComponentComponentsLink';
																title: string;
																href: any;
																description?: string;
															}>;
															files: Array<{
																__typename?: 'UploadFile';
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		ext?: string;
																		mime: string;
																		size: number;
																		url: string;
																		alternativeText?: string;
																		hash: string;
																		name: string;
																		caption?: string;
																	};
																};
															}>;
														};
														defaultModuleOptions: {
															__typename?: 'ComponentInternalDefaultModuleOptions';
															backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
															padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedPages';
										featuredPagesTitle?: any;
										items: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: {
													__typename: 'Page';
													publishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesHighlight';
										id: string;
										title?: any;
										theme?: {
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string };
											};
										};
										newsTab?: {
											__typename?: 'ComponentInternalHighlightNews';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										eventsTab?: {
											__typename?: 'ComponentInternalHighlightEvents';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										permitsTab?: {
											__typename?: 'ComponentInternalHighlightPermits';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Permit';
												data: {
													__typename?: 'Permit';
													attributes: { __typename: 'Permit'; slug: string; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										wooTab?: {
											__typename?: 'ComponentInternalHighlightWoo';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'WooRequest';
												data: {
													__typename?: 'WooRequest';
													attributes: {
														__typename: 'WooRequest';
														title: string;
														startDate: any;
														zip?: any;
														createdAt?: any;
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										mapsAndStatsTab?: {
											__typename?: 'ComponentInternalHighlightMapsAndStats';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'MapsFigure';
												data: {
													__typename?: 'MapsFigure';
													attributes: { __typename: 'MapsFigure'; slug: any; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										topicsTab?: {
											__typename?: 'ComponentInternalHighlightTopics';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										subsidiesTab?: {
											__typename?: 'ComponentInternalHighlightSubsidies';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Subsidy';
												data: {
													__typename?: 'Subsidy';
													attributes: {
														__typename: 'Subsidy';
														slug: string;
														header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesLinkBox';
										title?: any;
										description?: string;
										linkBoxLinks?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesMedia';
										transcript?: string;
										mediaLink?: string;
										mediaTitle?: any;
										mediaDescription?: string;
										media?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													size: number;
													ext?: string;
													url: string;
													alternativeText?: string;
													formats?: any;
													mime: string;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesNewsOverview' }
								| {
										__typename: 'ComponentModulesPhotoAlbum';
										id: string;
										description?: string;
										horizontal?: boolean;
										jsonTitle: any;
										photos: Array<{
											__typename: 'ComponentInternalPhoto';
											id: string;
											title: string;
											description?: string;
											photo: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														width?: number;
														height?: number;
														caption?: string;
														formats?: any;
														size: number;
														ext?: string;
														mime: string;
													};
												};
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesRegions' }
								| {
										__typename: 'ComponentModulesStepByStep';
										title?: any;
										stepByStepCard: Array<{
											__typename: 'ComponentInternalStepByStepCard';
											cardTitle: string;
											cardDescription?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesSubjects';
										id: string;
										description?: string;
										overviewTitle?: string;
										subjects: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
											};
										}>;
										projects: Array<{
											__typename?: 'Project';
											data: {
												__typename?: 'Project';
												documentId: string;
												attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
											};
										}>;
										themes: Array<{
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string; slug: string };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesThemes' }
								| { __typename?: 'Error' }
							>;
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesTable' }
		| {
				__typename?: 'ComponentModulesThemes';
				title?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: {
							__typename?: 'Theme';
							title: string;
							slug: string;
							header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type GetVacancyDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetVacancyDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	vacancyDetail?: {
		__typename?: 'VacancyDetail';
		data: {
			__typename?: 'VacancyDetail';
			documentId: string;
			attributes: {
				__typename?: 'VacancyDetail';
				share?: {
					__typename?: 'ComponentModulesShare';
					title?: any;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetVacancyInternalDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetVacancyInternalDetailQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	vacancyInternalDetail?: {
		__typename?: 'VacancyInternalDetail';
		data: {
			__typename?: 'VacancyInternalDetail';
			documentId: string;
			attributes: {
				__typename?: 'VacancyInternalDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetVacancyInternalOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetVacancyInternalOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	vacancyInternalOverview?: {
		__typename?: 'VacancyInternalOverview';
		data: {
			__typename?: 'VacancyInternalOverview';
			documentId: string;
			attributes: {
				__typename?: 'VacancyInternalOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesVacanciesOverview';
							id: string;
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetVacancyOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetVacancyOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	vacancyOverview?: {
		__typename?: 'VacancyOverview';
		data: {
			__typename?: 'VacancyOverview';
			documentId: string;
			attributes: {
				__typename?: 'VacancyOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules: Array<
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesVacanciesOverview';
							id: string;
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
};

export type GetWobRequestOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	limit?: InputMaybe<Scalars['Int']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetWobRequestOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	wobRequestOverview?: {
		__typename?: 'WobRequestOverview';
		data: {
			__typename?: 'WobRequestOverview';
			documentId: string;
			attributes: {
				__typename?: 'WobRequestOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				bodyText?: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				list: {
					__typename: 'ComponentModulesWobRequestOverview';
					id: string;
					sectionTitle: string;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	wobRequests_connection?: {
		__typename?: 'WobRequestEntityResponseCollection';
		data: Array<{
			__typename?: 'WobRequest';
			documentId: string;
			attributes: { __typename?: 'WobRequest'; title: string; createdAt?: any; date?: any; zip?: any };
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetWooDocumentCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetWooDocumentCountQuery = {
	__typename?: 'Query';
	countDocumentsPerCategory?: Array<{ __typename?: 'WooCategoryCount'; sitemap?: string; count?: number }>;
};

export type GetOpenWooRequestDetailQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
	slug: Scalars['String'];
}>;

export type GetOpenWooRequestDetailQuery = {
	__typename?: 'Query';
	openGelderlandInformation?: {
		__typename?: 'OpenGelderlandInformation';
		data: {
			__typename?: 'OpenGelderlandInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpenGelderlandInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	wooDocumentDetail?: {
		__typename?: 'WooDocumentDetail';
		data: {
			__typename?: 'WooDocumentDetail';
			documentId: string;
			attributes: {
				__typename?: 'WooDocumentDetail';
				modules?: Array<
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesShare';
							title?: any;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	wooRequestBySlug?: {
		__typename?: 'WooRequest';
		data: {
			__typename?: 'WooRequest';
			documentId: string;
			attributes: {
				__typename?: 'WooRequest';
				title: string;
				shortTitle?: string;
				description?: string;
				keywords?: string;
				publisher?: string;
				caseNumber?: string;
				slug: string;
				locale?: string;
				zip?: any;
				publishedAt?: any;
				createdAt?: any;
				updatedAt?: any;
				startDate: any;
				endDate?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				category?: {
					__typename?: 'WooCategory';
					data: {
						__typename?: 'WooCategory';
						documentId: string;
						attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
					};
				};
				files: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
					};
				}>;
			};
		};
	};
};

export type GetOpenWooRequestOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	limit?: InputMaybe<Scalars['Int']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetOpenWooRequestOverviewQuery = {
	__typename?: 'Query';
	openGelderlandInformation?: {
		__typename?: 'OpenGelderlandInformation';
		data: {
			__typename?: 'OpenGelderlandInformation';
			documentId: string;
			attributes: {
				__typename?: 'OpenGelderlandInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	openGelderlandWooOverview?: {
		__typename?: 'OpenGelderlandWooOverview';
		data: {
			__typename?: 'OpenGelderlandWooOverview';
			documentId: string;
			attributes: {
				__typename?: 'OpenGelderlandWooOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				woo_overview: {
					__typename?: 'ComponentModulesOpenWooRequestOverview';
					id: string;
					filterHeaderText: string;
					headerTitle: string;
					filterLink?: {
						__typename?: 'ComponentComponentsLink';
						id: string;
						title: string;
						href: any;
						description?: string;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	wooCategories: Array<{
		__typename?: 'WooCategory';
		data: {
			__typename?: 'WooCategory';
			documentId: string;
			attributes: { __typename?: 'WooCategory'; documentId: string; title: string; sitemap: string; resource: string };
		};
	}>;
	wooRequests_connection?: {
		__typename?: 'WooRequestEntityResponseCollection';
		data: Array<{
			__typename?: 'WooRequest';
			documentId: string;
			attributes: {
				__typename?: 'WooRequest';
				title: string;
				shortTitle?: string;
				description?: string;
				keywords?: string;
				publisher?: string;
				caseNumber?: string;
				slug: string;
				locale?: string;
				zip?: any;
				publishedAt?: any;
				createdAt?: any;
				updatedAt?: any;
				startDate: any;
				endDate?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				category?: {
					__typename?: 'WooCategory';
					data: {
						__typename?: 'WooCategory';
						documentId: string;
						attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
					};
				};
				files: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
					};
				}>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
	countDocumentsPerCategory?: Array<{ __typename?: 'WooCategoryCount'; sitemap?: string; count?: number }>;
};

export type GetWooRequestDetailpageQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetWooRequestDetailpageQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	wooRequestBySlug?: {
		__typename?: 'WooRequest';
		data: {
			__typename?: 'WooRequest';
			id: string;
			attributes: {
				__typename?: 'WooRequest';
				title: string;
				shortTitle?: string;
				description?: string;
				keywords?: string;
				publisher?: string;
				caseNumber?: string;
				slug: string;
				locale?: string;
				zip?: any;
				publishedAt?: any;
				createdAt?: any;
				updatedAt?: any;
				startDate: any;
				endDate?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				category?: {
					__typename?: 'WooCategory';
					data: {
						__typename?: 'WooCategory';
						documentId: string;
						attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
					};
				};
				files: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
					};
				}>;
			};
		};
	};
};

export type GetWooRequestDetailXmlQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	slug: Scalars['String'];
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetWooRequestDetailXmlQuery = {
	__typename?: 'Query';
	wooRequestBySlug?: {
		__typename?: 'WooRequest';
		data: {
			__typename?: 'WooRequest';
			id: string;
			attributes: {
				__typename?: 'WooRequest';
				title: string;
				shortTitle?: string;
				description?: string;
				keywords?: string;
				publisher?: string;
				caseNumber?: string;
				slug: string;
				locale?: string;
				zip?: any;
				publishedAt?: any;
				createdAt?: any;
				updatedAt?: any;
				startDate: any;
				endDate?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				category?: {
					__typename?: 'WooCategory';
					data: {
						__typename?: 'WooCategory';
						documentId: string;
						attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
					};
				};
				files: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
					};
				}>;
			};
		};
	};
};

export type WooRequestBySlugFieldsFragment = {
	__typename?: 'WooRequest';
	data: {
		__typename?: 'WooRequest';
		id: string;
		attributes: {
			__typename?: 'WooRequest';
			title: string;
			shortTitle?: string;
			description?: string;
			keywords?: string;
			publisher?: string;
			caseNumber?: string;
			slug: string;
			locale?: string;
			zip?: any;
			publishedAt?: any;
			createdAt?: any;
			updatedAt?: any;
			startDate: any;
			endDate?: any;
			themes: Array<{
				__typename?: 'Theme';
				data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
			}>;
			category?: {
				__typename?: 'WooCategory';
				data: {
					__typename?: 'WooCategory';
					documentId: string;
					attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
				};
			};
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
				};
			}>;
		};
	};
};

export type GetWooRequestOverviewQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	limit?: InputMaybe<Scalars['Int']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetWooRequestOverviewQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	wooRequestOverview?: {
		__typename?: 'WooRequestOverview';
		data: {
			__typename?: 'WooRequestOverview';
			documentId: string;
			attributes: {
				__typename?: 'WooRequestOverview';
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				bodyText?: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				list: {
					__typename: 'ComponentModulesWooRequestOverview';
					id: string;
					filterLabel?: string;
					sectionTitle: string;
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename: 'Error' }
				>;
			};
		};
	};
	wooRequests_connection?: {
		__typename?: 'WooRequestEntityResponseCollection';
		data: Array<{
			__typename?: 'WooRequest';
			documentId: string;
			attributes: {
				__typename?: 'WooRequest';
				title: string;
				shortTitle?: string;
				description?: string;
				keywords?: string;
				publisher?: string;
				caseNumber?: string;
				slug: string;
				locale?: string;
				zip?: any;
				publishedAt?: any;
				createdAt?: any;
				updatedAt?: any;
				startDate: any;
				endDate?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				category?: {
					__typename?: 'WooCategory';
					data: {
						__typename?: 'WooCategory';
						documentId: string;
						attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
					};
				};
				files: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
					};
				}>;
			};
		}>;
		pageInfo: { __typename?: 'Pagination'; total: number };
	};
};

export type GetWooRequestOverviewXmlQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
	sitemap?: InputMaybe<Scalars['String']>;
}>;

export type GetWooRequestOverviewXmlQuery = {
	__typename?: 'Query';
	wooDocuments: Array<{
		__typename?: 'WooRequest';
		data: {
			__typename?: 'WooRequest';
			documentId: string;
			attributes: {
				__typename?: 'WooRequest';
				title: string;
				shortTitle?: string;
				description?: string;
				keywords?: string;
				publisher?: string;
				caseNumber?: string;
				slug: string;
				locale?: string;
				zip?: any;
				publishedAt?: any;
				createdAt?: any;
				updatedAt?: any;
				startDate: any;
				endDate?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
				}>;
				category?: {
					__typename?: 'WooCategory';
					data: {
						__typename?: 'WooCategory';
						documentId: string;
						attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
					};
				};
				files: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
					};
				}>;
			};
		};
	}>;
};

export type GetWorkAtQueryVariables = Exact<{
	locale?: InputMaybe<Scalars['I18NLocaleCode']>;
	publicationState?: InputMaybe<PublicationStatus>;
}>;

export type GetWorkAtQuery = {
	__typename?: 'Query';
	pageInformation?: {
		__typename?: 'PageInformation';
		data: {
			__typename?: 'PageInformation';
			documentId: string;
			attributes: {
				__typename: 'PageInformation';
				locale?: string;
				navbar?: {
					__typename?: 'ComponentInternalNavbar';
					notificationMessage?: string;
					mostPopularTitle?: string;
					ThemeGroupTitle?: string;
					searchPlaceholderText?: string;
					notificationLink?: any;
					notificationIsExternal?: boolean;
					notificationPublishDate?: any;
					notificationUnpublishDate?: any;
					rightNavLink?: any;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								alternativeText?: string;
								size: number;
								url: string;
								formats?: any;
							};
						};
					};
					bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					mostPopularGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
					themeGroupLinks?: Array<{
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
					}>;
				};
				footer?: {
					__typename?: 'ComponentInternalFooter';
					accessibilityLink?: string;
					logo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								formats?: any;
								width?: number;
								height?: number;
							};
						};
					};
					themeLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						href?: any;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					contactLinkGroup?: {
						__typename?: 'ComponentComponentsLinkGroup';
						title: string;
						links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					};
					socialLinkGroup?: {
						__typename?: 'ComponentComponentsIconLinkGroup';
						title: string;
						links: Array<{
							__typename?: 'ComponentComponentsIconLink';
							title: string;
							href: any;
							icon: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
								};
							};
						}>;
					};
					bottomLinks?: Array<{
						__typename?: 'ComponentComponentsLink';
						title: string;
						href: any;
						description?: string;
					}>;
					accessibilityLogo?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				seo?: {
					__typename?: 'ComponentInternalSeo';
					id: string;
					title: string;
					description: string;
					noIndex: boolean;
					noFollow: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
			};
		};
	};
	workAt?: {
		__typename?: 'WorkAt';
		data: {
			__typename?: 'WorkAt';
			documentId: string;
			attributes: {
				__typename: 'WorkAt';
				locale?: string;
				header: {
					__typename?: 'ComponentModulesIntroHeader';
					title: string;
					excerpt: string;
					backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesPartners';
							id: string;
							heading: any;
							logos: Array<{
								__typename: 'ComponentComponentsIconLink';
								id: string;
								title: string;
								href: any;
								icon: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| { __typename?: 'Error' }
				>;
			};
		};
	};
};

export type CommentFieldsFragment = {
	__typename: 'ConversationsConversationitem';
	contentTypeId?: string;
	contentTypeUid?: string;
	message?: string;
	author?: string;
	publishedAt?: any;
};

export type CondoleancePageSlugFieldsFragment = {
	__typename?: 'CondoleancePage';
	title: string;
	slug: string;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type EfroOostInConvoWithArticleFieldsFragment = {
	__typename?: 'EfroOostInConvoWithArticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type EfroOostNewsArticleListFieldsFragment = {
	__typename?: 'EfroOostNewsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
};

export type EfroOostNewsArticleFieldsFragment = {
	__typename?: 'EfroOostNewsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNewsEfroOost';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'EfroOostNewsarticle';
					data: {
						__typename?: 'EfroOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'EfroOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type EfroOostPageSlugFieldsFragment = {
	__typename?: 'EfroOostPage';
	title: string;
	slug: string;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNewsEfroOost';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'EfroOostNewsarticle';
					data: {
						__typename?: 'EfroOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'EfroOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type EventFieldsFragment = {
	__typename: 'Event';
	title: string;
	url: string;
	location: string;
	from: any;
	until: any;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	theme: Array<{
		__typename?: 'Theme';
		data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
	}>;
	share?: {
		__typename?: 'ComponentModulesShare';
		title?: any;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
};

export type GeolinkPageSlugFieldsFragment = {
	__typename?: 'GeolinkPage';
	title: string;
	slug: string;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesCta' }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type HighlightMapsFiguresFieldsFragment = { __typename: 'MapsFigure'; slug: any; title: string };

export type HighlightNewsArticleEfroOostFieldsFragment = {
	__typename?: 'EfroOostNewsarticle';
	firstPublishedAt?: any;
	title: string;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
};

export type HighlightNewsArticleOpOostFieldsFragment = {
	__typename?: 'OpOostNewsarticle';
	firstPublishedAt?: any;
	title: string;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
};

export type HighlightNewsArticleRegioExpresFieldsFragment = {
	__typename?: 'RegioExpresNewsarticle';
	firstPublishedAt?: any;
	title: string;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
};

export type HighlightNewsArticleFieldsFragment = {
	__typename: 'Newsarticle';
	firstPublishedAt?: any;
	title: string;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
};

export type HighlightPermitsFieldsFragment = { __typename: 'Permit'; slug: string; title: string };

export type HighlightSubsidyFieldsFragment = {
	__typename: 'Subsidy';
	slug: string;
	header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
};

export type HighlightedPagesFieldsFragment = {
	__typename: 'Page';
	publishedAt?: any;
	title: string;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
};

export type HighlightWooFragment = {
	__typename: 'WooRequest';
	title: string;
	startDate: any;
	zip?: any;
	createdAt?: any;
};

export type InConvoWithArticleFieldsFragment = {
	__typename?: 'InConvoWithArticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesShare' }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type MapsFiguresFieldsFragment = {
	__typename?: 'MapsFigure';
	name: string;
	link: any;
	type: string;
	media?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; ext?: string; size: number };
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	themes: Array<{
		__typename?: 'Theme';
		data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
	}>;
};

export type NewsArticleListFieldsFragment = {
	__typename?: 'Newsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
};

export type NewsArticleFieldsFragment = {
	__typename?: 'Newsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type OpOostInConvoWithArticleFieldsFragment = {
	__typename?: 'OpOostInConvoWithArticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type OpOostNewsArticleListFieldsFragment = {
	__typename?: 'OpOostNewsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
};

export type OpOostNewsArticleFieldsFragment = {
	__typename?: 'OpOostNewsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNewsOpOost';
				featuredNewsTitle?: any;
				news: Array<{
					__typename?: 'OpOostNewsarticle';
					data: {
						__typename?: 'OpOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'OpOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type OpOostPageSlugFieldsFragment = {
	__typename?: 'OpOostPage';
	title: string;
	slug: string;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNewsOpOost';
				featuredNewsTitle?: any;
				news: Array<{
					__typename?: 'OpOostNewsarticle';
					data: {
						__typename?: 'OpOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'OpOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type PageSlugFieldsFragment = {
	__typename?: 'Page';
	documentId: string;
	title: string;
	slug: string;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesRegions';
				title?: any;
				regions: Array<{
					__typename?: 'Region';
					data: {
						__typename?: 'Region';
						documentId: string;
						attributes: {
							__typename: 'Region';
							title?: string;
							slug: string;
							locale?: string;
							header?: {
								__typename?: 'ComponentModulesExpandedHeader';
								headerTitle?: string;
								headerDescription?: string;
								title?: string;
								description?: string;
								headerButton?: {
									__typename?: 'ComponentComponentsButton';
									title?: string;
									variant: Enum_Componentcomponentsbutton_Variant;
									href: any;
									iconLeft?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
									iconRight?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
								};
								headerImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											name: string;
											url: string;
											alternativeText?: string;
											formats?: any;
										};
									};
								};
							};
							seo: {
								__typename?: 'ComponentModulesSeo';
								title?: string;
								description?: string;
								noIndex?: boolean;
								noFollow?: boolean;
								ogTitle?: string;
								ogDescription?: string;
								ogType?: string;
								ogUrl?: string;
								ogImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							};
							modules?: Array<
								| {
										__typename: 'ComponentModulesAccordeon';
										accordeonTitle?: any;
										sections: Array<{
											__typename: 'ComponentInternalAccordeonSection';
											accordeonSectionName?: string;
											items: Array<{
												__typename: 'ComponentInternalAccordeonItem';
												itemTitle: string;
												description?: string;
											}>;
										}>;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesBbvmsMediaplayer';
										videoId: string;
										playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
										url?: string;
										title?: any;
										description?: string;
										transcript?: string;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyText';
										bodyText?: string;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyTextTwoColumn';
										leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesCta';
										description?: string;
										imagePosition?: Enum_Componentmodulescta_Imageposition;
										videoLink?: string;
										ctaTitle?: any;
										buttons?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										}>;
										imageOrVideoFile?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													name: string;
													alternativeText?: string;
													caption?: string;
													url: string;
													mime: string;
													formats?: any;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesDownloads';
										downloadsTitle?: any;
										downloads: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													url: string;
													name: string;
													size: number;
													ext?: string;
													caption?: string;
												};
											};
										}>;
										downloadLinks?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedNews';
										featuredNewsTitle?: any;
										items: Array<{
											__typename?: 'Newsarticle';
											data: {
												__typename?: 'Newsarticle';
												documentId: string;
												attributes: {
													__typename: 'Newsarticle';
													firstPublishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													bodyText: {
														__typename?: 'ComponentModulesBodyText';
														bodyText?: string;
														sidebar?: {
															__typename?: 'ComponentInternalSidebar';
															title?: any;
															links?: Array<{
																__typename?: 'ComponentComponentsLink';
																title: string;
																href: any;
																description?: string;
															}>;
															files: Array<{
																__typename?: 'UploadFile';
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		ext?: string;
																		mime: string;
																		size: number;
																		url: string;
																		alternativeText?: string;
																		hash: string;
																		name: string;
																		caption?: string;
																	};
																};
															}>;
														};
														defaultModuleOptions: {
															__typename?: 'ComponentInternalDefaultModuleOptions';
															backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
															padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedPages';
										featuredPagesTitle?: any;
										items: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: {
													__typename: 'Page';
													publishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesHighlight';
										id: string;
										title?: any;
										theme?: {
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string };
											};
										};
										newsTab?: {
											__typename?: 'ComponentInternalHighlightNews';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										eventsTab?: {
											__typename?: 'ComponentInternalHighlightEvents';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										permitsTab?: {
											__typename?: 'ComponentInternalHighlightPermits';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Permit';
												data: {
													__typename?: 'Permit';
													attributes: { __typename: 'Permit'; slug: string; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										wooTab?: {
											__typename?: 'ComponentInternalHighlightWoo';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'WooRequest';
												data: {
													__typename?: 'WooRequest';
													attributes: {
														__typename: 'WooRequest';
														title: string;
														startDate: any;
														zip?: any;
														createdAt?: any;
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										mapsAndStatsTab?: {
											__typename?: 'ComponentInternalHighlightMapsAndStats';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'MapsFigure';
												data: {
													__typename?: 'MapsFigure';
													attributes: { __typename: 'MapsFigure'; slug: any; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										topicsTab?: {
											__typename?: 'ComponentInternalHighlightTopics';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										subsidiesTab?: {
											__typename?: 'ComponentInternalHighlightSubsidies';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Subsidy';
												data: {
													__typename?: 'Subsidy';
													attributes: {
														__typename: 'Subsidy';
														slug: string;
														header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesLinkBox';
										title?: any;
										description?: string;
										linkBoxLinks?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesMedia';
										transcript?: string;
										mediaLink?: string;
										mediaTitle?: any;
										mediaDescription?: string;
										media?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													size: number;
													ext?: string;
													url: string;
													alternativeText?: string;
													formats?: any;
													mime: string;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesNewsOverview' }
								| {
										__typename: 'ComponentModulesPhotoAlbum';
										id: string;
										description?: string;
										horizontal?: boolean;
										jsonTitle: any;
										photos: Array<{
											__typename: 'ComponentInternalPhoto';
											id: string;
											title: string;
											description?: string;
											photo: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														width?: number;
														height?: number;
														caption?: string;
														formats?: any;
														size: number;
														ext?: string;
														mime: string;
													};
												};
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesRegions' }
								| {
										__typename: 'ComponentModulesStepByStep';
										title?: any;
										stepByStepCard: Array<{
											__typename: 'ComponentInternalStepByStepCard';
											cardTitle: string;
											cardDescription?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesSubjects';
										id: string;
										description?: string;
										overviewTitle?: string;
										subjects: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
											};
										}>;
										projects: Array<{
											__typename?: 'Project';
											data: {
												__typename?: 'Project';
												documentId: string;
												attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
											};
										}>;
										themes: Array<{
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string; slug: string };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesThemes' }
								| { __typename?: 'Error' }
							>;
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesThemes';
				title?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: {
							__typename?: 'Theme';
							title: string;
							slug: string;
							header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type PermitFieldsFragment = {
	__typename?: 'Permit';
	publishedAt?: any;
	updatedAt?: any;
	title: string;
	slug: string;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	themes: Array<{
		__typename?: 'Theme';
		data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
	}>;
	permitLaws: Array<{
		__typename?: 'PermitLaw';
		data: { __typename?: 'PermitLaw'; documentId: string; attributes: { __typename?: 'PermitLaw'; name: string } };
	}>;
	permitProductTypes: Array<{
		__typename?: 'PermitProductType';
		data: {
			__typename?: 'PermitProductType';
			documentId: string;
			attributes: { __typename?: 'PermitProductType'; name: string };
		};
	}>;
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type PressReleaseFieldsFragment = {
	__typename?: 'PressRelease';
	title: string;
	locale?: string;
	firstPublishedAt?: any;
	slug: string;
	allowedOnHomePage?: boolean;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	theme: Array<{
		__typename?: 'Theme';
		data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
	}>;
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesFeaturedNews' }
		| { __typename?: 'ComponentModulesFeaturedPages' }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type ProjectFieldsFragment = {
	__typename?: 'Project';
	title?: string;
	firstPublishedAt?: any;
	updatedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type RegioExpresInConvoWithArticleFieldsFragment = {
	__typename?: 'RegioExpresInConvoWithArticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type RegioExpresNewsArticleListFieldsFragment = {
	__typename?: 'RegioExpresNewsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
};

export type RegioExpresNewsArticleFieldsFragment = {
	__typename?: 'RegioExpresNewsarticle';
	title: string;
	firstPublishedAt?: any;
	slug: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	tags: Array<{
		__typename?: 'Tag';
		data: { __typename?: 'Tag'; documentId: string; attributes: { __typename?: 'Tag'; name: string } };
	}>;
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNewsRegioExpres';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'RegioExpresNewsarticle';
					data: {
						__typename?: 'RegioExpresNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'RegioExpresNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type RegioExpresPageSlugFieldsFragment = {
	__typename?: 'RegioExpresPage';
	title: string;
	slug: string;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNewsRegioExpres';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'RegioExpresNewsarticle';
					data: {
						__typename?: 'RegioExpresNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'RegioExpresNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type RegionFieldsFragment = {
	__typename: 'Region';
	title?: string;
	slug: string;
	locale?: string;
	header?: {
		__typename?: 'ComponentModulesExpandedHeader';
		headerTitle?: string;
		headerDescription?: string;
		title?: string;
		description?: string;
		headerButton?: {
			__typename?: 'ComponentComponentsButton';
			title?: string;
			variant: Enum_Componentcomponentsbutton_Variant;
			href: any;
			iconLeft?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
			iconRight?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
		};
		headerImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; name: string; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesNewsOverview' }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesRegions' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesThemes' }
		| { __typename?: 'Error' }
	>;
};

export type RoadMaintenanceFieldsFragment = {
	__typename: 'RoadMaintenance';
	title: string;
	slug: string;
	locale?: string;
	roadMaintenanceStatus?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	aboutMaintenance: {
		__typename: 'ComponentInternalAboutMaintenance';
		startDate?: any;
		endDate?: any;
		contractor?: string;
		contractorWebsite?: string;
		detour?: string;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type SubsidyFieldsFragment = {
	__typename?: 'Subsidy';
	title: string;
	slug: string;
	subsidyCeiling?: string;
	subsidystatus: string;
	updatedAt?: any;
	endDate?: any;
	targetGroupText?: string;
	hideFromOverview: boolean;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	themes: Array<{
		__typename?: 'Theme';
		data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
	}>;
	subsidy_scales: Array<{
		__typename?: 'SubsidyScale';
		data: {
			__typename?: 'SubsidyScale';
			documentId: string;
			attributes: { __typename?: 'SubsidyScale'; name?: string };
		};
	}>;
	subsidy_kinds: Array<{
		__typename?: 'SubsidyKind';
		data: { __typename?: 'SubsidyKind'; documentId: string; attributes: { __typename?: 'SubsidyKind'; name?: string } };
	}>;
	target_groups: Array<{
		__typename?: 'TargetGroup';
		data: { __typename?: 'TargetGroup'; documentId: string; attributes: { __typename?: 'TargetGroup'; name?: string } };
	}>;
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesRegions' }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesThemes' }
		| { __typename?: 'Error' }
	>;
};

export type TagFieldsFragment = { __typename?: 'Tag'; name: string };

export type ThemeListFieldsFragment = {
	__typename?: 'Theme';
	title: string;
	slug: string;
	header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
};

export type ThemeFieldsFragment = {
	__typename: 'Theme';
	documentId: string;
	title: string;
	slug: string;
	locale?: string;
	header?: {
		__typename?: 'ComponentModulesExpandedHeader';
		headerTitle?: string;
		headerDescription?: string;
		title?: string;
		description?: string;
		headerButton?: {
			__typename?: 'ComponentComponentsButton';
			title?: string;
			variant: Enum_Componentcomponentsbutton_Variant;
			href: any;
			iconLeft?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
			iconRight?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
		};
		headerImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; name: string; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesNewsOverview' }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesRegions' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesThemes' }
		| { __typename?: 'Error' }
	>;
};

export type WobRequestFieldsFragment = {
	__typename?: 'WobRequest';
	title: string;
	createdAt?: any;
	date?: any;
	zip?: any;
};

export type WooCategoryFieldsFragment = {
	__typename?: 'WooCategory';
	documentId: string;
	title: string;
	sitemap: string;
	resource: string;
};

export type WooRequestFieldsFragment = {
	__typename?: 'WooRequest';
	title: string;
	shortTitle?: string;
	description?: string;
	keywords?: string;
	publisher?: string;
	caseNumber?: string;
	slug: string;
	locale?: string;
	zip?: any;
	publishedAt?: any;
	createdAt?: any;
	updatedAt?: any;
	startDate: any;
	endDate?: any;
	themes: Array<{
		__typename?: 'Theme';
		data: { __typename?: 'Theme'; attributes: { __typename?: 'Theme'; title: string } };
	}>;
	category?: {
		__typename?: 'WooCategory';
		data: {
			__typename?: 'WooCategory';
			documentId: string;
			attributes: { __typename?: 'WooCategory'; title: string; sitemap: string; resource: string };
		};
	};
	files: Array<{
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			attributes: { __typename?: 'UploadFile'; name: string; url: string; ext?: string; size: number };
		};
	}>;
};

export type ButtonFieldsFragment = {
	__typename?: 'ComponentComponentsButton';
	title?: string;
	variant: Enum_Componentcomponentsbutton_Variant;
	href: any;
	iconLeft?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; name: string };
		};
	};
	iconRight?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; name: string };
		};
	};
};

export type DefaultModuleOptionsExtendedFieldsFragment = {
	__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
	extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
	extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
};

export type DefaultModuleOptionsFieldsFragment = {
	__typename?: 'ComponentInternalDefaultModuleOptions';
	backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
	padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
};

export type EmptyStateFieldsFragment = {
	__typename?: 'ComponentInternalEmptyState';
	message?: string;
	title?: string;
	href?: string;
};

export type IconLinkFieldsFragment = {
	__typename: 'ComponentComponentsIconLink';
	id: string;
	title: string;
	href: any;
	icon: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
		};
	};
};

export type LinkFieldsFragment = {
	__typename?: 'ComponentComponentsLink';
	id: string;
	title: string;
	href: any;
	description?: string;
};

export type SidebarFieldsFragment = {
	__typename?: 'ComponentInternalSidebar';
	title?: any;
	links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
	files: Array<{
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: {
				__typename?: 'UploadFile';
				ext?: string;
				mime: string;
				size: number;
				url: string;
				alternativeText?: string;
				hash: string;
				name: string;
				caption?: string;
			};
		};
	}>;
};

export type AccordeonFieldsFragment = {
	__typename: 'ComponentModulesAccordeon';
	accordeonTitle?: any;
	sections: Array<{
		__typename: 'ComponentInternalAccordeonSection';
		accordeonSectionName?: string;
		items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
	}>;
	sidebar?: {
		__typename?: 'ComponentInternalSidebar';
		title?: any;
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		files: Array<{
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					ext?: string;
					mime: string;
					size: number;
					url: string;
					alternativeText?: string;
					hash: string;
					name: string;
					caption?: string;
				};
			};
		}>;
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type BbvmsMediaplayerFieldsFragment = {
	__typename: 'ComponentModulesBbvmsMediaplayer';
	videoId: string;
	playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
	url?: string;
	title?: any;
	description?: string;
	transcript?: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type BodyTextTwoColumnsFieldsFragment = {
	__typename?: 'ComponentModulesBodyTextTwoColumn';
	leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
	rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type BodyTextFieldsFragment = {
	__typename?: 'ComponentModulesBodyText';
	bodyText?: string;
	sidebar?: {
		__typename?: 'ComponentInternalSidebar';
		title?: any;
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		files: Array<{
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					ext?: string;
					mime: string;
					size: number;
					url: string;
					alternativeText?: string;
					hash: string;
					name: string;
					caption?: string;
				};
			};
		}>;
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type CollectionFieldsFragment = {
	__typename?: 'ComponentModulesCollections';
	id: string;
	description?: string;
	overviewTitle?: string;
	links: Array<{ __typename?: 'ComponentComponentsLink'; id: string; title: string; href: any; description?: string }>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type ContactModuleFieldsFragment = {
	__typename: 'Contact';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type CtaFieldsFragment = {
	__typename?: 'ComponentModulesCta';
	description?: string;
	imagePosition?: Enum_Componentmodulescta_Imageposition;
	videoLink?: string;
	ctaTitle?: any;
	buttons?: Array<{
		__typename?: 'ComponentComponentsButton';
		title?: string;
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	}>;
	imageOrVideoFile?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: {
				__typename?: 'UploadFile';
				name: string;
				alternativeText?: string;
				caption?: string;
				url: string;
				mime: string;
				formats?: any;
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
		extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
		extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
	};
};

export type DownloadFieldsFragment = {
	__typename?: 'ComponentModulesDownloads';
	downloadsTitle?: any;
	downloads: Array<{
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: {
				__typename?: 'UploadFile';
				url: string;
				name: string;
				size: number;
				ext?: string;
				caption?: string;
			};
		};
	}>;
	downloadLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
		extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
		extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
	};
};

export type EfroOostInConvoWithOverviewFieldsFragment = {
	__typename?: 'ComponentModulesInConvoWithOverview';
	id: string;
	filterLabel?: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type EventOverviewFieldsFragment = {
	__typename?: 'ComponentModulesEventOverview';
	id: string;
	filterLabel?: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type ExpandedHeaderFieldsFragment = {
	__typename?: 'ComponentModulesExpandedHeader';
	headerTitle?: string;
	headerDescription?: string;
	title?: string;
	description?: string;
	headerButton?: {
		__typename?: 'ComponentComponentsButton';
		title?: string;
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	headerImage?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; name: string; url: string; alternativeText?: string; formats?: any };
		};
	};
};

export type FeaturedNewsEfroOostFieldsFragment = {
	__typename?: 'ComponentModulesFeaturedNewsEfroOost';
	featuredNewsTitle?: any;
	items: Array<{
		__typename?: 'EfroOostNewsarticle';
		data: {
			__typename?: 'EfroOostNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'EfroOostNewsarticle';
				firstPublishedAt?: any;
				title: string;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
	cta?: {
		__typename?: 'ComponentComponentsButton';
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		ctaTitle?: string;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type FeaturedNewsOpOostFieldsFragment = {
	__typename?: 'ComponentModulesFeaturedNewsOpOost';
	featuredNewsTitle?: any;
	news: Array<{
		__typename?: 'OpOostNewsarticle';
		data: {
			__typename?: 'OpOostNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'OpOostNewsarticle';
				firstPublishedAt?: any;
				title: string;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
	cta?: {
		__typename?: 'ComponentComponentsButton';
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		ctaTitle?: string;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type FeaturedNewsRegioExpresFieldsFragment = {
	__typename?: 'ComponentModulesFeaturedNewsRegioExpres';
	featuredNewsTitle?: any;
	items: Array<{
		__typename?: 'RegioExpresNewsarticle';
		data: {
			__typename?: 'RegioExpresNewsarticle';
			documentId: string;
			attributes: {
				__typename?: 'RegioExpresNewsarticle';
				firstPublishedAt?: any;
				title: string;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
	cta?: {
		__typename?: 'ComponentComponentsButton';
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		ctaTitle?: string;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type FeaturedNewsFieldsFragment = {
	__typename?: 'ComponentModulesFeaturedNews';
	featuredNewsTitle?: any;
	items: Array<{
		__typename?: 'Newsarticle';
		data: {
			__typename?: 'Newsarticle';
			documentId: string;
			attributes: {
				__typename: 'Newsarticle';
				firstPublishedAt?: any;
				title: string;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				bodyText: {
					__typename?: 'ComponentModulesBodyText';
					bodyText?: string;
					sidebar?: {
						__typename?: 'ComponentInternalSidebar';
						title?: any;
						links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
						files: Array<{
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: {
									__typename?: 'UploadFile';
									ext?: string;
									mime: string;
									size: number;
									url: string;
									alternativeText?: string;
									hash: string;
									name: string;
									caption?: string;
								};
							};
						}>;
					};
					defaultModuleOptions: {
						__typename?: 'ComponentInternalDefaultModuleOptions';
						backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
						padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
					};
				};
			};
		};
	}>;
	cta?: {
		__typename?: 'ComponentComponentsButton';
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		ctaTitle?: string;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type FeaturedPagesFieldsFragment = {
	__typename?: 'ComponentModulesFeaturedPages';
	featuredPagesTitle?: any;
	items: Array<{
		__typename?: 'Page';
		data: {
			__typename?: 'Page';
			documentId: string;
			attributes: {
				__typename: 'Page';
				publishedAt?: any;
				title: string;
				slug: string;
				header: {
					__typename?: 'ComponentModulesIntroHeaderImage';
					title: string;
					excerpt?: string;
					backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
					cover?: {
						__typename?: 'UploadFile';
						url: string;
						alternativeText?: string;
						formats?: any;
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
			};
		};
	}>;
	cta?: {
		__typename?: 'ComponentComponentsButton';
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		ctaTitle?: string;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type FooterFieldsFragment = {
	__typename?: 'ComponentInternalFooter';
	accessibilityLink?: string;
	logo?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: {
				__typename?: 'UploadFile';
				url: string;
				alternativeText?: string;
				formats?: any;
				width?: number;
				height?: number;
			};
		};
	};
	themeLinkGroup?: {
		__typename?: 'ComponentComponentsLinkGroup';
		title: string;
		href?: any;
		links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
	};
	contactLinkGroup?: {
		__typename?: 'ComponentComponentsLinkGroup';
		title: string;
		links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
	};
	socialLinkGroup?: {
		__typename?: 'ComponentComponentsIconLinkGroup';
		title: string;
		links: Array<{
			__typename?: 'ComponentComponentsIconLink';
			title: string;
			href: any;
			icon: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
				};
			};
		}>;
	};
	bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
	accessibilityLogo?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
		};
	};
};

export type HighlightFieldsFragment = {
	__typename: 'ComponentModulesHighlight';
	id: string;
	title?: any;
	theme?: {
		__typename?: 'Theme';
		data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
	};
	newsTab?: {
		__typename?: 'ComponentInternalHighlightNews';
		id: string;
		title?: string;
		buttonTitle?: string;
		buttonHref?: any;
		items: Array<{
			__typename?: 'Newsarticle';
			data: {
				__typename?: 'Newsarticle';
				attributes: {
					__typename: 'Newsarticle';
					firstPublishedAt?: any;
					title: string;
					slug: string;
					header: {
						__typename?: 'ComponentModulesIntroHeaderImage';
						title: string;
						excerpt?: string;
						backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
						cover?: {
							__typename?: 'UploadFile';
							url: string;
							alternativeText?: string;
							formats?: any;
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
							};
						};
					};
					bodyText: {
						__typename?: 'ComponentModulesBodyText';
						bodyText?: string;
						sidebar?: {
							__typename?: 'ComponentInternalSidebar';
							title?: any;
							links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
							files: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										ext?: string;
										mime: string;
										size: number;
										url: string;
										alternativeText?: string;
										hash: string;
										name: string;
										caption?: string;
									};
								};
							}>;
						};
						defaultModuleOptions: {
							__typename?: 'ComponentInternalDefaultModuleOptions';
							backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
							padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
						};
					};
				};
			};
		}>;
		empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
	};
	eventsTab?: {
		__typename?: 'ComponentInternalHighlightEvents';
		id: string;
		title?: string;
		buttonTitle?: string;
		buttonHref?: any;
		items: Array<{
			__typename?: 'Newsarticle';
			data: {
				__typename?: 'Newsarticle';
				attributes: {
					__typename: 'Newsarticle';
					firstPublishedAt?: any;
					title: string;
					slug: string;
					header: {
						__typename?: 'ComponentModulesIntroHeaderImage';
						title: string;
						excerpt?: string;
						backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
						cover?: {
							__typename?: 'UploadFile';
							url: string;
							alternativeText?: string;
							formats?: any;
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
							};
						};
					};
					bodyText: {
						__typename?: 'ComponentModulesBodyText';
						bodyText?: string;
						sidebar?: {
							__typename?: 'ComponentInternalSidebar';
							title?: any;
							links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
							files: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										ext?: string;
										mime: string;
										size: number;
										url: string;
										alternativeText?: string;
										hash: string;
										name: string;
										caption?: string;
									};
								};
							}>;
						};
						defaultModuleOptions: {
							__typename?: 'ComponentInternalDefaultModuleOptions';
							backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
							padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
						};
					};
				};
			};
		}>;
		empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
	};
	permitsTab?: {
		__typename?: 'ComponentInternalHighlightPermits';
		id: string;
		title?: string;
		buttonTitle?: string;
		buttonHref?: any;
		items: Array<{
			__typename?: 'Permit';
			data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
		}>;
		empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
	};
	wooTab?: {
		__typename?: 'ComponentInternalHighlightWoo';
		id: string;
		title?: string;
		buttonTitle?: string;
		buttonHref?: any;
		items: Array<{
			__typename?: 'WooRequest';
			data: {
				__typename?: 'WooRequest';
				attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
			};
		}>;
		empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
	};
	mapsAndStatsTab?: {
		__typename?: 'ComponentInternalHighlightMapsAndStats';
		id: string;
		title?: string;
		buttonTitle?: string;
		buttonHref?: any;
		items: Array<{
			__typename?: 'MapsFigure';
			data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
		}>;
		empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
	};
	topicsTab?: {
		__typename?: 'ComponentInternalHighlightTopics';
		id: string;
		title?: string;
		buttonTitle?: string;
		buttonHref?: any;
		items: Array<{
			__typename?: 'Newsarticle';
			data: {
				__typename?: 'Newsarticle';
				attributes: {
					__typename: 'Newsarticle';
					firstPublishedAt?: any;
					title: string;
					slug: string;
					header: {
						__typename?: 'ComponentModulesIntroHeaderImage';
						title: string;
						excerpt?: string;
						backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
						cover?: {
							__typename?: 'UploadFile';
							url: string;
							alternativeText?: string;
							formats?: any;
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
							};
						};
					};
					bodyText: {
						__typename?: 'ComponentModulesBodyText';
						bodyText?: string;
						sidebar?: {
							__typename?: 'ComponentInternalSidebar';
							title?: any;
							links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
							files: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										ext?: string;
										mime: string;
										size: number;
										url: string;
										alternativeText?: string;
										hash: string;
										name: string;
										caption?: string;
									};
								};
							}>;
						};
						defaultModuleOptions: {
							__typename?: 'ComponentInternalDefaultModuleOptions';
							backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
							padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
						};
					};
				};
			};
		}>;
		empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
	};
	subsidiesTab?: {
		__typename?: 'ComponentInternalHighlightSubsidies';
		id: string;
		title?: string;
		buttonTitle?: string;
		buttonHref?: any;
		items: Array<{
			__typename?: 'Subsidy';
			data: {
				__typename?: 'Subsidy';
				attributes: {
					__typename: 'Subsidy';
					slug: string;
					header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
				};
			};
		}>;
		empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type HomepageHeaderFieldsFragment = {
	__typename?: 'ComponentModulesHomepageHeader';
	id: string;
	description?: string;
	popularHeader?: string;
	homepageTitle?: string;
	backgroundImage?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
		};
	};
	links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
};

export type InConvoWithOverviewFieldsFragment = {
	__typename?: 'ComponentModulesInConvoWithOverview';
	id: string;
	filterLabel?: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type IntroHeaderImageFieldsFragment = {
	__typename?: 'ComponentModulesIntroHeaderImage';
	title: string;
	excerpt?: string;
	backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
	cover?: {
		__typename?: 'UploadFile';
		url: string;
		alternativeText?: string;
		formats?: any;
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
		};
	};
};

export type IntroHeaderFieldsFragment = {
	__typename?: 'ComponentModulesIntroHeader';
	title: string;
	excerpt: string;
	backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
};

export type LinkBoxFieldsFragment = {
	__typename?: 'ComponentModulesLinkBox';
	title?: any;
	description?: string;
	linkBoxLinks?: Array<{
		__typename?: 'ComponentComponentsButton';
		title?: string;
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
		};
	}>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
		extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
		extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
	};
};

export type MapsFiguresOverviewFieldsFragment = {
	__typename?: 'ComponentModulesMapsFiguresOverview';
	id: string;
	showResultsText: string;
	headerTitle: string;
	searchPlaceholderText: string;
	themeFilterText: string;
	kindFilterText: string;
	showAllThemesText: string;
	overviewTitleText: string;
	filterHeaderText: string;
};

export type MediaFieldsFragment = {
	__typename?: 'ComponentModulesMedia';
	transcript?: string;
	mediaLink?: string;
	mediaTitle?: any;
	mediaDescription?: string;
	media?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: {
				__typename?: 'UploadFile';
				size: number;
				ext?: string;
				url: string;
				alternativeText?: string;
				formats?: any;
				mime: string;
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type NavbarFieldsFragment = {
	__typename?: 'ComponentInternalNavbar';
	notificationMessage?: string;
	mostPopularTitle?: string;
	ThemeGroupTitle?: string;
	searchPlaceholderText?: string;
	notificationLink?: any;
	notificationIsExternal?: boolean;
	notificationPublishDate?: any;
	notificationUnpublishDate?: any;
	rightNavLink?: any;
	logo?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: {
				__typename?: 'UploadFile';
				name: string;
				alternativeText?: string;
				size: number;
				url: string;
				formats?: any;
			};
		};
	};
	bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	mostPopularGroupLinks?: Array<{
		__typename?: 'ComponentComponentsLinkGroup';
		title: string;
		href?: any;
		links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	}>;
	themeGroupLinks?: Array<{
		__typename?: 'ComponentComponentsLinkGroup';
		title: string;
		href?: any;
		links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	}>;
};

export type NewsOverviewFieldsFragment = {
	__typename?: 'ComponentModulesNewsOverview';
	id: string;
	filterLabel?: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type NewsletterFieldsFragment = {
	__typename?: 'ComponentInternalNewsletter';
	title?: string;
	fieldLabel?: string;
	fieldPlaceholder?: string;
	submitButton?: {
		__typename?: 'ComponentComponentsButton';
		title?: string;
		variant: Enum_Componentcomponentsbutton_Variant;
		href: any;
		iconLeft?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
		iconRight?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type NotificationBarFieldsFragment = {
	__typename?: 'ComponentInternalNavbar';
	notificationLink?: any;
	notificationMessage?: string;
	notificationIsExternal?: boolean;
	notificationPublishDate?: any;
	notificationUnpublishDate?: any;
	mostPopularTitle?: string;
	ThemeGroupTitle?: string;
	bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string }>;
};

export type OpOostInConvoWithOverviewFieldsFragment = {
	__typename?: 'ComponentModulesInConvoWithOverview';
	id: string;
	filterLabel?: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type OpenGelderlandWooDocumentOverviewFragment = {
	__typename?: 'ComponentModulesOpenWooRequestOverview';
	id: string;
	filterHeaderText: string;
	headerTitle: string;
	filterLink?: { __typename?: 'ComponentComponentsLink'; id: string; title: string; href: any; description?: string };
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type PartnersFieldsFragment = {
	__typename: 'ComponentModulesPartners';
	id: string;
	heading: any;
	logos: Array<{
		__typename: 'ComponentComponentsIconLink';
		id: string;
		title: string;
		href: any;
		icon: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	}>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
		extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
		extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
	};
};

export type PermitsOverviewFieldsFragment = {
	__typename?: 'ComponentModulesPermitsOverview';
	id: string;
	headerTitle: string;
	searchPlaceholderText: string;
	themeFilterText: string;
	lawFilterText: string;
	productTypeFilterText: string;
	showAllThemesText: string;
	showAllLawsText: string;
	showAllProductTypesText: string;
	overviewTitleText: string;
	showResultsText: string;
	filterHeaderText: string;
};

export type PhotoAlbumFieldsFragment = {
	__typename: 'ComponentModulesPhotoAlbum';
	id: string;
	description?: string;
	horizontal?: boolean;
	jsonTitle: any;
	photos: Array<{
		__typename: 'ComponentInternalPhoto';
		id: string;
		title: string;
		description?: string;
		photo: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					width?: number;
					height?: number;
					caption?: string;
					formats?: any;
					size: number;
					ext?: string;
					mime: string;
				};
			};
		};
	}>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type PhotoFieldsFragment = {
	__typename: 'ComponentInternalPhoto';
	id: string;
	title: string;
	description?: string;
	photo: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: {
				__typename?: 'UploadFile';
				url: string;
				alternativeText?: string;
				width?: number;
				height?: number;
				caption?: string;
				formats?: any;
				size: number;
				ext?: string;
				mime: string;
			};
		};
	};
};

export type FullImageFieldsFragment = {
	__typename?: 'UploadFile';
	documentId: string;
	attributes: {
		__typename?: 'UploadFile';
		url: string;
		alternativeText?: string;
		width?: number;
		height?: number;
		caption?: string;
		formats?: any;
		size: number;
		ext?: string;
		mime: string;
	};
};

export type PressReleaseOverviewFieldsFragment = {
	__typename?: 'ComponentModulesPressReleaseOverview';
	id: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type ProjectOverviewFieldsFragment = {
	__typename?: 'ComponentModulesProjectOverview';
	id: string;
	filterLabel?: string;
	extendedDefaultModuleOptions?: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type RegioExpresInConvoWithOverviewFieldsFragment = {
	__typename?: 'ComponentModulesInConvoWithOverview';
	id: string;
	filterLabel?: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type RegionsFieldsFragment = {
	__typename?: 'ComponentModulesRegions';
	title?: any;
	regions: Array<{
		__typename?: 'Region';
		data: {
			__typename?: 'Region';
			documentId: string;
			attributes: {
				__typename: 'Region';
				title?: string;
				slug: string;
				locale?: string;
				header?: {
					__typename?: 'ComponentModulesExpandedHeader';
					headerTitle?: string;
					headerDescription?: string;
					title?: string;
					description?: string;
					headerButton?: {
						__typename?: 'ComponentComponentsButton';
						title?: string;
						variant: Enum_Componentcomponentsbutton_Variant;
						href: any;
						iconLeft?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
						iconRight?: {
							__typename?: 'UploadFile';
							data: {
								__typename?: 'UploadFile';
								documentId: string;
								attributes: { __typename?: 'UploadFile'; url: string; name: string };
							};
						};
					};
					headerImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								name: string;
								url: string;
								alternativeText?: string;
								formats?: any;
							};
						};
					};
				};
				seo: {
					__typename?: 'ComponentModulesSeo';
					title?: string;
					description?: string;
					noIndex?: boolean;
					noFollow?: boolean;
					ogTitle?: string;
					ogDescription?: string;
					ogType?: string;
					ogUrl?: string;
					ogImage?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				};
				modules?: Array<
					| {
							__typename: 'ComponentModulesAccordeon';
							accordeonTitle?: any;
							sections: Array<{
								__typename: 'ComponentInternalAccordeonSection';
								accordeonSectionName?: string;
								items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
							}>;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesBbvmsMediaplayer';
							videoId: string;
							playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
							url?: string;
							title?: any;
							description?: string;
							transcript?: string;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyText';
							bodyText?: string;
							sidebar?: {
								__typename?: 'ComponentInternalSidebar';
								title?: any;
								links?: Array<{
									__typename?: 'ComponentComponentsLink';
									title: string;
									href: any;
									description?: string;
								}>;
								files: Array<{
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											ext?: string;
											mime: string;
											size: number;
											url: string;
											alternativeText?: string;
											hash: string;
											name: string;
											caption?: string;
										};
									};
								}>;
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesBodyTextTwoColumn';
							leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesCta';
							description?: string;
							imagePosition?: Enum_Componentmodulescta_Imageposition;
							videoLink?: string;
							ctaTitle?: any;
							buttons?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							}>;
							imageOrVideoFile?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										name: string;
										alternativeText?: string;
										caption?: string;
										url: string;
										mime: string;
										formats?: any;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesDownloads';
							downloadsTitle?: any;
							downloads: Array<{
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										url: string;
										name: string;
										size: number;
										ext?: string;
										caption?: string;
									};
								};
							}>;
							downloadLinks?: Array<{
								__typename?: 'ComponentComponentsLink';
								title: string;
								href: any;
								description?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedNews';
							featuredNewsTitle?: any;
							items: Array<{
								__typename?: 'Newsarticle';
								data: {
									__typename?: 'Newsarticle';
									documentId: string;
									attributes: {
										__typename: 'Newsarticle';
										firstPublishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										bodyText: {
											__typename?: 'ComponentModulesBodyText';
											bodyText?: string;
											sidebar?: {
												__typename?: 'ComponentInternalSidebar';
												title?: any;
												links?: Array<{
													__typename?: 'ComponentComponentsLink';
													title: string;
													href: any;
													description?: string;
												}>;
												files: Array<{
													__typename?: 'UploadFile';
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															ext?: string;
															mime: string;
															size: number;
															url: string;
															alternativeText?: string;
															hash: string;
															name: string;
															caption?: string;
														};
													};
												}>;
											};
											defaultModuleOptions: {
												__typename?: 'ComponentInternalDefaultModuleOptions';
												backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
												padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesFeaturedPages';
							featuredPagesTitle?: any;
							items: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: {
										__typename: 'Page';
										publishedAt?: any;
										title: string;
										slug: string;
										header: {
											__typename?: 'ComponentModulesIntroHeaderImage';
											title: string;
											excerpt?: string;
											backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
											cover?: {
												__typename?: 'UploadFile';
												url: string;
												alternativeText?: string;
												formats?: any;
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
									};
								};
							}>;
							cta?: {
								__typename?: 'ComponentComponentsButton';
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								ctaTitle?: string;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename: 'ComponentModulesHighlight';
							id: string;
							title?: any;
							theme?: {
								__typename?: 'Theme';
								data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
							};
							newsTab?: {
								__typename?: 'ComponentInternalHighlightNews';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							eventsTab?: {
								__typename?: 'ComponentInternalHighlightEvents';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							permitsTab?: {
								__typename?: 'ComponentInternalHighlightPermits';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Permit';
									data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							wooTab?: {
								__typename?: 'ComponentInternalHighlightWoo';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'WooRequest';
									data: {
										__typename?: 'WooRequest';
										attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							mapsAndStatsTab?: {
								__typename?: 'ComponentInternalHighlightMapsAndStats';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'MapsFigure';
									data: {
										__typename?: 'MapsFigure';
										attributes: { __typename: 'MapsFigure'; slug: any; title: string };
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							topicsTab?: {
								__typename?: 'ComponentInternalHighlightTopics';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Newsarticle';
									data: {
										__typename?: 'Newsarticle';
										attributes: {
											__typename: 'Newsarticle';
											firstPublishedAt?: any;
											title: string;
											slug: string;
											header: {
												__typename?: 'ComponentModulesIntroHeaderImage';
												title: string;
												excerpt?: string;
												backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
												cover?: {
													__typename?: 'UploadFile';
													url: string;
													alternativeText?: string;
													formats?: any;
													data: {
														__typename?: 'UploadFile';
														documentId: string;
														attributes: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
														};
													};
												};
											};
											bodyText: {
												__typename?: 'ComponentModulesBodyText';
												bodyText?: string;
												sidebar?: {
													__typename?: 'ComponentInternalSidebar';
													title?: any;
													links?: Array<{
														__typename?: 'ComponentComponentsLink';
														title: string;
														href: any;
														description?: string;
													}>;
													files: Array<{
														__typename?: 'UploadFile';
														data: {
															__typename?: 'UploadFile';
															documentId: string;
															attributes: {
																__typename?: 'UploadFile';
																ext?: string;
																mime: string;
																size: number;
																url: string;
																alternativeText?: string;
																hash: string;
																name: string;
																caption?: string;
															};
														};
													}>;
												};
												defaultModuleOptions: {
													__typename?: 'ComponentInternalDefaultModuleOptions';
													backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
													padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
												};
											};
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							subsidiesTab?: {
								__typename?: 'ComponentInternalHighlightSubsidies';
								id: string;
								title?: string;
								buttonTitle?: string;
								buttonHref?: any;
								items: Array<{
									__typename?: 'Subsidy';
									data: {
										__typename?: 'Subsidy';
										attributes: {
											__typename: 'Subsidy';
											slug: string;
											header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
										};
									};
								}>;
								empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesLinkBox';
							title?: any;
							description?: string;
							linkBoxLinks?: Array<{
								__typename?: 'ComponentComponentsButton';
								title?: string;
								variant: Enum_Componentcomponentsbutton_Variant;
								href: any;
								iconLeft?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
								iconRight?: {
									__typename?: 'UploadFile';
									data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
								extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
								extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesMedia';
							transcript?: string;
							mediaLink?: string;
							mediaTitle?: any;
							mediaDescription?: string;
							media?: {
								__typename?: 'UploadFile';
								data: {
									__typename?: 'UploadFile';
									documentId: string;
									attributes: {
										__typename?: 'UploadFile';
										size: number;
										ext?: string;
										url: string;
										alternativeText?: string;
										formats?: any;
										mime: string;
									};
								};
							};
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesNewsOverview' }
					| {
							__typename: 'ComponentModulesPhotoAlbum';
							id: string;
							description?: string;
							horizontal?: boolean;
							jsonTitle: any;
							photos: Array<{
								__typename: 'ComponentInternalPhoto';
								id: string;
								title: string;
								description?: string;
								photo: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											url: string;
											alternativeText?: string;
											width?: number;
											height?: number;
											caption?: string;
											formats?: any;
											size: number;
											ext?: string;
											mime: string;
										};
									};
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesRegions' }
					| {
							__typename: 'ComponentModulesStepByStep';
							title?: any;
							stepByStepCard: Array<{
								__typename: 'ComponentInternalStepByStepCard';
								cardTitle: string;
								cardDescription?: string;
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| {
							__typename?: 'ComponentModulesSubjects';
							id: string;
							description?: string;
							overviewTitle?: string;
							subjects: Array<{
								__typename?: 'Page';
								data: {
									__typename?: 'Page';
									documentId: string;
									attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
								};
							}>;
							projects: Array<{
								__typename?: 'Project';
								data: {
									__typename?: 'Project';
									documentId: string;
									attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
								};
							}>;
							themes: Array<{
								__typename?: 'Theme';
								data: {
									__typename?: 'Theme';
									documentId: string;
									attributes: { __typename?: 'Theme'; title: string; slug: string };
								};
							}>;
							defaultModuleOptions: {
								__typename?: 'ComponentInternalDefaultModuleOptions';
								backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
								padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
							};
					  }
					| { __typename?: 'ComponentModulesThemes' }
					| { __typename?: 'Error' }
				>;
			};
		};
	}>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type RoadMaintenanceOverviewFieldsFragment = {
	__typename: 'ComponentModulesRoadMaintenanceOverview';
	id: string;
	title: string;
};

export type SchedulingFieldsFragment = {
	__typename: 'ComponentModulesScheduling';
	title?: any;
	firstColumnTitle: string;
	secondColumnTitle?: string;
	firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
	secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type SeoFieldsFragment = {
	__typename?: 'ComponentModulesSeo';
	title?: string;
	description?: string;
	noIndex?: boolean;
	noFollow?: boolean;
	ogTitle?: string;
	ogDescription?: string;
	ogType?: string;
	ogUrl?: string;
	ogImage?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; name: string };
		};
	};
};

export type SeoSingleFieldsFragment = {
	__typename?: 'ComponentInternalSeo';
	id: string;
	title: string;
	description: string;
	noIndex: boolean;
	noFollow: boolean;
	ogTitle?: string;
	ogDescription?: string;
	ogType?: string;
	ogUrl?: string;
	ogImage?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; name: string };
		};
	};
};

export type SharesFieldsFragment = {
	__typename?: 'ComponentModulesShare';
	title?: any;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type StepByStepFieldsFragment = {
	__typename: 'ComponentModulesStepByStep';
	title?: any;
	stepByStepCard: Array<{ __typename: 'ComponentInternalStepByStepCard'; cardTitle: string; cardDescription?: string }>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type SubjectsFieldsFragment = {
	__typename?: 'ComponentModulesSubjects';
	id: string;
	description?: string;
	overviewTitle?: string;
	subjects: Array<{
		__typename?: 'Page';
		data: {
			__typename?: 'Page';
			documentId: string;
			attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
		};
	}>;
	projects: Array<{
		__typename?: 'Project';
		data: {
			__typename?: 'Project';
			documentId: string;
			attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
		};
	}>;
	themes: Array<{
		__typename?: 'Theme';
		data: {
			__typename?: 'Theme';
			documentId: string;
			attributes: { __typename?: 'Theme'; title: string; slug: string };
		};
	}>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type SubsidyOverviewFieldsFragment = {
	__typename?: 'ComponentModulesSubsidyOverview';
	id: string;
	showResultsText: string;
	headerTitle: string;
	searchPlaceholderText: string;
	themeFilterText: string;
	showMoreThemesText: string;
	showLessThemesText: string;
	targetGroupFilterText: string;
	kindFilterText: string;
	scaleFilterText: string;
	overviewTitleText: string;
	filterHeaderText: string;
};

export type TableFieldsFragment = {
	__typename: 'ComponentModulesTable';
	table?: string;
	tableTitle?: any;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type TestimonialFieldsFragment = {
	__typename: 'ComponentModulesTestimonial';
	id: string;
	quote?: string;
	name: string;
	organization?: string;
	quoteTitle: any;
	photo?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
		};
	};
	logo?: {
		__typename?: 'UploadFile';
		data: {
			__typename?: 'UploadFile';
			documentId: string;
			attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
		};
	};
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
		extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
		extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
	};
};

export type ThemesFieldsFragment = {
	__typename?: 'ComponentModulesThemes';
	title?: any;
	themes: Array<{
		__typename?: 'Theme';
		data: {
			__typename?: 'Theme';
			documentId: string;
			attributes: {
				__typename?: 'Theme';
				title: string;
				slug: string;
				header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
			};
		};
	}>;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type VacancyOverviewFieldsFragment = {
	__typename: 'ComponentModulesVacanciesOverview';
	id: string;
	title?: any;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type WobRequestOverviewFieldsFragment = {
	__typename: 'ComponentModulesWobRequestOverview';
	id: string;
	sectionTitle: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type WooRequestOverviewFieldsFragment = {
	__typename: 'ComponentModulesWooRequestOverview';
	id: string;
	filterLabel?: string;
	sectionTitle: string;
	defaultModuleOptions: {
		__typename?: 'ComponentInternalDefaultModuleOptions';
		backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
		padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
	};
};

export type AgendaPageFieldsFragment = {
	__typename: 'AgendaPage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type CondoleanceInformationFieldsFragment = {
	__typename?: 'CondoleanceInformation';
	locale?: string;
	navbar?: {
		__typename?: 'ComponentInternalNavbar';
		notificationMessage?: string;
		mostPopularTitle?: string;
		ThemeGroupTitle?: string;
		searchPlaceholderText?: string;
		notificationLink?: any;
		notificationIsExternal?: boolean;
		notificationPublishDate?: any;
		notificationUnpublishDate?: any;
		rightNavLink?: any;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					size: number;
					url: string;
					formats?: any;
				};
			};
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		mostPopularGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
		themeGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
	};
	footer?: {
		__typename?: 'ComponentInternalFooter';
		accessibilityLink?: string;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					formats?: any;
					width?: number;
					height?: number;
				};
			};
		};
		themeLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		contactLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		socialLinkGroup?: {
			__typename?: 'ComponentComponentsIconLinkGroup';
			title: string;
			links: Array<{
				__typename?: 'ComponentComponentsIconLink';
				title: string;
				href: any;
				icon: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
			}>;
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		accessibilityLogo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo?: {
		__typename?: 'ComponentInternalSeo';
		id: string;
		title: string;
		description: string;
		noIndex: boolean;
		noFollow: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type CondoleanceHomePageFieldsFragment = {
	__typename?: 'CondoleanceHomepage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesHomepageHeader';
		id: string;
		description?: string;
		popularHeader?: string;
		homepageTitle?: string;
		backgroundImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type ContactFieldsFragment = {
	__typename: 'Contact';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type CookiePageFieldsFragment = {
	__typename: 'CookiePage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	bodyText: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type DecisionsPageFieldsFragment = {
	__typename: 'DecisionsPage';
	locale?: string;
	bodyText?: string;
	sidebarCurrentYearTitle: string;
	sidebarArchiveTitle: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	archiveLink: { __typename?: 'ComponentComponentsLink'; title: string; description?: string; href: any };
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type DownloadsPageFieldsFragment = {
	__typename: 'DownloadsPage';
	locale?: string;
	introHeader: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	downloads: Array<{
		__typename?: 'ComponentModulesDownloads';
		downloadsTitle?: any;
		downloads: Array<{
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					name: string;
					size: number;
					ext?: string;
					caption?: string;
				};
			};
		}>;
		downloadLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
			extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
			extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
		};
	}>;
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type EfroOostInConvoWithDetailSingleFieldsFragment = {
	__typename?: 'EfroOostInConvoWithDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type EfroOostInConvoWithOverviewSingleFieldsFragment = {
	__typename?: 'EfroOostInConvoWithOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesInConvoWithOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type EfroOostInformationFieldsFragment = {
	__typename?: 'EfroOostInformation';
	locale?: string;
	navbar?: {
		__typename?: 'ComponentInternalNavbar';
		notificationMessage?: string;
		mostPopularTitle?: string;
		ThemeGroupTitle?: string;
		searchPlaceholderText?: string;
		notificationLink?: any;
		notificationIsExternal?: boolean;
		notificationPublishDate?: any;
		notificationUnpublishDate?: any;
		rightNavLink?: any;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					size: number;
					url: string;
					formats?: any;
				};
			};
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		mostPopularGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
		themeGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
	};
	footer?: {
		__typename?: 'ComponentInternalFooter';
		accessibilityLink?: string;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					formats?: any;
					width?: number;
					height?: number;
				};
			};
		};
		themeLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		contactLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		socialLinkGroup?: {
			__typename?: 'ComponentComponentsIconLinkGroup';
			title: string;
			links: Array<{
				__typename?: 'ComponentComponentsIconLink';
				title: string;
				href: any;
				icon: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
			}>;
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		accessibilityLogo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo?: {
		__typename?: 'ComponentInternalSeo';
		id: string;
		title: string;
		description: string;
		noIndex: boolean;
		noFollow: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type EfroOostNewsDetailSingleFieldsFragment = {
	__typename?: 'EfroOostNewsDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNewsEfroOost';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'EfroOostNewsarticle';
					data: {
						__typename?: 'EfroOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'EfroOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type EfroOostNewsOverviewSingleFieldsFragment = {
	__typename?: 'EfroOostNewsOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesNewsOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type EfroOostHomePageFieldsFragment = {
	__typename?: 'EfroOostHomepage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesHomepageHeader';
		id: string;
		description?: string;
		popularHeader?: string;
		homepageTitle?: string;
		backgroundImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNewsEfroOost';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'EfroOostNewsarticle';
					data: {
						__typename?: 'EfroOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'EfroOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type EventOverviewSingleFieldsFragment = {
	__typename?: 'EventOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesEventOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type GeolinkInformationFieldsFragment = {
	__typename?: 'GeolinkInformation';
	locale?: string;
	navbar?: {
		__typename?: 'ComponentInternalNavbar';
		notificationMessage?: string;
		mostPopularTitle?: string;
		ThemeGroupTitle?: string;
		searchPlaceholderText?: string;
		notificationLink?: any;
		notificationIsExternal?: boolean;
		notificationPublishDate?: any;
		notificationUnpublishDate?: any;
		rightNavLink?: any;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					size: number;
					url: string;
					formats?: any;
				};
			};
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		mostPopularGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
		themeGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
	};
	footer?: {
		__typename?: 'ComponentInternalFooter';
		accessibilityLink?: string;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					formats?: any;
					width?: number;
					height?: number;
				};
			};
		};
		themeLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		contactLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		socialLinkGroup?: {
			__typename?: 'ComponentComponentsIconLinkGroup';
			title: string;
			links: Array<{
				__typename?: 'ComponentComponentsIconLink';
				title: string;
				href: any;
				icon: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
			}>;
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		accessibilityLogo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo?: {
		__typename?: 'ComponentInternalSeo';
		id: string;
		title: string;
		description: string;
		noIndex: boolean;
		noFollow: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type GeolinkHomePageFieldsFragment = {
	__typename?: 'GeolinkHomepage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesHomepageHeader';
		id: string;
		description?: string;
		popularHeader?: string;
		homepageTitle?: string;
		backgroundImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type HomePageFieldsFragment = {
	__typename?: 'HomePage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesHomepageHeader';
		id: string;
		description?: string;
		popularHeader?: string;
		homepageTitle?: string;
		backgroundImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesRegions';
				title?: any;
				regions: Array<{
					__typename?: 'Region';
					data: {
						__typename?: 'Region';
						documentId: string;
						attributes: {
							__typename: 'Region';
							title?: string;
							slug: string;
							locale?: string;
							header?: {
								__typename?: 'ComponentModulesExpandedHeader';
								headerTitle?: string;
								headerDescription?: string;
								title?: string;
								description?: string;
								headerButton?: {
									__typename?: 'ComponentComponentsButton';
									title?: string;
									variant: Enum_Componentcomponentsbutton_Variant;
									href: any;
									iconLeft?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
									iconRight?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
								};
								headerImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											name: string;
											url: string;
											alternativeText?: string;
											formats?: any;
										};
									};
								};
							};
							seo: {
								__typename?: 'ComponentModulesSeo';
								title?: string;
								description?: string;
								noIndex?: boolean;
								noFollow?: boolean;
								ogTitle?: string;
								ogDescription?: string;
								ogType?: string;
								ogUrl?: string;
								ogImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							};
							modules?: Array<
								| {
										__typename: 'ComponentModulesAccordeon';
										accordeonTitle?: any;
										sections: Array<{
											__typename: 'ComponentInternalAccordeonSection';
											accordeonSectionName?: string;
											items: Array<{
												__typename: 'ComponentInternalAccordeonItem';
												itemTitle: string;
												description?: string;
											}>;
										}>;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesBbvmsMediaplayer';
										videoId: string;
										playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
										url?: string;
										title?: any;
										description?: string;
										transcript?: string;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyText';
										bodyText?: string;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyTextTwoColumn';
										leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesCta';
										description?: string;
										imagePosition?: Enum_Componentmodulescta_Imageposition;
										videoLink?: string;
										ctaTitle?: any;
										buttons?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										}>;
										imageOrVideoFile?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													name: string;
													alternativeText?: string;
													caption?: string;
													url: string;
													mime: string;
													formats?: any;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesDownloads';
										downloadsTitle?: any;
										downloads: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													url: string;
													name: string;
													size: number;
													ext?: string;
													caption?: string;
												};
											};
										}>;
										downloadLinks?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedNews';
										featuredNewsTitle?: any;
										items: Array<{
											__typename?: 'Newsarticle';
											data: {
												__typename?: 'Newsarticle';
												documentId: string;
												attributes: {
													__typename: 'Newsarticle';
													firstPublishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													bodyText: {
														__typename?: 'ComponentModulesBodyText';
														bodyText?: string;
														sidebar?: {
															__typename?: 'ComponentInternalSidebar';
															title?: any;
															links?: Array<{
																__typename?: 'ComponentComponentsLink';
																title: string;
																href: any;
																description?: string;
															}>;
															files: Array<{
																__typename?: 'UploadFile';
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		ext?: string;
																		mime: string;
																		size: number;
																		url: string;
																		alternativeText?: string;
																		hash: string;
																		name: string;
																		caption?: string;
																	};
																};
															}>;
														};
														defaultModuleOptions: {
															__typename?: 'ComponentInternalDefaultModuleOptions';
															backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
															padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedPages';
										featuredPagesTitle?: any;
										items: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: {
													__typename: 'Page';
													publishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesHighlight';
										id: string;
										title?: any;
										theme?: {
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string };
											};
										};
										newsTab?: {
											__typename?: 'ComponentInternalHighlightNews';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										eventsTab?: {
											__typename?: 'ComponentInternalHighlightEvents';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										permitsTab?: {
											__typename?: 'ComponentInternalHighlightPermits';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Permit';
												data: {
													__typename?: 'Permit';
													attributes: { __typename: 'Permit'; slug: string; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										wooTab?: {
											__typename?: 'ComponentInternalHighlightWoo';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'WooRequest';
												data: {
													__typename?: 'WooRequest';
													attributes: {
														__typename: 'WooRequest';
														title: string;
														startDate: any;
														zip?: any;
														createdAt?: any;
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										mapsAndStatsTab?: {
											__typename?: 'ComponentInternalHighlightMapsAndStats';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'MapsFigure';
												data: {
													__typename?: 'MapsFigure';
													attributes: { __typename: 'MapsFigure'; slug: any; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										topicsTab?: {
											__typename?: 'ComponentInternalHighlightTopics';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										subsidiesTab?: {
											__typename?: 'ComponentInternalHighlightSubsidies';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Subsidy';
												data: {
													__typename?: 'Subsidy';
													attributes: {
														__typename: 'Subsidy';
														slug: string;
														header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesLinkBox';
										title?: any;
										description?: string;
										linkBoxLinks?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesMedia';
										transcript?: string;
										mediaLink?: string;
										mediaTitle?: any;
										mediaDescription?: string;
										media?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													size: number;
													ext?: string;
													url: string;
													alternativeText?: string;
													formats?: any;
													mime: string;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesNewsOverview' }
								| {
										__typename: 'ComponentModulesPhotoAlbum';
										id: string;
										description?: string;
										horizontal?: boolean;
										jsonTitle: any;
										photos: Array<{
											__typename: 'ComponentInternalPhoto';
											id: string;
											title: string;
											description?: string;
											photo: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														width?: number;
														height?: number;
														caption?: string;
														formats?: any;
														size: number;
														ext?: string;
														mime: string;
													};
												};
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesRegions' }
								| {
										__typename: 'ComponentModulesStepByStep';
										title?: any;
										stepByStepCard: Array<{
											__typename: 'ComponentInternalStepByStepCard';
											cardTitle: string;
											cardDescription?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesSubjects';
										id: string;
										description?: string;
										overviewTitle?: string;
										subjects: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
											};
										}>;
										projects: Array<{
											__typename?: 'Project';
											data: {
												__typename?: 'Project';
												documentId: string;
												attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
											};
										}>;
										themes: Array<{
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string; slug: string };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesThemes' }
								| { __typename?: 'Error' }
							>;
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesThemes';
				title?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: {
							__typename?: 'Theme';
							title: string;
							slug: string;
							header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type InConvoWithDetailSingleFieldsFragment = {
	__typename?: 'InConvoWithDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type InConvoWithOverviewSingleFieldsFragment = {
	__typename?: 'InConvoWithOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesInConvoWithOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type LoginSingleFieldsFragment = {
	__typename?: 'Login';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'ComponentModulesVacanciesOverview' }
		| { __typename: 'Error' }
	>;
};

export type MapsFiguresOverviewSingleFieldsFragment = {
	__typename?: 'MapsFiguresOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	mapsFiguresOverview: {
		__typename?: 'ComponentModulesMapsFiguresOverview';
		id: string;
		showResultsText: string;
		headerTitle: string;
		searchPlaceholderText: string;
		themeFilterText: string;
		kindFilterText: string;
		showAllThemesText: string;
		overviewTitleText: string;
		filterHeaderText: string;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'ComponentModulesRegions' }
		| { __typename: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'ComponentModulesThemes' }
		| { __typename: 'Error' }
	>;
};

export type NewsDetailSingleFieldsFragment = {
	__typename?: 'NewsDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type NewsOverviewSingleFieldsFragment = {
	__typename?: 'NewsOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesNewsOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type NewsletterArchiveOverviewSingleFieldsFragment = {
	__typename?: 'NewsletterArchiveOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPermitsOverview';
				id: string;
				headerTitle: string;
				searchPlaceholderText: string;
				themeFilterText: string;
				lawFilterText: string;
				productTypeFilterText: string;
				showAllThemesText: string;
				showAllLawsText: string;
				showAllProductTypesText: string;
				overviewTitleText: string;
				showResultsText: string;
				filterHeaderText: string;
		  }
		| { __typename: 'ComponentModulesPhotoAlbum' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type InternalNewsletterWithSubscriptionsFieldsFragment = {
	__typename?: 'InternalNewsletterWithSubscriptions';
	page?: {
		__typename?: 'NewsletterInternal';
		header: {
			__typename?: 'ComponentModulesIntroHeader';
			title: string;
			excerpt: string;
			backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
		};
		newsletter: {
			__typename?: 'ComponentInternalNewsletter';
			title?: string;
			fieldLabel?: string;
			fieldPlaceholder?: string;
			submitButton?: {
				__typename?: 'ComponentComponentsButton';
				title?: string;
				variant: Enum_Componentcomponentsbutton_Variant;
				href: any;
				iconLeft?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
				iconRight?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
			defaultModuleOptions: {
				__typename?: 'ComponentInternalDefaultModuleOptions';
				backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
				padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
			};
		};
		seo: {
			__typename?: 'ComponentModulesSeo';
			title?: string;
			description?: string;
			noIndex?: boolean;
			noFollow?: boolean;
			ogTitle?: string;
			ogDescription?: string;
			ogType?: string;
			ogUrl?: string;
			ogImage?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
		};
	};
};

export type NewsletterInternalSingleFieldsFragment = {
	__typename?: 'NewsletterInternal';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	newsletter: {
		__typename?: 'ComponentInternalNewsletter';
		title?: string;
		fieldLabel?: string;
		fieldPlaceholder?: string;
		submitButton?: {
			__typename?: 'ComponentComponentsButton';
			title?: string;
			variant: Enum_Componentcomponentsbutton_Variant;
			href: any;
			iconLeft?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
			iconRight?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type NewsletterPublicSingleFieldsFragment = {
	__typename?: 'NewsletterPublic';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	newsletter: {
		__typename?: 'ComponentInternalNewsletter';
		title?: string;
		fieldLabel?: string;
		fieldPlaceholder?: string;
		submitButton?: {
			__typename?: 'ComponentComponentsButton';
			title?: string;
			variant: Enum_Componentcomponentsbutton_Variant;
			href: any;
			iconLeft?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
			iconRight?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type PublicNewsletterFieldsFragment = {
	__typename?: 'PublicNewsletterPage';
	page?: {
		__typename?: 'NewsletterPublic';
		header: {
			__typename?: 'ComponentModulesIntroHeader';
			title: string;
			excerpt: string;
			backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
		};
		newsletter: {
			__typename?: 'ComponentInternalNewsletter';
			title?: string;
			fieldLabel?: string;
			fieldPlaceholder?: string;
			submitButton?: {
				__typename?: 'ComponentComponentsButton';
				title?: string;
				variant: Enum_Componentcomponentsbutton_Variant;
				href: any;
				iconLeft?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
				iconRight?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; name: string };
					};
				};
			};
			defaultModuleOptions: {
				__typename?: 'ComponentInternalDefaultModuleOptions';
				backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
				padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
			};
		};
		seo: {
			__typename?: 'ComponentModulesSeo';
			title?: string;
			description?: string;
			noIndex?: boolean;
			noFollow?: boolean;
			ogTitle?: string;
			ogDescription?: string;
			ogType?: string;
			ogUrl?: string;
			ogImage?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
		};
	};
};

export type NotFoundPageFieldsFragment = {
	__typename: 'NotFoundPage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	links: {
		__typename?: 'ComponentModulesLinkBox';
		title?: any;
		description?: string;
		linkBoxLinks?: Array<{
			__typename?: 'ComponentComponentsButton';
			title?: string;
			variant: Enum_Componentcomponentsbutton_Variant;
			href: any;
			iconLeft?: {
				__typename?: 'UploadFile';
				data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
			};
			iconRight?: {
				__typename?: 'UploadFile';
				data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
			};
		}>;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
			extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
			extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
		};
	};
	cta: {
		__typename?: 'ComponentModulesCta';
		description?: string;
		imagePosition?: Enum_Componentmodulescta_Imageposition;
		videoLink?: string;
		ctaTitle?: any;
		buttons?: Array<{
			__typename?: 'ComponentComponentsButton';
			title?: string;
			variant: Enum_Componentcomponentsbutton_Variant;
			href: any;
			iconLeft?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
			iconRight?: {
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: { __typename?: 'UploadFile'; url: string; name: string };
				};
			};
		}>;
		imageOrVideoFile?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					caption?: string;
					url: string;
					mime: string;
					formats?: any;
				};
			};
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
			extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
			extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
		};
	};
};

export type OpOostInConvoWithDetailSingleFieldsFragment = {
	__typename?: 'OpOostInConvoWithDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type OpOostInConvoWithOverviewSingleFieldsFragment = {
	__typename?: 'OpOostInConvoWithOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesInConvoWithOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type OpOostInformationFieldsFragment = {
	__typename?: 'OpOostInformation';
	locale?: string;
	navbar?: {
		__typename?: 'ComponentInternalNavbar';
		notificationMessage?: string;
		mostPopularTitle?: string;
		ThemeGroupTitle?: string;
		searchPlaceholderText?: string;
		notificationLink?: any;
		notificationIsExternal?: boolean;
		notificationPublishDate?: any;
		notificationUnpublishDate?: any;
		rightNavLink?: any;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					size: number;
					url: string;
					formats?: any;
				};
			};
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		mostPopularGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
		themeGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
	};
	footer?: {
		__typename?: 'ComponentInternalFooter';
		accessibilityLink?: string;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					formats?: any;
					width?: number;
					height?: number;
				};
			};
		};
		themeLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		contactLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		socialLinkGroup?: {
			__typename?: 'ComponentComponentsIconLinkGroup';
			title: string;
			links: Array<{
				__typename?: 'ComponentComponentsIconLink';
				title: string;
				href: any;
				icon: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
			}>;
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		accessibilityLogo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo?: {
		__typename?: 'ComponentInternalSeo';
		id: string;
		title: string;
		description: string;
		noIndex: boolean;
		noFollow: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type OpOostNewsDetailSingleFieldsFragment = {
	__typename?: 'OpOostNewsDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNewsOpOost';
				featuredNewsTitle?: any;
				news: Array<{
					__typename?: 'OpOostNewsarticle';
					data: {
						__typename?: 'OpOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'OpOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type OpOostNewsOverviewSingleFieldsFragment = {
	__typename?: 'OpOostNewsOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesNewsOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type OpOostHomePageFieldsFragment = {
	__typename?: 'OpOostHomepage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesHomepageHeader';
		id: string;
		description?: string;
		popularHeader?: string;
		homepageTitle?: string;
		backgroundImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNewsOpOost';
				featuredNewsTitle?: any;
				news: Array<{
					__typename?: 'OpOostNewsarticle';
					data: {
						__typename?: 'OpOostNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'OpOostNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type OpenGelderlandInformationFieldsFragment = {
	__typename?: 'OpenGelderlandInformation';
	locale?: string;
	navbar?: {
		__typename?: 'ComponentInternalNavbar';
		notificationMessage?: string;
		mostPopularTitle?: string;
		ThemeGroupTitle?: string;
		searchPlaceholderText?: string;
		notificationLink?: any;
		notificationIsExternal?: boolean;
		notificationPublishDate?: any;
		notificationUnpublishDate?: any;
		rightNavLink?: any;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					size: number;
					url: string;
					formats?: any;
				};
			};
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		mostPopularGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
		themeGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
	};
	footer?: {
		__typename?: 'ComponentInternalFooter';
		accessibilityLink?: string;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					formats?: any;
					width?: number;
					height?: number;
				};
			};
		};
		themeLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		contactLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		socialLinkGroup?: {
			__typename?: 'ComponentComponentsIconLinkGroup';
			title: string;
			links: Array<{
				__typename?: 'ComponentComponentsIconLink';
				title: string;
				href: any;
				icon: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
			}>;
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		accessibilityLogo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo?: {
		__typename?: 'ComponentInternalSeo';
		id: string;
		title: string;
		description: string;
		noIndex: boolean;
		noFollow: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type OpenGelderlandWooRequestOverviewSingleFieldsFragment = {
	__typename?: 'OpenGelderlandWooOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	woo_overview: {
		__typename?: 'ComponentModulesOpenWooRequestOverview';
		id: string;
		filterHeaderText: string;
		headerTitle: string;
		filterLink?: { __typename?: 'ComponentComponentsLink'; id: string; title: string; href: any; description?: string };
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type OpenGelderlandHomePageFieldsFragment = {
	__typename?: 'OpenGelderlandHomepage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeaderImage';
		title: string;
		excerpt?: string;
		backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
		cover?: {
			__typename?: 'UploadFile';
			url: string;
			alternativeText?: string;
			formats?: any;
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	collections: {
		__typename?: 'ComponentModulesCollections';
		id: string;
		description?: string;
		overviewTitle?: string;
		links: Array<{
			__typename?: 'ComponentComponentsLink';
			id: string;
			title: string;
			href: any;
			description?: string;
		}>;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type PageInformationFieldsFragment = {
	__typename: 'PageInformation';
	locale?: string;
	navbar?: {
		__typename?: 'ComponentInternalNavbar';
		notificationMessage?: string;
		mostPopularTitle?: string;
		ThemeGroupTitle?: string;
		searchPlaceholderText?: string;
		notificationLink?: any;
		notificationIsExternal?: boolean;
		notificationPublishDate?: any;
		notificationUnpublishDate?: any;
		rightNavLink?: any;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					size: number;
					url: string;
					formats?: any;
				};
			};
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		mostPopularGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
		themeGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
	};
	footer?: {
		__typename?: 'ComponentInternalFooter';
		accessibilityLink?: string;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					formats?: any;
					width?: number;
					height?: number;
				};
			};
		};
		themeLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		contactLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		socialLinkGroup?: {
			__typename?: 'ComponentComponentsIconLinkGroup';
			title: string;
			links: Array<{
				__typename?: 'ComponentComponentsIconLink';
				title: string;
				href: any;
				icon: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
			}>;
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		accessibilityLogo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo?: {
		__typename?: 'ComponentInternalSeo';
		id: string;
		title: string;
		description: string;
		noIndex: boolean;
		noFollow: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type PasswordPageFieldsFragment = {
	__typename: 'PasswordProtectionPasswordPage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	modules?: Array<
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesRegions';
				title?: any;
				regions: Array<{
					__typename?: 'Region';
					data: {
						__typename?: 'Region';
						documentId: string;
						attributes: {
							__typename: 'Region';
							title?: string;
							slug: string;
							locale?: string;
							header?: {
								__typename?: 'ComponentModulesExpandedHeader';
								headerTitle?: string;
								headerDescription?: string;
								title?: string;
								description?: string;
								headerButton?: {
									__typename?: 'ComponentComponentsButton';
									title?: string;
									variant: Enum_Componentcomponentsbutton_Variant;
									href: any;
									iconLeft?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
									iconRight?: {
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; name: string };
										};
									};
								};
								headerImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: {
											__typename?: 'UploadFile';
											name: string;
											url: string;
											alternativeText?: string;
											formats?: any;
										};
									};
								};
							};
							seo: {
								__typename?: 'ComponentModulesSeo';
								title?: string;
								description?: string;
								noIndex?: boolean;
								noFollow?: boolean;
								ogTitle?: string;
								ogDescription?: string;
								ogType?: string;
								ogUrl?: string;
								ogImage?: {
									__typename?: 'UploadFile';
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; name: string };
									};
								};
							};
							modules?: Array<
								| {
										__typename: 'ComponentModulesAccordeon';
										accordeonTitle?: any;
										sections: Array<{
											__typename: 'ComponentInternalAccordeonSection';
											accordeonSectionName?: string;
											items: Array<{
												__typename: 'ComponentInternalAccordeonItem';
												itemTitle: string;
												description?: string;
											}>;
										}>;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesBbvmsMediaplayer';
										videoId: string;
										playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
										url?: string;
										title?: any;
										description?: string;
										transcript?: string;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyText';
										bodyText?: string;
										sidebar?: {
											__typename?: 'ComponentInternalSidebar';
											title?: any;
											links?: Array<{
												__typename?: 'ComponentComponentsLink';
												title: string;
												href: any;
												description?: string;
											}>;
											files: Array<{
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														ext?: string;
														mime: string;
														size: number;
														url: string;
														alternativeText?: string;
														hash: string;
														name: string;
														caption?: string;
													};
												};
											}>;
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesBodyTextTwoColumn';
										leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesCta';
										description?: string;
										imagePosition?: Enum_Componentmodulescta_Imageposition;
										videoLink?: string;
										ctaTitle?: any;
										buttons?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: { __typename?: 'UploadFile'; url: string; name: string };
												};
											};
										}>;
										imageOrVideoFile?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													name: string;
													alternativeText?: string;
													caption?: string;
													url: string;
													mime: string;
													formats?: any;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesDownloads';
										downloadsTitle?: any;
										downloads: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													url: string;
													name: string;
													size: number;
													ext?: string;
													caption?: string;
												};
											};
										}>;
										downloadLinks?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedNews';
										featuredNewsTitle?: any;
										items: Array<{
											__typename?: 'Newsarticle';
											data: {
												__typename?: 'Newsarticle';
												documentId: string;
												attributes: {
													__typename: 'Newsarticle';
													firstPublishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
													bodyText: {
														__typename?: 'ComponentModulesBodyText';
														bodyText?: string;
														sidebar?: {
															__typename?: 'ComponentInternalSidebar';
															title?: any;
															links?: Array<{
																__typename?: 'ComponentComponentsLink';
																title: string;
																href: any;
																description?: string;
															}>;
															files: Array<{
																__typename?: 'UploadFile';
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		ext?: string;
																		mime: string;
																		size: number;
																		url: string;
																		alternativeText?: string;
																		hash: string;
																		name: string;
																		caption?: string;
																	};
																};
															}>;
														};
														defaultModuleOptions: {
															__typename?: 'ComponentInternalDefaultModuleOptions';
															backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
															padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesFeaturedPages';
										featuredPagesTitle?: any;
										items: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: {
													__typename: 'Page';
													publishedAt?: any;
													title: string;
													slug: string;
													header: {
														__typename?: 'ComponentModulesIntroHeaderImage';
														title: string;
														excerpt?: string;
														backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
														cover?: {
															__typename?: 'UploadFile';
															url: string;
															alternativeText?: string;
															formats?: any;
															data: {
																__typename?: 'UploadFile';
																documentId: string;
																attributes: {
																	__typename?: 'UploadFile';
																	url: string;
																	alternativeText?: string;
																	formats?: any;
																};
															};
														};
													};
												};
											};
										}>;
										cta?: {
											__typename?: 'ComponentComponentsButton';
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											ctaTitle?: string;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														formats?: any;
													};
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename: 'ComponentModulesHighlight';
										id: string;
										title?: any;
										theme?: {
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string };
											};
										};
										newsTab?: {
											__typename?: 'ComponentInternalHighlightNews';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										eventsTab?: {
											__typename?: 'ComponentInternalHighlightEvents';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										permitsTab?: {
											__typename?: 'ComponentInternalHighlightPermits';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Permit';
												data: {
													__typename?: 'Permit';
													attributes: { __typename: 'Permit'; slug: string; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										wooTab?: {
											__typename?: 'ComponentInternalHighlightWoo';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'WooRequest';
												data: {
													__typename?: 'WooRequest';
													attributes: {
														__typename: 'WooRequest';
														title: string;
														startDate: any;
														zip?: any;
														createdAt?: any;
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										mapsAndStatsTab?: {
											__typename?: 'ComponentInternalHighlightMapsAndStats';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'MapsFigure';
												data: {
													__typename?: 'MapsFigure';
													attributes: { __typename: 'MapsFigure'; slug: any; title: string };
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										topicsTab?: {
											__typename?: 'ComponentInternalHighlightTopics';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Newsarticle';
												data: {
													__typename?: 'Newsarticle';
													attributes: {
														__typename: 'Newsarticle';
														firstPublishedAt?: any;
														title: string;
														slug: string;
														header: {
															__typename?: 'ComponentModulesIntroHeaderImage';
															title: string;
															excerpt?: string;
															backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
															cover?: {
																__typename?: 'UploadFile';
																url: string;
																alternativeText?: string;
																formats?: any;
																data: {
																	__typename?: 'UploadFile';
																	documentId: string;
																	attributes: {
																		__typename?: 'UploadFile';
																		url: string;
																		alternativeText?: string;
																		formats?: any;
																	};
																};
															};
														};
														bodyText: {
															__typename?: 'ComponentModulesBodyText';
															bodyText?: string;
															sidebar?: {
																__typename?: 'ComponentInternalSidebar';
																title?: any;
																links?: Array<{
																	__typename?: 'ComponentComponentsLink';
																	title: string;
																	href: any;
																	description?: string;
																}>;
																files: Array<{
																	__typename?: 'UploadFile';
																	data: {
																		__typename?: 'UploadFile';
																		documentId: string;
																		attributes: {
																			__typename?: 'UploadFile';
																			ext?: string;
																			mime: string;
																			size: number;
																			url: string;
																			alternativeText?: string;
																			hash: string;
																			name: string;
																			caption?: string;
																		};
																	};
																}>;
															};
															defaultModuleOptions: {
																__typename?: 'ComponentInternalDefaultModuleOptions';
																backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
																padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
															};
														};
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										subsidiesTab?: {
											__typename?: 'ComponentInternalHighlightSubsidies';
											id: string;
											title?: string;
											buttonTitle?: string;
											buttonHref?: any;
											items: Array<{
												__typename?: 'Subsidy';
												data: {
													__typename?: 'Subsidy';
													attributes: {
														__typename: 'Subsidy';
														slug: string;
														header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
													};
												};
											}>;
											empty?: {
												__typename?: 'ComponentInternalEmptyState';
												message?: string;
												title?: string;
												href?: string;
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesLinkBox';
										title?: any;
										description?: string;
										linkBoxLinks?: Array<{
											__typename?: 'ComponentComponentsButton';
											title?: string;
											variant: Enum_Componentcomponentsbutton_Variant;
											href: any;
											iconLeft?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
											iconRight?: {
												__typename?: 'UploadFile';
												data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
											extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
											extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesMedia';
										transcript?: string;
										mediaLink?: string;
										mediaTitle?: any;
										mediaDescription?: string;
										media?: {
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													size: number;
													ext?: string;
													url: string;
													alternativeText?: string;
													formats?: any;
													mime: string;
												};
											};
										};
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesNewsOverview' }
								| {
										__typename: 'ComponentModulesPhotoAlbum';
										id: string;
										description?: string;
										horizontal?: boolean;
										jsonTitle: any;
										photos: Array<{
											__typename: 'ComponentInternalPhoto';
											id: string;
											title: string;
											description?: string;
											photo: {
												__typename?: 'UploadFile';
												data: {
													__typename?: 'UploadFile';
													documentId: string;
													attributes: {
														__typename?: 'UploadFile';
														url: string;
														alternativeText?: string;
														width?: number;
														height?: number;
														caption?: string;
														formats?: any;
														size: number;
														ext?: string;
														mime: string;
													};
												};
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesRegions' }
								| {
										__typename: 'ComponentModulesStepByStep';
										title?: any;
										stepByStepCard: Array<{
											__typename: 'ComponentInternalStepByStepCard';
											cardTitle: string;
											cardDescription?: string;
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| {
										__typename?: 'ComponentModulesSubjects';
										id: string;
										description?: string;
										overviewTitle?: string;
										subjects: Array<{
											__typename?: 'Page';
											data: {
												__typename?: 'Page';
												documentId: string;
												attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
											};
										}>;
										projects: Array<{
											__typename?: 'Project';
											data: {
												__typename?: 'Project';
												documentId: string;
												attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
											};
										}>;
										themes: Array<{
											__typename?: 'Theme';
											data: {
												__typename?: 'Theme';
												documentId: string;
												attributes: { __typename?: 'Theme'; title: string; slug: string };
											};
										}>;
										defaultModuleOptions: {
											__typename?: 'ComponentInternalDefaultModuleOptions';
											backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
											padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
										};
								  }
								| { __typename?: 'ComponentModulesThemes' }
								| { __typename?: 'Error' }
							>;
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesThemes';
				title?: any;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: {
							__typename?: 'Theme';
							title: string;
							slug: string;
							header?: { __typename?: 'ComponentModulesExpandedHeader'; description?: string };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type PermitDetailSingleFieldsFragment = {
	__typename?: 'PermitDetail';
	locale?: string;
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type PermitsOverviewSingleFieldsFragment = {
	__typename?: 'PermitsOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPermitsOverview';
				id: string;
				headerTitle: string;
				searchPlaceholderText: string;
				themeFilterText: string;
				lawFilterText: string;
				productTypeFilterText: string;
				showAllThemesText: string;
				showAllLawsText: string;
				showAllProductTypesText: string;
				overviewTitleText: string;
				showResultsText: string;
				filterHeaderText: string;
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type PressReleaseOverviewSingleFieldsFragment = {
	__typename?: 'PressReleaseOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'ComponentModulesLinkBox' }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPressReleaseOverview';
				id: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type PressReleaseDetailFieldsFragment = {
	__typename: 'PressReleaseDetail';
	modules?: Array<
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export type PrivacyPolicyFieldsFragment = {
	__typename: 'PrivacyPolicy';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	bodytext: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
};

export type ProjectDetailSingleFieldsFragment = {
	__typename?: 'ProjectDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesScheduling';
				title?: any;
				firstColumnTitle: string;
				secondColumnTitle?: string;
				firstColumnRows: Array<{ __typename: 'ComponentInternalFirstRowItems'; id: string; bodyText?: string }>;
				secondColumnRows?: Array<{ __typename: 'ComponentInternalSecondColumnItems'; id: string; bodyText?: string }>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type ProjectOverviewSingleFieldsFragment = {
	__typename?: 'ProjectOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| { __typename: 'ComponentModulesAccordeon' }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'ComponentModulesPartners' }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesProjectOverview';
				id: string;
				filterLabel?: string;
				extendedDefaultModuleOptions?: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'ComponentModulesScheduling' }
		| { __typename: 'ComponentModulesStepByStep' }
		| { __typename: 'ComponentModulesSubjects' }
		| { __typename: 'ComponentModulesTable' }
		| { __typename: 'ComponentModulesTestimonial' }
		| { __typename: 'Error' }
	>;
};

export type RegioExpresInConvoWithDetailSingleFieldsFragment = {
	__typename?: 'RegioExpresInConvoWithDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type RegioExpresInConvoWithOverviewSingleFieldsFragment = {
	__typename?: 'RegioExpresInConvoOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesInConvoWithOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type RegioExpresInformationFieldsFragment = {
	__typename?: 'RegioExpresInformation';
	locale?: string;
	navbar?: {
		__typename?: 'ComponentInternalNavbar';
		notificationMessage?: string;
		mostPopularTitle?: string;
		ThemeGroupTitle?: string;
		searchPlaceholderText?: string;
		notificationLink?: any;
		notificationIsExternal?: boolean;
		notificationPublishDate?: any;
		notificationUnpublishDate?: any;
		rightNavLink?: any;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					name: string;
					alternativeText?: string;
					size: number;
					url: string;
					formats?: any;
				};
			};
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		mostPopularGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
		themeGroupLinks?: Array<{
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
		}>;
	};
	footer?: {
		__typename?: 'ComponentInternalFooter';
		accessibilityLink?: string;
		logo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: {
					__typename?: 'UploadFile';
					url: string;
					alternativeText?: string;
					formats?: any;
					width?: number;
					height?: number;
				};
			};
		};
		themeLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			href?: any;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		contactLinkGroup?: {
			__typename?: 'ComponentComponentsLinkGroup';
			title: string;
			links: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		};
		socialLinkGroup?: {
			__typename?: 'ComponentComponentsIconLinkGroup';
			title: string;
			links: Array<{
				__typename?: 'ComponentComponentsIconLink';
				title: string;
				href: any;
				icon: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
			}>;
		};
		bottomLinks?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
		accessibilityLogo?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
	};
	seo?: {
		__typename?: 'ComponentInternalSeo';
		id: string;
		title: string;
		description: string;
		noIndex: boolean;
		noFollow: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
};

export type RegioExpresNewsDetailSingleFieldsFragment = {
	__typename?: 'RegioExpresNewsDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNewsRegioExpres';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'RegioExpresNewsarticle';
					data: {
						__typename?: 'RegioExpresNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'RegioExpresNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type RegioExpresNewsOverviewSingleFieldsFragment = {
	__typename?: 'RegioExpresNewsOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesNewsOverview';
				id: string;
				filterLabel?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type RegioExpresHomePageFieldsFragment = {
	__typename?: 'RegioExpresHomepage';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesHomepageHeader';
		id: string;
		description?: string;
		popularHeader?: string;
		homepageTitle?: string;
		backgroundImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
			};
		};
		links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any }>;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNewsRegioExpres';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'RegioExpresNewsarticle';
					data: {
						__typename?: 'RegioExpresNewsarticle';
						documentId: string;
						attributes: {
							__typename?: 'RegioExpresNewsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTestimonial';
				id: string;
				quote?: string;
				name: string;
				organization?: string;
				quoteTitle: any;
				photo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				logo?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type RoadMaintenanceDetailSingleFieldsFragment = {
	__typename?: 'RoadMaintenanceDetail';
	locale?: string;
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type RoadMaintenanceOverviewSingleFieldsFragment = {
	__typename?: 'RoadMaintenanceOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	list: { __typename: 'ComponentModulesRoadMaintenanceOverview'; id: string; title: string };
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'ComponentModulesPhotoAlbum' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type SearchOverviewSingleFieldsFragment = {
	__typename?: 'SearchOverview';
	searchHeader?: {
		__typename?: 'ComponentModulesSearchHeader';
		id: string;
		title?: string;
		searchPlaceholder?: string;
	};
	Zoekresultaten: { __typename?: 'ComponentModulesSearchOverview'; id: string; resultLabel?: string };
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type SitemapPageFieldsFragment = {
	__typename?: 'Sitemap';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type SubsidyDetailSingleFieldsFragment = {
	__typename?: 'SubsidyDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesPhotoAlbum' }
		| { __typename?: 'ComponentModulesRegions' }
		| { __typename?: 'ComponentModulesScheduling' }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesTable';
				table?: string;
				tableTitle?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesThemes' }
		| { __typename?: 'Error' }
	>;
};

export type SubsidyOverviewSingleFieldsFragment = {
	__typename?: 'SubsidyOverview';
	locale?: string;
	publishedAt?: any;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| { __typename?: 'ComponentModulesAccordeon' }
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'ComponentModulesDownloads' }
		| { __typename?: 'ComponentModulesFeaturedNews' }
		| { __typename?: 'ComponentModulesFeaturedPages' }
		| { __typename?: 'ComponentModulesHighlight' }
		| { __typename?: 'ComponentModulesLinkBox' }
		| { __typename?: 'ComponentModulesMedia' }
		| { __typename?: 'ComponentModulesPhotoAlbum' }
		| { __typename?: 'ComponentModulesRegions' }
		| { __typename?: 'ComponentModulesSubjects' }
		| {
				__typename?: 'ComponentModulesSubsidyOverview';
				id: string;
				showResultsText: string;
				headerTitle: string;
				searchPlaceholderText: string;
				themeFilterText: string;
				showMoreThemesText: string;
				showLessThemesText: string;
				targetGroupFilterText: string;
				kindFilterText: string;
				scaleFilterText: string;
				overviewTitleText: string;
				filterHeaderText: string;
		  }
		| { __typename?: 'ComponentModulesThemes' }
		| { __typename?: 'Error' }
	>;
};

export type VacancyDetailSingleFieldsFragment = {
	__typename?: 'VacancyDetail';
	share?: {
		__typename?: 'ComponentModulesShare';
		title?: any;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type VacancyInternalDetailSingleFieldsFragment = {
	__typename?: 'VacancyInternalDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedNews';
				featuredNewsTitle?: any;
				items: Array<{
					__typename?: 'Newsarticle';
					data: {
						__typename?: 'Newsarticle';
						documentId: string;
						attributes: {
							__typename: 'Newsarticle';
							firstPublishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
							bodyText: {
								__typename?: 'ComponentModulesBodyText';
								bodyText?: string;
								sidebar?: {
									__typename?: 'ComponentInternalSidebar';
									title?: any;
									links?: Array<{
										__typename?: 'ComponentComponentsLink';
										title: string;
										href: any;
										description?: string;
									}>;
									files: Array<{
										__typename?: 'UploadFile';
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: {
												__typename?: 'UploadFile';
												ext?: string;
												mime: string;
												size: number;
												url: string;
												alternativeText?: string;
												hash: string;
												name: string;
												caption?: string;
											};
										};
									}>;
								};
								defaultModuleOptions: {
									__typename?: 'ComponentInternalDefaultModuleOptions';
									backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
									padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesFeaturedPages';
				featuredPagesTitle?: any;
				items: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: {
							__typename: 'Page';
							publishedAt?: any;
							title: string;
							slug: string;
							header: {
								__typename?: 'ComponentModulesIntroHeaderImage';
								title: string;
								excerpt?: string;
								backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
								cover?: {
									__typename?: 'UploadFile';
									url: string;
									alternativeText?: string;
									formats?: any;
									data: {
										__typename?: 'UploadFile';
										documentId: string;
										attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
									};
								};
							};
						};
					};
				}>;
				cta?: {
					__typename?: 'ComponentComponentsButton';
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					ctaTitle?: string;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type VacancyInternalOverviewSingleFieldsFragment = {
	__typename?: 'VacancyInternalOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesVacanciesOverview';
				id: string;
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type VacancyOverviewSingleFieldsFragment = {
	__typename?: 'VacancyOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules: Array<
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesVacanciesOverview';
				id: string;
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type WobRequestOverviewSingleFieldsFragment = {
	__typename?: 'WobRequestOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	bodyText?: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	list: {
		__typename: 'ComponentModulesWobRequestOverview';
		id: string;
		sectionTitle: string;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type WooDocumentDetailSingleFieldsFragment = {
	__typename?: 'WooDocumentDetail';
	modules?: Array<
		| {
				__typename: 'ComponentModulesBbvmsMediaplayer';
				videoId: string;
				playout: Enum_Componentmodulesbbvmsmediaplayer_Playout;
				url?: string;
				title?: any;
				description?: string;
				transcript?: string;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesShare';
				title?: any;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type WooRequestOverviewSingleFieldsFragment = {
	__typename?: 'WooRequestOverview';
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	bodyText?: {
		__typename?: 'ComponentModulesBodyText';
		bodyText?: string;
		sidebar?: {
			__typename?: 'ComponentInternalSidebar';
			title?: any;
			links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
			files: Array<{
				__typename?: 'UploadFile';
				data: {
					__typename?: 'UploadFile';
					documentId: string;
					attributes: {
						__typename?: 'UploadFile';
						ext?: string;
						mime: string;
						size: number;
						url: string;
						alternativeText?: string;
						hash: string;
						name: string;
						caption?: string;
					};
				};
			}>;
		};
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	list: {
		__typename: 'ComponentModulesWooRequestOverview';
		id: string;
		filterLabel?: string;
		sectionTitle: string;
		defaultModuleOptions: {
			__typename?: 'ComponentInternalDefaultModuleOptions';
			backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
			padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
		};
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename: 'ComponentModulesAccordeon';
				accordeonTitle?: any;
				sections: Array<{
					__typename: 'ComponentInternalAccordeonSection';
					accordeonSectionName?: string;
					items: Array<{ __typename: 'ComponentInternalAccordeonItem'; itemTitle: string; description?: string }>;
				}>;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesBodyTextTwoColumn';
				leftColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				rightColumn: { __typename?: 'ComponentInternalBodyTextColumn'; bodyText?: string };
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesDownloads';
				downloadsTitle?: any;
				downloads: Array<{
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							url: string;
							name: string;
							size: number;
							ext?: string;
							caption?: string;
						};
					};
				}>;
				downloadLinks?: Array<{
					__typename?: 'ComponentComponentsLink';
					title: string;
					href: any;
					description?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesHighlight';
				id: string;
				title?: any;
				theme?: {
					__typename?: 'Theme';
					data: { __typename?: 'Theme'; documentId: string; attributes: { __typename?: 'Theme'; title: string } };
				};
				newsTab?: {
					__typename?: 'ComponentInternalHighlightNews';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				eventsTab?: {
					__typename?: 'ComponentInternalHighlightEvents';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				permitsTab?: {
					__typename?: 'ComponentInternalHighlightPermits';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Permit';
						data: { __typename?: 'Permit'; attributes: { __typename: 'Permit'; slug: string; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				wooTab?: {
					__typename?: 'ComponentInternalHighlightWoo';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'WooRequest';
						data: {
							__typename?: 'WooRequest';
							attributes: { __typename: 'WooRequest'; title: string; startDate: any; zip?: any; createdAt?: any };
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				mapsAndStatsTab?: {
					__typename?: 'ComponentInternalHighlightMapsAndStats';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'MapsFigure';
						data: { __typename?: 'MapsFigure'; attributes: { __typename: 'MapsFigure'; slug: any; title: string } };
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				topicsTab?: {
					__typename?: 'ComponentInternalHighlightTopics';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Newsarticle';
						data: {
							__typename?: 'Newsarticle';
							attributes: {
								__typename: 'Newsarticle';
								firstPublishedAt?: any;
								title: string;
								slug: string;
								header: {
									__typename?: 'ComponentModulesIntroHeaderImage';
									title: string;
									excerpt?: string;
									backgroundColor?: Enum_Componentmodulesintroheaderimage_Backgroundcolor;
									cover?: {
										__typename?: 'UploadFile';
										url: string;
										alternativeText?: string;
										formats?: any;
										data: {
											__typename?: 'UploadFile';
											documentId: string;
											attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
										};
									};
								};
								bodyText: {
									__typename?: 'ComponentModulesBodyText';
									bodyText?: string;
									sidebar?: {
										__typename?: 'ComponentInternalSidebar';
										title?: any;
										links?: Array<{
											__typename?: 'ComponentComponentsLink';
											title: string;
											href: any;
											description?: string;
										}>;
										files: Array<{
											__typename?: 'UploadFile';
											data: {
												__typename?: 'UploadFile';
												documentId: string;
												attributes: {
													__typename?: 'UploadFile';
													ext?: string;
													mime: string;
													size: number;
													url: string;
													alternativeText?: string;
													hash: string;
													name: string;
													caption?: string;
												};
											};
										}>;
									};
									defaultModuleOptions: {
										__typename?: 'ComponentInternalDefaultModuleOptions';
										backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
										padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
									};
								};
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				subsidiesTab?: {
					__typename?: 'ComponentInternalHighlightSubsidies';
					id: string;
					title?: string;
					buttonTitle?: string;
					buttonHref?: any;
					items: Array<{
						__typename?: 'Subsidy';
						data: {
							__typename?: 'Subsidy';
							attributes: {
								__typename: 'Subsidy';
								slug: string;
								header: { __typename?: 'ComponentModulesIntroHeader'; title: string };
							};
						};
					}>;
					empty?: { __typename?: 'ComponentInternalEmptyState'; message?: string; title?: string; href?: string };
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesMedia';
				transcript?: string;
				mediaLink?: string;
				mediaTitle?: any;
				mediaDescription?: string;
				media?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							size: number;
							ext?: string;
							url: string;
							alternativeText?: string;
							formats?: any;
							mime: string;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPhotoAlbum';
				id: string;
				description?: string;
				horizontal?: boolean;
				jsonTitle: any;
				photos: Array<{
					__typename: 'ComponentInternalPhoto';
					id: string;
					title: string;
					description?: string;
					photo: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								url: string;
								alternativeText?: string;
								width?: number;
								height?: number;
								caption?: string;
								formats?: any;
								size: number;
								ext?: string;
								mime: string;
							};
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesStepByStep';
				title?: any;
				stepByStepCard: Array<{
					__typename: 'ComponentInternalStepByStepCard';
					cardTitle: string;
					cardDescription?: string;
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesSubjects';
				id: string;
				description?: string;
				overviewTitle?: string;
				subjects: Array<{
					__typename?: 'Page';
					data: {
						__typename?: 'Page';
						documentId: string;
						attributes: { __typename?: 'Page'; title: string; slug: string; shortDescription?: string };
					};
				}>;
				projects: Array<{
					__typename?: 'Project';
					data: {
						__typename?: 'Project';
						documentId: string;
						attributes: { __typename?: 'Project'; title?: string; slug: string; shortDescription?: string };
					};
				}>;
				themes: Array<{
					__typename?: 'Theme';
					data: {
						__typename?: 'Theme';
						documentId: string;
						attributes: { __typename?: 'Theme'; title: string; slug: string };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| { __typename: 'Error' }
	>;
};

export type WorkAtFieldsFragment = {
	__typename: 'WorkAt';
	locale?: string;
	header: {
		__typename?: 'ComponentModulesIntroHeader';
		title: string;
		excerpt: string;
		backgroundColor?: Enum_Componentmodulesintroheader_Backgroundcolor;
	};
	seo: {
		__typename?: 'ComponentModulesSeo';
		title?: string;
		description?: string;
		noIndex?: boolean;
		noFollow?: boolean;
		ogTitle?: string;
		ogDescription?: string;
		ogType?: string;
		ogUrl?: string;
		ogImage?: {
			__typename?: 'UploadFile';
			data: {
				__typename?: 'UploadFile';
				documentId: string;
				attributes: { __typename?: 'UploadFile'; url: string; name: string };
			};
		};
	};
	modules?: Array<
		| {
				__typename?: 'ComponentModulesBodyText';
				bodyText?: string;
				sidebar?: {
					__typename?: 'ComponentInternalSidebar';
					title?: any;
					links?: Array<{ __typename?: 'ComponentComponentsLink'; title: string; href: any; description?: string }>;
					files: Array<{
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: {
								__typename?: 'UploadFile';
								ext?: string;
								mime: string;
								size: number;
								url: string;
								alternativeText?: string;
								hash: string;
								name: string;
								caption?: string;
							};
						};
					}>;
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptions';
					backgroundColor: Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor;
					padding: Enum_Componentinternaldefaultmoduleoptions_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesCta';
				description?: string;
				imagePosition?: Enum_Componentmodulescta_Imageposition;
				videoLink?: string;
				ctaTitle?: any;
				buttons?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; name: string };
						};
					};
				}>;
				imageOrVideoFile?: {
					__typename?: 'UploadFile';
					data: {
						__typename?: 'UploadFile';
						documentId: string;
						attributes: {
							__typename?: 'UploadFile';
							name: string;
							alternativeText?: string;
							caption?: string;
							url: string;
							mime: string;
							formats?: any;
						};
					};
				};
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename?: 'ComponentModulesLinkBox';
				title?: any;
				description?: string;
				linkBoxLinks?: Array<{
					__typename?: 'ComponentComponentsButton';
					title?: string;
					variant: Enum_Componentcomponentsbutton_Variant;
					href: any;
					iconLeft?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
					iconRight?: {
						__typename?: 'UploadFile';
						data: { __typename?: 'UploadFile'; attributes: { __typename?: 'UploadFile'; url: string } };
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| {
				__typename: 'ComponentModulesPartners';
				id: string;
				heading: any;
				logos: Array<{
					__typename: 'ComponentComponentsIconLink';
					id: string;
					title: string;
					href: any;
					icon: {
						__typename?: 'UploadFile';
						data: {
							__typename?: 'UploadFile';
							documentId: string;
							attributes: { __typename?: 'UploadFile'; url: string; alternativeText?: string; formats?: any };
						};
					};
				}>;
				defaultModuleOptions: {
					__typename?: 'ComponentInternalDefaultModuleOptionsExtended';
					extendedBackgroundColor: Enum_Componentinternaldefaultmoduleoptionsextended_Backgroundcolor;
					extendedPadding: Enum_Componentinternaldefaultmoduleoptionsextended_Padding;
				};
		  }
		| { __typename?: 'Error' }
	>;
};

export const NewsletterFieldFieldsFragmentDoc = gql`
	fragment newsletterFieldFields on NewsletterField {
		field
		value
	}
`;
export const NewsletterContactDataFieldsFragmentDoc = gql`
	fragment newsletterContactDataFields on NewsletterContactData {
		id
		email
		create_date
		custom {
			...newsletterFieldFields
		}
	}
	${NewsletterFieldFieldsFragmentDoc}
`;
export const CampaignNewsletterContactFieldsFragmentDoc = gql`
	fragment campaignNewsletterContactFields on CampaignNewsletterContact {
		id
		contact {
			...newsletterContactDataFields
		}
	}
	${NewsletterContactDataFieldsFragmentDoc}
`;
export const CampaignNewsletterFieldFieldsFragmentDoc = gql`
	fragment campaignNewsletterFieldFields on CampaignNewsletterField {
		campaignId
		newsletter
		value
	}
`;
export const ButtonFieldsFragmentDoc = gql`
	fragment buttonFields on ComponentComponentsButton {
		title
		variant
		href
		iconLeft {
			data {
				documentId
				attributes {
					url
					name
				}
			}
		}
		iconRight {
			data {
				documentId
				attributes {
					url
					name
				}
			}
		}
	}
`;
export const DefaultModuleOptionsExtendedFieldsFragmentDoc = gql`
	fragment defaultModuleOptionsExtendedFields on ComponentInternalDefaultModuleOptionsExtended {
		extendedBackgroundColor: backgroundColor
		extendedPadding: padding
	}
`;
export const CtaFieldsFragmentDoc = gql`
	fragment ctaFields on ComponentModulesCta {
		ctaTitle: title
		description
		buttons {
			...buttonFields
		}
		imageOrVideoFile {
			data {
				documentId
				attributes {
					name
					alternativeText
					caption
					url
					mime
					formats
				}
			}
		}
		imagePosition
		videoLink
		defaultModuleOptions {
			...defaultModuleOptionsExtendedFields
		}
	}
	${ButtonFieldsFragmentDoc}
	${DefaultModuleOptionsExtendedFieldsFragmentDoc}
`;
export const IntroHeaderImageFieldsFragmentDoc = gql`
	fragment introHeaderImageFields on ComponentModulesIntroHeaderImage {
		title
		excerpt
		backgroundColor
		cover {
			url
			alternativeText
			formats
			data {
				documentId
				attributes {
					url
					alternativeText
					formats
				}
			}
		}
	}
`;
export const SidebarFieldsFragmentDoc = gql`
	fragment sidebarFields on ComponentInternalSidebar {
		title
		links {
			title
			href
			description
		}
		files {
			data {
				documentId
				attributes {
					ext
					mime
					size
					url
					alternativeText
					hash
					name
					caption
				}
			}
		}
	}
`;
export const DefaultModuleOptionsFieldsFragmentDoc = gql`
	fragment defaultModuleOptionsFields on ComponentInternalDefaultModuleOptions {
		backgroundColor
		padding
	}
`;
export const BodyTextFieldsFragmentDoc = gql`
	fragment bodyTextFields on ComponentModulesBodyText {
		bodyText
		sidebar {
			...sidebarFields
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${SidebarFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const HighlightNewsArticleFieldsFragmentDoc = gql`
	fragment highlightNewsArticleFields on Newsarticle {
		__typename
		firstPublishedAt
		title
		slug: slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const FeaturedNewsFieldsFragmentDoc = gql`
	fragment featuredNewsFields on ComponentModulesFeaturedNews {
		featuredNewsTitle: title
		items: newsArticles(pagination: { limit: 3 }, sort: "firstPublishedAt:DESC") {
			data {
				documentId
				attributes {
					...highlightNewsArticleFields
					firstPublishedAt
				}
			}
		}
		cta {
			ctaTitle: title
			variant
			href
			iconLeft {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
			iconRight {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${HighlightNewsArticleFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const HighlightedPagesFieldsFragmentDoc = gql`
	fragment highlightedPagesFields on Page {
		__typename
		publishedAt
		title
		slug
		header {
			...introHeaderImageFields
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
`;
export const FeaturedPagesFieldsFragmentDoc = gql`
	fragment featuredPagesFields on ComponentModulesFeaturedPages {
		featuredPagesTitle: title
		items: pages(pagination: { limit: 6 }) {
			data {
				documentId
				attributes {
					...highlightedPagesFields
					publishedAt
				}
			}
		}
		cta {
			ctaTitle: title
			variant
			href
			iconLeft {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
			iconRight {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${HighlightedPagesFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const BodyTextTwoColumnsFieldsFragmentDoc = gql`
	fragment bodyTextTwoColumnsFields on ComponentModulesBodyTextTwoColumn {
		leftColumn {
			bodyText
		}
		rightColumn {
			bodyText
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const DownloadFieldsFragmentDoc = gql`
	fragment downloadFields on ComponentModulesDownloads {
		downloadsTitle: title
		downloads(pagination: { pageSize: 200 }) {
			data {
				documentId
				attributes {
					url
					name
					size
					ext
					caption
				}
			}
		}
		downloadLinks {
			title
			href
			description
		}
		defaultModuleOptions {
			...defaultModuleOptionsExtendedFields
		}
	}
	${DefaultModuleOptionsExtendedFieldsFragmentDoc}
`;
export const LinkBoxFieldsFragmentDoc = gql`
	fragment linkBoxFields on ComponentModulesLinkBox {
		title
		description
		linkBoxLinks: links {
			title
			variant
			href
			iconLeft {
				data {
					attributes {
						url
					}
				}
			}
			iconRight {
				data {
					attributes {
						url
					}
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsExtendedFields
		}
	}
	${DefaultModuleOptionsExtendedFieldsFragmentDoc}
`;
export const SubjectsFieldsFragmentDoc = gql`
	fragment subjectsFields on ComponentModulesSubjects {
		id
		overviewTitle: title
		description
		subjects(sort: "publishedAt:ASC", pagination: { limit: 999 }) {
			data {
				documentId
				attributes {
					title
					slug
					shortDescription
				}
			}
		}
		projects(sort: "publishedAt:ASC", pagination: { limit: 999 }) {
			data {
				documentId
				attributes {
					title
					slug
					shortDescription
				}
			}
		}
		themes(sort: "publishedAt:ASC", pagination: { limit: 999 }) {
			data {
				documentId
				attributes {
					title
					slug
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const MediaFieldsFragmentDoc = gql`
	fragment mediaFields on ComponentModulesMedia {
		mediaTitle: title
		mediaDescription: description
		transcript
		mediaLink
		media {
			data {
				documentId
				attributes {
					size
					ext
					url
					alternativeText
					formats
					mime
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const AccordeonFieldsFragmentDoc = gql`
	fragment accordeonFields on ComponentModulesAccordeon {
		__typename
		accordeonTitle
		sections {
			__typename
			accordeonSectionName
			items(pagination: { limit: 100 }) {
				__typename
				itemTitle
				description
			}
		}
		sidebar {
			...sidebarFields
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${SidebarFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const EmptyStateFieldsFragmentDoc = gql`
	fragment emptyStateFields on ComponentInternalEmptyState {
		message
		title: buttonTitle
		href: buttonHref
	}
`;
export const HighlightPermitsFieldsFragmentDoc = gql`
	fragment highlightPermitsFields on Permit {
		__typename
		slug
		title
	}
`;
export const HighlightWooFragmentDoc = gql`
	fragment highlightWoo on WooRequest {
		__typename
		title
		startDate
		zip
		createdAt
	}
`;
export const HighlightMapsFiguresFieldsFragmentDoc = gql`
	fragment highlightMapsFiguresFields on MapsFigure {
		__typename
		slug: link
		title: name
	}
`;
export const HighlightSubsidyFieldsFragmentDoc = gql`
	fragment highlightSubsidyFields on Subsidy {
		__typename
		slug
		header {
			title
		}
	}
`;
export const HighlightFieldsFragmentDoc = gql`
	fragment highlightFields on ComponentModulesHighlight {
		__typename
		id
		title
		theme {
			data {
				documentId
				attributes {
					title
				}
			}
		}
		newsTab {
			id
			title
			buttonTitle
			buttonHref
			items: newsArticles {
				data {
					attributes {
						...highlightNewsArticleFields
					}
				}
			}
			empty {
				...emptyStateFields
			}
		}
		eventsTab {
			id
			title
			buttonTitle
			buttonHref
			items: events {
				data {
					attributes {
						...highlightNewsArticleFields
					}
				}
			}
			empty {
				...emptyStateFields
			}
		}
		permitsTab {
			id
			title
			buttonTitle
			buttonHref
			items: permits {
				data {
					attributes {
						...highlightPermitsFields
					}
				}
			}
			empty {
				...emptyStateFields
			}
		}
		wooTab {
			id
			title
			buttonTitle
			buttonHref
			items: requests {
				data {
					attributes {
						...highlightWoo
					}
				}
			}
			empty {
				...emptyStateFields
			}
		}
		mapsAndStatsTab {
			id
			title
			buttonTitle
			buttonHref
			items: mapsAndStats {
				data {
					attributes {
						...highlightMapsFiguresFields
					}
				}
			}
			empty {
				...emptyStateFields
			}
		}
		topicsTab {
			id
			title
			buttonTitle
			buttonHref
			items: topics {
				data {
					attributes {
						...highlightNewsArticleFields
					}
				}
			}
			empty {
				...emptyStateFields
			}
		}
		subsidiesTab {
			id
			title
			buttonTitle
			buttonHref
			items: subsidies(filters: { header: { title: { notNull: true } } }) {
				data {
					attributes {
						...highlightSubsidyFields
					}
				}
			}
			empty {
				...emptyStateFields
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${HighlightNewsArticleFieldsFragmentDoc}
	${EmptyStateFieldsFragmentDoc}
	${HighlightPermitsFieldsFragmentDoc}
	${HighlightWooFragmentDoc}
	${HighlightMapsFiguresFieldsFragmentDoc}
	${HighlightSubsidyFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const StepByStepFieldsFragmentDoc = gql`
	fragment stepByStepFields on ComponentModulesStepByStep {
		__typename
		title
		stepByStepCard(pagination: { limit: 50 }) {
			__typename
			cardTitle
			cardDescription
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const FullImageFieldsFragmentDoc = gql`
	fragment fullImageFields on UploadFile {
		documentId
		attributes {
			url
			alternativeText
			width
			height
			caption
			formats
			size
			ext
			mime
		}
	}
`;
export const PhotoFieldsFragmentDoc = gql`
	fragment photoFields on ComponentInternalPhoto {
		__typename
		id
		title
		description
		photo {
			data {
				...fullImageFields
			}
		}
	}
	${FullImageFieldsFragmentDoc}
`;
export const PhotoAlbumFieldsFragmentDoc = gql`
	fragment photoAlbumFields on ComponentModulesPhotoAlbum {
		__typename
		id
		jsonTitle: title
		description
		horizontal
		photos {
			...photoFields
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${PhotoFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const RegionDetailFieldsFragmentDoc = gql`
	fragment regionDetailFields on RegionDetail {
		__typename
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const IntroHeaderFieldsFragmentDoc = gql`
	fragment introHeaderFields on ComponentModulesIntroHeader {
		title
		excerpt
		backgroundColor
	}
`;
export const SeoFieldsFragmentDoc = gql`
	fragment seoFields on ComponentModulesSeo {
		title
		description
		noIndex
		noFollow
		ogTitle
		ogDescription
		ogImage {
			data {
				documentId
				attributes {
					url
					name
				}
			}
		}
		ogType
		ogUrl
	}
`;
export const ThemeListFieldsFragmentDoc = gql`
	fragment themeListFields on Theme {
		title
		slug
		header {
			description
		}
	}
`;
export const ThemesFieldsFragmentDoc = gql`
	fragment themesFields on ComponentModulesThemes {
		title
		themes(pagination: { limit: 15 }, filters: { slug: { notNull: true } }) {
			data {
				documentId
				attributes {
					...themeListFields
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${ThemeListFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const ExpandedHeaderFieldsFragmentDoc = gql`
	fragment expandedHeaderFields on ComponentModulesExpandedHeader {
		headerTitle
		headerDescription
		headerButton {
			...buttonFields
		}
		headerImage {
			data {
				documentId
				attributes {
					name
					url
					alternativeText
					formats
				}
			}
		}
		title
		description
	}
	${ButtonFieldsFragmentDoc}
`;
export const BbvmsMediaplayerFieldsFragmentDoc = gql`
	fragment bbvmsMediaplayerFields on ComponentModulesBbvmsMediaplayer {
		__typename
		videoId
		playout
		url
		title
		description
		transcript
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const RegionFieldsFragmentDoc = gql`
	fragment regionFields on Region {
		__typename
		title
		slug
		locale
		header {
			...expandedHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${ExpandedHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const RegionsFieldsFragmentDoc = gql`
	fragment regionsFields on ComponentModulesRegions {
		title
		regions {
			data {
				documentId
				attributes {
					...regionFields
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${RegionFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const RegionOverviewSingleFieldsFragmentDoc = gql`
	fragment regionOverviewSingleFields on RegionOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesThemes {
				...themesFields
			}
			... on ComponentModulesRegions {
				...regionsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${ThemesFieldsFragmentDoc}
	${RegionsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const ThemeDetailFieldsFragmentDoc = gql`
	fragment themeDetailFields on ThemeDetail {
		__typename
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const ThemeOverviewSingleFieldsFragmentDoc = gql`
	fragment ThemeOverviewSingleFields on ThemeOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesThemes {
				...themesFields
			}
			... on ComponentModulesRegions {
				...regionsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${ThemesFieldsFragmentDoc}
	${RegionsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const WooRequestFieldsFragmentDoc = gql`
	fragment wooRequestFields on WooRequest {
		title
		shortTitle
		description
		keywords
		publisher
		caseNumber
		slug
		locale
		zip
		publishedAt
		createdAt
		updatedAt
		startDate
		endDate
		themes {
			data {
				attributes {
					title
				}
			}
		}
		category {
			data {
				documentId
				attributes {
					title
					sitemap
					resource
				}
			}
		}
		files(pagination: { limit: 999 }, sort: ["name"]) {
			data {
				attributes {
					name
					url
					ext
					size
				}
			}
		}
	}
`;
export const WooRequestBySlugFieldsFragmentDoc = gql`
	fragment wooRequestBySlugFields on WooRequest {
		data {
			id
			attributes {
				...wooRequestFields
			}
		}
	}
	${WooRequestFieldsFragmentDoc}
`;
export const CommentFieldsFragmentDoc = gql`
	fragment commentFields on ConversationsConversationitem {
		__typename
		contentTypeId
		contentTypeUid
		message
		author
		publishedAt: createdAt
	}
`;
export const SchedulingFieldsFragmentDoc = gql`
	fragment schedulingFields on ComponentModulesScheduling {
		__typename
		title
		firstColumnTitle
		firstColumnRows(pagination: { limit: 99 }) {
			__typename
			id
			bodyText
		}
		secondColumnTitle
		secondColumnRows(pagination: { limit: 99 }) {
			__typename
			id
			bodyText
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const TableFieldsFragmentDoc = gql`
	fragment tableFields on ComponentModulesTable {
		__typename
		tableTitle: title
		table
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const TestimonialFieldsFragmentDoc = gql`
	fragment testimonialFields on ComponentModulesTestimonial {
		__typename
		id
		quoteTitle: title
		quote
		name
		organization
		photo {
			data {
				documentId
				attributes {
					url
					alternativeText
					formats
				}
			}
		}
		logo {
			data {
				documentId
				attributes {
					url
					alternativeText
					formats
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsExtendedFields
		}
	}
	${DefaultModuleOptionsExtendedFieldsFragmentDoc}
`;
export const IconLinkFieldsFragmentDoc = gql`
	fragment iconLinkFields on ComponentComponentsIconLink {
		__typename
		id
		title
		href
		icon {
			data {
				documentId
				attributes {
					url
					alternativeText
					formats
				}
			}
		}
	}
`;
export const PartnersFieldsFragmentDoc = gql`
	fragment partnersFields on ComponentModulesPartners {
		__typename
		id
		heading: title
		logos {
			... on ComponentComponentsIconLink {
				...iconLinkFields
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsExtendedFields
		}
	}
	${IconLinkFieldsFragmentDoc}
	${DefaultModuleOptionsExtendedFieldsFragmentDoc}
`;
export const CondoleancePageSlugFieldsFragmentDoc = gql`
	fragment condoleancePageSlugFields on CondoleancePage {
		title
		slug
		seo {
			...seoFields
		}
		header {
			...introHeaderImageFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${IntroHeaderImageFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const EfroOostInConvoWithArticleFieldsFragmentDoc = gql`
	fragment efroOostInConvoWithArticleFields on EfroOostInConvoWithArticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const EfroOostNewsArticleListFieldsFragmentDoc = gql`
	fragment efroOostNewsArticleListFields on EfroOostNewsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const HighlightNewsArticleEfroOostFieldsFragmentDoc = gql`
	fragment highlightNewsArticleEfroOostFields on EfroOostNewsarticle {
		firstPublishedAt
		title
		slug: slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const FeaturedNewsEfroOostFieldsFragmentDoc = gql`
	fragment featuredNewsEfroOostFields on ComponentModulesFeaturedNewsEfroOost {
		featuredNewsTitle: title
		items: newsArticles(pagination: { limit: 3 }, sort: "firstPublishedAt:DESC") {
			data {
				documentId
				attributes {
					...highlightNewsArticleEfroOostFields
					firstPublishedAt
				}
			}
		}
		cta {
			ctaTitle: title
			variant
			href
			iconLeft {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
			iconRight {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${HighlightNewsArticleEfroOostFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const SharesFieldsFragmentDoc = gql`
	fragment sharesFields on ComponentModulesShare {
		title
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const EfroOostNewsArticleFieldsFragmentDoc = gql`
	fragment efroOostNewsArticleFields on EfroOostNewsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesFeaturedNewsEfroOost {
				...featuredNewsEfroOostFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${FeaturedNewsEfroOostFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const EfroOostPageSlugFieldsFragmentDoc = gql`
	fragment efroOostPageSlugFields on EfroOostPage {
		title
		slug
		seo {
			...seoFields
		}
		header {
			...introHeaderImageFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsEfroOost {
				...featuredNewsEfroOostFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${IntroHeaderImageFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsEfroOostFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const EventFieldsFragmentDoc = gql`
	fragment eventFields on Event {
		__typename
		title
		url
		location
		from
		until
		header {
			...introHeaderImageFields
		}
		theme {
			data {
				documentId
				attributes {
					title
				}
			}
		}
		share {
			...sharesFields
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
`;
export const GeolinkPageSlugFieldsFragmentDoc = gql`
	fragment geolinkPageSlugFields on GeolinkPage {
		title
		slug
		seo {
			...seoFields
		}
		header {
			...introHeaderImageFields
		}
		modules {
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const InConvoWithArticleFieldsFragmentDoc = gql`
	fragment inConvoWithArticleFields on InConvoWithArticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const MapsFiguresFieldsFragmentDoc = gql`
	fragment mapsFiguresFields on MapsFigure {
		name
		link
		type
		media {
			data {
				documentId
				attributes {
					url
					ext
					size
				}
			}
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		themes {
			data {
				documentId
				attributes {
					title
				}
			}
		}
	}
`;
export const NewsArticleListFieldsFragmentDoc = gql`
	fragment newsArticleListFields on Newsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const NewsArticleFieldsFragmentDoc = gql`
	fragment newsArticleFields on Newsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const OpOostInConvoWithArticleFieldsFragmentDoc = gql`
	fragment opOostInConvoWithArticleFields on OpOostInConvoWithArticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const OpOostNewsArticleListFieldsFragmentDoc = gql`
	fragment opOostNewsArticleListFields on OpOostNewsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const HighlightNewsArticleOpOostFieldsFragmentDoc = gql`
	fragment highlightNewsArticleOpOostFields on OpOostNewsarticle {
		firstPublishedAt
		title
		slug: slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const FeaturedNewsOpOostFieldsFragmentDoc = gql`
	fragment featuredNewsOpOostFields on ComponentModulesFeaturedNewsOpOost {
		featuredNewsTitle: title
		news(pagination: { limit: 3 }, sort: "firstPublishedAt:DESC") {
			data {
				documentId
				attributes {
					...highlightNewsArticleOpOostFields
					firstPublishedAt
				}
			}
		}
		cta {
			ctaTitle: title
			variant
			href
			iconLeft {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
			iconRight {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${HighlightNewsArticleOpOostFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const OpOostNewsArticleFieldsFragmentDoc = gql`
	fragment opOostNewsArticleFields on OpOostNewsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesFeaturedNewsOpOost {
				...featuredNewsOpOostFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${FeaturedNewsOpOostFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const OpOostPageSlugFieldsFragmentDoc = gql`
	fragment opOostPageSlugFields on OpOostPage {
		title
		slug
		seo {
			...seoFields
		}
		header {
			...introHeaderImageFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsOpOost {
				...featuredNewsOpOostFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${IntroHeaderImageFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsOpOostFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const PageSlugFieldsFragmentDoc = gql`
	fragment pageSlugFields on Page {
		documentId
		title
		slug
		seo {
			...seoFields
		}
		header {
			...introHeaderImageFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesThemes {
				...themesFields
			}
			... on ComponentModulesRegions {
				...regionsFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${IntroHeaderImageFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${ThemesFieldsFragmentDoc}
	${RegionsFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const PermitFieldsFragmentDoc = gql`
	fragment permitFields on Permit {
		publishedAt
		updatedAt
		title
		slug
		seo {
			...seoFields
		}
		header {
			...introHeaderImageFields
		}
		themes {
			data {
				documentId
				attributes {
					title
				}
			}
		}
		permitLaws {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		permitProductTypes {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${IntroHeaderImageFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const PressReleaseFieldsFragmentDoc = gql`
	fragment pressReleaseFields on PressRelease {
		title
		locale
		firstPublishedAt
		slug
		header {
			...introHeaderFields
		}
		bodyText {
			...bodyTextFields
		}
		allowedOnHomePage
		seo {
			...seoFields
		}
		theme {
			data {
				documentId
				attributes {
					title
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const ProjectFieldsFragmentDoc = gql`
	fragment projectFields on Project {
		title
		firstPublishedAt
		updatedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const RegioExpresInConvoWithArticleFieldsFragmentDoc = gql`
	fragment regioExpresInConvoWithArticleFields on RegioExpresInConvoWithArticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const RegioExpresNewsArticleListFieldsFragmentDoc = gql`
	fragment regioExpresNewsArticleListFields on RegioExpresNewsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const HighlightNewsArticleRegioExpresFieldsFragmentDoc = gql`
	fragment highlightNewsArticleRegioExpresFields on RegioExpresNewsarticle {
		firstPublishedAt
		title
		slug: slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const FeaturedNewsRegioExpresFieldsFragmentDoc = gql`
	fragment featuredNewsRegioExpresFields on ComponentModulesFeaturedNewsRegioExpres {
		featuredNewsTitle: title
		items: newsArticles(pagination: { limit: 3 }, sort: "firstPublishedAt:DESC") {
			data {
				documentId
				attributes {
					...highlightNewsArticleRegioExpresFields
					firstPublishedAt
				}
			}
		}
		cta {
			ctaTitle: title
			variant
			href
			iconLeft {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
			iconRight {
				data {
					attributes {
						url
						alternativeText
						formats
					}
				}
			}
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${HighlightNewsArticleRegioExpresFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const RegioExpresNewsArticleFieldsFragmentDoc = gql`
	fragment regioExpresNewsArticleFields on RegioExpresNewsarticle {
		title
		firstPublishedAt
		slug
		header {
			...introHeaderImageFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		tags {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesFeaturedNewsRegioExpres {
				...featuredNewsRegioExpresFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${FeaturedNewsRegioExpresFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const RegioExpresPageSlugFieldsFragmentDoc = gql`
	fragment regioExpresPageSlugFields on RegioExpresPage {
		title
		slug
		seo {
			...seoFields
		}
		header {
			...introHeaderImageFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsRegioExpres {
				...featuredNewsRegioExpresFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${IntroHeaderImageFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsRegioExpresFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const RoadMaintenanceFieldsFragmentDoc = gql`
	fragment roadMaintenanceFields on RoadMaintenance {
		__typename
		title
		slug
		locale
		roadMaintenanceStatus
		header {
			...introHeaderFields
		}
		aboutMaintenance {
			__typename
			startDate
			endDate
			contractor
			contractorWebsite
			detour
			defaultModuleOptions {
				...defaultModuleOptionsFields
			}
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const SubsidyFieldsFragmentDoc = gql`
	fragment subsidyFields on Subsidy {
		title
		slug
		subsidyCeiling
		subsidystatus
		updatedAt
		endDate
		targetGroupText
		hideFromOverview
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		themes {
			data {
				documentId
				attributes {
					title
				}
			}
		}
		subsidy_scales {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		subsidy_kinds {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		target_groups {
			data {
				documentId
				attributes {
					name
				}
			}
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const TagFieldsFragmentDoc = gql`
	fragment tagFields on Tag {
		name
	}
`;
export const ThemeFieldsFragmentDoc = gql`
	fragment themeFields on Theme {
		__typename
		documentId
		title
		slug
		locale
		header {
			...expandedHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${ExpandedHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const WobRequestFieldsFragmentDoc = gql`
	fragment wobRequestFields on WobRequest {
		title
		createdAt
		date
		zip
	}
`;
export const WooCategoryFieldsFragmentDoc = gql`
	fragment wooCategoryFields on WooCategory {
		documentId
		title
		sitemap
		resource
	}
`;
export const ContactModuleFieldsFragmentDoc = gql`
	fragment contactModuleFields on Contact {
		__typename
		locale
		header {
			...introHeaderFields
		}
		modules {
			__typename
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
		seo {
			...seoFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
`;
export const EfroOostInConvoWithOverviewFieldsFragmentDoc = gql`
	fragment efroOostInConvoWithOverviewFields on ComponentModulesInConvoWithOverview {
		id
		filterLabel
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const InConvoWithOverviewFieldsFragmentDoc = gql`
	fragment inConvoWithOverviewFields on ComponentModulesInConvoWithOverview {
		id
		filterLabel
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const NotificationBarFieldsFragmentDoc = gql`
	fragment notificationBarFields on ComponentInternalNavbar {
		notificationLink
		notificationMessage
		notificationIsExternal
		notificationPublishDate
		notificationUnpublishDate
		mostPopularTitle
		ThemeGroupTitle
		bottomLinks {
			title
		}
	}
`;
export const RegioExpresInConvoWithOverviewFieldsFragmentDoc = gql`
	fragment regioExpresInConvoWithOverviewFields on ComponentModulesInConvoWithOverview {
		id
		filterLabel
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const AgendaPageFieldsFragmentDoc = gql`
	fragment agendaPageFields on AgendaPage {
		__typename
		locale
		header {
			...introHeaderFields
		}
		modules {
			__typename
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
		seo {
			...seoFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
`;
export const NavbarFieldsFragmentDoc = gql`
	fragment navbarFields on ComponentInternalNavbar {
		notificationMessage
		logo {
			data {
				documentId
				attributes {
					name
					alternativeText
					size
					url
					formats
				}
			}
		}
		bottomLinks {
			title
			href
		}
		mostPopularTitle
		mostPopularGroupLinks {
			title
			href
			links {
				title
				href
			}
		}
		ThemeGroupTitle
		themeGroupLinks {
			title
			href
			links {
				title
				href
			}
		}
		searchPlaceholderText
		notificationLink
		notificationIsExternal
		notificationPublishDate
		notificationUnpublishDate
		rightNavLink
	}
`;
export const FooterFieldsFragmentDoc = gql`
	fragment footerFields on ComponentInternalFooter {
		logo {
			data {
				documentId
				attributes {
					url
					alternativeText
					formats
					width
					height
				}
			}
		}
		themeLinkGroup {
			title
			href
			links {
				title
				href
				description
			}
		}
		contactLinkGroup {
			title
			links {
				title
				href
				description
			}
		}
		socialLinkGroup {
			title
			links {
				title
				href
				icon {
					data {
						attributes {
							url
							alternativeText
							formats
						}
					}
				}
			}
		}
		bottomLinks {
			title
			href
			description
		}
		accessibilityLogo {
			data {
				documentId
				attributes {
					url
					alternativeText
					formats
				}
			}
		}
		accessibilityLink
	}
`;
export const SeoSingleFieldsFragmentDoc = gql`
	fragment seoSingleFields on ComponentInternalSeo {
		id
		title
		description
		noIndex
		noFollow
		ogTitle
		ogDescription
		ogImage {
			data {
				documentId
				attributes {
					url
					name
				}
			}
		}
		ogType
		ogUrl
	}
`;
export const CondoleanceInformationFieldsFragmentDoc = gql`
	fragment condoleanceInformationFields on CondoleanceInformation {
		locale
		navbar {
			...navbarFields
		}
		footer {
			...footerFields
		}
		seo {
			...seoSingleFields
		}
	}
	${NavbarFieldsFragmentDoc}
	${FooterFieldsFragmentDoc}
	${SeoSingleFieldsFragmentDoc}
`;
export const HomepageHeaderFieldsFragmentDoc = gql`
	fragment homepageHeaderFields on ComponentModulesHomepageHeader {
		id
		homepageTitle: title
		backgroundImage {
			data {
				documentId
				attributes {
					url
					alternativeText
					formats
				}
			}
		}
		description
		popularHeader
		links {
			title
			href
		}
	}
`;
export const CondoleanceHomePageFieldsFragmentDoc = gql`
	fragment condoleanceHomePageFields on CondoleanceHomepage {
		header {
			...homepageHeaderFields
		}
		seo {
			...seoFields
		}
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${HomepageHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const ContactFieldsFragmentDoc = gql`
	fragment contactFields on Contact {
		__typename
		locale
		header {
			...introHeaderFields
		}
		modules {
			__typename
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
		seo {
			...seoFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
`;
export const CookiePageFieldsFragmentDoc = gql`
	fragment cookiePageFields on CookiePage {
		__typename
		locale
		header {
			...introHeaderFields
		}
		bodyText {
			...bodyTextFields
		}
		seo {
			...seoFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
`;
export const DecisionsPageFieldsFragmentDoc = gql`
	fragment decisionsPageFields on DecisionsPage {
		__typename
		locale
		bodyText
		sidebarCurrentYearTitle
		sidebarArchiveTitle
		header {
			...introHeaderFields
		}
		archiveLink {
			title
			description
			href
		}
		modules {
			__typename
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
		seo {
			...seoFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
`;
export const DownloadsPageFieldsFragmentDoc = gql`
	fragment downloadsPageFields on DownloadsPage {
		__typename
		locale
		introHeader {
			...introHeaderImageFields
		}
		downloads {
			...downloadFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const EfroOostInConvoWithDetailSingleFieldsFragmentDoc = gql`
	fragment efroOostInConvoWithDetailSingleFields on EfroOostInConvoWithDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const OpOostInConvoWithOverviewFieldsFragmentDoc = gql`
	fragment opOostInConvoWithOverviewFields on ComponentModulesInConvoWithOverview {
		id
		filterLabel
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const EfroOostInConvoWithOverviewSingleFieldsFragmentDoc = gql`
	fragment efroOostInConvoWithOverviewSingleFields on EfroOostInConvoWithOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesInConvoWithOverview {
				...opOostInConvoWithOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${OpOostInConvoWithOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const EfroOostInformationFieldsFragmentDoc = gql`
	fragment efroOostInformationFields on EfroOostInformation {
		locale
		navbar {
			...navbarFields
		}
		footer {
			...footerFields
		}
		seo {
			...seoSingleFields
		}
	}
	${NavbarFieldsFragmentDoc}
	${FooterFieldsFragmentDoc}
	${SeoSingleFieldsFragmentDoc}
`;
export const EfroOostNewsDetailSingleFieldsFragmentDoc = gql`
	fragment efroOostNewsDetailSingleFields on EfroOostNewsDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsEfroOost {
				...featuredNewsEfroOostFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsEfroOostFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const NewsOverviewFieldsFragmentDoc = gql`
	fragment newsOverviewFields on ComponentModulesNewsOverview {
		id
		filterLabel
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const EfroOostNewsOverviewSingleFieldsFragmentDoc = gql`
	fragment efroOostNewsOverviewSingleFields on EfroOostNewsOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesNewsOverview {
				...newsOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${NewsOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const EfroOostHomePageFieldsFragmentDoc = gql`
	fragment efroOostHomePageFields on EfroOostHomepage {
		header {
			...homepageHeaderFields
		}
		seo {
			...seoFields
		}
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsEfroOost {
				...featuredNewsEfroOostFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${HomepageHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsEfroOostFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const EventOverviewFieldsFragmentDoc = gql`
	fragment eventOverviewFields on ComponentModulesEventOverview {
		id
		filterLabel
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const EventOverviewSingleFieldsFragmentDoc = gql`
	fragment eventOverviewSingleFields on EventOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesEventOverview {
				...eventOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${EventOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const GeolinkInformationFieldsFragmentDoc = gql`
	fragment geolinkInformationFields on GeolinkInformation {
		locale
		navbar {
			...navbarFields
		}
		footer {
			...footerFields
		}
		seo {
			...seoSingleFields
		}
	}
	${NavbarFieldsFragmentDoc}
	${FooterFieldsFragmentDoc}
	${SeoSingleFieldsFragmentDoc}
`;
export const GeolinkHomePageFieldsFragmentDoc = gql`
	fragment geolinkHomePageFields on GeolinkHomepage {
		header {
			...homepageHeaderFields
		}
		seo {
			...seoFields
		}
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${HomepageHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const HomePageFieldsFragmentDoc = gql`
	fragment homePageFields on HomePage {
		header {
			...homepageHeaderFields
		}
		seo {
			...seoFields
		}
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesThemes {
				...themesFields
			}
			... on ComponentModulesRegions {
				...regionsFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${HomepageHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${ThemesFieldsFragmentDoc}
	${RegionsFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const InConvoWithDetailSingleFieldsFragmentDoc = gql`
	fragment inConvoWithDetailSingleFields on InConvoWithDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const InConvoWithOverviewSingleFieldsFragmentDoc = gql`
	fragment inConvoWithOverviewSingleFields on InConvoWithOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesInConvoWithOverview {
				...opOostInConvoWithOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${OpOostInConvoWithOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const LoginSingleFieldsFragmentDoc = gql`
	fragment loginSingleFields on Login {
		header {
			...introHeaderFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const MapsFiguresOverviewFieldsFragmentDoc = gql`
	fragment mapsFiguresOverviewFields on ComponentModulesMapsFiguresOverview {
		id
		showResultsText
		headerTitle
		searchPlaceholderText
		themeFilterText
		kindFilterText
		showAllThemesText
		showResultsText
		overviewTitleText
		filterHeaderText
		overviewTitleText
		filterHeaderText
	}
`;
export const MapsFiguresOverviewSingleFieldsFragmentDoc = gql`
	fragment mapsFiguresOverviewSingleFields on MapsFiguresOverview {
		header {
			...introHeaderFields
		}
		mapsFiguresOverview {
			...mapsFiguresOverviewFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${MapsFiguresOverviewFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const NewsDetailSingleFieldsFragmentDoc = gql`
	fragment newsDetailSingleFields on NewsDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
`;
export const NewsOverviewSingleFieldsFragmentDoc = gql`
	fragment newsOverviewSingleFields on NewsOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesNewsOverview {
				...newsOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${NewsOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const PermitsOverviewFieldsFragmentDoc = gql`
	fragment permitsOverviewFields on ComponentModulesPermitsOverview {
		id
		headerTitle
		searchPlaceholderText
		themeFilterText
		lawFilterText
		productTypeFilterText
		showAllThemesText
		showAllLawsText
		showAllProductTypesText
		overviewTitleText
		showResultsText
		filterHeaderText
	}
`;
export const NewsletterArchiveOverviewSingleFieldsFragmentDoc = gql`
	fragment newsletterArchiveOverviewSingleFields on NewsletterArchiveOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesPermitsOverview {
				...permitsOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${PermitsOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
`;
export const NewsletterFieldsFragmentDoc = gql`
	fragment newsletterFields on ComponentInternalNewsletter {
		title
		fieldLabel
		fieldPlaceholder
		submitButton {
			...buttonFields
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${ButtonFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const NewsletterInternalSingleFieldsFragmentDoc = gql`
	fragment newsletterInternalSingleFields on NewsletterInternal {
		header {
			...introHeaderFields
		}
		newsletter {
			...newsletterFields
		}
		seo {
			...seoFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${NewsletterFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
`;
export const InternalNewsletterWithSubscriptionsFieldsFragmentDoc = gql`
	fragment internalNewsletterWithSubscriptionsFields on InternalNewsletterWithSubscriptions {
		page {
			...newsletterInternalSingleFields
		}
	}
	${NewsletterInternalSingleFieldsFragmentDoc}
`;
export const NewsletterPublicSingleFieldsFragmentDoc = gql`
	fragment newsletterPublicSingleFields on NewsletterPublic {
		header {
			...introHeaderFields
		}
		newsletter {
			...newsletterFields
		}
		seo {
			...seoFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${NewsletterFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
`;
export const PublicNewsletterFieldsFragmentDoc = gql`
	fragment publicNewsletterFields on PublicNewsletterPage {
		page {
			...newsletterPublicSingleFields
		}
	}
	${NewsletterPublicSingleFieldsFragmentDoc}
`;
export const NotFoundPageFieldsFragmentDoc = gql`
	fragment notFoundPageFields on NotFoundPage {
		__typename
		locale
		header {
			...introHeaderFields
		}
		links {
			...linkBoxFields
		}
		cta {
			...ctaFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
`;
export const OpOostInConvoWithDetailSingleFieldsFragmentDoc = gql`
	fragment opOostInConvoWithDetailSingleFields on OpOostInConvoWithDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const OpOostInConvoWithOverviewSingleFieldsFragmentDoc = gql`
	fragment opOostInConvoWithOverviewSingleFields on OpOostInConvoWithOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesInConvoWithOverview {
				...opOostInConvoWithOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${OpOostInConvoWithOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const OpOostInformationFieldsFragmentDoc = gql`
	fragment opOostInformationFields on OpOostInformation {
		locale
		navbar {
			...navbarFields
		}
		footer {
			...footerFields
		}
		seo {
			...seoSingleFields
		}
	}
	${NavbarFieldsFragmentDoc}
	${FooterFieldsFragmentDoc}
	${SeoSingleFieldsFragmentDoc}
`;
export const OpOostNewsDetailSingleFieldsFragmentDoc = gql`
	fragment opOostNewsDetailSingleFields on OpOostNewsDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsOpOost {
				...featuredNewsOpOostFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsOpOostFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const OpOostNewsOverviewSingleFieldsFragmentDoc = gql`
	fragment opOostNewsOverviewSingleFields on OpOostNewsOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesNewsOverview {
				...newsOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${NewsOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const OpOostHomePageFieldsFragmentDoc = gql`
	fragment opOostHomePageFields on OpOostHomepage {
		header {
			...homepageHeaderFields
		}
		seo {
			...seoFields
		}
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsOpOost {
				...featuredNewsOpOostFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${HomepageHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsOpOostFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const OpenGelderlandInformationFieldsFragmentDoc = gql`
	fragment openGelderlandInformationFields on OpenGelderlandInformation {
		locale
		navbar {
			...navbarFields
		}
		footer {
			...footerFields
		}
		seo {
			...seoSingleFields
		}
	}
	${NavbarFieldsFragmentDoc}
	${FooterFieldsFragmentDoc}
	${SeoSingleFieldsFragmentDoc}
`;
export const LinkFieldsFragmentDoc = gql`
	fragment linkFields on ComponentComponentsLink {
		id
		title
		href
		description
	}
`;
export const OpenGelderlandWooDocumentOverviewFragmentDoc = gql`
	fragment openGelderlandWooDocumentOverview on ComponentModulesOpenWooRequestOverview {
		id
		filterHeaderText
		headerTitle
		filterLink {
			...linkFields
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${LinkFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const OpenGelderlandWooRequestOverviewSingleFieldsFragmentDoc = gql`
	fragment openGelderlandWooRequestOverviewSingleFields on OpenGelderlandWooOverview {
		header {
			...introHeaderFields
		}
		woo_overview {
			...openGelderlandWooDocumentOverview
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${OpenGelderlandWooDocumentOverviewFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const CollectionFieldsFragmentDoc = gql`
	fragment collectionFields on ComponentModulesCollections {
		id
		overviewTitle: title
		description
		links {
			...linkFields
		}
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${LinkFieldsFragmentDoc}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const OpenGelderlandHomePageFieldsFragmentDoc = gql`
	fragment openGelderlandHomePageFields on OpenGelderlandHomepage {
		header {
			...introHeaderImageFields
		}
		collections {
			...collectionFields
		}
		seo {
			...seoFields
		}
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
		}
	}
	${IntroHeaderImageFieldsFragmentDoc}
	${CollectionFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
`;
export const PageInformationFieldsFragmentDoc = gql`
	fragment pageInformationFields on PageInformation {
		__typename
		locale
		navbar {
			...navbarFields
		}
		footer {
			...footerFields
		}
		seo {
			...seoSingleFields
		}
	}
	${NavbarFieldsFragmentDoc}
	${FooterFieldsFragmentDoc}
	${SeoSingleFieldsFragmentDoc}
`;
export const PasswordPageFieldsFragmentDoc = gql`
	fragment passwordPageFields on PasswordProtectionPasswordPage {
		__typename
		locale
		header {
			...introHeaderFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesThemes {
				...themesFields
			}
			... on ComponentModulesRegions {
				...regionsFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${ThemesFieldsFragmentDoc}
	${RegionsFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const PermitDetailSingleFieldsFragmentDoc = gql`
	fragment permitDetailSingleFields on PermitDetail {
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
		}
	}
	${CtaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const PermitsOverviewSingleFieldsFragmentDoc = gql`
	fragment permitsOverviewSingleFields on PermitsOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesPermitsOverview {
				...permitsOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${PermitsOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
`;
export const PressReleaseOverviewFieldsFragmentDoc = gql`
	fragment pressReleaseOverviewFields on ComponentModulesPressReleaseOverview {
		id
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const PressReleaseOverviewSingleFieldsFragmentDoc = gql`
	fragment pressReleaseOverviewSingleFields on PressReleaseOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesPressReleaseOverview {
				...pressReleaseOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${PressReleaseOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const PressReleaseDetailFieldsFragmentDoc = gql`
	fragment pressReleaseDetailFields on PressReleaseDetail {
		__typename
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const PrivacyPolicyFieldsFragmentDoc = gql`
	fragment privacyPolicyFields on PrivacyPolicy {
		__typename
		locale
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		bodytext {
			...bodyTextFields
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const ProjectDetailSingleFieldsFragmentDoc = gql`
	fragment projectDetailSingleFields on ProjectDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesScheduling {
				...schedulingFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${SchedulingFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const ProjectOverviewFieldsFragmentDoc = gql`
	fragment projectOverviewFields on ComponentModulesProjectOverview {
		id
		filterLabel
		extendedDefaultModuleOptions: defaultModuleOptions {
			backgroundColor
			padding
		}
	}
`;
export const ProjectOverviewSingleFieldsFragmentDoc = gql`
	fragment projectOverviewSingleFields on ProjectOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesProjectOverview {
				...projectOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${ProjectOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const RegioExpresInConvoWithDetailSingleFieldsFragmentDoc = gql`
	fragment regioExpresInConvoWithDetailSingleFields on RegioExpresInConvoWithDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const RegioExpresInConvoWithOverviewSingleFieldsFragmentDoc = gql`
	fragment regioExpresInConvoWithOverviewSingleFields on RegioExpresInConvoOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesInConvoWithOverview {
				...opOostInConvoWithOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${OpOostInConvoWithOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const RegioExpresInformationFieldsFragmentDoc = gql`
	fragment regioExpresInformationFields on RegioExpresInformation {
		locale
		navbar {
			...navbarFields
		}
		footer {
			...footerFields
		}
		seo {
			...seoSingleFields
		}
	}
	${NavbarFieldsFragmentDoc}
	${FooterFieldsFragmentDoc}
	${SeoSingleFieldsFragmentDoc}
`;
export const RegioExpresNewsDetailSingleFieldsFragmentDoc = gql`
	fragment regioExpresNewsDetailSingleFields on RegioExpresNewsDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsRegioExpres {
				...featuredNewsRegioExpresFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsRegioExpresFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const RegioExpresNewsOverviewSingleFieldsFragmentDoc = gql`
	fragment regioExpresNewsOverviewSingleFields on RegioExpresNewsOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesNewsOverview {
				...newsOverviewFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${NewsOverviewFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const RegioExpresHomePageFieldsFragmentDoc = gql`
	fragment regioExpresHomePageFields on RegioExpresHomepage {
		header {
			...homepageHeaderFields
		}
		seo {
			...seoFields
		}
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNewsRegioExpres {
				...featuredNewsRegioExpresFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesTestimonial {
				...testimonialFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${HomepageHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsRegioExpresFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${TestimonialFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const RoadMaintenanceDetailSingleFieldsFragmentDoc = gql`
	fragment roadMaintenanceDetailSingleFields on RoadMaintenanceDetail {
		locale
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
		}
	}
	${CtaFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
`;
export const RoadMaintenanceOverviewFieldsFragmentDoc = gql`
	fragment roadMaintenanceOverviewFields on ComponentModulesRoadMaintenanceOverview {
		__typename
		id
		title
	}
`;
export const RoadMaintenanceOverviewSingleFieldsFragmentDoc = gql`
	fragment roadMaintenanceOverviewSingleFields on RoadMaintenanceOverview {
		header {
			...introHeaderFields
		}
		list {
			...roadMaintenanceOverviewFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${RoadMaintenanceOverviewFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
`;
export const SearchOverviewSingleFieldsFragmentDoc = gql`
	fragment searchOverviewSingleFields on SearchOverview {
		searchHeader {
			id
			title
			searchPlaceholder
		}
		Zoekresultaten {
			id
			resultLabel
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const SitemapPageFieldsFragmentDoc = gql`
	fragment sitemapPageFields on Sitemap {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const SubsidyDetailSingleFieldsFragmentDoc = gql`
	fragment subsidyDetailSingleFields on SubsidyDetail {
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesTable {
				...tableFields
			}
		}
	}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${TableFieldsFragmentDoc}
`;
export const SubsidyOverviewFieldsFragmentDoc = gql`
	fragment subsidyOverviewFields on ComponentModulesSubsidyOverview {
		id
		showResultsText
		headerTitle
		searchPlaceholderText
		themeFilterText
		showMoreThemesText
		showLessThemesText
		targetGroupFilterText
		kindFilterText
		scaleFilterText
		overviewTitleText
		filterHeaderText
		overviewTitleText
		filterHeaderText
	}
`;
export const SubsidyOverviewSingleFieldsFragmentDoc = gql`
	fragment subsidyOverviewSingleFields on SubsidyOverview {
		locale
		publishedAt
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesSubsidyOverview {
				...subsidyOverviewFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${SubsidyOverviewFieldsFragmentDoc}
`;
export const VacancyDetailSingleFieldsFragmentDoc = gql`
	fragment vacancyDetailSingleFields on VacancyDetail {
		share {
			...sharesFields
		}
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${SharesFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const VacancyInternalDetailSingleFieldsFragmentDoc = gql`
	fragment vacancyInternalDetailSingleFields on VacancyInternalDetail {
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesFeaturedNews {
				...featuredNewsFields
			}
			... on ComponentModulesFeaturedPages {
				...featuredPagesFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${DownloadFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${FeaturedNewsFieldsFragmentDoc}
	${FeaturedPagesFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const VacancyOverviewFieldsFragmentDoc = gql`
	fragment vacancyOverviewFields on ComponentModulesVacanciesOverview {
		__typename
		id
		title
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const VacancyInternalOverviewSingleFieldsFragmentDoc = gql`
	fragment vacancyInternalOverviewSingleFields on VacancyInternalOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesVacanciesOverview {
				...vacancyOverviewFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${VacancyOverviewFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const VacancyOverviewSingleFieldsFragmentDoc = gql`
	fragment vacancyOverviewSingleFields on VacancyOverview {
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
			... on ComponentModulesVacanciesOverview {
				...vacancyOverviewFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
	${VacancyOverviewFieldsFragmentDoc}
`;
export const WobRequestOverviewFieldsFragmentDoc = gql`
	fragment wobRequestOverviewFields on ComponentModulesWobRequestOverview {
		__typename
		id
		sectionTitle: title
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const WobRequestOverviewSingleFieldsFragmentDoc = gql`
	fragment wobRequestOverviewSingleFields on WobRequestOverview {
		header {
			...introHeaderFields
		}
		bodyText {
			...bodyTextFields
		}
		list {
			...wobRequestOverviewFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${WobRequestOverviewFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const WooDocumentDetailSingleFieldsFragmentDoc = gql`
	fragment wooDocumentDetailSingleFields on WooDocumentDetail {
		modules {
			__typename
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesShare {
				...sharesFields
			}
			... on ComponentModulesBbvmsMediaplayer {
				...bbvmsMediaplayerFields
			}
		}
	}
	${CtaFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${SharesFieldsFragmentDoc}
	${BbvmsMediaplayerFieldsFragmentDoc}
`;
export const WooRequestOverviewFieldsFragmentDoc = gql`
	fragment wooRequestOverviewFields on ComponentModulesWooRequestOverview {
		__typename
		id
		sectionTitle: title
		filterLabel
		defaultModuleOptions {
			...defaultModuleOptionsFields
		}
	}
	${DefaultModuleOptionsFieldsFragmentDoc}
`;
export const WooRequestOverviewSingleFieldsFragmentDoc = gql`
	fragment wooRequestOverviewSingleFields on WooRequestOverview {
		header {
			...introHeaderFields
		}
		bodyText {
			...bodyTextFields
		}
		list {
			...wooRequestOverviewFields
		}
		seo {
			...seoFields
		}
		modules {
			__typename
			... on ComponentModulesDownloads {
				...downloadFields
			}
			... on ComponentModulesStepByStep {
				...stepByStepFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesHighlight {
				...highlightFields
			}
			... on ComponentModulesSubjects {
				...subjectsFields
			}
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesBodyTextTwoColumn {
				...bodyTextTwoColumnsFields
			}
			... on ComponentModulesAccordeon {
				...accordeonFields
			}
			... on ComponentModulesMedia {
				...mediaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesPhotoAlbum {
				...photoAlbumFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${WooRequestOverviewFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${DownloadFieldsFragmentDoc}
	${StepByStepFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${HighlightFieldsFragmentDoc}
	${SubjectsFieldsFragmentDoc}
	${BodyTextTwoColumnsFieldsFragmentDoc}
	${AccordeonFieldsFragmentDoc}
	${MediaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${PhotoAlbumFieldsFragmentDoc}
`;
export const WorkAtFieldsFragmentDoc = gql`
	fragment workAtFields on WorkAt {
		__typename
		locale
		header {
			...introHeaderFields
		}
		seo {
			...seoFields
		}
		modules {
			... on ComponentModulesBodyText {
				...bodyTextFields
			}
			... on ComponentModulesCta {
				...ctaFields
			}
			... on ComponentModulesLinkBox {
				...linkBoxFields
			}
			... on ComponentModulesPartners {
				...partnersFields
			}
		}
	}
	${IntroHeaderFieldsFragmentDoc}
	${SeoFieldsFragmentDoc}
	${BodyTextFieldsFragmentDoc}
	${CtaFieldsFragmentDoc}
	${LinkBoxFieldsFragmentDoc}
	${PartnersFieldsFragmentDoc}
`;
export const AddUserToNewslettersDocument = gql`
	mutation addUserToNewsletters($campaignId: String!, $email: String!, $newsletters: [NewslettersListInput]!) {
		addUserToNewsletters(campaignId: $campaignId, email: $email, newsletters: $newsletters) {
			campaign
			succeeded
		}
	}
`;
export type AddUserToNewslettersMutationFn = Apollo.MutationFunction<
	AddUserToNewslettersMutation,
	AddUserToNewslettersMutationVariables
>;
export type AddUserToNewslettersMutationResult = Apollo.MutationResult<AddUserToNewslettersMutation>;
export type AddUserToNewslettersMutationOptions = Apollo.BaseMutationOptions<
	AddUserToNewslettersMutation,
	AddUserToNewslettersMutationVariables
>;
export const UpdateUserNewsletterSubscriptionDocument = gql`
	mutation updateUserNewsletterSubscription(
		$campaignId: String!
		$userId: String!
		$email: String!
		$newsletters: [NewslettersListInput]!
	) {
		updateUserNewsletterSubscription(
			campaignId: $campaignId
			userId: $userId
			email: $email
			newsletters: $newsletters
		) {
			campaign
			succeeded
		}
	}
`;
export type UpdateUserNewsletterSubscriptionMutationFn = Apollo.MutationFunction<
	UpdateUserNewsletterSubscriptionMutation,
	UpdateUserNewsletterSubscriptionMutationVariables
>;
export type UpdateUserNewsletterSubscriptionMutationResult =
	Apollo.MutationResult<UpdateUserNewsletterSubscriptionMutation>;
export type UpdateUserNewsletterSubscriptionMutationOptions = Apollo.BaseMutationOptions<
	UpdateUserNewsletterSubscriptionMutation,
	UpdateUserNewsletterSubscriptionMutationVariables
>;
export const GetCommentsDocument = gql`
	query GetComments($id: String, $uid: String, $page: Int, $pageSize: Int) {
		getCommentsEnabled(contentTypeUid: $uid, contentTypeId: $id)
		conversationsConversationitems: getConversationItems(
			contentTypeUid: $uid
			contentTypeId: $id
			page: $page
			pageSize: $pageSize
		) {
			data {
				id
				attributes {
					contentTypeUid
					contentTypeId
					author
					message
					createdAt
					updatedAt
					publishedAt
				}
			}
			meta {
				pagination {
					total
					page
					pageSize
					pageCount
				}
			}
		}
	}
`;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const AddCommentDocument = gql`
	mutation addComment($contentTypeUid: String, $contentTypeId: String, $author: String, $message: String) {
		addComment(contentTypeUid: $contentTypeUid, contentTypeId: $contentTypeId, author: $author, message: $message) {
			data {
				attributes {
					...commentFields
				}
			}
		}
	}
	${CommentFieldsFragmentDoc}
`;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const GetCondoleancePageSlugsDocument = gql`
	query getCondoleancePageSlugs {
		findAllSlugs(uid: "api::condoleance-page.condoleance-page") {
			slug
			locale
		}
	}
`;
export type GetCondoleancePageSlugsQueryResult = Apollo.QueryResult<
	GetCondoleancePageSlugsQuery,
	GetCondoleancePageSlugsQueryVariables
>;
export const GetEfroOostInConvoWithArticleSlugsDocument = gql`
	query GetEfroOostInConvoWithArticleSlugs {
		findAllSlugs(uid: "api::efro-oost-in-convo-with-article.efro-oost-in-convo-with-article") {
			locale
			slug
		}
	}
`;
export type GetEfroOostInConvoWithArticleSlugsQueryResult = Apollo.QueryResult<
	GetEfroOostInConvoWithArticleSlugsQuery,
	GetEfroOostInConvoWithArticleSlugsQueryVariables
>;
export const GetEfroOostInConvoWithArticlesDocument = gql`
	query GetEfroOostInConvoWithArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		efroOostInConvoWithArticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { allowedOnHomePage: { eq: $showOnHomePage } }
		) {
			data {
				documentId
				attributes {
					...efroOostInConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${EfroOostInConvoWithArticleFieldsFragmentDoc}
`;
export type GetEfroOostInConvoWithArticlesQueryResult = Apollo.QueryResult<
	GetEfroOostInConvoWithArticlesQuery,
	GetEfroOostInConvoWithArticlesQueryVariables
>;
export const GetEfroOostNewsArticleSlugsDocument = gql`
	query GetEfroOostNewsArticleSlugs {
		findAllSlugs(uid: "api::efro-oost-newsarticle.efro-oost-newsarticle") {
			locale
			slug
		}
	}
`;
export type GetEfroOostNewsArticleSlugsQueryResult = Apollo.QueryResult<
	GetEfroOostNewsArticleSlugsQuery,
	GetEfroOostNewsArticleSlugsQueryVariables
>;
export const GetEfroOostNewsArticlesDocument = gql`
	query GetEfroOostNewsArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		efroOostNewsarticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { allowedOnHomePage: { eq: $showOnHomePage } }
		) {
			data {
				documentId
				attributes {
					...efroOostNewsArticleListFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${EfroOostNewsArticleListFieldsFragmentDoc}
`;
export type GetEfroOostNewsArticlesQueryResult = Apollo.QueryResult<
	GetEfroOostNewsArticlesQuery,
	GetEfroOostNewsArticlesQueryVariables
>;
export const GetEfroOostPageSlugsDocument = gql`
	query getEfroOostPageSlugs {
		findAllSlugs(uid: "api::efro-oost-page.efro-oost-page") {
			locale
			slug
		}
	}
`;
export type GetEfroOostPageSlugsQueryResult = Apollo.QueryResult<
	GetEfroOostPageSlugsQuery,
	GetEfroOostPageSlugsQueryVariables
>;
export const GetEventsDocument = gql`
	query GetEvents(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$themeIds: [ID]
		$locale: I18NLocaleCode
	) {
		events_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			filters: { theme: { documentId: { in: $themeIds } } }
			locale: $locale
			status: $publicationState
		) {
			data {
				documentId
				attributes {
					...eventFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${EventFieldsFragmentDoc}
`;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetNotesByDocumentIdDocument = gql`
	query GetNotesByDocumentId($documentId: String!) {
		notesByDocumentId(documentId: $documentId) {
			id
			title
			note
			authorMemo
			authorPage
			linkedPages
			createdAt
			updatedAt
		}
	}
`;
export type GetNotesByDocumentIdQueryResult = Apollo.QueryResult<
	GetNotesByDocumentIdQuery,
	GetNotesByDocumentIdQueryVariables
>;
export const GetGeolinkPageSlugsDocument = gql`
	query getGeolinkPageSlugs {
		findAllSlugs(uid: "api::geolink-page.geolink-page") {
			slug
			locale
		}
	}
`;
export type GetGeolinkPageSlugsQueryResult = Apollo.QueryResult<
	GetGeolinkPageSlugsQuery,
	GetGeolinkPageSlugsQueryVariables
>;
export const GlobalSearchDocument = gql`
	query globalSearch(
		$sort: String
		$searchValue: String!
		$createdAtBefore: String
		$createdAtAfter: String
		$domain: String
	) {
		searchCollectionTypes(
			searchQuery: $searchValue
			sort: $sort
			createdAtBefore: $createdAtBefore
			createdAtAfter: $createdAtAfter
			domain: $domain
		) {
			id
			title
			excerpt
			createdAt
			fullPath
			searchSortKey
		}
	}
`;
export type GlobalSearchQueryResult = Apollo.QueryResult<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const GlobalSearchWooRequestsDocument = gql`
	query globalSearchWooRequests($searchValue: String!, $locale: String, $limit: Int) {
		searchWooRequests(searchQuery: $searchValue, locale: $locale, limit: $limit) {
			id
			title
			createdAt
			fullPath
		}
	}
`;
export type GlobalSearchWooRequestsQueryResult = Apollo.QueryResult<
	GlobalSearchWooRequestsQuery,
	GlobalSearchWooRequestsQueryVariables
>;
export const GetHighlightDocument = gql`
	query GetHighlight {
		newsarticles(
			pagination: { limit: 3 }
			status: PUBLISHED
			sort: "firstPublishedAt:DESC"
			filters: { title: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...highlightNewsArticleFields
				}
			}
		}
		subsidies(
			pagination: { limit: 5 }
			status: PUBLISHED
			sort: "publishedAt:DESC"
			filters: { and: [{ title: { notNull: true } }, { header: { title: { notNull: true } } }] }
		) {
			data {
				documentId
				attributes {
					...highlightSubsidyFields
				}
			}
		}
		permits(
			pagination: { limit: 5 }
			status: PUBLISHED
			sort: "publishedAt:DESC"
			filters: { title: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...highlightPermitsFields
				}
			}
		}
		mapsFigures(pagination: { limit: 5 }, status: PUBLISHED, sort: "publishedAt:DESC") {
			data {
				documentId
				attributes {
					...highlightMapsFiguresFields
				}
			}
		}
		wooRequests(pagination: { limit: 5 }, status: PUBLISHED, sort: "startDate:DESC") {
			data {
				documentId
				attributes {
					...highlightWoo
				}
			}
		}
		events(pagination: { limit: 5 }, status: PUBLISHED, sort: "publishedAt:DESC") {
			data {
				documentId
				attributes {
					...eventFields
				}
			}
		}
	}
	${HighlightNewsArticleFieldsFragmentDoc}
	${HighlightSubsidyFieldsFragmentDoc}
	${HighlightPermitsFieldsFragmentDoc}
	${HighlightMapsFiguresFieldsFragmentDoc}
	${HighlightWooFragmentDoc}
	${EventFieldsFragmentDoc}
`;
export type GetHighlightQueryResult = Apollo.QueryResult<GetHighlightQuery, GetHighlightQueryVariables>;
export const GetHighlightWithThemeDocument = gql`
	query GetHighlightWithTheme($themeId: ID) {
		newsarticles(
			pagination: { limit: 3 }
			status: PUBLISHED
			sort: "firstPublishedAt:DESC"
			filters: { and: [{ theme: { documentId: { eq: $themeId } } }, { title: { notNull: true } }] }
		) {
			data {
				documentId
				attributes {
					...highlightNewsArticleFields
				}
			}
		}
		subsidies(
			pagination: { limit: 5 }
			status: PUBLISHED
			sort: "publishedAt:DESC"
			filters: {
				and: [
					{ themes: { documentId: { in: [$themeId] } } }
					{ title: { notNull: true } }
					{ header: { title: { notNull: true } } }
				]
			}
		) {
			data {
				documentId
				attributes {
					...highlightSubsidyFields
				}
			}
		}
		permits(
			pagination: { limit: 5 }
			status: PUBLISHED
			sort: "publishedAt:DESC"
			filters: { and: [{ themes: { documentId: { in: [$themeId] } } }, { title: { notNull: true } }] }
		) {
			data {
				documentId
				attributes {
					...highlightPermitsFields
				}
			}
		}
		mapsFigures(
			pagination: { limit: 5 }
			status: PUBLISHED
			sort: "publishedAt:DESC"
			filters: { themes: { documentId: { in: [$themeId] } } }
		) {
			data {
				documentId
				attributes {
					...highlightMapsFiguresFields
				}
			}
		}
		wooRequests(
			pagination: { limit: 5 }
			status: PUBLISHED
			sort: "startDate:DESC"
			filters: { themes: { documentId: { in: [$themeId] } } }
		) {
			data {
				documentId
				attributes {
					...highlightWoo
				}
			}
		}
		events(
			pagination: { limit: 5 }
			status: PUBLISHED
			sort: "publishedAt:DESC"
			filters: { theme: { documentId: { in: [$themeId] } } }
		) {
			data {
				documentId
				attributes {
					...eventFields
				}
			}
		}
	}
	${HighlightNewsArticleFieldsFragmentDoc}
	${HighlightSubsidyFieldsFragmentDoc}
	${HighlightPermitsFieldsFragmentDoc}
	${HighlightMapsFiguresFieldsFragmentDoc}
	${HighlightWooFragmentDoc}
	${EventFieldsFragmentDoc}
`;
export type GetHighlightWithThemeQueryResult = Apollo.QueryResult<
	GetHighlightWithThemeQuery,
	GetHighlightWithThemeQueryVariables
>;
export const GetInConvoWithArticleSlugsDocument = gql`
	query GetInConvoWithArticleSlugs {
		findAllSlugs(uid: "api::in-convo-with-article.in-convo-with-article") {
			locale
			slug
		}
	}
`;
export type GetInConvoWithArticleSlugsQueryResult = Apollo.QueryResult<
	GetInConvoWithArticleSlugsQuery,
	GetInConvoWithArticleSlugsQueryVariables
>;
export const GetInConvoWithArticlesDocument = gql`
	query GetInConvoWithArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		inConvoWithArticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { allowedOnHomePage: { eq: $showOnHomePage } }
		) {
			data {
				documentId
				attributes {
					...inConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${InConvoWithArticleFieldsFragmentDoc}
`;
export type GetInConvoWithArticlesQueryResult = Apollo.QueryResult<
	GetInConvoWithArticlesQuery,
	GetInConvoWithArticlesQueryVariables
>;
export const GetLoginDocument = gql`
	query getLogin($locale: I18NLocaleCode) {
		login(locale: $locale) {
			data {
				documentId
				attributes {
					...loginSingleFields
				}
			}
		}
	}
	${LoginSingleFieldsFragmentDoc}
`;
export type GetLoginQueryResult = Apollo.QueryResult<GetLoginQuery, GetLoginQueryVariables>;
export const GetNewsArticleSlugsDocument = gql`
	query GetNewsArticleSlugs {
		findAllSlugs(uid: "api::newsarticle.newsarticle") {
			locale
			slug
		}
	}
`;
export type GetNewsArticleSlugsQueryResult = Apollo.QueryResult<
	GetNewsArticleSlugsQuery,
	GetNewsArticleSlugsQueryVariables
>;
export const GetNewsArticlesDocument = gql`
	query GetNewsArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$themeIds: [ID]
		$projectId: ID
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		newsarticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: {
				theme: { documentId: { in: $themeIds } }
				project: { documentId: { eq: $projectId } }
				and: { allowedOnHomePage: { eq: $showOnHomePage } }
			}
		) {
			data {
				documentId
				attributes {
					...newsArticleListFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${NewsArticleListFieldsFragmentDoc}
`;
export type GetNewsArticlesQueryResult = Apollo.QueryResult<GetNewsArticlesQuery, GetNewsArticlesQueryVariables>;
export const GetNewsArticleContactPersonDocument = gql`
	query GetNewsArticleContactPerson($id: String!) {
		getNewsarticleContactPersonById(id: $id) {
			contactPerson
		}
	}
`;
export type GetNewsArticleContactPersonQueryResult = Apollo.QueryResult<
	GetNewsArticleContactPersonQuery,
	GetNewsArticleContactPersonQueryVariables
>;
export const GetManyNewslettersDocument = gql`
	query getManyNewsletters {
		getManyNewsletters {
			campaign {
				id
				name
			}
			newsletters {
				field
				description
			}
		}
	}
`;
export type GetManyNewslettersQueryResult = Apollo.QueryResult<
	GetManyNewslettersQuery,
	GetManyNewslettersQueryVariables
>;
export const GetNewsletterContactDocument = gql`
	query getNewsletterContact($email: String!) {
		newsletterContact(email: $email) {
			active
			campaigns {
				...campaignNewsletterContactFields
			}
			newsletters {
				...campaignNewsletterFieldFields
			}
		}
	}
	${CampaignNewsletterContactFieldsFragmentDoc}
	${CampaignNewsletterFieldFieldsFragmentDoc}
`;
export type GetNewsletterContactQueryResult = Apollo.QueryResult<
	GetNewsletterContactQuery,
	GetNewsletterContactQueryVariables
>;
export const GetNotificationBarDocument = gql`
	query getNotificationBar($locale: I18NLocaleCode) {
		pageInformation(locale: $locale) {
			data {
				attributes {
					navbar {
						...notificationBarFields
					}
				}
			}
		}
	}
	${NotificationBarFieldsFragmentDoc}
`;
export type GetNotificationBarQueryResult = Apollo.QueryResult<
	GetNotificationBarQuery,
	GetNotificationBarQueryVariables
>;
export const GetOpOostInConvoWithArticleSlugsDocument = gql`
	query GetOpOostInConvoWithArticleSlugs {
		findAllSlugs(uid: "api::op-oost-in-convo-with-article.op-oost-in-convo-with-article") {
			locale
			slug
		}
	}
`;
export type GetOpOostInConvoWithArticleSlugsQueryResult = Apollo.QueryResult<
	GetOpOostInConvoWithArticleSlugsQuery,
	GetOpOostInConvoWithArticleSlugsQueryVariables
>;
export const GetOpOostInConvoWithArticlesDocument = gql`
	query GetOpOostInConvoWithArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		opOostInConvoWithArticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { allowedOnHomePage: { eq: $showOnHomePage } }
		) {
			data {
				documentId
				attributes {
					...opOostInConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${OpOostInConvoWithArticleFieldsFragmentDoc}
`;
export type GetOpOostInConvoWithArticlesQueryResult = Apollo.QueryResult<
	GetOpOostInConvoWithArticlesQuery,
	GetOpOostInConvoWithArticlesQueryVariables
>;
export const GetOpOostNewsArticleSlugsDocument = gql`
	query GetOpOostNewsArticleSlugs {
		findAllSlugs(uid: "api::op-oost-newsarticle.op-oost-newsarticle") {
			locale
			slug
		}
	}
`;
export type GetOpOostNewsArticleSlugsQueryResult = Apollo.QueryResult<
	GetOpOostNewsArticleSlugsQuery,
	GetOpOostNewsArticleSlugsQueryVariables
>;
export const GetOpOostNewsArticlesDocument = gql`
	query GetOpOostNewsArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		opOostNewsarticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { allowedOnHomePage: { eq: $showOnHomePage } }
		) {
			data {
				documentId
				attributes {
					...opOostNewsArticleListFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${OpOostNewsArticleListFieldsFragmentDoc}
`;
export type GetOpOostNewsArticlesQueryResult = Apollo.QueryResult<
	GetOpOostNewsArticlesQuery,
	GetOpOostNewsArticlesQueryVariables
>;
export const GetOpOostPageSlugsDocument = gql`
	query getOpOostPageSlugs {
		findAllSlugs(uid: "api::op-oost-page.op-oost-page") {
			slug
			locale
		}
	}
`;
export type GetOpOostPageSlugsQueryResult = Apollo.QueryResult<
	GetOpOostPageSlugsQuery,
	GetOpOostPageSlugsQueryVariables
>;
export const GetPageSlugsDocument = gql`
	query GetPageSlugs {
		findAllSlugs(uid: "api::page.page") {
			slug
			locale
		}
	}
`;
export type GetPageSlugsQueryResult = Apollo.QueryResult<GetPageSlugsQuery, GetPageSlugsQueryVariables>;
export const PasswordStatusDocument = gql`
	query PasswordStatus($uid: String!, $slug: String!, $locale: I18NLocaleCode) {
		passwordStatusBySlug(uid: $uid, slug: $slug, locale: $locale) {
			exists
			protected
			enabled
			documentId
		}
	}
`;
export type PasswordStatusQueryResult = Apollo.QueryResult<PasswordStatusQuery, PasswordStatusQueryVariables>;
export const GetPermitSlugsDocument = gql`
	query getPermitSlugs {
		findAllSlugs(uid: "api::permit.permit") {
			slug
			locale
		}
	}
`;
export type GetPermitSlugsQueryResult = Apollo.QueryResult<GetPermitSlugsQuery, GetPermitSlugsQueryVariables>;
export const GetPressReleaseSlugsDocument = gql`
	query getPressReleaseSlugs {
		findAllSlugs(uid: "api::press-release.press-release") {
			slug
			locale
		}
	}
`;
export type GetPressReleaseSlugsQueryResult = Apollo.QueryResult<
	GetPressReleaseSlugsQuery,
	GetPressReleaseSlugsQueryVariables
>;
export const GetPressReleasesDocument = gql`
	query GetPressReleases(
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$publicationState: PublicationStatus
	) {
		pressReleases_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: {
				and: [
					{ header: { title: { notNull: true } } }
					{ header: { excerpt: { notNull: true } } }
					{ slug: { notNull: true } }
				]
			}
		) {
			data {
				documentId
				attributes {
					...pressReleaseFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PressReleaseFieldsFragmentDoc}
`;
export type GetPressReleasesQueryResult = Apollo.QueryResult<GetPressReleasesQuery, GetPressReleasesQueryVariables>;
export const GetPressReleaseContactPersonDocument = gql`
	query GetPressReleaseContactPerson($id: String!) {
		getPressReleaseContactPersonById(id: $id) {
			contactPerson
		}
	}
`;
export type GetPressReleaseContactPersonQueryResult = Apollo.QueryResult<
	GetPressReleaseContactPersonQuery,
	GetPressReleaseContactPersonQueryVariables
>;
export const GetProjectSlugsDocument = gql`
	query getProjectSlugs {
		findAllSlugs(uid: "api::project.project") {
			slug
			locale
		}
	}
`;
export type GetProjectSlugsQueryResult = Apollo.QueryResult<GetProjectSlugsQuery, GetProjectSlugsQueryVariables>;
export const GetProjectsDocument = gql`
	query GetProjects(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$themeIds: [ID]
		$locale: I18NLocaleCode
	) {
		projects_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { theme: { documentId: { in: $themeIds } } }
		) {
			data {
				documentId
				attributes {
					...projectFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${ProjectFieldsFragmentDoc}
`;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetRegioExpresInConvoWithArticleSlugsDocument = gql`
	query GetRegioExpresInConvoWithArticleSlugs {
		findAllSlugs(uid: "api::regio-expres-in-convo-with-article.regio-expres-in-convo-with-article") {
			locale
			slug
		}
	}
`;
export type GetRegioExpresInConvoWithArticleSlugsQueryResult = Apollo.QueryResult<
	GetRegioExpresInConvoWithArticleSlugsQuery,
	GetRegioExpresInConvoWithArticleSlugsQueryVariables
>;
export const GetRegioExpresInConvoWithArticlesDocument = gql`
	query GetRegioExpresInConvoWithArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		regioExpresInConvoWithArticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { allowedOnHomePage: { eq: $showOnHomePage } }
		) {
			data {
				documentId
				attributes {
					...regioExpresInConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${RegioExpresInConvoWithArticleFieldsFragmentDoc}
`;
export type GetRegioExpresInConvoWithArticlesQueryResult = Apollo.QueryResult<
	GetRegioExpresInConvoWithArticlesQuery,
	GetRegioExpresInConvoWithArticlesQueryVariables
>;
export const GetRegioExpresNewsArticleSlugsDocument = gql`
	query GetRegioExpresNewsArticleSlugs {
		findAllSlugs(uid: "api::regio-expres-newsarticle.regio-expres-newsarticle") {
			locale
			slug
		}
	}
`;
export type GetRegioExpresNewsArticleSlugsQueryResult = Apollo.QueryResult<
	GetRegioExpresNewsArticleSlugsQuery,
	GetRegioExpresNewsArticleSlugsQueryVariables
>;
export const GetRegioExpresNewsArticlesDocument = gql`
	query GetRegioExpresNewsArticles(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
		$showOnHomePage: Boolean
	) {
		regioExpresNewsarticles_connection(
			pagination: { limit: $limit, start: $start }
			sort: $sort
			locale: $locale
			status: $publicationState
			filters: { allowedOnHomePage: { eq: $showOnHomePage } }
		) {
			data {
				documentId
				attributes {
					...regioExpresNewsArticleListFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${RegioExpresNewsArticleListFieldsFragmentDoc}
`;
export type GetRegioExpresNewsArticlesQueryResult = Apollo.QueryResult<
	GetRegioExpresNewsArticlesQuery,
	GetRegioExpresNewsArticlesQueryVariables
>;
export const GetRegioexpresPageSlugsDocument = gql`
	query getRegioexpresPageSlugs {
		findAllSlugs(uid: "api::regio-expres-page.regio-expres-page") {
			slug
			locale
		}
	}
`;
export type GetRegioexpresPageSlugsQueryResult = Apollo.QueryResult<
	GetRegioexpresPageSlugsQuery,
	GetRegioexpresPageSlugsQueryVariables
>;
export const GetRegionSlugsDocument = gql`
	query getRegionSlugs {
		findAllSlugs(uid: "api::region.region") {
			slug
			locale
		}
	}
`;
export type GetRegionSlugsQueryResult = Apollo.QueryResult<GetRegionSlugsQuery, GetRegionSlugsQueryVariables>;
export const GetRegionsDocument = gql`
	query getRegions($locale: I18NLocaleCode) {
		regions(locale: $locale, pagination: { limit: -1 }) {
			data {
				documentId
				attributes {
					...regionFields
				}
			}
		}
	}
	${RegionFieldsFragmentDoc}
`;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetRoadMaintenancesSlugsDocument = gql`
	query GetRoadMaintenancesSlugs {
		findAllSlugs(uid: "api::road-maintenance.road-maintenance") {
			locale
			slug
		}
	}
`;
export type GetRoadMaintenancesSlugsQueryResult = Apollo.QueryResult<
	GetRoadMaintenancesSlugsQuery,
	GetRoadMaintenancesSlugsQueryVariables
>;
export const GetRoadMaintenancesDocument = gql`
	query GetRoadMaintenances($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		roadMaintenances_connection(
			pagination: { limit: 9999, start: 0 }
			sort: "title"
			locale: $locale
			filters: { roadMaintenanceStatus: { in: ["Planned", "Active"] } }
		) {
			data {
				documentId
				attributes {
					...roadMaintenanceFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${RoadMaintenanceFieldsFragmentDoc}
`;
export type GetRoadMaintenancesQueryResult = Apollo.QueryResult<
	GetRoadMaintenancesQuery,
	GetRoadMaintenancesQueryVariables
>;
export const GlobalSearchNotesDocument = gql`
	query globalSearchNotes($searchValue: String!, $limit: Int) {
		searchNotes(searchQuery: $searchValue, limit: $limit) {
			id
			documentId
			title
			note
			authorMemo
			authorPage
			createdAt
			updatedAt
		}
	}
`;
export type GlobalSearchNotesQueryResult = Apollo.QueryResult<GlobalSearchNotesQuery, GlobalSearchNotesQueryVariables>;
export const GetFullSitemapDocument = gql`
	query GetFullSitemap($locale: I18NLocaleCode, $domain: String) {
		findSitemapList(_locale: $locale, _domain: $domain) {
			slug
			title
			updated_at
		}
	}
`;
export type GetFullSitemapQueryResult = Apollo.QueryResult<GetFullSitemapQuery, GetFullSitemapQueryVariables>;
export const GetSubsidyFiltersDocument = gql`
	query getSubsidyFilters($locale: I18NLocaleCode) {
		subsidyKinds_connection(locale: $locale) {
			data {
				documentId
				attributes {
					name
					locale
				}
			}
			pageInfo {
				total
			}
		}
		subsidyScales_connection(locale: $locale) {
			data {
				documentId
				attributes {
					name
					locale
				}
			}
			pageInfo {
				total
			}
		}
		subsidyGroups: targetGroups_connection(locale: $locale) {
			data {
				documentId
				attributes {
					name
					locale
				}
			}
			pageInfo {
				total
			}
		}
	}
`;
export type GetSubsidyFiltersQueryResult = Apollo.QueryResult<GetSubsidyFiltersQuery, GetSubsidyFiltersQueryVariables>;
export const GetSubsidySlugsDocument = gql`
	query GetSubsidySlugs {
		findAllSlugs(uid: "api::subsidy.subsidy") {
			slug
			locale
		}
	}
`;
export type GetSubsidySlugsQueryResult = Apollo.QueryResult<GetSubsidySlugsQuery, GetSubsidySlugsQueryVariables>;
export const GetTagsDocument = gql`
	query getTags($locale: I18NLocaleCode) {
		tags(locale: $locale) {
			data {
				documentId
				attributes {
					...tagFields
				}
			}
		}
	}
	${TagFieldsFragmentDoc}
`;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetThemeSlugsDocument = gql`
	query getThemeSlugs {
		findAllSlugs(uid: "api::theme.theme") {
			slug
			locale
		}
	}
`;
export type GetThemeSlugsQueryResult = Apollo.QueryResult<GetThemeSlugsQuery, GetThemeSlugsQueryVariables>;
export const GetThemesDocument = gql`
	query getThemes($locale: I18NLocaleCode) {
		themes(locale: $locale, pagination: { limit: -1 }, filters: { slug: { notNull: true } }) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
		}
	}
	${ThemeFieldsFragmentDoc}
`;
export type GetThemesQueryResult = Apollo.QueryResult<GetThemesQuery, GetThemesQueryVariables>;
export const GetWobRequestsDocument = gql`
	query GetWobRequests(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$locale: I18NLocaleCode
	) {
		wobRequests_connection(
			pagination: { limit: $limit, start: $start }
			locale: $locale
			status: $publicationState
			sort: $sort
			filters: { zip: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...wobRequestFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${WobRequestFieldsFragmentDoc}
`;
export type GetWobRequestsQueryResult = Apollo.QueryResult<GetWobRequestsQuery, GetWobRequestsQueryVariables>;
export const GetWooCategoriesDocument = gql`
	query GetWooCategories {
		wooCategories {
			data {
				documentId
				attributes {
					title
				}
			}
		}
	}
`;
export type GetWooCategoriesQueryResult = Apollo.QueryResult<GetWooCategoriesQuery, GetWooCategoriesQueryVariables>;
export const GetWooRequestSlugsDocument = gql`
	query getWooRequestSlugs {
		findAllSlugs(uid: "api::woo-request.woo-request") {
			slug
			locale
		}
	}
`;
export type GetWooRequestSlugsQueryResult = Apollo.QueryResult<
	GetWooRequestSlugsQuery,
	GetWooRequestSlugsQueryVariables
>;
export const GetWooRequestsDocument = gql`
	query GetWooRequests(
		$publicationState: PublicationStatus
		$limit: Int
		$start: Int
		$sort: [String]
		$themeIds: [ID]
		$categoryIds: [ID]
		$locale: I18NLocaleCode
		$searchValue: String
	) {
		wooRequests_connection(
			pagination: { limit: $limit, start: $start }
			locale: $locale
			status: $publicationState
			sort: $sort
			filters: {
				and: {
					zip: { notNull: true }
					themes: { documentId: { in: $themeIds } }
					category: { documentId: { in: $categoryIds } }
					title: { containsi: $searchValue }
				}
			}
		) {
			data {
				documentId
				attributes {
					...wooRequestFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${WooRequestFieldsFragmentDoc}
`;
export type GetWooRequestsQueryResult = Apollo.QueryResult<GetWooRequestsQuery, GetWooRequestsQueryVariables>;
export const GetAgendaPageDocument = gql`
	query GetAgendaPage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		agendaPage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...agendaPageFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${AgendaPageFieldsFragmentDoc}
`;
export type GetAgendaPageQueryResult = Apollo.QueryResult<GetAgendaPageQuery, GetAgendaPageQueryVariables>;
export const GetCondoleanceHomepageDocument = gql`
	query GetCondoleanceHomepage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		condoleanceInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...condoleanceInformationFields
				}
			}
		}
		condoleanceHomepage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...condoleanceHomePageFields
				}
			}
		}
	}
	${CondoleanceInformationFieldsFragmentDoc}
	${CondoleanceHomePageFieldsFragmentDoc}
`;
export type GetCondoleanceHomepageQueryResult = Apollo.QueryResult<
	GetCondoleanceHomepageQuery,
	GetCondoleanceHomepageQueryVariables
>;
export const GetCondoleancePageDocument = gql`
	query GetCondoleancePage($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		condoleanceInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...condoleanceInformationFields
				}
			}
		}
		condoleancePageBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...condoleancePageSlugFields
				}
			}
		}
	}
	${CondoleanceInformationFieldsFragmentDoc}
	${CondoleancePageSlugFieldsFragmentDoc}
`;
export type GetCondoleancePageQueryResult = Apollo.QueryResult<
	GetCondoleancePageQuery,
	GetCondoleancePageQueryVariables
>;
export const GetContactDocument = gql`
	query GetContact($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		contact(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...contactFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${ContactFieldsFragmentDoc}
`;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetCookiePageDocument = gql`
	query GetCookiePage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		cookiePage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...cookiePageFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${CookiePageFieldsFragmentDoc}
`;
export type GetCookiePageQueryResult = Apollo.QueryResult<GetCookiePageQuery, GetCookiePageQueryVariables>;
export const GetDecisionsPageDocument = gql`
	query GetDecisionsPage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		decisionsPage(locale: $locale) {
			data {
				documentId
				attributes {
					...decisionsPageFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${DecisionsPageFieldsFragmentDoc}
`;
export type GetDecisionsPageQueryResult = Apollo.QueryResult<GetDecisionsPageQuery, GetDecisionsPageQueryVariables>;
export const GetDownloadsPageDocument = gql`
	query GetDownloadsPage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		downloadsPage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...downloadsPageFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${DownloadsPageFieldsFragmentDoc}
`;
export type GetDownloadsPageQueryResult = Apollo.QueryResult<GetDownloadsPageQuery, GetDownloadsPageQueryVariables>;
export const GetEfroOostHomepageDocument = gql`
	query GetEfroOostHomepage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		efroOostHomepage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostHomePageFields
				}
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${EfroOostHomePageFieldsFragmentDoc}
`;
export type GetEfroOostHomepageQueryResult = Apollo.QueryResult<
	GetEfroOostHomepageQuery,
	GetEfroOostHomepageQueryVariables
>;
export const GetEfroOostInConvoWithDetailDocument = gql`
	query GetEfroOostInConvoWithDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		efroOostInConvoWithDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInConvoWithDetailSingleFields
				}
			}
		}
		efroOostInConvoWithArticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInConvoWithArticleFields
				}
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${EfroOostInConvoWithDetailSingleFieldsFragmentDoc}
	${EfroOostInConvoWithArticleFieldsFragmentDoc}
`;
export type GetEfroOostInConvoWithDetailQueryResult = Apollo.QueryResult<
	GetEfroOostInConvoWithDetailQuery,
	GetEfroOostInConvoWithDetailQueryVariables
>;
export const GetEfroOostInConvoWithOverviewDocument = gql`
	query GetEfroOostInConvoWithOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		efroOostInConvoWithOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInConvoWithOverviewSingleFields
				}
			}
		}
		efroOostInConvoWithArticles_connection(
			pagination: { limit: 9, start: 0 }
			sort: "publishedAt:DESC"
			locale: $locale
			status: $publicationState
		) {
			data {
				documentId
				attributes {
					...efroOostInConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${EfroOostInConvoWithOverviewSingleFieldsFragmentDoc}
	${EfroOostInConvoWithArticleFieldsFragmentDoc}
`;
export type GetEfroOostInConvoWithOverviewQueryResult = Apollo.QueryResult<
	GetEfroOostInConvoWithOverviewQuery,
	GetEfroOostInConvoWithOverviewQueryVariables
>;
export const GetEfroOostNewsDetailDocument = gql`
	query GetEfroOostNewsDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		efroOostNewsDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostNewsDetailSingleFields
				}
			}
		}
		efroOostNewsarticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostNewsArticleFields
				}
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${EfroOostNewsDetailSingleFieldsFragmentDoc}
	${EfroOostNewsArticleFieldsFragmentDoc}
`;
export type GetEfroOostNewsDetailQueryResult = Apollo.QueryResult<
	GetEfroOostNewsDetailQuery,
	GetEfroOostNewsDetailQueryVariables
>;
export const GetEfroOostNewsOverviewDocument = gql`
	query GetEfroOostNewsOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		efroOostNewsOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostNewsOverviewSingleFields
				}
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${EfroOostNewsOverviewSingleFieldsFragmentDoc}
`;
export type GetEfroOostNewsOverviewQueryResult = Apollo.QueryResult<
	GetEfroOostNewsOverviewQuery,
	GetEfroOostNewsOverviewQueryVariables
>;
export const GetEfroOostPageDocument = gql`
	query GetEfroOostPage($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		efroOostPageBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostPageSlugFields
				}
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${EfroOostPageSlugFieldsFragmentDoc}
`;
export type GetEfroOostPageQueryResult = Apollo.QueryResult<GetEfroOostPageQuery, GetEfroOostPageQueryVariables>;
export const GetEventOverviewDocument = gql`
	query GetEventOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		eventOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...eventOverviewSingleFields
				}
			}
		}
		themes_connection(
			locale: $locale
			status: $publicationState
			pagination: { limit: -1 }
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${EventOverviewSingleFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetEventOverviewQueryResult = Apollo.QueryResult<GetEventOverviewQuery, GetEventOverviewQueryVariables>;
export const GetGeoLinkPageDocument = gql`
	query GetGeoLinkPage($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		geolinkInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...geolinkInformationFields
				}
			}
		}
		geolinkPageBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...geolinkPageSlugFields
				}
			}
		}
	}
	${GeolinkInformationFieldsFragmentDoc}
	${GeolinkPageSlugFieldsFragmentDoc}
`;
export type GetGeoLinkPageQueryResult = Apollo.QueryResult<GetGeoLinkPageQuery, GetGeoLinkPageQueryVariables>;
export const GetGeolinkHomepageDocument = gql`
	query GetGeolinkHomepage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		geolinkInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...geolinkInformationFields
				}
			}
		}
		geolinkHomepage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...geolinkHomePageFields
				}
			}
		}
	}
	${GeolinkInformationFieldsFragmentDoc}
	${GeolinkHomePageFieldsFragmentDoc}
`;
export type GetGeolinkHomepageQueryResult = Apollo.QueryResult<
	GetGeolinkHomepageQuery,
	GetGeolinkHomepageQueryVariables
>;
export const GetHomePageDocument = gql`
	query GetHomePage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		homePage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...homePageFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${HomePageFieldsFragmentDoc}
`;
export type GetHomePageQueryResult = Apollo.QueryResult<GetHomePageQuery, GetHomePageQueryVariables>;
export const GetInConvoWithDetailDocument = gql`
	query GetInConvoWithDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		inConvoWithDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...inConvoWithDetailSingleFields
				}
			}
		}
		inConvoWithArticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...inConvoWithArticleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${InConvoWithDetailSingleFieldsFragmentDoc}
	${InConvoWithArticleFieldsFragmentDoc}
`;
export type GetInConvoWithDetailQueryResult = Apollo.QueryResult<
	GetInConvoWithDetailQuery,
	GetInConvoWithDetailQueryVariables
>;
export const GetInConvoWithOverviewDocument = gql`
	query GetInConvoWithOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		inConvoWithOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...inConvoWithOverviewSingleFields
				}
			}
		}
		inConvoWithArticles_connection(
			pagination: { limit: 9, start: 0 }
			sort: "publishedAt:DESC"
			locale: $locale
			status: $publicationState
		) {
			data {
				documentId
				attributes {
					...inConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${InConvoWithOverviewSingleFieldsFragmentDoc}
	${InConvoWithArticleFieldsFragmentDoc}
`;
export type GetInConvoWithOverviewQueryResult = Apollo.QueryResult<
	GetInConvoWithOverviewQuery,
	GetInConvoWithOverviewQueryVariables
>;
export const GetMapsFiguresOverviewDocument = gql`
	query GetMapsFiguresOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		mapsFiguresOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...mapsFiguresOverviewSingleFields
				}
			}
		}
		themes_connection(
			pagination: { limit: 9, start: 0 }
			sort: "title:ASC"
			locale: $locale
			status: $publicationState
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${MapsFiguresOverviewSingleFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetMapsFiguresOverviewQueryResult = Apollo.QueryResult<
	GetMapsFiguresOverviewQuery,
	GetMapsFiguresOverviewQueryVariables
>;
export const GetNewsDetailDocument = gql`
	query GetNewsDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		newsDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...newsDetailSingleFields
				}
			}
		}
		newsarticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...newsArticleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${NewsDetailSingleFieldsFragmentDoc}
	${NewsArticleFieldsFragmentDoc}
`;
export type GetNewsDetailQueryResult = Apollo.QueryResult<GetNewsDetailQuery, GetNewsDetailQueryVariables>;
export const GetNewsOverviewDocument = gql`
	query GetNewsOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		newsOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...newsOverviewSingleFields
				}
			}
		}
		themes_connection(
			locale: $locale
			status: $publicationState
			pagination: { limit: -1 }
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${NewsOverviewSingleFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetNewsOverviewQueryResult = Apollo.QueryResult<GetNewsOverviewQuery, GetNewsOverviewQueryVariables>;
export const GetArchiveNewsletterOverviewPageDocument = gql`
	query GetArchiveNewsletterOverviewPage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				__typename
				id
				attributes {
					...pageInformationFields
				}
			}
		}
		newsletterArchiveOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				__typename
				attributes {
					...newsletterArchiveOverviewSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${NewsletterArchiveOverviewSingleFieldsFragmentDoc}
`;
export type GetArchiveNewsletterOverviewPageQueryResult = Apollo.QueryResult<
	GetArchiveNewsletterOverviewPageQuery,
	GetArchiveNewsletterOverviewPageQueryVariables
>;
export const GetInternalNewsletterPageDocument = gql`
	query GetInternalNewsletterPage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				__typename
				id
				attributes {
					...pageInformationFields
				}
			}
		}
		internalNewsletterWithSubscriptions(_locale: $locale, _publicationState: $publicationState) {
			...internalNewsletterWithSubscriptionsFields
		}
	}
	${PageInformationFieldsFragmentDoc}
	${InternalNewsletterWithSubscriptionsFieldsFragmentDoc}
`;
export type GetInternalNewsletterPageQueryResult = Apollo.QueryResult<
	GetInternalNewsletterPageQuery,
	GetInternalNewsletterPageQueryVariables
>;
export const GetPublicNewsletterPageCondoleanceDocument = gql`
	query GetPublicNewsletterPageCondoleance($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		condoleanceInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...condoleanceInformationFields
				}
			}
		}
		publicNewsletterPage(_locale: $locale, _publicationState: $publicationState) {
			...publicNewsletterFields
		}
	}
	${CondoleanceInformationFieldsFragmentDoc}
	${PublicNewsletterFieldsFragmentDoc}
`;
export type GetPublicNewsletterPageCondoleanceQueryResult = Apollo.QueryResult<
	GetPublicNewsletterPageCondoleanceQuery,
	GetPublicNewsletterPageCondoleanceQueryVariables
>;
export const GetPublicNewsletterPageOfroOostDocument = gql`
	query GetPublicNewsletterPageOfroOost($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		publicNewsletterPage(_locale: $locale, _publicationState: $publicationState) {
			...publicNewsletterFields
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${PublicNewsletterFieldsFragmentDoc}
`;
export type GetPublicNewsletterPageOfroOostQueryResult = Apollo.QueryResult<
	GetPublicNewsletterPageOfroOostQuery,
	GetPublicNewsletterPageOfroOostQueryVariables
>;
export const GetPublicNewsletterPageGeolinkDocument = gql`
	query GetPublicNewsletterPageGeolink($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		geolinkInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...geolinkInformationFields
				}
			}
		}
		publicNewsletterPage(_locale: $locale, _publicationState: $publicationState) {
			...publicNewsletterFields
		}
	}
	${GeolinkInformationFieldsFragmentDoc}
	${PublicNewsletterFieldsFragmentDoc}
`;
export type GetPublicNewsletterPageGeolinkQueryResult = Apollo.QueryResult<
	GetPublicNewsletterPageGeolinkQuery,
	GetPublicNewsletterPageGeolinkQueryVariables
>;
export const GetPublicNewsletterPageOpOostDocument = gql`
	query GetPublicNewsletterPageOpOost($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		publicNewsletterPage(_locale: $locale, _publicationState: $publicationState) {
			...publicNewsletterFields
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${PublicNewsletterFieldsFragmentDoc}
`;
export type GetPublicNewsletterPageOpOostQueryResult = Apollo.QueryResult<
	GetPublicNewsletterPageOpOostQuery,
	GetPublicNewsletterPageOpOostQueryVariables
>;
export const GetPublicNewsletterPageRegioExpresDocument = gql`
	query GetPublicNewsletterPageRegioExpres($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		publicNewsletterPage(_locale: $locale, _publicationState: $publicationState) {
			...publicNewsletterFields
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${PublicNewsletterFieldsFragmentDoc}
`;
export type GetPublicNewsletterPageRegioExpresQueryResult = Apollo.QueryResult<
	GetPublicNewsletterPageRegioExpresQuery,
	GetPublicNewsletterPageRegioExpresQueryVariables
>;
export const GetPublicNewsletterPageDocument = gql`
	query GetPublicNewsletterPage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				__typename
				id
				attributes {
					...pageInformationFields
				}
			}
		}
		publicNewsletterPage(_locale: $locale, _publicationState: $publicationState) {
			...publicNewsletterFields
		}
	}
	${PageInformationFieldsFragmentDoc}
	${PublicNewsletterFieldsFragmentDoc}
`;
export type GetPublicNewsletterPageQueryResult = Apollo.QueryResult<
	GetPublicNewsletterPageQuery,
	GetPublicNewsletterPageQueryVariables
>;
export const GetNotFoundDocument = gql`
	query GetNotFound($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		notFoundPage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...notFoundPageFields
				}
			}
		}
	}
	${NotFoundPageFieldsFragmentDoc}
`;
export type GetNotFoundQueryResult = Apollo.QueryResult<GetNotFoundQuery, GetNotFoundQueryVariables>;
export const GetOpOostHomepageDocument = gql`
	query GetOpOostHomepage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		opOostHomepage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostHomePageFields
				}
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${OpOostHomePageFieldsFragmentDoc}
`;
export type GetOpOostHomepageQueryResult = Apollo.QueryResult<GetOpOostHomepageQuery, GetOpOostHomepageQueryVariables>;
export const GetOpOostInConvoWithDetailDocument = gql`
	query GetOpOostInConvoWithDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		opOostInConvoWithDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInConvoWithDetailSingleFields
				}
			}
		}
		opOostInConvoWithArticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInConvoWithArticleFields
				}
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${OpOostInConvoWithDetailSingleFieldsFragmentDoc}
	${OpOostInConvoWithArticleFieldsFragmentDoc}
`;
export type GetOpOostInConvoWithDetailQueryResult = Apollo.QueryResult<
	GetOpOostInConvoWithDetailQuery,
	GetOpOostInConvoWithDetailQueryVariables
>;
export const GetOpOostInConvoWithOverviewDocument = gql`
	query GetOpOostInConvoWithOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		opOostInConvoWithOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInConvoWithOverviewSingleFields
				}
			}
		}
		opOostInConvoWithArticles_connection(
			pagination: { limit: 9, start: 0 }
			sort: "publishedAt:DESC"
			locale: $locale
			status: $publicationState
		) {
			data {
				documentId
				attributes {
					...opOostInConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${OpOostInConvoWithOverviewSingleFieldsFragmentDoc}
	${OpOostInConvoWithArticleFieldsFragmentDoc}
`;
export type GetOpOostInConvoWithOverviewQueryResult = Apollo.QueryResult<
	GetOpOostInConvoWithOverviewQuery,
	GetOpOostInConvoWithOverviewQueryVariables
>;
export const GetOpOostNewsDetailDocument = gql`
	query GetOpOostNewsDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		opOostNewsDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostNewsDetailSingleFields
				}
			}
		}
		opOostNewsarticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostNewsArticleFields
				}
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${OpOostNewsDetailSingleFieldsFragmentDoc}
	${OpOostNewsArticleFieldsFragmentDoc}
`;
export type GetOpOostNewsDetailQueryResult = Apollo.QueryResult<
	GetOpOostNewsDetailQuery,
	GetOpOostNewsDetailQueryVariables
>;
export const GetOpOostNewsOverviewDocument = gql`
	query GetOpOostNewsOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		opOostNewsOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostNewsOverviewSingleFields
				}
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${OpOostNewsOverviewSingleFieldsFragmentDoc}
`;
export type GetOpOostNewsOverviewQueryResult = Apollo.QueryResult<
	GetOpOostNewsOverviewQuery,
	GetOpOostNewsOverviewQueryVariables
>;
export const GetOpOostPageDocument = gql`
	query GetOpOostPage($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		opOostPageBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostPageSlugFields
				}
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${OpOostPageSlugFieldsFragmentDoc}
`;
export type GetOpOostPageQueryResult = Apollo.QueryResult<GetOpOostPageQuery, GetOpOostPageQueryVariables>;
export const GetOpenGelderlandHomepageDocument = gql`
	query GetOpenGelderlandHomepage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		openGelderlandInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...openGelderlandInformationFields
				}
			}
		}
		openGelderlandHomepage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...openGelderlandHomePageFields
				}
			}
		}
	}
	${OpenGelderlandInformationFieldsFragmentDoc}
	${OpenGelderlandHomePageFieldsFragmentDoc}
`;
export type GetOpenGelderlandHomepageQueryResult = Apollo.QueryResult<
	GetOpenGelderlandHomepageQuery,
	GetOpenGelderlandHomepageQueryVariables
>;
export const GetPageInformationCondoleanceDocument = gql`
	query GetPageInformationCondoleance($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		condoleanceInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...condoleanceInformationFields
				}
			}
		}
	}
	${CondoleanceInformationFieldsFragmentDoc}
`;
export type GetPageInformationCondoleanceQueryResult = Apollo.QueryResult<
	GetPageInformationCondoleanceQuery,
	GetPageInformationCondoleanceQueryVariables
>;
export const GetPageInformationEfroOostDocument = gql`
	query GetPageInformationEfroOost($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
`;
export type GetPageInformationEfroOostQueryResult = Apollo.QueryResult<
	GetPageInformationEfroOostQuery,
	GetPageInformationEfroOostQueryVariables
>;
export const GetPageInformationGelderlandDocument = gql`
	query GetPageInformationGelderland($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
`;
export type GetPageInformationGelderlandQueryResult = Apollo.QueryResult<
	GetPageInformationGelderlandQuery,
	GetPageInformationGelderlandQueryVariables
>;
export const GetPageInformationGeolinkDocument = gql`
	query GetPageInformationGeolink($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		geolinkInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...geolinkInformationFields
				}
			}
		}
	}
	${GeolinkInformationFieldsFragmentDoc}
`;
export type GetPageInformationGeolinkQueryResult = Apollo.QueryResult<
	GetPageInformationGeolinkQuery,
	GetPageInformationGeolinkQueryVariables
>;
export const GetPageInformationOpOostDocument = gql`
	query GetPageInformationOpOost($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
`;
export type GetPageInformationOpOostQueryResult = Apollo.QueryResult<
	GetPageInformationOpOostQuery,
	GetPageInformationOpOostQueryVariables
>;
export const GetPageInformationRegioExpresDocument = gql`
	query GetPageInformationRegioExpres($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
`;
export type GetPageInformationRegioExpresQueryResult = Apollo.QueryResult<
	GetPageInformationRegioExpresQuery,
	GetPageInformationRegioExpresQueryVariables
>;
export const GetPageDocument = gql`
	query GetPage($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		pageBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageSlugFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${PageSlugFieldsFragmentDoc}
`;
export type GetPageQueryResult = Apollo.QueryResult<GetPageQuery, GetPageQueryVariables>;
export const GetPasswordPageDocument = gql`
	query GetPasswordPage($locale: I18NLocaleCode) {
		passwordProtectionPasswordPage(locale: $locale) {
			data {
				documentId
				attributes {
					...passwordPageFields
				}
			}
		}
	}
	${PasswordPageFieldsFragmentDoc}
`;
export type GetPasswordPageQueryResult = Apollo.QueryResult<GetPasswordPageQuery, GetPasswordPageQueryVariables>;
export const GetPermitDetailDocument = gql`
	query GetPermitDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		permitDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...permitDetailSingleFields
				}
			}
		}
		permitBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...permitFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${PermitDetailSingleFieldsFragmentDoc}
	${PermitFieldsFragmentDoc}
`;
export type GetPermitDetailQueryResult = Apollo.QueryResult<GetPermitDetailQuery, GetPermitDetailQueryVariables>;
export const GetPermitsOverviewDocument = gql`
	query GetPermitsOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		permitsOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...permitsOverviewSingleFields
				}
			}
		}
		permitLaws_connection(pagination: { limit: 99, start: 0 }, locale: $locale) {
			data {
				documentId
				attributes {
					name
				}
			}
			pageInfo {
				total
			}
		}
		permitProductTypes_connection(pagination: { limit: 9, start: 0 }, locale: $locale) {
			data {
				documentId
				attributes {
					name
				}
			}
			pageInfo {
				total
			}
		}
		themes_connection(
			pagination: { limit: 9, start: 0 }
			sort: "title:ASC"
			locale: $locale
			status: $publicationState
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${PermitsOverviewSingleFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetPermitsOverviewQueryResult = Apollo.QueryResult<
	GetPermitsOverviewQuery,
	GetPermitsOverviewQueryVariables
>;
export const GetPressReleaseDetailDocument = gql`
	query GetPressReleaseDetail($locale: I18NLocaleCode, $publicationState: PublicationStatus, $slug: String!) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		pressReleaseDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pressReleaseDetailFields
				}
			}
		}
		pressReleaseBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...pressReleaseFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${PressReleaseDetailFieldsFragmentDoc}
	${PressReleaseFieldsFragmentDoc}
`;
export type GetPressReleaseDetailQueryResult = Apollo.QueryResult<
	GetPressReleaseDetailQuery,
	GetPressReleaseDetailQueryVariables
>;
export const GetPressReleaseOverviewDocument = gql`
	query GetPressReleaseOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		pressReleaseOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pressReleaseOverviewSingleFields
				}
			}
		}
		pressReleases_connection(
			pagination: { limit: 12, start: 0 }
			sort: "publishedAt:DESC"
			locale: $locale
			status: $publicationState
			filters: {
				and: [
					{ header: { title: { notNull: true } } }
					{ header: { excerpt: { notNull: true } } }
					{ slug: { notNull: true } }
				]
			}
		) {
			data {
				documentId
				attributes {
					...pressReleaseFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${PressReleaseOverviewSingleFieldsFragmentDoc}
	${PressReleaseFieldsFragmentDoc}
`;
export type GetPressReleaseOverviewQueryResult = Apollo.QueryResult<
	GetPressReleaseOverviewQuery,
	GetPressReleaseOverviewQueryVariables
>;
export const GetPrivacyPolicyDocument = gql`
	query GetPrivacyPolicy($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		privacyPolicy(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...privacyPolicyFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${PrivacyPolicyFieldsFragmentDoc}
`;
export type GetPrivacyPolicyQueryResult = Apollo.QueryResult<GetPrivacyPolicyQuery, GetPrivacyPolicyQueryVariables>;
export const GetProjectDetailDocument = gql`
	query GetProjectDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		projectDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...projectDetailSingleFields
				}
			}
		}
		projectBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...projectFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${ProjectDetailSingleFieldsFragmentDoc}
	${ProjectFieldsFragmentDoc}
`;
export type GetProjectDetailQueryResult = Apollo.QueryResult<GetProjectDetailQuery, GetProjectDetailQueryVariables>;
export const GetProjectOverviewDocument = gql`
	query GetProjectOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		projectOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...projectOverviewSingleFields
				}
			}
		}
		themes_connection(
			locale: $locale
			status: $publicationState
			pagination: { limit: -1 }
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${ProjectOverviewSingleFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetProjectOverviewQueryResult = Apollo.QueryResult<
	GetProjectOverviewQuery,
	GetProjectOverviewQueryVariables
>;
export const GetRegioExpresHomepageDocument = gql`
	query GetRegioExpresHomepage($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		regioExpresHomepage(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresHomePageFields
				}
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${RegioExpresHomePageFieldsFragmentDoc}
`;
export type GetRegioExpresHomepageQueryResult = Apollo.QueryResult<
	GetRegioExpresHomepageQuery,
	GetRegioExpresHomepageQueryVariables
>;
export const GetRegioExpresInConvoWithDetailDocument = gql`
	query GetRegioExpresInConvoWithDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		regioExpresInConvoWithDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInConvoWithDetailSingleFields
				}
			}
		}
		regioExpresInConvoWithArticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInConvoWithArticleFields
				}
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${RegioExpresInConvoWithDetailSingleFieldsFragmentDoc}
	${RegioExpresInConvoWithArticleFieldsFragmentDoc}
`;
export type GetRegioExpresInConvoWithDetailQueryResult = Apollo.QueryResult<
	GetRegioExpresInConvoWithDetailQuery,
	GetRegioExpresInConvoWithDetailQueryVariables
>;
export const GetRegioExpresInConvoWithOverviewDocument = gql`
	query GetRegioExpresInConvoWithOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		regioExpresInConvoOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInConvoWithOverviewSingleFields
				}
			}
		}
		regioExpresInConvoWithArticles_connection(
			pagination: { limit: 9, start: 0 }
			sort: "publishedAt:DESC"
			locale: $locale
			status: $publicationState
		) {
			data {
				documentId
				attributes {
					...regioExpresInConvoWithArticleFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${RegioExpresInConvoWithOverviewSingleFieldsFragmentDoc}
	${RegioExpresInConvoWithArticleFieldsFragmentDoc}
`;
export type GetRegioExpresInConvoWithOverviewQueryResult = Apollo.QueryResult<
	GetRegioExpresInConvoWithOverviewQuery,
	GetRegioExpresInConvoWithOverviewQueryVariables
>;
export const GetRegioExpresNewsDetailDocument = gql`
	query GetRegioExpresNewsDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		regioExpresNewsDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresNewsDetailSingleFields
				}
			}
		}
		regioExpresNewsarticleBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresNewsArticleFields
				}
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${RegioExpresNewsDetailSingleFieldsFragmentDoc}
	${RegioExpresNewsArticleFieldsFragmentDoc}
`;
export type GetRegioExpresNewsDetailQueryResult = Apollo.QueryResult<
	GetRegioExpresNewsDetailQuery,
	GetRegioExpresNewsDetailQueryVariables
>;
export const GetRegioExpresNewsOverviewDocument = gql`
	query GetRegioExpresNewsOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		regioExpresNewsOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresNewsOverviewSingleFields
				}
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${RegioExpresNewsOverviewSingleFieldsFragmentDoc}
`;
export type GetRegioExpresNewsOverviewQueryResult = Apollo.QueryResult<
	GetRegioExpresNewsOverviewQuery,
	GetRegioExpresNewsOverviewQueryVariables
>;
export const GetRegioExpresPageDocument = gql`
	query GetRegioExpresPage($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		regioExpresPageBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresPageSlugFields
				}
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${RegioExpresPageSlugFieldsFragmentDoc}
`;
export type GetRegioExpresPageQueryResult = Apollo.QueryResult<
	GetRegioExpresPageQuery,
	GetRegioExpresPageQueryVariables
>;
export const GetRegionDetailDocument = gql`
	query GetRegionDetail($locale: I18NLocaleCode, $publicationState: PublicationStatus, $slug: String!) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		regionDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regionDetailFields
				}
			}
		}
		regionBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...regionFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${RegionDetailFieldsFragmentDoc}
	${RegionFieldsFragmentDoc}
`;
export type GetRegionDetailQueryResult = Apollo.QueryResult<GetRegionDetailQuery, GetRegionDetailQueryVariables>;
export const GetRegionOverviewDocument = gql`
	query GetRegionOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		regionOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regionOverviewSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${RegionOverviewSingleFieldsFragmentDoc}
`;
export type GetRegionOverviewQueryResult = Apollo.QueryResult<GetRegionOverviewQuery, GetRegionOverviewQueryVariables>;
export const GetRoadMaintenanceDetailDocument = gql`
	query GetRoadMaintenanceDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		roadMaintenanceDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...roadMaintenanceDetailSingleFields
				}
			}
		}
		roadMaintenanceBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...roadMaintenanceFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${RoadMaintenanceDetailSingleFieldsFragmentDoc}
	${RoadMaintenanceFieldsFragmentDoc}
`;
export type GetRoadMaintenanceDetailQueryResult = Apollo.QueryResult<
	GetRoadMaintenanceDetailQuery,
	GetRoadMaintenanceDetailQueryVariables
>;
export const GetRoadMaintenanceOverviewDocument = gql`
	query GetRoadMaintenanceOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		roadMaintenanceOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...roadMaintenanceOverviewSingleFields
				}
			}
		}
		themes_connection(
			locale: $locale
			status: $publicationState
			pagination: { limit: -1 }
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${RoadMaintenanceOverviewSingleFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetRoadMaintenanceOverviewQueryResult = Apollo.QueryResult<
	GetRoadMaintenanceOverviewQuery,
	GetRoadMaintenanceOverviewQueryVariables
>;
export const GetSearchOverviewDocument = gql`
	query GetSearchOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		opOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		efroOostInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		regioExpresInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		searchOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...searchOverviewSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${OpOostInformationFieldsFragmentDoc}
	${EfroOostInformationFieldsFragmentDoc}
	${RegioExpresInformationFieldsFragmentDoc}
	${SearchOverviewSingleFieldsFragmentDoc}
`;
export type GetSearchOverviewQueryResult = Apollo.QueryResult<GetSearchOverviewQuery, GetSearchOverviewQueryVariables>;
export const GetLocalSitemapCondoleanceDocument = gql`
	query GetLocalSitemapCondoleance($locale: I18NLocaleCode) {
		condoleanceInformation(locale: $locale) {
			data {
				documentId
				attributes {
					...condoleanceInformationFields
				}
			}
		}
		sitemap {
			data {
				documentId
				attributes {
					...sitemapPageFields
				}
			}
		}
	}
	${CondoleanceInformationFieldsFragmentDoc}
	${SitemapPageFieldsFragmentDoc}
`;
export type GetLocalSitemapCondoleanceQueryResult = Apollo.QueryResult<
	GetLocalSitemapCondoleanceQuery,
	GetLocalSitemapCondoleanceQueryVariables
>;
export const GetLocalSitemapEfroOostDocument = gql`
	query GetLocalSitemapEfroOost($locale: I18NLocaleCode) {
		efroOostInformation(locale: $locale) {
			data {
				documentId
				attributes {
					...efroOostInformationFields
				}
			}
		}
		sitemap {
			data {
				documentId
				attributes {
					...sitemapPageFields
				}
			}
		}
	}
	${EfroOostInformationFieldsFragmentDoc}
	${SitemapPageFieldsFragmentDoc}
`;
export type GetLocalSitemapEfroOostQueryResult = Apollo.QueryResult<
	GetLocalSitemapEfroOostQuery,
	GetLocalSitemapEfroOostQueryVariables
>;
export const GetLocalSitemapGeolinkDocument = gql`
	query GetLocalSitemapGeolink($locale: I18NLocaleCode) {
		geolinkInformation(locale: $locale) {
			data {
				documentId
				attributes {
					...geolinkInformationFields
				}
			}
		}
		sitemap {
			data {
				documentId
				attributes {
					...sitemapPageFields
				}
			}
		}
	}
	${GeolinkInformationFieldsFragmentDoc}
	${SitemapPageFieldsFragmentDoc}
`;
export type GetLocalSitemapGeolinkQueryResult = Apollo.QueryResult<
	GetLocalSitemapGeolinkQuery,
	GetLocalSitemapGeolinkQueryVariables
>;
export const GetLocalSitemapOpOostDocument = gql`
	query GetLocalSitemapOpOost($locale: I18NLocaleCode) {
		opOostInformation(locale: $locale) {
			data {
				documentId
				attributes {
					...opOostInformationFields
				}
			}
		}
		sitemap {
			data {
				documentId
				attributes {
					...sitemapPageFields
				}
			}
		}
	}
	${OpOostInformationFieldsFragmentDoc}
	${SitemapPageFieldsFragmentDoc}
`;
export type GetLocalSitemapOpOostQueryResult = Apollo.QueryResult<
	GetLocalSitemapOpOostQuery,
	GetLocalSitemapOpOostQueryVariables
>;
export const GetLocalSitemapRegioExpresDocument = gql`
	query GetLocalSitemapRegioExpres($locale: I18NLocaleCode) {
		regioExpresInformation(locale: $locale) {
			data {
				documentId
				attributes {
					...regioExpresInformationFields
				}
			}
		}
		sitemap {
			data {
				documentId
				attributes {
					...sitemapPageFields
				}
			}
		}
	}
	${RegioExpresInformationFieldsFragmentDoc}
	${SitemapPageFieldsFragmentDoc}
`;
export type GetLocalSitemapRegioExpresQueryResult = Apollo.QueryResult<
	GetLocalSitemapRegioExpresQuery,
	GetLocalSitemapRegioExpresQueryVariables
>;
export const GetLocalSitemapDocument = gql`
	query GetLocalSitemap($locale: I18NLocaleCode) {
		pageInformation(locale: $locale) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		sitemap {
			data {
				documentId
				attributes {
					...sitemapPageFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${SitemapPageFieldsFragmentDoc}
`;
export type GetLocalSitemapQueryResult = Apollo.QueryResult<GetLocalSitemapQuery, GetLocalSitemapQueryVariables>;
export const GetSubsidyDetailDocument = gql`
	query GetSubsidyDetail($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		subsidyDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...subsidyDetailSingleFields
				}
			}
		}
		subsidyBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...subsidyFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${SubsidyDetailSingleFieldsFragmentDoc}
	${SubsidyFieldsFragmentDoc}
`;
export type GetSubsidyDetailQueryResult = Apollo.QueryResult<GetSubsidyDetailQuery, GetSubsidyDetailQueryVariables>;
export const GetSubsidyOverviewDocument = gql`
	query GetSubsidyOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		subsidyOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...subsidyOverviewSingleFields
				}
			}
		}
		kinds: subsidyKinds_connection(locale: $locale) {
			data {
				documentId
				attributes {
					name
				}
			}
			pageInfo {
				total
			}
		}
		scales: subsidyScales_connection(locale: $locale) {
			data {
				documentId
				attributes {
					name
				}
			}
			pageInfo {
				total
			}
		}
		groups: targetGroups_connection(locale: $locale) {
			data {
				documentId
				attributes {
					name
				}
			}
			pageInfo {
				total
			}
		}
		themes(
			locale: $locale
			status: $publicationState
			pagination: { limit: -1 }
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
		}
		themes_connection(
			locale: $locale
			status: $publicationState
			pagination: { limit: -1 }
			filters: { slug: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${SubsidyOverviewSingleFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetSubsidyOverviewQueryResult = Apollo.QueryResult<
	GetSubsidyOverviewQuery,
	GetSubsidyOverviewQueryVariables
>;
export const GetThemeDetailDocument = gql`
	query GetThemeDetail($locale: I18NLocaleCode, $publicationState: PublicationStatus, $slug: String!) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		themeDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...themeDetailFields
				}
			}
		}
		themeBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			data {
				documentId
				attributes {
					...themeFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${ThemeDetailFieldsFragmentDoc}
	${ThemeFieldsFragmentDoc}
`;
export type GetThemeDetailQueryResult = Apollo.QueryResult<GetThemeDetailQuery, GetThemeDetailQueryVariables>;
export const GetThemeOverviewDocument = gql`
	query GetThemeOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		themeOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...ThemeOverviewSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${ThemeOverviewSingleFieldsFragmentDoc}
`;
export type GetThemeOverviewQueryResult = Apollo.QueryResult<GetThemeOverviewQuery, GetThemeOverviewQueryVariables>;
export const GetVacancyDetailDocument = gql`
	query GetVacancyDetail($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		vacancyDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...vacancyDetailSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${VacancyDetailSingleFieldsFragmentDoc}
`;
export type GetVacancyDetailQueryResult = Apollo.QueryResult<GetVacancyDetailQuery, GetVacancyDetailQueryVariables>;
export const GetVacancyInternalDetailDocument = gql`
	query GetVacancyInternalDetail($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		vacancyInternalDetail(locale: $locale) {
			data {
				documentId
				attributes {
					...vacancyInternalDetailSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${VacancyInternalDetailSingleFieldsFragmentDoc}
`;
export type GetVacancyInternalDetailQueryResult = Apollo.QueryResult<
	GetVacancyInternalDetailQuery,
	GetVacancyInternalDetailQueryVariables
>;
export const GetVacancyInternalOverviewDocument = gql`
	query GetVacancyInternalOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		vacancyInternalOverview(locale: $locale) {
			data {
				documentId
				attributes {
					...vacancyInternalOverviewSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${VacancyInternalOverviewSingleFieldsFragmentDoc}
`;
export type GetVacancyInternalOverviewQueryResult = Apollo.QueryResult<
	GetVacancyInternalOverviewQuery,
	GetVacancyInternalOverviewQueryVariables
>;
export const GetVacancyOverviewDocument = gql`
	query GetVacancyOverview($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		vacancyOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...vacancyOverviewSingleFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${VacancyOverviewSingleFieldsFragmentDoc}
`;
export type GetVacancyOverviewQueryResult = Apollo.QueryResult<
	GetVacancyOverviewQuery,
	GetVacancyOverviewQueryVariables
>;
export const GetWobRequestOverviewDocument = gql`
	query GetWobRequestOverview($locale: I18NLocaleCode, $limit: Int, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		wobRequestOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...wobRequestOverviewSingleFields
				}
			}
		}
		wobRequests_connection(
			pagination: { limit: $limit }
			locale: $locale
			status: $publicationState
			sort: "date:DESC"
			filters: { zip: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...wobRequestFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${WobRequestOverviewSingleFieldsFragmentDoc}
	${WobRequestFieldsFragmentDoc}
`;
export type GetWobRequestOverviewQueryResult = Apollo.QueryResult<
	GetWobRequestOverviewQuery,
	GetWobRequestOverviewQueryVariables
>;
export const GetWooDocumentCountDocument = gql`
	query GetWooDocumentCount {
		countDocumentsPerCategory {
			sitemap
			count
		}
	}
`;
export type GetWooDocumentCountQueryResult = Apollo.QueryResult<
	GetWooDocumentCountQuery,
	GetWooDocumentCountQueryVariables
>;
export const GetOpenWooRequestDetailDocument = gql`
	query GetOpenWooRequestDetail($locale: I18NLocaleCode, $publicationState: PublicationStatus, $slug: String!) {
		openGelderlandInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...openGelderlandInformationFields
				}
			}
		}
		wooDocumentDetail(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...wooDocumentDetailSingleFields
				}
			}
		}
		wooRequestBySlug(locale: $locale, status: $publicationState, slug: $slug) {
			data {
				documentId
				attributes {
					...wooRequestFields
				}
			}
		}
	}
	${OpenGelderlandInformationFieldsFragmentDoc}
	${WooDocumentDetailSingleFieldsFragmentDoc}
	${WooRequestFieldsFragmentDoc}
`;
export type GetOpenWooRequestDetailQueryResult = Apollo.QueryResult<
	GetOpenWooRequestDetailQuery,
	GetOpenWooRequestDetailQueryVariables
>;
export const GetOpenWooRequestOverviewDocument = gql`
	query GetOpenWooRequestOverview($locale: I18NLocaleCode, $limit: Int, $publicationState: PublicationStatus) {
		openGelderlandInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...openGelderlandInformationFields
				}
			}
		}
		openGelderlandWooOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...openGelderlandWooRequestOverviewSingleFields
				}
			}
		}
		wooCategories(pagination: { limit: 20 }) {
			data {
				documentId
				attributes {
					...wooCategoryFields
				}
			}
		}
		wooRequests_connection(
			pagination: { limit: $limit }
			locale: $locale
			status: $publicationState
			sort: ["startDate:DESC", "documentId:ASC"]
			filters: { zip: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...wooRequestFields
				}
			}
			pageInfo {
				total
			}
		}
		countDocumentsPerCategory {
			sitemap
			count
		}
	}
	${OpenGelderlandInformationFieldsFragmentDoc}
	${OpenGelderlandWooRequestOverviewSingleFieldsFragmentDoc}
	${WooCategoryFieldsFragmentDoc}
	${WooRequestFieldsFragmentDoc}
`;
export type GetOpenWooRequestOverviewQueryResult = Apollo.QueryResult<
	GetOpenWooRequestOverviewQuery,
	GetOpenWooRequestOverviewQueryVariables
>;
export const GetWooRequestDetailpageDocument = gql`
	query GetWooRequestDetailpage($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		wooRequestBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			...wooRequestBySlugFields
		}
	}
	${PageInformationFieldsFragmentDoc}
	${WooRequestBySlugFieldsFragmentDoc}
`;
export type GetWooRequestDetailpageQueryResult = Apollo.QueryResult<
	GetWooRequestDetailpageQuery,
	GetWooRequestDetailpageQueryVariables
>;
export const GetWooRequestDetailXmlDocument = gql`
	query GetWooRequestDetailXML($locale: I18NLocaleCode, $slug: String!, $publicationState: PublicationStatus) {
		wooRequestBySlug(locale: $locale, slug: $slug, status: $publicationState) {
			...wooRequestBySlugFields
		}
	}
	${WooRequestBySlugFieldsFragmentDoc}
`;
export type GetWooRequestDetailXmlQueryResult = Apollo.QueryResult<
	GetWooRequestDetailXmlQuery,
	GetWooRequestDetailXmlQueryVariables
>;
export const GetWooRequestOverviewDocument = gql`
	query GetWooRequestOverview($locale: I18NLocaleCode, $limit: Int, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		wooRequestOverview(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...wooRequestOverviewSingleFields
				}
			}
		}
		wooRequests_connection(
			pagination: { limit: $limit }
			locale: $locale
			status: $publicationState
			sort: ["startDate:DESC", "documentId:ASC"]
			filters: { zip: { notNull: true } }
		) {
			data {
				documentId
				attributes {
					...wooRequestFields
				}
			}
			pageInfo {
				total
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${WooRequestOverviewSingleFieldsFragmentDoc}
	${WooRequestFieldsFragmentDoc}
`;
export type GetWooRequestOverviewQueryResult = Apollo.QueryResult<
	GetWooRequestOverviewQuery,
	GetWooRequestOverviewQueryVariables
>;
export const GetWooRequestOverviewXmlDocument = gql`
	query GetWooRequestOverviewXML($locale: I18NLocaleCode, $publicationState: PublicationStatus, $sitemap: String) {
		wooDocuments: wooRequests(
			pagination: { limit: 1000 }
			locale: $locale
			status: $publicationState
			filters: { category: { sitemap: { eq: $sitemap } } }
		) {
			data {
				documentId
				attributes {
					...wooRequestFields
				}
			}
		}
	}
	${WooRequestFieldsFragmentDoc}
`;
export type GetWooRequestOverviewXmlQueryResult = Apollo.QueryResult<
	GetWooRequestOverviewXmlQuery,
	GetWooRequestOverviewXmlQueryVariables
>;
export const GetWorkAtDocument = gql`
	query GetWorkAt($locale: I18NLocaleCode, $publicationState: PublicationStatus) {
		pageInformation(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...pageInformationFields
				}
			}
		}
		workAt(locale: $locale, status: $publicationState) {
			data {
				documentId
				attributes {
					...workAtFields
				}
			}
		}
	}
	${PageInformationFieldsFragmentDoc}
	${WorkAtFieldsFragmentDoc}
`;
export type GetWorkAtQueryResult = Apollo.QueryResult<GetWorkAtQuery, GetWorkAtQueryVariables>;

export interface PossibleTypesResultData {
	possibleTypes: {
		[key: string]: string[];
	};
}
const result: PossibleTypesResultData = {
	possibleTypes: {
		AgendaPageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'Error'
		],
		CondoleanceHomepageModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		CondoleancePageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		ContactModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesLinkBox',
			'ComponentModulesPartners',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		DecisionsPageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'Error'
		],
		DownloadsPageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'Error'
		],
		EfroOostHomepageModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsEfroOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		EfroOostInConvoWithArticleModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		EfroOostInConvoWithDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		EfroOostInConvoWithOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesInConvoWithOverview',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		EfroOostNewsDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsEfroOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		EfroOostNewsOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesNewsOverview',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		EfroOostNewsarticleModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsEfroOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesShare',
			'ComponentModulesTestimonial',
			'Error'
		],
		EfroOostPageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsEfroOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesShare',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		EventOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesEventOverview',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		GenericMorph: [
			'AgendaPage',
			'AuditLogAuditLog',
			'ComponentComponentsButton',
			'ComponentComponentsIconLink',
			'ComponentComponentsIconLinkGroup',
			'ComponentComponentsInternalLinkSubLayer',
			'ComponentComponentsLink',
			'ComponentComponentsLinkGroup',
			'ComponentComponentsSubject',
			'ComponentInternalAboutMaintenance',
			'ComponentInternalAccordeonItem',
			'ComponentInternalAccordeonSection',
			'ComponentInternalBodyTextColumn',
			'ComponentInternalDefaultModuleOptions',
			'ComponentInternalDefaultModuleOptionsExtended',
			'ComponentInternalEmptyState',
			'ComponentInternalFirstRowItems',
			'ComponentInternalFooter',
			'ComponentInternalHighlightEvents',
			'ComponentInternalHighlightMapsAndStats',
			'ComponentInternalHighlightNews',
			'ComponentInternalHighlightPermits',
			'ComponentInternalHighlightSubsidies',
			'ComponentInternalHighlightTopics',
			'ComponentInternalHighlightWoo',
			'ComponentInternalNavbar',
			'ComponentInternalNewsletter',
			'ComponentInternalPhoto',
			'ComponentInternalSecondColumnItems',
			'ComponentInternalSeo',
			'ComponentInternalSidebar',
			'ComponentInternalStepByStepCard',
			'ComponentInternalTest',
			'ComponentLinkFieldLinkField',
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCollections',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesEventOverview',
			'ComponentModulesExpandedHeader',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedNewsEfroOost',
			'ComponentModulesFeaturedNewsOpOost',
			'ComponentModulesFeaturedNewsRegioExpres',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesHomepageHeader',
			'ComponentModulesInConvoWithOverview',
			'ComponentModulesInternalInternalLink',
			'ComponentModulesIntroHeader',
			'ComponentModulesIntroHeaderImage',
			'ComponentModulesLinkBox',
			'ComponentModulesMapsFiguresOverview',
			'ComponentModulesMedia',
			'ComponentModulesNewsOverview',
			'ComponentModulesOpenWooRequestOverview',
			'ComponentModulesPartners',
			'ComponentModulesPermitsOverview',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesPressReleaseOverview',
			'ComponentModulesProjectOverview',
			'ComponentModulesRegions',
			'ComponentModulesRoadMaintenanceOverview',
			'ComponentModulesScheduling',
			'ComponentModulesSearchHeader',
			'ComponentModulesSearchOverview',
			'ComponentModulesSeo',
			'ComponentModulesShare',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesSubsidyOverview',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'ComponentModulesThemes',
			'ComponentModulesVacanciesOverview',
			'ComponentModulesWobRequestOverview',
			'ComponentModulesWooRequestOverview',
			'ComponentSdgSdgLink',
			'ComponentSdgSdgProductVertaling',
			'CondoleanceHomepage',
			'CondoleanceInformation',
			'CondoleancePage',
			'Contact',
			'ConversationsConversationitem',
			'ConversationsConversations',
			'CookiePage',
			'DecisionsPage',
			'DownloadsPage',
			'EfroOostHomepage',
			'EfroOostInConvoWithArticle',
			'EfroOostInConvoWithDetail',
			'EfroOostInConvoWithOverview',
			'EfroOostInformation',
			'EfroOostNewsDetail',
			'EfroOostNewsOverview',
			'EfroOostNewsarticle',
			'EfroOostPage',
			'Event',
			'EventOverview',
			'GeolinkHomepage',
			'GeolinkInformation',
			'GeolinkPage',
			'HomePage',
			'I18NLocale',
			'InConvoWithArticle',
			'InConvoWithDetail',
			'InConvoWithOverview',
			'InternalLinksLinkReference',
			'Login',
			'MapsFigure',
			'MapsFiguresOverview',
			'NewsDetail',
			'NewsOverview',
			'Newsarticle',
			'Newsletter',
			'NewsletterArchiveOverview',
			'NewsletterInternal',
			'NewsletterPublic',
			'NotFoundPage',
			'NotesNote',
			'OpOostHomepage',
			'OpOostInConvoWithArticle',
			'OpOostInConvoWithDetail',
			'OpOostInConvoWithOverview',
			'OpOostInformation',
			'OpOostNewsDetail',
			'OpOostNewsOverview',
			'OpOostNewsarticle',
			'OpOostPage',
			'OpenGelderlandHomepage',
			'OpenGelderlandInformation',
			'OpenGelderlandWooOverview',
			'Page',
			'PageInformation',
			'PasswordProtectionPasswordPage',
			'PasswordProtectionPasswordProtection',
			'Permit',
			'PermitDetail',
			'PermitLaw',
			'PermitProductType',
			'PermitsOverview',
			'PressRelease',
			'PressReleaseDetail',
			'PressReleaseOverview',
			'PrivacyPolicy',
			'Project',
			'ProjectDetail',
			'ProjectOverview',
			'RecordLockingOpenEntity',
			'RecycleBinRecycleBinItem',
			'RedirectsRedirect',
			'RegioExpresHomepage',
			'RegioExpresInConvoOverview',
			'RegioExpresInConvoWithArticle',
			'RegioExpresInConvoWithDetail',
			'RegioExpresInformation',
			'RegioExpresNewsDetail',
			'RegioExpresNewsOverview',
			'RegioExpresNewsarticle',
			'RegioExpresPage',
			'Region',
			'RegionDetail',
			'RegionOverview',
			'ReviewWorkflowsWorkflow',
			'ReviewWorkflowsWorkflowStage',
			'RoadMaintenance',
			'RoadMaintenanceDetail',
			'RoadMaintenanceOverview',
			'SchedulerScheduler',
			'SdgLocatie',
			'SdgSdg',
			'SdgUplLijst',
			'SearchOverview',
			'Sitemap',
			'Subsidy',
			'SubsidyDetail',
			'SubsidyKind',
			'SubsidyOverview',
			'SubsidyScale',
			'Tag',
			'TargetGroup',
			'Theme',
			'ThemeDetail',
			'ThemeOverview',
			'Upl',
			'UploadFile',
			'UsersPermissionsPermission',
			'UsersPermissionsRole',
			'UsersPermissionsUser',
			'VacancyDetail',
			'VacancyInternalDetail',
			'VacancyInternalOverview',
			'VacancyOverview',
			'VersioningHistory',
			'WobRequest',
			'WobRequestOverview',
			'WooCategory',
			'WooDocumentDetail',
			'WooRequest',
			'WooRequestOverview',
			'WorkAt'
		],
		GeolinkHomepageModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		GeolinkPageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		HomePageModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesSubjects',
			'ComponentModulesTestimonial',
			'ComponentModulesThemes',
			'Error'
		],
		InConvoWithArticleModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesShare',
			'ComponentModulesTestimonial',
			'Error'
		],
		InConvoWithDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		InConvoWithOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesInConvoWithOverview',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		LoginModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesVacanciesOverview',
			'Error'
		],
		MapsFiguresOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesThemes',
			'Error'
		],
		NewsDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesShare',
			'ComponentModulesSubjects',
			'Error'
		],
		NewsOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesNewsOverview',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		NewsarticleModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesShare',
			'ComponentModulesTestimonial',
			'Error'
		],
		NewsletterArchiveOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesPermitsOverview',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'Error'
		],
		OpOostHomepageModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsOpOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		OpOostInConvoWithArticleModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		OpOostInConvoWithDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		OpOostInConvoWithOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesInConvoWithOverview',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		OpOostNewsDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsOpOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		OpOostNewsOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesNewsOverview',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		OpOostNewsarticleModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsOpOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesShare',
			'ComponentModulesTestimonial',
			'Error'
		],
		OpOostPageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsOpOost',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesShare',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		OpenGelderlandHomepageModulesDynamicZone: ['ComponentModulesCta', 'Error'],
		OpenGelderlandWooOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'Error'
		],
		PageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesScheduling',
			'ComponentModulesShare',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'ComponentModulesThemes',
			'Error'
		],
		PasswordProtectionPasswordPageModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesSubjects',
			'ComponentModulesTestimonial',
			'ComponentModulesThemes',
			'Error'
		],
		PermitDetailModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'Error'
		],
		PermitModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		PermitsOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesPermitsOverview',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'Error'
		],
		PressReleaseDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesSubjects',
			'Error'
		],
		PressReleaseModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		PressReleaseOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesPressReleaseOverview',
			'Error'
		],
		ProjectDetailModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		ProjectModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		ProjectOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesProjectOverview',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		RegioExpresHomepageModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsRegioExpres',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		RegioExpresInConvoOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesInConvoWithOverview',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		RegioExpresInConvoWithArticleModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesTestimonial',
			'Error'
		],
		RegioExpresInConvoWithDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		RegioExpresNewsDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsRegioExpres',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		RegioExpresNewsOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesNewsOverview',
			'ComponentModulesPhotoAlbum',
			'Error'
		],
		RegioExpresNewsarticleModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsRegioExpres',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesShare',
			'ComponentModulesTestimonial',
			'Error'
		],
		RegioExpresPageModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNewsRegioExpres',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPartners',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesShare',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'ComponentModulesTestimonial',
			'Error'
		],
		RegionDetailModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesThemes',
			'Error'
		],
		RegionModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesNewsOverview',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesThemes',
			'Error'
		],
		RegionOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesThemes',
			'Error'
		],
		RoadMaintenanceDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'Error'
		],
		RoadMaintenanceModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesScheduling',
			'ComponentModulesShare',
			'ComponentModulesStepByStep',
			'ComponentModulesTable',
			'Error'
		],
		RoadMaintenanceOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'Error'
		],
		SearchOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'Error'
		],
		SitemapModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'Error'
		],
		SubsidyDetailModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesThemes',
			'Error'
		],
		SubsidyModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesThemes',
			'Error'
		],
		SubsidyOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesSubjects',
			'ComponentModulesSubsidyOverview',
			'ComponentModulesThemes',
			'Error'
		],
		ThemeDetailModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesThemes',
			'Error'
		],
		ThemeModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesNewsOverview',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesThemes',
			'Error'
		],
		ThemeOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesRegions',
			'ComponentModulesScheduling',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'ComponentModulesTable',
			'ComponentModulesThemes',
			'Error'
		],
		VacancyDetailModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesSubjects',
			'Error'
		],
		VacancyInternalDetailModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesFeaturedNews',
			'ComponentModulesFeaturedPages',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesSubjects',
			'Error'
		],
		VacancyInternalOverviewModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesVacanciesOverview',
			'Error'
		],
		VacancyOverviewModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesVacanciesOverview',
			'Error'
		],
		WobRequestOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'Error'
		],
		WooDocumentDetailModulesDynamicZone: [
			'ComponentModulesBbvmsMediaplayer',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesLinkBox',
			'ComponentModulesShare',
			'Error'
		],
		WooRequestOverviewModulesDynamicZone: [
			'ComponentModulesAccordeon',
			'ComponentModulesBodyText',
			'ComponentModulesBodyTextTwoColumn',
			'ComponentModulesCta',
			'ComponentModulesDownloads',
			'ComponentModulesHighlight',
			'ComponentModulesLinkBox',
			'ComponentModulesMedia',
			'ComponentModulesPhotoAlbum',
			'ComponentModulesStepByStep',
			'ComponentModulesSubjects',
			'Error'
		],
		WorkAtModulesDynamicZone: [
			'ComponentModulesBodyText',
			'ComponentModulesCta',
			'ComponentModulesLinkBox',
			'ComponentModulesPartners',
			'Error'
		]
	}
};
export default result;
